import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/iconProperties.ts
const iconSizes = {
	xs: 12,
	sm: 16,
	md: 24,
	lg: 32,
	xl: 40,
	xxl: 60
};
//#endregion
//#region src/icons/AlarmClockOff/AlarmClockOffIcon.tsx
const AlarmClockOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.707 2.293a1 1 0 0 0-1.414 0 1 1 0 0 0 0 1.414L2.586 4 1.293 5.293a1 1 0 0 0 1.414 1.414L4 5.414l1.432 1.433a9 9 0 0 0-.464 11.77l-1.675 1.676a1 1 0 1 0 1.414 1.414l1.675-1.675a9 9 0 0 0 11.772-.464l2.139 2.14a1 1 0 0 0 1.414-1.415z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20.42 16.178A8.998 8.998 0 0 0 12 4c-1.096 0-2.172.2-3.178.58zm-.713-13.885a1 1 0 1 0-1.414 1.414l3 3a1 1 0 1 0 1.414-1.414z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10.5 5.142a8 8 0 0 1 9.358 9.358m-1.722 3.634A8 8 0 1 1 6.862 6.869M4 4 2 6m20 0-3-3M6 19l-2 2m17 0L3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlarmClockMinus/AlarmClockMinusIcon.tsx
const AlarmClockMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414zm14-1.414a1 1 0 1 0-1.414 1.414l3 3a1 1 0 1 0 1.414-1.414z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 22a9 9 0 0 0 5.618-1.968l1.675 1.675a1 1 0 0 0 1.414-1.414l-1.675-1.675a9 9 0 1 0-14.064 0l-1.675 1.675a1 1 0 1 0 1.414 1.414l1.676-1.675A9 9 0 0 0 12 22M9 12a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M9 13h6m-3 8a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlarmClockPlus/AlarmClockPlusIcon.tsx
const AlarmClockPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414zm14-1.414a1 1 0 1 0-1.414 1.414l3 3a1 1 0 1 0 1.414-1.414z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 22a9 9 0 0 0 5.618-1.968l1.675 1.675a1 1 0 0 0 1.414-1.414l-1.675-1.675a9 9 0 1 0-14.064 0l-1.675 1.675a1 1 0 1 0 1.414 1.414l1.676-1.675A9 9 0 0 0 12 22m0-13a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2m-8-5v-6m-3 3h6m-3 8a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlignJustify/AlignJustifyIcon.tsx
const AlignJustifyIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 10a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 10H3m18 8H3M21 6H3m18 8H3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlignCenter/AlignCenterIcon.tsx
const AlignCenterIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M3 5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2zm3 4a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2zm-4 5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m4 3a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18 10H6m15-4H3m18 8H3m15 4H6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Archive/ArchiveIcon.tsx
const ArchiveIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 5a3 3 0 0 1 3-3h16a3 3 0 1 1 0 6H4a3 3 0 0 1-3-3m3 5a1 1 0 0 0-1 1v5.241c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 22 7.954 22 8.758 22h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V11a1 1 0 0 0-1-1zm6 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 7.997a2.3 2.3 0 0 1-.39-.035A2 2 0 0 1 2.038 6.39C2 6.197 2 5.965 2 5.5s0-.697.038-.89A2 2 0 0 1 3.61 3.038C3.803 3 4.035 3 4.5 3h15c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89s0 .697-.038.89a2 2 0 0 1-1.572 1.572c-.107.02-.226.03-.39.035M10 13h4M4 8h16v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 21 16.88 21 15.2 21H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 18.72 4 17.88 4 16.2z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlignRight/AlignRightIcon.tsx
const AlignRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7 10a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M3 6a1 1 0 0 1 1-1h17a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h17a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m4 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 10H8m13-4H4m17 8H4m17 4H8"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Anchor/AnchorIcon.tsx
const AnchorIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M16 5a4 4 0 0 1-3 3.874v12.07A9 9 0 0 0 20.944 13H19a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1 11 11 0 1 1-22 0 1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H3.056A9 9 0 0 0 11 20.944V8.874A4.002 4.002 0 0 1 12 1a4 4 0 0 1 4 4m-4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v14m0 0A10 10 0 0 1 2 12h3m7 10a10 10 0 0 0 10-10h-3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Activity/ActivityIcon.tsx
const ActivityIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9 2a1 1 0 0 1 .949.684L15 17.838l2.051-6.154A1 1 0 0 1 18 11h4a1 1 0 1 1 0 2h-3.28l-2.771 8.316a1 1 0 0 1-1.898 0L9 6.162l-2.051 6.154A1 1 0 0 1 6 13H2a1 1 0 1 1 0-2h3.28l2.77-8.316A1 1 0 0 1 9 2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 12h-4l-3 9L9 3l-3 9H2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlignLeft/AlignLeftIcon.tsx
const AlignLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 10a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0-4a1 1 0 0 1 1-1h17a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h17a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 10H3m17-4H3m17 8H3m13 4H3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlarmClock/AlarmClockIcon.tsx
const AlarmClockIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414zm14-1.414a1 1 0 1 0-1.414 1.414l3 3a1 1 0 1 0 1.414-1.414z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 22a9 9 0 0 0 5.618-1.968l1.675 1.675a1 1 0 0 0 1.414-1.414l-1.675-1.675a9 9 0 1 0-14.064 0l-1.675 1.675a1 1 0 1 0 1.414 1.414l1.676-1.675A9 9 0 0 0 12 22m1-13a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2 2a1 1 0 0 0 1.414-1.414L13 12.586z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M12 9v4l2 2m-2 6a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlarmClockCheck/AlarmClockCheckIcon.tsx
const AlarmClockCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414zm14-1.414a1 1 0 1 0-1.414 1.414l3 3a1 1 0 1 0 1.414-1.414z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 22a9 9 0 0 0 5.618-1.968l1.675 1.675a1 1 0 0 0 1.414-1.414l-1.675-1.675a9 9 0 1 0-14.064 0l-1.675 1.675a1 1 0 1 0 1.414 1.414l1.676-1.675A9 9 0 0 0 12 22m4.207-10.293a1 1 0 0 0-1.414-1.414L11 14.086l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M9 13.5l2 2 4.5-4.5M12 21a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowChunkDown/ArrowChunkDownIcon.tsx
const ArrowChunkDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.777 2h4.446c.12 0 .261 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.125.01.268.01.387V13h3a1 1 0 0 1 .707 1.707l-7 7a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 5 13h3V3.777c0-.12 0-.262.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655c.218-.112.426-.142.571-.154.126-.01.268-.01.387-.01",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 3.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.219C9.38 3 9.52 3 9.8 3h4.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C15 3.38 15 3.52 15 3.8V14h4l-7 7-7-7h4z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlertTriangle/AlertTriangleIcon.tsx
const AlertTriangleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12.813 1.668a2 2 0 0 0-1.626 0c-.4.178-.659.49-.84.746-.177.25-.367.579-.576.94l-8.267 14.28c-.21.362-.4.692-.53.971-.132.285-.274.666-.229 1.102a2 2 0 0 0 .813 1.41c.355.258.757.326 1.069.355.306.028.687.028 1.106.028h16.534c.419 0 .8 0 1.106-.028.312-.029.714-.097 1.069-.354a2 2 0 0 0 .813-1.41c.045-.437-.097-.818-.229-1.103-.13-.28-.32-.609-.53-.971L14.23 3.354c-.21-.361-.4-.69-.577-.94-.18-.255-.44-.568-.84-.746M13 9a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 9v4m0 4h.01M10.615 3.892 2.39 18.098c-.456.788-.684 1.182-.65 1.506a1 1 0 0 0 .406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 0 0 .407-.705c.034-.324-.195-.718-.65-1.506L13.383 3.892c-.454-.785-.681-1.178-.978-1.31a1 1 0 0 0-.812 0c-.297.132-.524.525-.979 1.31"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowCircleDownLeft/ArrowCircleDownLeftIcon.tsx
const ArrowCircleDownLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.778 4.222c-4.296-4.296-11.26-4.296-15.556 0s-4.296 11.26 0 15.556 11.26 4.296 15.556 0 4.296-11.26 0-15.556m-4.242 4.242a1 1 0 0 1 0 1.415l-3.95 3.95h3.242a1 1 0 1 1 0 2H9.172a1 1 0 0 1-1-1V9.171a1 1 0 0 1 2 0v3.242l3.95-3.95a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 9v6m0 0h6m-6 0 6-6m7 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Announcement/AnnouncementIcon.tsx
const AnnouncementIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3.038 14.274A5.5 5.5 0 0 1 6.5 4.5h3.75c1.8 0 3.608-.912 5.15-1.753.457-.249.85-.462 1.167-.606.292-.132.718-.302 1.176-.245.573.07 1.048.351 1.384.821.264.37.321.807.347 1.123.046.588.026 1.182.026 1.772a4.502 4.502 0 0 1 0 8.777c0 .59.02 1.183-.026 1.771-.026.316-.083.754-.347 1.123-.336.47-.81.751-1.384.821-.458.056-.884-.113-1.176-.245-.411-.186-.806-.41-1.201-.625-1.394-.76-3.003-1.467-4.366-1.673 0 1.559.137 3.176-.014 4.729a3 3 0 0 1-2.696 2.696c-.318.03-.655.03-.973.004a3 3 0 0 1-2.597-2.028 5 5 0 0 1-.108-.39zM19.5 12.292a2.5 2.5 0 0 0 0-4.584z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m4 14 1.575 6.299c.044.177.066.265.092.343A2 2 0 0 0 7.4 21.993c.08.007.172.007.355.007.228 0 .343 0 .44-.01a2 2 0 0 0 1.797-1.797c.009-.096.009-.21.009-.44V5.5m8.5 8a3.5 3.5 0 1 0 0-7m-8.25-1H6.5a4.5 4.5 0 0 0 0 9h3.75c1.766 0 3.927.947 5.594 1.856.973.53 1.46.795 1.778.756a.95.95 0 0 0 .691-.41c.187-.262.187-.784.187-1.828V5.126c0-1.044 0-1.566-.187-1.827a.95.95 0 0 0-.691-.41c-.319-.04-.805.225-1.778.755-1.667.91-3.828 1.856-5.594 1.856"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowChunkLeft/ArrowChunkLeftIcon.tsx
const ArrowChunkLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10.383 4.076A1 1 0 0 1 11 5v3h9.223c.12 0 .262 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.126.01.268.01.387v4.446c0 .12 0 .261-.01.387a1.5 1.5 0 0 1-.153.571 1.5 1.5 0 0 1-.656.656 1.5 1.5 0 0 1-.571.153c-.125.01-.268.01-.387.01H11v3a1 1 0 0 1-1.707.707l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.09-.217",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m3 12 7-7v4h10.2c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218C21 9.38 21 9.52 21 9.8v4.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C20.62 15 20.48 15 20.2 15H10v4z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowCircleDownRight/ArrowCircleDownRightIcon.tsx
const ArrowCircleDownRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4.222 4.222c-4.296 4.296-4.296 11.26 0 15.556s11.26 4.296 15.556 0 4.296-11.26 0-15.556-11.26-4.296-15.556 0m4.242 4.242a1 1 0 0 1 1.415 0l3.95 3.95V9.172a1 1 0 1 1 2 0v5.656a1 1 0 0 1-1 1H9.171a1 1 0 1 1 0-2h3.242l-3.95-3.95a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 9v6m0 0H9m6 0L9 9m13 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AlertCircle/AlertCircleIcon.tsx
const AlertCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m1 7a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 8v4m0 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowCircleUpLeft/ArrowCircleUpLeftIcon.tsx
const ArrowCircleUpLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.778 19.778c4.296-4.296 4.296-11.26 0-15.556s-11.26-4.296-15.556 0-4.296 11.26 0 15.556 11.26 4.296 15.556 0m-4.242-4.242a1 1 0 0 1-1.415 0l-3.95-3.95v3.242a1 1 0 0 1-2 0V9.172a1 1 0 0 1 1-1h5.657a1 1 0 1 1 0 2h-3.242l3.95 3.95a1 1 0 0 1 0 1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 15V9m0 0h6M9 9l6 6m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowLeft/ArrowLeftIcon.tsx
const ArrowLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.707 5.707a1 1 0 0 0-1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L7.414 13H19a1 1 0 1 0 0-2H7.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 12H5m0 0 7 7m-7-7 7-7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowUp/ArrowUpIcon.tsx
const ArrowUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.707 4.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 1 0 1.414 1.414L11 7.414V19a1 1 0 1 0 2 0V7.414l5.293 5.293a1 1 0 0 0 1.414-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 19V5m0 0-7 7m7-7 7 7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowDownRight/ArrowDownRightIcon.tsx
const ArrowDownRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7.707 6.293a1 1 0 0 0-1.414 1.414L14.586 16H7a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1V7a1 1 0 1 0-2 0v7.586z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m7 7 10 10m0 0V7m0 10H7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowDown/ArrowDownIcon.tsx
const ArrowDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M13 5a1 1 0 1 0-2 0v11.586l-5.293-5.293a1 1 0 0 0-1.414 1.414l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0-1.414-1.414L13 16.586z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 5v14m0 0 7-7m-7 7-7-7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowDownLeft/ArrowDownLeftIcon.tsx
const ArrowDownLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m9.414 16 8.293-8.293a1 1 0 0 0-1.414-1.414L8 14.586V7a1 1 0 0 0-2 0v10a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 7 7 17m0 0h10M7 17V7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowCircleLeft/ArrowCircleLeftIcon.tsx
const ArrowCircleLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M23 12c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11 11-4.925 11-11m-6 0a1 1 0 0 1-1 1h-5.586l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 1 1 1.414 1.414L10.414 11H16a1 1 0 0 1 1 1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m12 8-4 4m0 0 4 4m-4-4h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowUpLeft/ArrowUpLeftIcon.tsx
const ArrowUpLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V9.414l8.293 8.293a1 1 0 0 0 1.414-1.414L9.414 8H17a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 17 7 7m0 0v10M7 7h10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowUpRight/ArrowUpRightIcon.tsx
const ArrowUpRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7 6a1 1 0 0 0 0 2h7.586l-8.293 8.293a1 1 0 1 0 1.414 1.414L16 9.414V17a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 17 17 7m0 0H7m10 0v10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowRight/ArrowRightIcon.tsx
const ArrowRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.707 4.293a1 1 0 1 0-1.414 1.414L16.586 11H5a1 1 0 1 0 0 2h11.586l-5.293 5.293a1 1 0 0 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 12h14m0 0-7-7m7 7-7 7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowsDown/ArrowsDownIcon.tsx
const ArrowsDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m6 17.586-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L8 17.586V4a1 1 0 1 0-2 0zm12-5 2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 12.586V4a1 1 0 1 1 2 0z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 4v11m0 0-4-4m4 4 4-4M7 4v16m0 0-4-4m4 4 4-4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowsUp/ArrowsUpIcon.tsx
const ArrowsUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7.707 3.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L6 6.414V20a1 1 0 1 0 2 0V6.414l2.293 2.293a1 1 0 1 0 1.414-1.414zm10 5a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L16 11.414V20a1 1 0 1 0 2 0v-8.586l2.293 2.293a1 1 0 0 0 1.414-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 20V4m0 0L3 8m4-4 4 4m6 12V9m0 0-4 4m4-4 4 4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowsLeft/ArrowsLeftIcon.tsx
const ArrowsLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M13.707 3.707a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L11.414 8H20a1 1 0 1 0 0-2h-8.586zM6.414 16l2.293-2.293a1 1 0 1 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L6.414 18H20a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 17H4m0 0 4 4m-4-4 4-4m12-6H9m0 0 4 4M9 7l4-4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Attachment/AttachmentIcon.tsx
const AttachmentIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10.167 3A2.667 2.667 0 0 0 7.5 5.667V16.5a4.5 4.5 0 1 0 9 0V5.256a1 1 0 1 1 2 0V16.5a6.5 6.5 0 1 1-13 0V5.667a4.667 4.667 0 0 1 9.333 0v10.779a2.833 2.833 0 1 1-5.666 0V6.65a1 1 0 0 1 2 0v9.795a.833.833 0 1 0 1.666 0V5.666A2.667 2.667 0 0 0 10.167 3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17.5 5.256V16.5a5.5 5.5 0 1 1-11 0V5.667a3.667 3.667 0 0 1 7.333 0v10.779a1.833 1.833 0 1 1-3.666 0V6.65"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowCircleUpRight/ArrowCircleUpRightIcon.tsx
const ArrowCircleUpRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4.222 19.778c4.296 4.296 11.26 4.296 15.556 0s4.296-11.26 0-15.556-11.26-4.296-15.556 0-4.296 11.26 0 15.556m4.242-4.242a1 1 0 0 1 0-1.415l3.95-3.95H9.172a1 1 0 0 1 0-2h5.656a1 1 0 0 1 1 1v5.657a1 1 0 1 1-2 0v-3.242l-3.95 3.95a1 1 0 0 1-1.414 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 15V9m0 0H9m6 0-6 6m13-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Atom/AtomIcon.tsx
const AtomIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15.12 2.575c-.999.411-2.052.98-3.12 1.686-1.068-.706-2.121-1.275-3.12-1.686-1.16-.477-2.293-.762-3.315-.77-1.027-.007-2.023.268-2.757 1.003-.735.734-1.01 1.73-1.003 2.757.008 1.022.293 2.156.77 3.316.411.998.98 2.051 1.686 3.119-.706 1.068-1.275 2.121-1.686 3.12-.477 1.16-.762 2.293-.77 3.315-.007 1.027.268 2.023 1.003 2.757.734.735 1.73 1.01 2.757 1.003 1.022-.008 2.156-.293 3.316-.77.998-.411 2.05-.98 3.119-1.686 1.068.706 2.121 1.275 3.12 1.686 1.16.477 2.293.762 3.315.77 1.027.007 2.023-.268 2.757-1.003.735-.734 1.01-1.73 1.003-2.757-.008-1.022-.293-2.156-.77-3.316-.411-.998-.98-2.051-1.686-3.119.706-1.068 1.275-2.121 1.686-3.12.477-1.16.762-2.293.77-3.315.007-1.027-.268-2.023-1.003-2.757-.734-.735-1.73-1.01-2.757-1.003-1.022.008-2.156.293-3.316.77m.76 1.85c-.676.278-1.396.647-2.14 1.1a29 29 0 0 1 2.503 2.232 29 29 0 0 1 2.233 2.502 16 16 0 0 0 1.1-2.14c.417-1.015.613-1.886.619-2.569.005-.677-.175-1.086-.417-1.328s-.65-.422-1.328-.417c-.683.005-1.554.202-2.57.62M4.426 8.119c.278.677.647 1.397 1.1 2.14a29 29 0 0 1 2.232-2.502 29 29 0 0 1 2.502-2.233 15.6 15.6 0 0 0-2.14-1.1c-1.015-.417-1.886-.614-2.569-.619-.677-.005-1.086.175-1.328.417s-.422.65-.417 1.328c.005.683.202 1.554.62 2.57m4.747 1.053A27 27 0 0 0 6.707 12a27 27 0 0 0 2.465 2.829A27 27 0 0 0 12 17.293a27 27 0 0 0 2.828-2.465A27 27 0 0 0 17.293 12a27 27 0 0 0-2.465-2.828A27 27 0 0 0 12 6.707a27 27 0 0 0-2.828 2.465M4.425 15.88c.278-.677.647-1.397 1.1-2.14a29 29 0 0 0 2.232 2.502 29 29 0 0 0 2.502 2.233 15.6 15.6 0 0 1-2.14 1.1c-1.015.417-1.886.613-2.569.619-.677.005-1.086-.175-1.328-.417s-.422-.65-.417-1.328c.005-.683.202-1.554.62-2.57m11.456 3.694a15.6 15.6 0 0 1-2.14-1.1 29 29 0 0 0 2.502-2.232 29 29 0 0 0 2.233-2.502c.452.743.82 1.463 1.1 2.14.417 1.015.613 1.886.619 2.569.005.677-.175 1.086-.417 1.328s-.65.422-1.328.417c-.683-.005-1.554-.202-2.57-.62",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 12h.01m3.525 3.536c-4.686 4.686-10.068 6.902-12.02 4.95-1.953-1.953.263-7.335 4.949-12.021s10.068-6.903 12.02-4.95c1.953 1.952-.263 7.334-4.949 12.02m0-7.072c4.686 4.687 6.902 10.069 4.95 12.021-1.953 1.953-7.335-.263-12.021-4.95-4.686-4.686-6.902-10.068-4.95-12.02 1.953-1.953 7.335.263 12.021 4.95M12.499 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Bank/BankIcon.tsx
const BankIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.825 2.032a2 2 0 0 1 .35 0c.133.012.261.04.362.063l7.454 1.656c.2.045.4.09.568.14.188.056.402.138.61.288a2 2 0 0 1 .669.834c.101.236.135.463.15.658.012.176.012.38.012.585v1.176c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201q-.066.006-.138.009v6.016l.138.009c.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017H4.568c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C2 19.93 2 19.684 2 19.432v-.864c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201L4 16.008V9.992l-.138-.009a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C2 7.93 2 7.684 2 7.432V6.256c0-.205 0-.41.013-.585.014-.195.048-.422.15-.658a2 2 0 0 1 .668-.834 2 2 0 0 1 .61-.288c.169-.05.368-.095.568-.14l7.454-1.656a3 3 0 0 1 .362-.063M6 10v6h2.5v-6zm4.5 0v6h3v-6zm5 0v6H18v-6z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 9v8m4.5-8v8m5-8v8M19 9v8M3 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h14.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 17.76 3 18.04 3 18.6m8.653-15.523-7.4 1.645c-.447.099-.67.149-.838.269a1 1 0 0 0-.334.417C3 5.597 3 5.826 3 6.283V7.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 9 4.04 9 4.6 9h14.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.24 21 7.96 21 7.4V6.283c0-.457 0-.686-.081-.875a1 1 0 0 0-.335-.417c-.166-.12-.39-.17-.837-.27l-7.4-1.644a2 2 0 0 0-.26-.049 1 1 0 0 0-.174 0c-.066.006-.13.02-.26.05"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowCircleRight/ArrowCircleRightIcon.tsx
const ArrowCircleRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12m6 0a1 1 0 0 1 1-1h5.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.586 13H8a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m12 16 4-4m0 0-4-4m4 4H8m14 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BarChart/BarChartIcon.tsx
const BarChartIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18 9a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1M6 13a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m6-10a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18 20V10m-6 10V4M6 20v-6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Award/AwardIcon.tsx
const AwardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1a8.5 8.5 0 0 0-6 14.52V22a1 1 0 0 0 1.371.928L12 21.079l4.629 1.85A1 1 0 0 0 18 22v-6.48A8.5 8.5 0 0 0 12 1M8 17.002A8.46 8.46 0 0 0 12 18a8.46 8.46 0 0 0 4-.998v3.521l-3.331-1.333-.022-.008c-.079-.032-.242-.099-.42-.126a1.5 1.5 0 0 0-.454 0c-.178.027-.341.094-.42.126l-.021.008L8 20.523z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 15.09V22l4.703-1.881c.11-.044.165-.066.221-.075a.5.5 0 0 1 .152 0c.056.009.111.03.221.075L17 22v-6.91m2.5-5.59a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/AwardMedal/AwardMedalIcon.tsx
const AwardMedalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.162 1h9.677c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.297 1.167.03.375.03.83.03 1.356v.787c0 .347 0 .652-.061.954a3 3 0 0 1-.267.761c-.14.274-.332.513-.548.783l-3.647 4.559a6 6 0 1 1-8.954 0L3.876 8.446c-.216-.27-.408-.509-.547-.783a3 3 0 0 1-.268-.761C3 6.6 3 6.295 3 5.948v-.787c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C6.18 1 6.635 1 7.162 1M12 10.371 16.723 4.3c.322-.414.483-.622.482-.795a.5.5 0 0 0-.19-.388c-.136-.108-.399-.108-.924-.108H7.91c-.525 0-.788 0-.924.108a.5.5 0 0 0-.19.388c-.001.173.16.38.482.795z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.876 13.095 4.701 7.877c-.26-.325-.39-.488-.482-.669a2 2 0 0 1-.178-.507C4 6.5 4 6.294 4 5.878V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 2 6.08 2 7.2 2h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C20 3.52 20 4.08 20 5.2v.678c0 .416 0 .624-.04.823a2 2 0 0 1-.179.507c-.092.181-.222.344-.482.669l-4.175 5.218M5 3l7 9 7-9m-3.464 10.465a5 5 0 1 1-7.071 7.07 5 5 0 0 1 7.07-7.07"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BarChartChunk/BarChartChunkIcon.tsx
const BarChartChunkIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3.568 6h.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77C7 8.07 7 8.316 7 8.568v10.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201C4.93 22 4.684 22 4.432 22h-.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C1 19.93 1 19.684 1 19.432V8.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C3.07 6 3.316 6 3.568 6m8-4h.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v14.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017h-.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C9 19.93 9 19.684 9 19.432V4.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C11.07 2 11.316 2 11.568 2m8 8h.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v6.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017h-.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C17 19.93 17 19.684 17 19.432v-6.864c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201c.208-.017.454-.017.706-.017",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 7H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 7.76 3 8.04 3 8.6v10.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H9m0 0h6m-6 0V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 3 10.04 3 10.6 3h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 3.76 15 4.04 15 4.6V21m0-10h4.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 11.76 21 12.04 21 12.6v6.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C20.24 21 19.96 21 19.4 21H15"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Beach/BeachIcon.tsx
const BeachIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3.47 5.052C6.815.936 12.744-.264 17.487 2.466l.013.008.013.007c4.736 2.743 6.661 8.477 4.769 13.432-.138.36-.305.874-.757 1.245a2.1 2.1 0 0 1-1.278.454 2 2 0 0 1-.818-.193 8 8 0 0 1-.624-.336l-6.439-3.717L7.96 21H22a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h3.65l4.984-8.634-6.439-3.717c-.21-.122-.427-.247-.603-.373a2 2 0 0 1-.575-.612A2.1 2.1 0 0 1 2.77 6.33c.096-.578.457-.979.7-1.278m1.552 1.262a9.01 9.01 0 0 1 8.264-3.224q-.412.266-.818.586C11.008 4.824 9.5 6.554 8.186 8.643L4.758 6.651a6 6 0 0 1 .264-.337m13.953 1.119c-.265 1.838-1.01 4.008-2.161 6.191l3.439 1.973a9.01 9.01 0 0 0-1.18-9.166q-.025.49-.098 1.002",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6.25 21.96 12 12m5-8.66C12.687.85 7.29 1.938 4.246 5.683c-.297.365-.446.548-.489.81-.034.208.017.485.123.667.134.23.371.366.845.64l14.55 8.4c.474.274.711.41.976.412.212 0 .476-.093.64-.227.205-.168.289-.388.457-.828C23.07 11.048 21.313 5.83 17 3.34m0 0C15.087 2.235 11.297 5.217 8.536 10M17 3.34c1.913 1.104 1.226 5.877-1.536 10.66M22 22H2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Beaker/BeakerIcon.tsx
const BeakerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.5 2a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H15v3.545a8.5 8.5 0 1 1-6 0V3h-.5a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10 2v4.66c0 .218 0 .326-.033.413a.5.5 0 0 1-.138.198c-.07.06-.183.102-.409.185a7.5 7.5 0 1 0 5.16 0c-.226-.083-.339-.125-.409-.185a.5.5 0 0 1-.138-.198C14 6.986 14 6.878 14 6.66V2M8.5 2h7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Bell/BellIcon.tsx
const BellIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.604 20.338a1 1 0 0 1 1.412-.088c.53.468 1.223.75 1.984.75s1.455-.282 1.984-.75a1 1 0 1 1 1.323 1.5A4.98 4.98 0 0 1 12 23a4.98 4.98 0 0 1-3.308-1.25 1 1 0 0 1-.088-1.412M7.05 3.05A7 7 0 0 1 19 8c0 2.913.732 4.844 1.5 6.077l.011.02c.358.573.64 1.027.83 1.358.096.165.183.325.247.466.032.071.068.158.096.252.024.079.068.246.051.45-.01.136-.039.37-.173.611a1.5 1.5 0 0 1-.428.47c-.25.186-.538.229-.634.243h-.004a5 5 0 0 1-.483.04c-.336.013-.8.013-1.377.013H5.364c-.577 0-1.041 0-1.376-.013a5 5 0 0 1-.484-.04H3.5a1.4 1.4 0 0 1-.634-.242 1.5 1.5 0 0 1-.428-.47 1.5 1.5 0 0 1-.173-.613c-.017-.203.027-.37.05-.449.029-.094.065-.18.097-.251a6 6 0 0 1 .247-.467c.19-.33.472-.785.83-1.359l.012-.019C4.268 12.844 5 10.913 5 8a7 7 0 0 1 2.05-4.95",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.354 21c.705.622 1.632 1 2.646 1s1.94-.378 2.646-1M18 8A6 6 0 1 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936C18.78 13.206 18 11.09 18 8"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BellOff/BellOffIcon.tsx
const BellOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l2.856 2.856Q5.001 7.27 5 8c0 2.913-.732 4.844-1.5 6.077l-.011.02c-.358.573-.64 1.027-.83 1.358a6 6 0 0 0-.247.467c-.032.07-.068.157-.096.251a1.2 1.2 0 0 0-.051.45c.01.136.039.37.173.611.134.242.318.39.428.47.25.186.538.229.634.243h.004c.147.023.315.034.484.04.335.013.799.013 1.376.013h11.222l3.707 3.707a1 1 0 0 0 1.414-1.414L6.997 5.583a1 1 0 0 0-.066-.066z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.604 20.338a1 1 0 0 1 1.412-.088c.53.468 1.222.75 1.984.75.761 0 1.455-.282 1.984-.75a1 1 0 1 1 1.323 1.5A5 5 0 0 1 12 23a5 5 0 0 1-3.308-1.25 1 1 0 0 1-.088-1.412m12.926-3.05a1.5 1.5 0 0 0 .205-.666 1.2 1.2 0 0 0-.05-.449 2 2 0 0 0-.097-.251 6 6 0 0 0-.247-.467c-.19-.33-.472-.784-.83-1.358l-.012-.02C19.732 12.844 19 10.913 19 8A7 7 0 0 0 7.173 2.93z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.633 3.034A6 6 0 0 1 18 8c0 2.1.27 3.751.648 5.032M6.258 6.257A6 6 0 0 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H17m-7.646 4c.705.622 1.632 1 2.646 1s1.94-.378 2.646-1M21 21 3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowsRight/ArrowsRightIcon.tsx
const ArrowsRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11.707 2.293a1 1 0 1 0-1.414 1.414L12.586 6H4a1 1 0 0 0 0 2h8.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414zM3 17a1 1 0 0 1 1-1h13.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L17.586 18H4a1 1 0 0 1-1-1"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 7h11m0 0-4 4m4-4-4-4M4 17h16m0 0-4 4m4-4-4-4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BellRinging/BellRingingIcon.tsx
const BellRingingIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.604 20.338a1 1 0 0 1 1.412-.088c.53.468 1.223.75 1.984.75s1.455-.282 1.984-.75a1 1 0 1 1 1.324 1.5A4.98 4.98 0 0 1 12 23a4.98 4.98 0 0 1-3.308-1.25 1 1 0 0 1-.088-1.412M5.197 1.809a1 1 0 0 1-.38 1.362A3.01 3.01 0 0 0 3.295 5.81a1 1 0 0 1-2 .02 5.01 5.01 0 0 1 2.54-4.4 1 1 0 0 1 1.363.379m13.601 0a1 1 0 0 1 1.362-.38 5.01 5.01 0 0 1 2.541 4.4 1 1 0 0 1-2-.019 3.01 3.01 0 0 0-1.524-2.64 1 1 0 0 1-.378-1.36M7.05 3.05A7 7 0 0 1 19 8c0 2.913.732 4.844 1.5 6.077l.011.02c.358.573.64 1.027.83 1.358.096.165.183.325.247.466.032.071.068.158.096.252.024.079.068.246.051.45-.01.136-.039.37-.173.611a1.5 1.5 0 0 1-.428.47c-.25.186-.538.229-.634.243h-.004a5 5 0 0 1-.483.04c-.336.013-.8.013-1.377.013H5.364c-.577 0-1.041 0-1.376-.013a5 5 0 0 1-.484-.04H3.5a1.4 1.4 0 0 1-.634-.242 1.5 1.5 0 0 1-.428-.47 1.5 1.5 0 0 1-.173-.613c-.017-.203.027-.37.05-.449.029-.094.065-.18.097-.251a6 6 0 0 1 .247-.467c.19-.33.473-.785.83-1.359l.012-.019C4.268 12.844 5 10.913 5 8a7 7 0 0 1 2.05-4.95",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.354 21c.706.622 1.632 1 2.646 1s1.94-.378 2.646-1M2.294 5.82A4.01 4.01 0 0 1 4.326 2.3m17.376 3.52A4.01 4.01 0 0 0 19.67 2.3M18 8A6 6 0 1 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.088 1.936.014.182.053.252.2.36.133.099.73.099 1.927.099h13.222c1.197 0 1.795 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.087-1.936C18.78 13.206 18 11.09 18 8"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BookOpen/BookOpenIcon.tsx
const BookOpenIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m18.221 1.998.617.002c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.31c.193.38.264.772.296 1.168.031.374.031.83.031 1.356v8.677c0 .528 0 .982-.03 1.357-.033.395-.104.788-.297 1.167a3 3 0 0 1-1.311 1.31c-.378.194-.772.265-1.167.297-.669.055-1.346.046-2.02.037q-.376-.005-.75-.006c-1.314 0-1.763.01-2.156.13a3 3 0 0 0-1.033.552c-.46.378-.797.915-1.121 1.431q-.14.226-.28.438a1 1 0 0 1-1.667.004q-.142-.215-.283-.442c-.324-.516-.661-1.053-1.12-1.43a3 3 0 0 0-1.034-.554c-.393-.119-.842-.13-2.156-.13q-.374.001-.75.007c-.674.01-1.351.018-2.02-.037-.395-.032-.789-.103-1.167-.296a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 15.82 1 15.365 1 14.838V6.161c0-.527 0-.982.03-1.356.033-.396.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.297C4.18 2 4.635 2 5.161 2l.618-.002c.844-.005 1.69-.009 2.53.06.728.06 1.369.185 1.961.487A5 5 0 0 1 12 4a5 5 0 0 1 1.73-1.455c.592-.302 1.233-.428 1.961-.487.84-.069 1.686-.065 2.53-.06"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m12 21-.1-.15c-.695-1.042-1.042-1.563-1.5-1.94a4 4 0 0 0-1.378-.737C8.453 18 7.827 18 6.575 18H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 3 4.08 3 5.2 3h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 6.04 12 7.16 12 9.4M12 21V9.4M12 21l.1-.15c.695-1.042 1.042-1.563 1.5-1.94a4 4 0 0 1 1.378-.737C15.547 18 16.173 18 17.425 18H18.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 3 19.92 3 18.8 3h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C12 6.04 12 7.16 12 9.4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Bold/BoldIcon.tsx
const BoldIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h9a5 5 0 0 0 2.436-9.367A5 5 0 0 0 14 3zm8 8a3 3 0 1 0 0-6H7v6zm-7 2v6h8a3 3 0 1 0 0-6z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 12h8a4 4 0 0 0 0-8H6zm0 0h9a4 4 0 0 1 0 8H6z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BoldSquare/BoldSquareIcon.tsx
const BoldSquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M14.5 9.5A1.5 1.5 0 0 1 13 11H9.5V8H13a1.5 1.5 0 0 1 1.5 1.5m-5 6.5v-3H14a1.5 1.5 0 0 1 0 3z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2M7.5 7a1 1 0 0 1 1-1H13a3.5 3.5 0 0 1 2.852 5.53A3.5 3.5 0 0 1 14 18H8.5a1 1 0 0 1-1-1z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.5 12H13a2.5 2.5 0 0 0 0-5H8.5zm0 0H14a2.5 2.5 0 0 1 0 5H8.5zm-.7 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BookClosed/BookClosedIcon.tsx
const BookClosedIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3.044 19.252c.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392.541.044 1.206.044 2.01.044h8.08c.527 0 .982 0 1.357-.03.395-.033.788-.104 1.167-.297a3 3 0 0 0 1.31-1.311c.194-.378.265-.772.297-1.167.028-.336.03-.736.03-1.195V5.161c0-.527 0-.981-.03-1.356-.032-.395-.103-.789-.296-1.167a3 3 0 0 0-1.311-1.311c-.379-.193-.772-.264-1.167-.296C17.82 1 17.365 1 16.838 1h-8.08c-.804 0-1.469 0-2.01.044-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .671-.01 1.343.044 2.01m15.932.78c-.022.272-.06.372-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085-.283.023-.656.024-1.232.024h-8c-.857 0-1.44 0-1.89-.038-.438-.035-.662-.1-.818-.18a2 2 0 0 1-.874-.874c-.18-.352-.268-.656-.201-1.168A2 2 0 0 1 7 17h12c0 1.005.058 2.03-.024 3.032",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 19v-3H7a3 3 0 0 0-3 3m4.8 3h8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 2 17.92 2 16.8 2h-8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Bookmark/BookmarkIcon.tsx
const BookmarkIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.759 2h4.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C20 6.29 20 6.954 20 7.758V21a1 1 0 0 1-1.496.868L12 18.152l-6.504 3.716A1 1 0 0 1 4 21V7.759c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C8.29 2 8.954 2 9.758 2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C7.28 3 8.12 3 9.8 3h4.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 5.28 19 6.12 19 7.8V21l-7-4-7 4z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BookmarkMinus/BookmarkMinusIcon.tsx
const BookmarkMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.241 2H9.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C4 6.29 4 6.954 4 7.758V21a1 1 0 0 0 1.496.868L12 18.152l6.504 3.716A1 1 0 0 0 20 21V7.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C15.71 2 15.046 2 14.242 2M9 9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 10h6m4 11V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BellPlus/BellPlusIcon.tsx
const BellPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				d: "M19 2C19 1.44772 18.5523 1 18 1C17.4477 1 17 1.44772 17 2V4H15C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6H17V8C17 8.55228 17.4477 9 18 9C18.5523 9 19 8.55228 19 8V6H21C21.5523 6 22 5.55228 22 5C22 4.44772 21.5523 4 21 4H19V2Z",
				fill: "currentColor"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				d: "M15.006 1.813C15.011 1.735 14.969 1.66 14.898 1.628 13.996 1.218 13.009 1 12 1 10.144 1 8.363 1.738 7.05 3.05 5.737 4.363 5 6.143 5 8 5 10.913 4.268 12.844 3.501 14.077L3.489 14.096C3.131 14.67 2.849 15.124 2.659 15.455 2.563 15.62 2.476 15.78 2.412 15.922 2.38 15.992 2.344 16.079 2.316 16.173 2.292 16.252 2.248 16.419 2.265 16.622 2.276 16.759 2.304 16.993 2.438 17.234 2.572 17.476 2.756 17.623 2.866 17.705 3.116 17.89 3.404 17.933 3.5 17.947L3.504 17.948C3.651 17.97 3.819 17.98 3.988 17.987 4.323 18 4.787 18 5.364 18H18.636C19.213 18 19.677 18 20.013 17.987 20.181 17.98 20.349 17.97 20.496 17.948L20.5 17.947C20.596 17.933 20.884 17.89 21.134 17.705 21.244 17.623 21.428 17.476 21.562 17.234 21.696 16.993 21.724 16.759 21.735 16.622 21.752 16.419 21.708 16.252 21.684 16.173 21.656 16.079 21.62 15.992 21.588 15.922 21.524 15.78 21.437 15.62 21.341 15.455 21.151 15.124 20.869 14.671 20.511 14.097L20.499 14.077C20.123 13.472 19.754 12.698 19.477 11.722 19.378 11.374 19.329 11.2 19.262 11.119 19.184 11.025 19.153 11.003 19.037 10.964 18.938 10.93 18.713 10.95 18.263 10.989 18.176 10.996 18.089 11 18 11 16.343 11 15 9.657 15 8 13.343 8 12 6.657 12 5 12 3.406 13.244 2.102 14.814 2.006 14.917 1.999 14.999 1.916 15.006 1.813ZM8.604 20.338C8.97 19.924 9.602 19.885 10.016 20.25 10.545 20.718 11.239 21 12 21 12.762 21 13.455 20.718 13.984 20.25 14.398 19.885 15.03 19.924 15.396 20.338 15.761 20.752 15.722 21.384 15.308 21.75 14.427 22.527 13.267 23 12 23 10.733 23 9.573 22.527 8.692 21.75 8.278 21.384 8.239 20.752 8.604 20.338Z",
				fill: "currentColor"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.354 21c.705.622 1.632 1 2.646 1s1.94-.378 2.646-1M18 8V2m-3 3h6m-8-2.916A6 6 0 0 0 6 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H18.61c1.196 0 1.794 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936-.492-.79-.955-1.81-1.264-3.105"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BookmarkAdd/BookmarkAddIcon.tsx
const BookmarkAddIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.241 2H9.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C4 6.29 4 6.954 4 7.758V21a1 1 0 0 0 1.496.868L12 18.152l6.504 3.716A1 1 0 0 0 20 21V7.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C15.71 2 15.046 2 14.242 2M12 6a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2V7a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 13V7m-3 3h6m4 11V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BookmarkX/BookmarkXIcon.tsx
const BookmarkXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.241 2H9.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C4 6.29 4 6.954 4 7.758V21a1 1 0 0 0 1.496.868L12 18.152l6.504 3.716A1 1 0 0 0 20 21V7.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C15.71 2 15.046 2 14.242 2M8.793 6.793a1 1 0 0 1 1.414 0L12 8.586l1.793-1.793a1 1 0 1 1 1.414 1.414L13.414 10l1.793 1.793a1 1 0 0 1-1.414 1.414L12 11.414l-1.793 1.793a1 1 0 0 1-1.414-1.414L10.586 10 8.793 8.207a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9.5 7.5 5 5m0-5-5 5M19 21V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Brush/BrushIcon.tsx
const BrushIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.264 2.208a3.204 3.204 0 0 1 4.528 4.528l-6.39 6.902c-.394.425-.591.638-.823.72a1 1 0 0 1-.633.013c-.235-.074-.44-.279-.85-.689l-2.778-2.778c-.41-.41-.615-.615-.689-.85a1 1 0 0 1 .013-.633c.082-.232.295-.429.72-.823zm-8.502 9.968c-.41-.41-.616-.615-.86-.687a1.1 1.1 0 0 0-.655.031c-.237.095-.385.275-.681.635a2.96 2.96 0 0 0-.682 1.861 4.49 4.49 0 0 0-3.566 1.302c-1.031 1.031-.973 2.482-.934 3.471l.005.126c.045 1.112.078 1.933-.279 2.629A1 1 0 0 0 2 23c.272 0 .583.008.915.017.752.02 1.613.042 2.39-.02 1.144-.091 2.437-.375 3.377-1.315a4.49 4.49 0 0 0 1.302-3.566 2.95 2.95 0 0 0 1.861-.682c.36-.296.54-.444.635-.681.076-.192.09-.457.031-.654-.071-.245-.277-.45-.687-.861z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 11.222 12.778 15m-4.803 5.975C6.608 22.342 4 22 2 22c1.025-2-.342-4.608 1.025-5.975a3.5 3.5 0 1 1 4.95 4.95m3.947-5.05 9.137-9.868a2.204 2.204 0 0 0-3.116-3.116l-9.868 9.137c-.51.473-.765.709-.913.96a2 2 0 0 0-.038 1.968c.139.257.385.503.876.994s.737.737.994.876a2 2 0 0 0 1.968-.038c.251-.148.487-.403.96-.913"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BookmarkCheck/BookmarkCheckIcon.tsx
const BookmarkCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.241 2H9.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C4 6.29 4 6.954 4 7.758V21a1 1 0 0 0 1.496.868L12 18.152l6.504 3.716A1 1 0 0 0 20 21V7.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C15.71 2 15.046 2 14.242 2m1.966 6.707a1 1 0 0 0-1.414-1.414L11 11.086 9.707 9.793a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 10.5 2 2L15.5 8M19 21V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BrushAlt/BrushAltIcon.tsx
const BrushAltIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M6.862 1.017C7.07 1 7.316 1 7.568 1h8.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706V7.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C18.24 9 17.96 9 17.4 9H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 8.24 5 7.96 5 7.4V3.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201M6.254 11c-.219 0-.328 0-.427.02a1.04 1.04 0 0 0-.793.86c-.012.1-.005.191.01.372.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.413.21.849.313 1.316.367V19.5a3.5 3.5 0 1 0 7 0v-3.568c.467-.055.903-.158 1.316-.368a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.015-.181.022-.272.01-.372a1.04 1.04 0 0 0-.793-.86c-.099-.02-.208-.02-.427-.02z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.24 2 16.96 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V10m12 0H6m12 0v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C15.72 15 14.88 15 13.2 15h-2.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C6 12.72 6 11.88 6 10.2V10m8.5 5v4.5a2.5 2.5 0 0 1-5 0V15"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Briefcase/BriefcaseIcon.tsx
const BriefcaseIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.863 2h.275c.795 0 1.386 0 1.897.136a4 4 0 0 1 2.829 2.829c.082.307.115.643.128 1.035h1.846c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v7.678c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 18.82 1 18.365 1 17.839v-7.677c0-.528 0-.982.03-1.357.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 6 4.635 6 5.161 6h1.847c.013-.392.046-.728.128-1.035a4 4 0 0 1 2.829-2.829C10.476 2 11.067 2 11.863 2m3.127 4H9.01c.01-.258.026-.399.058-.518a2 2 0 0 1 1.415-1.414C10.705 4.008 11.006 4 12 4c.995 0 1.296.009 1.518.068a2 2 0 0 1 1.414 1.414c.032.12.049.26.058.518",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 7c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.121-2.122C13.395 3 12.93 3 12 3s-1.395 0-1.777.102a3 3 0 0 0-2.12 2.122C8 5.605 8 6.07 8 7M5.2 21h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 19.48 22 18.92 22 17.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 7 19.92 7 18.8 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 8.52 2 9.08 2 10.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 21 4.08 21 5.2 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Building/BuildingIcon.tsx
const BuildingIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.161 2h5.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V20h1a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h1V6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C8.18 2 8.635 2 9.161 2M8 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.5 7h5m-5 4h5m-5 4h5m3.5 6V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 3 15.92 3 14.8 3H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 4.52 6 5.08 6 6.2V21m14 0H4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Backpack/BackpackIcon.tsx
const BackpackIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.675 2h8.65c.766 0 1.399 0 1.915.04.535.042 1.029.131 1.495.356a4 4 0 0 1 1.869 1.868c.225.467.314.96.356 1.496.04.516.04 1.149.04 1.915v.08c0 1.032 0 1.864-.052 2.539-.055.694-.169 1.306-.443 1.875A5 5 0 0 1 21 13v4.839c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H7.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A18 18 0 0 1 3 17.838V13a5 5 0 0 1-.505-.83c-.274-.57-.388-1.182-.442-1.876C2 9.619 2 8.787 2 7.755v-.08c0-.766 0-1.399.04-1.915.042-.535.131-1.029.356-1.496a4 4 0 0 1 1.868-1.868c.467-.225.96-.314 1.496-.356C6.276 2 6.91 2 7.675 2m9.619 12.948c.626-.05 1.185-.147 1.706-.367V17.8c0 .577 0 .949-.024 1.232-.022.272-.06.372-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085C17.75 20 17.377 20 16.8 20H7.2c-.577 0-.949 0-1.232-.024-.272-.022-.373-.06-.422-.085a1 1 0 0 1-.437-.437c-.025-.05-.063-.15-.085-.422C5 18.75 5 18.377 5 17.8v-3.219c.521.22 1.08.318 1.706.367C7.381 15 8.213 15 9.245 15h5.51c1.032 0 1.864 0 2.539-.053M9 9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 13v4.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 21 17.92 21 16.8 21H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 19.48 4 18.92 4 17.8V13m5-3h6m-5.714 4h5.428c2.133 0 3.199 0 4.021-.396a4 4 0 0 0 1.869-1.868C21 10.913 21 9.846 21 7.714c0-1.6 0-2.399-.297-3.016a3 3 0 0 0-1.401-1.4C18.685 3 17.885 3 16.286 3H7.714c-1.6 0-2.399 0-3.016.297a3 3 0 0 0-1.4 1.401C3 5.315 3 6.115 3 7.714c0 2.133 0 3.199.396 4.021a4 4 0 0 0 1.868 1.869C6.087 14 7.154 14 9.286 14"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BuildingAddLeft/BuildingAddLeftIcon.tsx
const BuildingAddLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.162 2h3.676c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V20a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2v-5.838c0-.528 0-.982.03-1.357.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C5.18 10 5.635 10 6.161 10H10V6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C13.18 2 13.635 2 14.162 2M19 7a1 1 0 0 0-1-1h-4a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1m0 4a1 1 0 0 0-1-1h-4a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1m-1 3a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11 11H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 12.52 3 13.08 3 14.2V21m18 0V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3h-3.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C11 4.52 11 5.08 11 6.2V21m11 0H2M14.5 7h3m-3 4h3m-3 4h3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BuildingAdd/BuildingAddIcon.tsx
const BuildingAddIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13.339 2h-2.677c-.528 0-.982 0-1.357.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167-.031.375-.031.83-.031 1.356V10H4.568c-.252 0-.498 0-.706.017a2 2 0 0 0-.77.201 2 2 0 0 0-.874.874 2 2 0 0 0-.201.77C2 12.07 2 12.316 2 12.568V20a1 1 0 1 0 0 2h20a1 1 0 1 0 0-2v-7.432c0-.252 0-.498-.017-.706a2 2 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2 2 0 0 0-.77-.201 9 9 0 0 0-.706-.017H17.5V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 13.338 2M10 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7.5 11H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 11.76 3 12.04 3 12.6V21m13.5-10h2.9c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 11.76 21 12.04 21 12.6V21m-4.5 0V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.98 3 14.42 3 13.3 3h-2.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C7.5 4.52 7.5 5.08 7.5 6.2V21M22 21H2m9-14h2m-2 4h2m-2 4h2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/BuildingAddRight/BuildingAddRightIcon.tsx
const BuildingAddRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V20a1 1 0 1 0 0 2h20a1 1 0 1 0 0-2v-5.838c0-.528 0-.982-.03-1.357-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C18.82 10 18.365 10 17.838 10H14V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 9.839 2M5 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13 11h4.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 12.52 21 13.08 21 14.2V21m-8 0V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C11.48 3 10.92 3 9.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2V21m19 0H2M6.5 7h3m-3 4h3m-3 4h3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CalendarCheck/CalendarCheckIcon.tsx
const CalendarCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M22.707 15.793a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l1.293 1.293 3.793-3.793a1 1 0 0 1 1.414 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M17 2a1 1 0 1 0-2 0v1H9V2a1 1 0 1 0-2 0v1.002c-.475.003-.891.013-1.252.042-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 23 6.954 23 7.758 23h5.568c.606 0 .909 0 1.049-.12a.5.5 0 0 0 .174-.42c-.015-.183-.229-.397-.657-.826l-.513-.513a3 3 0 0 1 4.118-4.36l2.382-2.382a3 3 0 0 1 1.33-.774c.345-.093.518-.14.596-.2a.4.4 0 0 0 .157-.206c.038-.092.038-.227.038-.499V8.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392-.361-.03-.776-.04-1.252-.042zM7 6v-.998c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15 15 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 10H3m18 2.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22H12m4-20v4M8 2v4m6.5 13 2 2 4.5-4.5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowCircleDown/ArrowCircleDownIcon.tsx
const ArrowCircleDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m0 6a1 1 0 0 1 1 1v5.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V8a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m8 12 4 4m0 0 4-4m-4 4V8m10 4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Bus/BusIcon.tsx
const BusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7.759 1h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748q.109.215.183.439c.079.238.119.358.083.5a.56.56 0 0 1-.216.299c-.123.078-.276.078-.58.078H2.966c-.305 0-.458 0-.581-.078a.56.56 0 0 1-.216-.3c-.036-.141.004-.26.083-.5q.074-.224.183-.438a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 1 6.954 1 7.758 1M2.8 6.5c-.28 0-.42 0-.527.054a.5.5 0 0 0-.219.219C2 6.88 2 7.02 2 7.299V10.2c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C2.38 11 2.52 11 2.8 11h18.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 10.62 22 10.48 22 10.2V7.3c0-.28 0-.42-.054-.527a.5.5 0 0 0-.219-.219C21.62 6.5 21.48 6.5 21.2 6.5z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M22 13.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C21.62 13 21.48 13 21.2 13H2.8c-.28 0-.42 0-.527.055a.5.5 0 0 0-.219.218C2 13.38 2 13.52 2 13.8v.441c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565A4 4 0 0 0 4 19.464v1.76c0 .118 0 .26.01.386.012.145.042.353.153.571a1.5 1.5 0 0 0 .656.656c.218.11.426.141.571.153.125.01.268.01.387.01h1.946c.12 0 .261 0 .387-.01.145-.012.353-.042.57-.153a1.5 1.5 0 0 0 .656-.656c.111-.218.142-.426.154-.571.01-.125.01-.268.01-.387V20h5v1.223c0 .12 0 .262.01.387.012.145.042.353.153.571a1.5 1.5 0 0 0 .656.656c.218.11.426.141.571.153.125.01.268.01.387.01h1.946c.12 0 .262 0 .387-.01.145-.012.353-.042.57-.153a1.5 1.5 0 0 0 .656-.656c.112-.218.142-.426.154-.571.01-.125.01-.268.01-.387v-1.759a4 4 0 0 0 1.564-1.648c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01zM5.5 15.5a1 1 0 0 1 1-1H8a1 1 0 1 1 0 2H6.5a1 1 0 0 1-1-1m10.5-1a1 1 0 1 0 0 2h1.5a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.5 19v2.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C8.12 22 7.98 22 7.7 22H5.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C5 21.62 5 21.48 5 21.2V19m14 0v2.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C18.62 22 18.48 22 18.2 22h-1.9c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218c-.055-.107-.055-.247-.055-.527V19M3 12h18M3 5.5h18m-14.5 10H8m8 0h1.5M7.8 19h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 16.72 21 15.88 21 14.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 2 17.88 2 16.2 2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 4.28 3 5.12 3 6.8v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 19 6.12 19 7.8 19"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Box/BoxIcon.tsx
const BoxIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 5a3 3 0 0 1 3-3h16a3 3 0 1 1 0 6H4a3 3 0 0 1-3-3m3 5a1 1 0 0 0-1 1v5.241c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 22 7.954 22 8.758 22h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V11a1 1 0 0 0-1-1zm6 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.5 8v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.22 21 17.38 21 15.7 21H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 18.72 3.5 17.88 3.5 16.2V8m.1-5h16.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C22 3.76 22 4.04 22 4.6v1.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C21.24 8 20.96 8 20.4 8H3.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C2 7.24 2 6.96 2 6.4V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 3 3.04 3 3.6 3m6 8.5h4.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C16 12.26 16 12.54 16 13.1v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 14.74 8 14.46 8 13.9v-.8c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.76 11.5 9.04 11.5 9.6 11.5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CalendarHeart/CalendarHeartIcon.tsx
const CalendarHeartIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18.997 16.83c-.8-.908-2.133-1.153-3.135-.32-1.002.832-1.143 2.223-.356 3.208.468.585 1.614 1.635 2.466 2.39.352.311.528.467.74.53.18.055.39.055.571 0 .212-.063.388-.219.74-.53.852-.755 1.998-1.805 2.466-2.39a2.256 2.256 0 0 0-.356-3.209c-1.02-.823-2.336-.587-3.136.322",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M16 1a1 1 0 0 1 1 1v1.002c.476.003.891.013 1.252.042.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 7.29 22 7.954 22 8.758v4.339c0 .368 0 .552-.057.66a.43.43 0 0 1-.228.22c-.111.053-.338.044-.792.027a4.24 4.24 0 0 0-1.927.39c-1.356-.623-3.028-.573-4.412.577-1.823 1.514-2.122 4.142-.64 5.996.143.18.327.384.535.6.46.48.689.719.7.901a.49.49 0 0 1-.176.414c-.14.118-.46.118-1.1.118H7.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 18.71 2 18.046 2 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392.361-.03.777-.04 1.252-.042V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1M7 5.002V6a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0v-.998c.445.003.795.012 1.089.036.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C20 7.361 20 7.943 20 8.8V9H4v-.2c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18.294-.024.643-.033 1.089-.036",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 10H3m18 1.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22h4.7M16 2v4M8 2v4m9.498 9.712c-.7-.78-1.867-.989-2.744-.275-.877.713-1 1.906-.311 2.75.688.844 3.055 2.813 3.055 2.813s2.366-1.97 3.055-2.813c.688-.844.58-2.044-.312-2.75s-2.044-.504-2.743.275"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CalendarPlus/CalendarPlusIcon.tsx
const CalendarPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				d: "M20 15C20 14.4477 19.5523 14 19 14C18.4477 14 18 14.4477 18 15V17H16C15.4477 17 15 17.4477 15 18C15 18.5523 15.4477 19 16 19H18V21C18 21.5523 18.4477 22 19 22C19.5523 22 20 21.5523 20 21V19H22C22.5523 19 23 18.5523 23 18C23 17.4477 22.5523 17 22 17H20V15Z",
				fill: "currentColor"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16 1C16.5523 1 17 1.44772 17 2V3.00163C17.4755 3.00489 17.891 3.01472 18.2518 3.04419C18.8139 3.09012 19.3306 3.18868 19.816 3.43597C20.5686 3.81947 21.1805 4.43139 21.564 5.18404C21.8113 5.66937 21.9099 6.18608 21.9558 6.74817C22 7.28936 22 7.95372 22 8.75868V13.2455C22 13.386 21.886 13.5 21.7455 13.5C21.6546 13.5 21.5713 13.4511 21.522 13.3747C20.9879 12.5476 20.0579 12 19 12C17.3431 12 16 13.3431 16 15C14.3431 15 13 16.3431 13 18C13 19.6569 14.3431 21 16 21C16 21.1376 16.0093 21.273 16.0272 21.4057C16.1317 22.1784 16.1839 22.5648 16.1358 22.6863C16.0784 22.8313 16.0519 22.8617 15.916 22.9381C15.8021 23.0021 15.5286 23.0024 14.9815 23.003C12.5739 23.0055 10.1663 23 7.75868 23C6.95372 23 6.28937 23 5.74818 22.9558C5.18608 22.9099 4.66938 22.8113 4.18404 22.564C3.43139 22.1805 2.81947 21.5686 2.43598 20.816C2.18868 20.3306 2.09012 19.8139 2.0442 19.2518C1.99998 18.7106 1.99999 18.0463 2 17.2413V8.7587C1.99999 7.95375 1.99998 7.28936 2.0442 6.74817C2.09012 6.18608 2.18868 5.66937 2.43598 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C4.66938 3.18868 5.18608 3.09012 5.74818 3.04419C6.10898 3.01472 6.52454 3.00489 7 3.00163V2C7 1.44772 7.44772 1 8 1C8.55229 1 9 1.44772 9 2V3H15V2C15 1.44772 15.4477 1 16 1ZM7 5.00176V6C7 6.55228 7.44772 7 8 7C8.55229 7 9 6.55228 9 6V5H15V6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6V5.00176C17.4455 5.00489 17.7954 5.01357 18.089 5.03755C18.5274 5.07337 18.7516 5.1383 18.908 5.21799C19.2843 5.40973 19.5903 5.7157 19.782 6.09202C19.8617 6.24842 19.9266 6.47262 19.9624 6.91104C19.9992 7.36113 20 7.94342 20 8.8V9H4V8.8C4 7.94342 4.00078 7.36113 4.03755 6.91104C4.07337 6.47262 4.1383 6.24842 4.21799 6.09202C4.40974 5.7157 4.7157 5.40973 5.09202 5.21799C5.24842 5.1383 5.47262 5.07337 5.91104 5.03755C6.20463 5.01357 6.55447 5.00489 7 5.00176Z",
				fill: "currentColor"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 11.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22h4.7M21 10H3m13-8v4M8 2v4m10 15v-6m-3 3h6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CalendarMinus/CalendarMinusIcon.tsx
const CalendarMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M17 2a1 1 0 1 0-2 0v1H9V2a1 1 0 1 0-2 0v1.002c-.475.003-.891.013-1.252.042-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 23 6.954 23 7.758 23h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392q.413-.21.763-.507c.236-.199.354-.298.38-.488a.58.58 0 0 0-.16-.44c-.143-.129-.335-.129-.72-.129H16a3 3 0 1 1 0-6h5.2c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 14.62 22 14.48 22 14.2V8.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392-.361-.03-.776-.04-1.252-.042zM7 6v-.998c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15 15 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 18h6m0-6.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22h4.7M21 10H3m13-8v4M8 2v4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Car/CarIcon.tsx
const CarIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.161 2h7.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V8h1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1h-.354a4 4 0 0 1 .918 1.184c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v3.274c0 .439 0 .817-.021 1.13-.023.33-.072.66-.207.986a3 3 0 0 1-1.624 1.624 3.1 3.1 0 0 1-.986.207c-.313.021-.691.021-1.13.021q-.189.001-.381.005c-.375.008-.755.016-1.12-.042a3 3 0 0 1-2.494-2.494 4 4 0 0 1-.035-.469H8.998a4 4 0 0 1-.035.47 3 3 0 0 1-2.494 2.493c-.365.058-.745.05-1.12.042L4.969 22c-.439 0-.817 0-1.13-.021a3.1 3.1 0 0 1-.986-.207 3 3 0 0 1-1.624-1.624 3 3 0 0 1-.207-.986C1 18.85 1 18.471 1 18.032v-3.273c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565A4 4 0 0 1 2.354 10H2a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0h1V6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C7.18 2 7.635 2 8.161 2M6 9.002q.325-.003.688-.002H6V6.2c0-.577 0-.949.024-1.232.022-.272.06-.373.085-.422a1 1 0 0 1 .437-.437c.05-.025.15-.063.422-.085C7.25 4 7.623 4 8.2 4h7.6c.577 0 .949 0 1.232.024.272.022.372.06.422.085a1 1 0 0 1 .437.437c.025.05.063.15.085.422C18 5.25 18 5.623 18 6.2V9h-.688.205zM17.517 9H18v.002zM4.5 13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M18 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 10V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C17.48 3 16.92 3 15.8 3H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 4.52 5 5.08 5 6.2V10m0-1H2V8m17 1h3V8M6 13.5h.01m11.99 0h.01M6.8 10h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 12.28 22 13.12 22 14.8V18c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C20.398 21 19.932 21 19 21h-.6c-.372 0-.557 0-.713-.025a2 2 0 0 1-1.662-1.662C16 19.157 16 18.972 16 18.6c0-.093 0-.14-.006-.178a.5.5 0 0 0-.416-.416C15.54 18 15.493 18 15.4 18H8.6c-.093 0-.14 0-.178.006a.5.5 0 0 0-.416.416C8 18.46 8 18.507 8 18.6c0 .372 0 .557-.025.713a2 2 0 0 1-1.662 1.662C6.157 21 5.972 21 5.6 21H5c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C2 19.398 2 18.932 2 18v-3.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 10 5.12 10 6.8 10m-.3 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m12 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CalendarDate/CalendarDateIcon.tsx
const CalendarDateIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17 2a1 1 0 1 0-2 0v1H9V2a1 1 0 1 0-2 0v1.002c-.475.003-.891.013-1.252.042-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 23 6.954 23 7.758 23h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392-.361-.03-.776-.04-1.252-.042zM7 6v-.998c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15 15 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0m5.472 6.118A1 1 0 0 1 13 13v4h.25a1 1 0 1 1 0 2h-2.5a1 1 0 1 1 0-2H11v-2.134a1 1 0 0 1-1.055-1.698l1.5-1a1 1 0 0 1 1.027-.05",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 10H3m13-8v4M8 2v4m2.5 8 1.5-1v5m-1.25 0h2.5M7.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Calendar/CalendarIcon.tsx
const CalendarIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M16 1a1 1 0 0 1 1 1v1.002c.476.003.891.013 1.252.042.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 7.29 22 7.954 22 8.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 18.71 2 18.046 2 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392.361-.03.777-.04 1.252-.042V2a1 1 0 0 1 2 0v1h6V2a1 1 0 0 1 1-1M7 5.002V6a1 1 0 0 0 2 0V5h6v1a1 1 0 1 0 2 0v-.998c.445.003.795.012 1.089.036.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C20 7.361 20 7.943 20 8.8V9H4v-.2c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18.294-.024.643-.033 1.089-.036",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 10H3m13-8v4M8 2v4m-.2 16h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.72 21 18.88 21 17.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CertificateHeart/CertificateHeartIcon.tsx
const CertificateHeartIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5 1C3.247 1 2 2.544 2 4.222v15.556C2 21.456 3.247 23 5 23h14c1.753 0 3-1.544 3-3.222V4.222C22 2.544 20.753 1 19 1zm2 13a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm2 3.5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm.254-11.563c.877-.714 2.044-.504 2.744.275.7-.78 1.851-.981 2.743-.275s1 1.906.312 2.75c-.389.476-1.313 1.311-2.043 1.948-.347.302-.52.454-.73.515a1.03 1.03 0 0 1-.565 0c-.21-.062-.383-.213-.73-.515-.73-.637-1.654-1.472-2.043-1.948-.688-.844-.565-2.037.312-2.75",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 18.5h6M7 15h10M5 2h14c1.105 0 2 .995 2 2.222v15.556C21 21.005 20.105 22 19 22H5c-1.105 0-2-.995-2-2.222V4.222C3 2.995 3.895 2 5 2m6.998 4.212c-.7-.78-1.867-.989-2.744-.275-.877.713-1 1.906-.312 2.75.689.844 3.056 2.813 3.056 2.813s2.366-1.97 3.055-2.813c.688-.844.58-2.044-.312-2.75s-2.044-.504-2.743.275"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Cash/CashIcon.tsx
const CashIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.161 4H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v7.678c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 16.82 1 16.365 1 15.839V8.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 4 4.635 4 5.161 4M12 7a1 1 0 0 1 1 1h1a1 1 0 1 1 0 2h-2.5a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 1 .5 4.95V16a1 1 0 1 1-2 0h-1a1 1 0 1 1 0-2h2.5a.5.5 0 0 0 0-1h-1a2.5 2.5 0 0 1-.5-4.95V8a1 1 0 0 1 1-1m4.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-12 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H10m2-7v1m0 6v1m6-4h.01M6 12h.01M2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2M18.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-12 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CameraOff/CameraOffIcon.tsx
const CameraOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M2.707 1.293a1 1 0 0 0-1.414 1.414l20 20a1 1 0 0 0 1.414-1.414l-.679-.68A3.98 3.98 0 0 0 23 18V8.325c0-.3 0-.522-.02-.72a4 4 0 0 0-3.586-3.586C19.197 4 18.965 4 18.65 4h-.056c-.156 0-.19 0-.213-.002a1 1 0 0 1-.867-.625 4 4 0 0 1-.065-.19l-.008-.021a3 3 0 0 0-2.701-2.156C14.648 1 14.553 1 14.442 1H9.558a3 3 0 0 0-2.999 2.161l-.033.1-.027.08a1 1 0 0 1-.97.659h-.115zM16.5 12c0 .88-.253 1.702-.69 2.396L9.604 8.19A4.5 4.5 0 0 1 16.5 12",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M1.62 5.862a4 4 0 0 0-.6 1.744c-.02.197-.02.42-.02.72v7.915c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.999l-5.507-5.508a4 4 0 0 1-4.242-4.242z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 5h.419c.133 0 .2 0 .26-.004a2 2 0 0 0 1.735-1.25c.023-.056.044-.12.086-.246.042-.127.063-.19.086-.246a2 2 0 0 1 1.735-1.25C9.38 2 9.448 2 9.58 2h4.838c.133 0 .2 0 .26.004a2 2 0 0 1 1.735 1.25c.023.056.044.12.086.246.042.127.063.19.086.246a2 2 0 0 0 1.735 1.25c.06.004.131.004.273.004.37 0 .554 0 .702.015a3 3 0 0 1 2.69 2.69c.014.147.014.322.014.672V18a3 3 0 0 1-1.439 2.562m-5.497-5.49A4 4 0 0 0 9.43 9.434M22 22 2 2m0 5.5v8.7c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21h8.7M12 16.5a4 4 0 0 1-4-4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChatAlert/ChatAlertIcon.tsx
const ChatAlertIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12.5 2a9.5 9.5 0 0 0-9.004 12.536c.056.168.09.267.111.34l.007.025-.003.008a8 8 0 0 1-.136.256l-1.652 3.058c-.102.19-.209.387-.282.559-.073.17-.192.484-.133.856a1.5 1.5 0 0 0 .7 1.048c.321.196.656.206.842.204a7 7 0 0 0 .624-.047l5.155-.533.158-.016h.004l.012.004c.04.014.092.035.183.07A9.5 9.5 0 0 0 22 11.5 9.5 9.5 0 0 0 12.5 2m1 5.5a1 1 0 1 0-2 0V11a1 1 0 1 0 2 0zm-1 6a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12.5 11V7.5m0 7h.01M12.5 20a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.9.9 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021s.12.009.187.024c.069.016.155.05.329.116A8.5 8.5 0 0 0 12.5 20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Camera/CameraIcon.tsx
const CameraIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.558 1a3 3 0 0 0-2.999 2.162l-.008.022a3 3 0 0 1-.065.189 1 1 0 0 1-.867.625A5 5 0 0 1 5.406 4H5.35c-.315 0-.546 0-.744.02A4 4 0 0 0 1.02 7.605c-.02.197-.02.42-.02.72v7.915c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.324c0-.3 0-.522-.02-.72a4 4 0 0 0-3.586-3.586C19.197 4 18.965 4 18.65 4h-.056c-.156 0-.19 0-.213-.002a1 1 0 0 1-.867-.625 4 4 0 0 1-.065-.19l-.008-.021a3 3 0 0 0-2.701-2.156C14.648 1 14.553 1 14.442 1zM16 12.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M2 8.377c0-.35 0-.525.015-.673a3 3 0 0 1 2.69-2.69C4.851 5 5.035 5 5.404 5c.143 0 .214 0 .274-.004a2 2 0 0 0 1.735-1.25c.023-.056.044-.12.086-.246.042-.127.063-.19.086-.246a2 2 0 0 1 1.735-1.25C9.38 2 9.448 2 9.58 2h4.838c.133 0 .2 0 .26.004a2 2 0 0 1 1.735 1.25c.023.056.044.12.086.246.042.127.063.19.086.246a2 2 0 0 0 1.735 1.25c.06.004.131.004.273.004.37 0 .554 0 .702.015a3 3 0 0 1 2.69 2.69c.014.147.014.322.014.672V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 16.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Calculator/CalculatorIcon.tsx
const CalculatorIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2m-.552 16.207 11-11a1 1 0 0 0-1.414-1.414l-11 11a1 1 0 1 0 1.414 1.414M9.5 6.5a1 1 0 1 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1zm3 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m17.5 6.5-11 11m2-7v-4m-2 2h4m3 7h4M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Chat/ChatIcon.tsx
const ChatIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3 11.5a9.5 9.5 0 1 1 6.086 8.868l-.183-.07-.012-.004h-.004l-.158.016-5.155.533a7 7 0 0 1-.624.047c-.186.002-.52-.008-.842-.204a1.5 1.5 0 0 1-.7-1.048c-.059-.372.06-.685.133-.856.073-.172.18-.37.282-.559l1.652-3.057c.072-.133.11-.204.136-.257l.003-.008-.007-.024a11 11 0 0 0-.111-.341A9.5 9.5 0 0 1 3 11.5",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 11.5a8.5 8.5 0 0 1-11.555 7.935c-.174-.067-.26-.1-.33-.116a1 1 0 0 0-.186-.025 2 2 0 0 0-.303.021l-5.12.53c-.49.05-.733.075-.877-.013a.5.5 0 0 1-.234-.35c-.026-.166.09-.382.324-.814l1.636-3.027c.134-.25.202-.374.232-.494a.9.9 0 0 0 .028-.326c-.01-.123-.064-.283-.172-.604A8.5 8.5 0 1 1 21 11.5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChatDots/ChatDotsIcon.tsx
const ChatDotsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 2C6.477 2 2 6.477 2 12c0 1.328.26 2.598.732 3.76l.084.211.005.014-.001.005-.03.183-.597 3.587c-.027.16-.057.34-.069.496-.013.17-.017.44.106.727a1.5 1.5 0 0 0 .787.787c.286.123.557.119.727.106.156-.012.336-.042.496-.069l3.587-.598.183-.029h.005l.014.005c.045.016.105.04.21.083A10 10 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2M6 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m4.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7.5 12h.01M12 12h.01m4.49 0h.01M12 21a9 9 0 1 0-8.342-5.616c.081.2.122.3.14.381a1 1 0 0 1 .024.219c0 .083-.015.173-.045.353l-.593 3.558c-.062.373-.093.56-.035.694a.5.5 0 0 0 .262.262c.135.058.321.027.694-.035l3.558-.593c.18-.03.27-.045.353-.045.081 0 .14.006.219.024.08.018.18.059.38.14A9 9 0 0 0 12 21m-4-9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChatNotification/ChatNotificationIcon.tsx
const ChatNotificationIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#E52554",
				d: "M23.11 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15.315 2.25c.165-.442.247-.662.219-.803a.47.47 0 0 0-.197-.305c-.117-.084-.298-.096-.662-.121A9 9 0 0 0 14.053 1C9.617 1 5.918 4.175 5.148 8.373A8.3 8.3 0 0 1 7.618 8C12.33 8 16 11.89 16 16.5c0 .814-.114 1.605-.328 2.356a9 9 0 0 0 1.572-.431l.038-.015q.087-.034.176-.064l.14.02.034.004 3.212.471c.152.023.324.048.474.056.166.01.425.009.698-.109a1.5 1.5 0 0 0 .772-.754c.123-.27.13-.529.125-.695a6 6 0 0 0-.045-.475l-.406-3.298-.02-.164c.013-.052.034-.103.054-.153l.015-.037.009-.021a8.9 8.9 0 0 0 .556-3.919c-.03-.364-.044-.546-.13-.661a.47.47 0 0 0-.31-.193c-.14-.026-.36.06-.8.234a5 5 0 0 1-6.521-6.402M7.632 10c-3.54 0-6.369 2.933-6.369 6.5 0 .717.114 1.41.326 2.057.04.12.064.195.08.25l.007.023-.001.006-.04.186-.611 2.762a1 1 0 0 0 1.111 1.207l2.995-.41.168-.021h.005l.022.006.224.078A6.2 6.2 0 0 0 7.632 23C11.172 23 14 20.067 14 16.5S11.172 10 7.632 10",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#E52554",
				d: "M20.12 3.879a3 3 0 1 1-4.242 4.242 3 3 0 0 1 4.243-4.242"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M11.707 3.036a8.5 8.5 0 0 0-7.264 11.18c.108.322.162.482.172.605a.9.9 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021s.12.009.187.024c.069.016.155.05.329.116a8.5 8.5 0 0 0 11.52-7.153M20.12 3.88a3 3 0 1 1-4.243 4.242A3 3 0 0 1 20.12 3.88"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChatDouble/ChatDoubleIcon.tsx
const ChatDoubleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1.263 16.5c0-3.567 2.829-6.5 6.369-6.5S14 12.933 14 16.5 11.172 23 7.632 23a6.3 6.3 0 0 1-2.083-.356l-.224-.078-.022-.007h-.005l-.168.023-2.995.409a1 1 0 0 1-1.111-1.207l.611-2.762.041-.192-.007-.023a7 7 0 0 0-.08-.25 6.6 6.6 0 0 1-.326-2.057",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.148 8.373A8.3 8.3 0 0 1 7.618 8C12.33 8 16 11.89 16 16.5c0 .814-.114 1.605-.328 2.356a9 9 0 0 0 1.572-.431q.106-.041.214-.079l.174.024 3.212.471c.152.023.324.048.474.056.166.01.425.009.698-.109a1.5 1.5 0 0 0 .772-.754c.123-.27.13-.529.125-.695a6 6 0 0 0-.045-.475l-.406-3.298-.02-.164c.018-.072.051-.142.078-.211A8.9 8.9 0 0 0 23.105 10c0-4.977-4.059-9-9.052-9-4.436 0-8.135 3.175-8.905 7.373"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6.094 11.229A8 8 0 0 1 6 10c0-4.418 3.605-8 8.053-8 4.447 0 8.052 3.582 8.052 8a7.9 7.9 0 0 1-.52 2.835c-.07.182-.105.274-.12.345a1 1 0 0 0-.024.194c-.002.073.008.153.028.314l.403 3.27c.043.355.065.532.006.66a.5.5 0 0 1-.257.252c-.13.055-.306.03-.66-.022l-3.184-.467c-.167-.024-.25-.037-.326-.036a1 1 0 0 0-.2.021 3 3 0 0 0-.358.122 8.2 8.2 0 0 1-4.07.42M7.632 22C10.597 22 13 19.538 13 16.5S10.597 11 7.632 11s-5.369 2.462-5.369 5.5c0 .61.097 1.198.277 1.747.075.232.113.348.126.427.013.083.015.13.01.213-.005.08-.025.17-.065.351L2 22l2.995-.409c.163-.022.245-.034.316-.033.076 0 .115.005.19.02.07.013.173.05.381.123a5.3 5.3 0 0 0 1.75.299"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CheckCircle/CheckCircleIcon.tsx
const CheckCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m5.207 8.707a1 1 0 0 0-1.414-1.414L10.5 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m7.5 12 3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CheckVerified/CheckVerifiedIcon.tsx
const CheckVerifiedIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15.134 2.154a4.83 4.83 0 0 0-6.268 0 2.83 2.83 0 0 1-1.612.668 4.83 4.83 0 0 0-4.432 4.432 2.83 2.83 0 0 1-.668 1.612 4.83 4.83 0 0 0 0 6.268c.387.454.62 1.018.668 1.612a4.83 4.83 0 0 0 4.432 4.432 2.83 2.83 0 0 1 1.612.668 4.83 4.83 0 0 0 6.268 0 2.83 2.83 0 0 1 1.612-.668 4.83 4.83 0 0 0 4.432-4.432 2.83 2.83 0 0 1 .668-1.612 4.83 4.83 0 0 0 0-6.268 2.83 2.83 0 0 1-.668-1.612 4.83 4.83 0 0 0-4.432-4.432 2.83 2.83 0 0 1-1.612-.668m1.073 8.053a1 1 0 0 0-1.414-1.414L11 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 12 2 2 4.5-4.5M7.334 3.819a3.83 3.83 0 0 0 2.18-.904 3.83 3.83 0 0 1 4.972 0c.613.523 1.376.84 2.18.904a3.83 3.83 0 0 1 3.515 3.515 3.82 3.82 0 0 0 .904 2.18 3.83 3.83 0 0 1 0 4.972 3.83 3.83 0 0 0-.904 2.18 3.83 3.83 0 0 1-3.515 3.515 3.83 3.83 0 0 0-2.18.904 3.83 3.83 0 0 1-4.972 0 3.83 3.83 0 0 0-2.18-.904 3.83 3.83 0 0 1-3.515-3.515 3.83 3.83 0 0 0-.904-2.18 3.83 3.83 0 0 1 0-4.972c.523-.613.84-1.376.904-2.18a3.83 3.83 0 0 1 3.515-3.515"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChatCheck/ChatCheckIcon.tsx
const ChatCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12.5 2a9.5 9.5 0 0 0-9.004 12.536c.056.168.09.267.111.34l.007.025-.003.008a8 8 0 0 1-.136.256l-1.652 3.058c-.102.19-.209.387-.282.559-.073.17-.192.484-.133.856a1.5 1.5 0 0 0 .7 1.048c.321.196.656.206.842.204a7 7 0 0 0 .624-.047l5.155-.533.158-.016h.004l.012.004c.04.014.092.035.183.07A9.5 9.5 0 0 0 22 11.5 9.5 9.5 0 0 0 12.5 2m4.207 7.707a1 1 0 0 0-1.414-1.414L11.5 12.086l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9.5 11.5 2 2L16 9m-3.5 11a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.9.9 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021s.12.009.187.024c.069.016.155.05.329.116A8.5 8.5 0 0 0 12.5 20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Check/CheckIcon.tsx
const CheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M20.707 5.293a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 15.586 19.293 5.293a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 6 9 17l-5-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronDown/ChevronDownIcon.tsx
const ChevronDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.293 8.293a1 1 0 0 1 1.414 0L12 13.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m6 9 6 6 6-6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronLeftDouble/ChevronLeftDoubleIcon.tsx
const ChevronLeftDoubleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18.707 6.293a1 1 0 0 1 0 1.414L14.414 12l4.293 4.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.707 6.293a1 1 0 0 1 0 1.414L7.414 12l4.293 4.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m18 17-5-5 5-5m-7 10-5-5 5-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronRight/ChevronRightIcon.tsx
const ChevronRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 18 6-6-6-6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronLeft/ChevronLeftIcon.tsx
const ChevronLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15.707 5.293a1 1 0 0 1 0 1.414L10.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m15 18-6-6 6-6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronDownDouble/ChevronDownDoubleIcon.tsx
const ChevronDownDoubleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.293 12.293a1 1 0 0 1 1.414 0L12 16.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.293 5.293a1 1 0 0 1 1.414 0L12 9.586l4.293-4.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m7 13 5 5 5-5M7 6l5 5 5-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronRightDouble/ChevronRightDoubleIcon.tsx
const ChevronRightDoubleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L9.586 12 5.293 7.707a1 1 0 0 1 0-1.414",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L16.586 12l-4.293-4.293a1 1 0 0 1 0-1.414",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m6 17 5-5-5-5m7 10 5-5-5-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronUp/ChevronUpIcon.tsx
const ChevronUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.293 8.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 10.414l-5.293 5.293a1 1 0 0 1-1.414-1.414z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m18 15-6-6-6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Circle/CircleIcon.tsx
const CircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronUpDouble/ChevronUpDoubleIcon.tsx
const ChevronUpDoubleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.293 12.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L12 14.414l-4.293 4.293a1 1 0 0 1-1.414-1.414z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.293 5.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L12 7.414l-4.293 4.293a1 1 0 0 1-1.414-1.414z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m17 18-5-5-5 5m10-7-5-5-5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronSelectorVertical/ChevronSelectorVerticalIcon.tsx
const ChevronSelectorVerticalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.293 14.293a1 1 0 0 1 1.414 0L12 18.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414m0-4.586a1 1 0 0 0 1.414 0L12 5.414l4.293 4.293a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 0 1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m7 15 5 5 5-5M7 9l5-5 5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ChevronSelectorHorizontal/ChevronSelectorHorizontalIcon.tsx
const ChevronSelectorHorizontalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.707 6.293a1 1 0 0 1 0 1.414L5.414 12l4.293 4.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0m4.586 0a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L18.586 12l-4.293-4.293a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 7-5 5 5 5m6-10 5 5-5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClipboardCheck/ClipboardCheckIcon.tsx
const ClipboardCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.862 1.017C9.07 1 9.316 1 9.568 1h4.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77l.01.146c.394.013.733.045 1.042.128a4 4 0 0 1 2.829 2.829C21 6.476 21 7.067 21 7.863v9.378c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242v-9.38c0-.795 0-1.386.136-1.897a4 4 0 0 1 2.829-2.829c.31-.083.648-.115 1.043-.128q.003-.076.009-.146a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201m.247 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437m7.098 9.661a1 1 0 0 0-1.414-1.414L11 15.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1 11 2 2 4.5-4.5M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClipboardDownload/ClipboardDownloadIcon.tsx
const ClipboardDownloadIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.862 1.017C9.07 1 9.316 1 9.568 1h4.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77l.01.146c.394.013.733.045 1.042.128a4 4 0 0 1 2.829 2.829C21 6.476 21 7.067 21 7.863v9.378c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242v-9.38c0-.795 0-1.386.136-1.897a4 4 0 0 1 2.829-2.829c.31-.083.648-.115 1.043-.128q.003-.076.009-.146a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201m.247 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437M13 11a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 14.586z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 11v6m0 0-3-3m3 3 3-3m1-10c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1.6 2h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClipboardX/ClipboardXIcon.tsx
const ClipboardXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.862 1.017C9.07 1 9.316 1 9.568 1h4.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77l.01.146c.394.013.733.045 1.042.128a4 4 0 0 1 2.829 2.829C21 6.476 21 7.067 21 7.863v9.378c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242v-9.38c0-.795 0-1.386.136-1.897a4 4 0 0 1 2.829-2.829c.31-.083.648-.115 1.043-.128q.003-.076.009-.146a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201m.247 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437m-.316 7.747a1 1 0 0 1 1.414 0L12 13.086l1.793-1.793a1 1 0 0 1 1.414 1.414L13.414 14.5l1.793 1.793a1 1 0 0 1-1.414 1.414L12 15.914l-1.793 1.793a1 1 0 0 1-1.414-1.414l1.793-1.793-1.793-1.793a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1.5 8 5 5m0-5-5 5m.1-11h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClipboardPlus/ClipboardPlusIcon.tsx
const ClipboardPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.862 1.017C9.07 1 9.316 1 9.568 1h4.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77l.01.146c.394.013.733.045 1.042.128a4 4 0 0 1 2.829 2.829C21 6.476 21 7.067 21 7.863v9.378c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242v-9.38c0-.795 0-1.386.136-1.897a4 4 0 0 1 2.829-2.829c.31-.083.648-.115 1.043-.128q.003-.076.009-.146a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201m.247 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437M12 10a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m4 13v-6m-3 3h6M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Clipboard/ClipboardIcon.tsx
const ClipboardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.568 1c-.252 0-.498 0-.706.017a2 2 0 0 0-.77.201 2 2 0 0 0-.874.874 2 2 0 0 0-.201.77l-.01.146c-.394.013-.733.045-1.042.128a4 4 0 0 0-2.829 2.829C3 6.476 3 7.067 3 7.863v9.378c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-9.38c0-.795 0-1.386-.136-1.897a4 4 0 0 0-2.829-2.829c-.31-.083-.648-.115-1.043-.128l-.009-.146a2 2 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2 2 0 0 0-.77-.201C14.93 1 14.684 1 14.432 1zM9 4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 3 10.04 3 10.6 3h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 3.76 15 4.04 15 4.6V5H9z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1.6 2h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowCircleUp/ArrowCircleUpIcon.tsx
const ArrowCircleUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m0-6a1 1 0 0 1-1-1v-5.586l-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 10.414V16a1 1 0 0 1-1 1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 12-4-4m0 0-4 4m4-4v8m10-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClipboardAttachment/ClipboardAttachmentIcon.tsx
const ClipboardAttachmentIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.862 1.017C9.07 1 9.316 1 9.568 1h4.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77l.01.146c.394.013.733.045 1.042.128a4 4 0 0 1 2.829 2.829C21 6.476 21 7.067 21 7.863v9.378c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242v-9.38c0-.795 0-1.386.136-1.897a4 4 0 0 1 2.829-2.829c.31-.083.648-.115 1.043-.128q.003-.076.009-.146a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201m.247 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437M13 11a.5.5 0 0 1 1 0v4.5a2 2 0 1 1-4 0v-4a1 1 0 1 0-2 0v4a4 4 0 0 0 8 0V11a2.5 2.5 0 0 0-5 0v4.5a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m4 11.5V11a1.5 1.5 0 0 1 3 0v4.5a3 3 0 1 1-6 0v-4M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClockPlus/ClockPlusIcon.tsx
const ClockPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 12.583 22.9546 13.1555 22.8673 13.714C22.7945 14.1789 22.7581 14.4114 22.6659 14.5191C22.5671 14.6346 22.4996 14.671 22.3488 14.69C22.2081 14.7078 21.8857 14.5612 21.2408 14.2678C20.8627 14.0958 20.4425 14 20 14C18.3431 14 17 15.3431 17 17C15.3431 17 14 18.3431 14 20C14 20.4425 14.0958 20.8627 14.2678 21.2408C14.5612 21.8857 14.7078 22.2081 14.69 22.3488C14.671 22.4996 14.6346 22.5671 14.5191 22.6659C14.4114 22.7581 14.1789 22.7945 13.714 22.8673C13.1555 22.9546 12.583 23 12 23C5.92487 23 1 18.0751 1 12ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V12C11 12.3788 11.214 12.725 11.5528 12.8944L15.5528 14.8944C16.0468 15.1414 16.6474 14.9412 16.8944 14.4472C17.1414 13.9532 16.9412 13.3526 16.4472 13.1056L13 11.382V6Z",
				fill: "currentColor"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				d: "M21 17C21 16.4477 20.5523 16 20 16C19.4477 16 19 16.4477 19 17V19H17C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21H19V23C19 23.5523 19.4477 24 20 24C20.5523 24 21 23.5523 21 23V21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19H21V17Z",
				fill: "currentColor"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21.92 13.265Q22 12.643 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10q.653 0 1.285-.082M12 6v6l3.738 1.87M19 22v-6m-3 3h6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClockFastForward/ClockFastForwardIcon.tsx
const ClockFastForwardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 4a8 8 0 1 0 6.223 13.028 1 1 0 0 1 1.554 1.258A9.98 9.98 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c5.134 0 9.365 3.87 9.935 8.851l.058-.058a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.413 0l-2.001-2a1 1 0 0 1 1.414-1.414l.568.568A8 8 0 0 0 12 4"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13 7a1 1 0 1 0-2 0v5a1 1 0 0 0 .445.832l3 2a1 1 0 0 0 1.11-1.664L13 11.465z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m22.7 11.5-2 2-2-2m2.245 1.5q.055-.492.055-1a9 9 0 1 0-2 5.657M12 7v5l3 2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClipboardMinus/ClipboardMinusIcon.tsx
const ClipboardMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.862 1.017C9.07 1 9.316 1 9.568 1h4.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77l.01.146c.394.013.733.045 1.042.128a4 4 0 0 1 2.829 2.829C21 6.476 21 7.067 21 7.863v9.378c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242v-9.38c0-.795 0-1.386.136-1.897a4 4 0 0 1 2.829-2.829c.31-.083.648-.115 1.043-.128q.003-.076.009-.146a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201m.247 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 3 13.96 3 13.4 3h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437M9 13a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 4c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C20 6.605 20 7.07 20 8v9.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V8c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C6.605 4 7.07 4 8 4m1 10h6M9.6 6h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 2 14.96 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 6 9.04 6 9.6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClockStopwatch/ClockStopwatchIcon.tsx
const ClockStopwatchIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M10 1a1 1 0 0 0 0 2h1v1.052c-4.777.5-8.5 4.539-8.5 9.448a9.5 9.5 0 0 0 19 0c0-4.909-3.723-8.948-8.5-9.448V3h1a1 1 0 1 0 0-2zm3 8.5a1 1 0 1 0-2 0v4a1 1 0 0 0 .486.857l2.5 1.5a1 1 0 0 0 1.028-1.714L13 12.933z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.122 3.385a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414m-12.244 0a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 9.5v4l2.5 1.5M12 5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m0 0V2m-2 0h4m6.329 3.592-1.5-1.5.75.75m-15.908.75 1.5-1.5-.75.75"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClockSnooze/ClockSnoozeIcon.tsx
const ClockSnoozeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18 19a1 1 0 1 1 0-2h4a1 1 0 0 1 .707 1.707L20.414 21H22a1 1 0 1 1 0 2h-4a1 1 0 0 1-.707-1.707L19.586 19z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11c.805 0 1.59-.087 2.345-.25.228-.05.342-.075.423-.131a.44.44 0 0 0 .168-.197c.042-.09.05-.253.068-.58a3 3 0 0 1 .76-1.842A3 3 0 0 1 18 15h4c.163 0 .244 0 .287-.007a.46.46 0 0 0 .375-.298c.017-.04.029-.092.053-.196C22.9 13.696 23 12.86 23 12c0-6.075-4.925-11-11-11m0 4a1 1 0 0 1 1 1v5.382l3.447 1.724a1 1 0 1 1-.894 1.788l-4-2A1 1 0 0 1 11 12V6a1 1 0 0 1 1-1",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.5 17h5l-5 5h5m.45-9q.05-.493.05-1c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10a10 10 0 0 0 1-.05M12 6v6l3.738 1.87"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClockCheck/ClockCheckIcon.tsx
const ClockCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M22.707 16.793a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l1.293 1.293 3.793-3.793a1 1 0 0 1 1.414 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11q.56 0 1.105-.055l-.038.004c.386-.05.567-.557.3-.84l.012.012a3 3 0 0 1 4.118-4.36l2.382-2.382a3 3 0 0 1 2.025-.877c.355-.012.532-.017.627-.062a.44.44 0 0 0 .204-.18c.057-.087.078-.212.119-.46q.145-.88.146-1.8c0-6.075-4.925-11-11-11m0 4a1 1 0 0 1 1 1v5.382l3.447 1.724a1 1 0 1 1-.894 1.788l-4-2A1 1 0 0 1 11 12V6a1 1 0 0 1 1-1",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m14.5 19 2 2 4.5-4.5m.985-3.95Q22 12.276 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 5.435 4.337 9.858 9.739 9.997M12 6v6l3.738 1.87"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClockRefresh/ClockRefreshIcon.tsx
const ClockRefreshIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m19.54 5.675-.108.406C16.553 2.457 11.379 1.389 7.25 3.773a9.49 9.49 0 0 0-4.698 7.229 1 1 0 0 0 1.989.211A7.502 7.502 0 0 1 17.645 7.06l-.344-.092a1 1 0 1 0-.517 1.932l2.732.732a1 1 0 0 0 1.225-.707l.732-2.732a1 1 0 1 0-1.932-.518m1.019 6.223a1 1 0 0 1 .888 1.1 9.49 9.49 0 0 1-4.698 7.23c-4.129 2.383-9.303 1.315-12.182-2.309l-.109.406a1 1 0 0 1-1.932-.518l.733-2.732a1 1 0 0 1 1.224-.707l2.732.732a1 1 0 1 1-.517 1.932l-.345-.093a7.503 7.503 0 0 0 13.105-4.152 1 1 0 0 1 1.1-.889"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13 7.5a1 1 0 0 0-2 0V12a1 1 0 0 0 .486.857l2.5 1.5a1 1 0 1 0 1.028-1.715L13 11.434z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.453 12.893A8.5 8.5 0 0 1 4.638 16.25l-.25-.433m-.842-4.71A8.5 8.5 0 0 1 19.361 7.75l.25.433M3.493 18.066l.732-2.732 2.732.732m10.085-8.132 2.732.732.732-2.732M12 7.5V12l2.5 1.5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Cloud/CloudIcon.tsx
const CloudIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.25 9.143a7.002 7.002 0 0 1 13.5 0A5.502 5.502 0 0 1 17.5 20h-11A5.5 5.5 0 0 1 5.25 9.143",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6.5 19a4.5 4.5 0 0 1-.42-8.98 6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 17.5 19z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClockRewind/ClockRewindIcon.tsx
const ClockRewindIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 4a8 8 0 1 0 7.791 9.823l-.384.384a1 1 0 0 1-1.414-1.414l2-2a1 1 0 0 1 1.415 0l2 2a1 1 0 0 1-1.415 1.414l-.195-.195C20.867 18.57 16.834 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2a10 10 0 0 1 8.616 4.92 1 1 0 0 1-1.723 1.018A8 8 0 0 0 12 4"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13 7a1 1 0 1 0-2 0v5a1 1 0 0 0 .445.832l3 2a1 1 0 0 0 1.11-1.664L13 11.465z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m22.7 13.5-2-2-2 2M21 12a9 9 0 1 1-1.245-4.57M12 7v5l3 2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Columns/ColumnsIcon.tsx
const ColumnsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.162 2h.677c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v11.677c0 .528 0 .982-.03 1.357-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031h-.678c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C13 18.82 13 18.365 13 17.838V6.162c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C16.18 2 16.635 2 17.162 2M6.161 2h.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v11.677c0 .528 0 .982-.03 1.357-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296C7.82 22 7.365 22 6.839 22H6.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A18 18 0 0 1 2 17.838V6.162c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C5.18 2 5.635 2 6.161 2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6.8 3h-.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C10 19.48 10 18.92 10 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C8.48 3 7.92 3 6.8 3m11 0h-.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C14 4.52 14 5.08 14 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 21 16.08 21 17.2 21h.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CodeCircle/CodeCircleIcon.tsx
const CodeCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m-1.793 8.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L7.914 12zm5-1.414a1 1 0 1 0-1.414 1.414L16.086 12l-2.293 2.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m14.5 15 3-3-3-3m-5 0-3 3 3 3M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CloudMoon/CloudMoonIcon.tsx
const CloudMoonIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M16.134 2.406a1 1 0 0 0-1.213-1.213 6.5 6.5 0 0 0-4.736 7.854 7 7 0 0 0-5.604 4.158A5.001 5.001 0 0 0 6 23h11.5a5.5 5.5 0 0 0 2.807-10.23 6.5 6.5 0 0 0 2.5-3.692 1 1 0 0 0-1.213-1.212Q21.07 7.998 20.5 8a4.5 4.5 0 0 1-4.366-5.594m.607 9.588a4.5 4.5 0 0 0 3.505-2 6.5 6.5 0 0 1-6.241-6.24A4.5 4.5 0 0 0 12 7.5c0 .573.107 1.119.3 1.62a7 7 0 0 1 4.44 2.874",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6 3a1 1 0 0 0-2 0v1H3a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0V6h1a1 1 0 0 0 0-2H6z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.5 13a5.5 5.5 0 0 0 5.337-4.164 5.5 5.5 0 0 1-6.673-6.672 5.502 5.502 0 0 0-3.548 7.867M5 7V3M3 5h4M6 22a4 4 0 0 1-.679-7.943 6.003 6.003 0 0 1 10.968-.892A4.5 4.5 0 1 1 17.5 22z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Colors/ColorsIcon.tsx
const ColorsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M13.45 13.23a6.22 6.22 0 0 1-5.85-1.662 6.2 6.2 0 1 1 5.85 1.662m1.698 1.544a8.23 8.23 0 0 0 3.698-3.06c.154-.232.231-.349.33-.407a.5.5 0 0 1 .289-.07c.114.009.212.065.408.176a6.2 6.2 0 0 1-5.567 11.065c-.251-.11-.377-.165-.456-.273a.5.5 0 0 1-.096-.327c.008-.134.103-.276.291-.561a8.16 8.16 0 0 0 1.355-4.494V16.8a8.2 8.2 0 0 0-.252-2.026M4.127 11.413c.196-.111.293-.167.408-.175a.5.5 0 0 1 .289.069c.099.058.176.175.33.408a8.19 8.19 0 0 0 8.066 3.595l.006.026q.172.705.174 1.464v.021q0 .127-.006.252a6.2 6.2 0 1 1-9.267-5.66"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 20.472a6 6 0 1 0 5.58-10.262m-11.16 0a6 6 0 1 0 7.16 3.58M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Coins/CoinsIcon.tsx
const CoinsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7.203 7.203a8 8 0 1 0 3.595 15.595A8 8 0 0 0 7.202 7.202"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.044 5.045Q8.517 5 9 5c5.523 0 10 4.477 10 10q0 .483-.045.956a8 8 0 1 0-10.91-10.91"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.938 15.938A7.001 7.001 0 0 0 15 2a7 7 0 0 0-6.938 6.062M16 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CoinsHand/CoinsHandIcon.tsx
const CoinsHandIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M16.5 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-4.468-.22A6.48 6.48 0 0 0 10 6.5a6.47 6.47 0 0 0 .888 3.282 4.5 4.5 0 1 1 1.144-8.003m5.677 14.114c0 .792-.523 1.46-1.245 1.685l.464-.022c.507 0 1-.16 1.405-.456l2.829-2.063a1.81 1.81 0 0 1 2.318.16 1.69 1.69 0 0 1 0 2.44l-2.427 2.361a4.73 4.73 0 0 1-2.393 1.246l-3.431.668a4.8 4.8 0 0 1-2.055-.048l-3.103-.754a4.8 4.8 0 0 0-1.134-.137c-.407 0-.61 0-.773-.058a1 1 0 0 1-.606-.606c-.058-.163-.058-.366-.058-.773v-3.429c0-.285 0-.428.037-.56a1 1 0 0 1 .157-.324c.081-.11.194-.199.419-.375l1.185-.93S11.263 13 12.348 13q.677 0 1.334.163l2.684.667c.79.196 1.343.901 1.343 1.71z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.474 13h.052c.21 0 .415 0 .59.012.19.013.415.043.65.14a2 2 0 0 1 1.082 1.083c.097.234.127.46.14.65.012.174.012.379.012.588v5.053c0 .21 0 .415-.012.59a2 2 0 0 1-.14.65 2 2 0 0 1-1.083 1.082c-.234.097-.46.127-.65.14-.174.012-.378.012-.589.012h-.052c-.21 0-.415 0-.59-.012a2 2 0 0 1-.65-.14 2 2 0 0 1-1.082-1.083 2 2 0 0 1-.14-.65C1 20.941 1 20.737 1 20.527v-5.054c0-.21 0-.414.012-.588a2 2 0 0 1 .14-.65 2 2 0 0 1 1.083-1.083 2 2 0 0 1 .65-.14C3.059 13 3.263 13 3.474 13",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13.53 8.352a3.5 3.5 0 1 1 .941-4.704M6 20.088h2.61q.512 0 1.009.12l2.758.67a4.3 4.3 0 0 0 1.826.043l3.05-.593a4.2 4.2 0 0 0 2.127-1.107l2.158-2.1a1.503 1.503 0 0 0 0-2.168 1.61 1.61 0 0 0-2.06-.143l-2.515 1.835a2.12 2.12 0 0 1-1.25.405h-2.427 1.545c.871 0 1.577-.687 1.577-1.534v-.307c0-.703-.492-1.317-1.194-1.487l-2.385-.58A5 5 0 0 0 11.643 13c-.965 0-2.711.799-2.711.799L6 15.025M20 6.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2 14.6v5.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 21.24 6 20.96 6 20.4v-5.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C5.24 13 4.96 13 4.4 13h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.76 2 14.04 2 14.6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CoinsStack/CoinsStackIcon.tsx
const CoinsStackIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M7.5 2c-1.604 0-3.1.235-4.23.646l-.106.039c-.521.199-1.006.453-1.384.778C1.38 3.807 1 4.323 1 5v1.5c0 .677.38 1.193.78 1.537.403.346.928.613 1.49.817 1.13.411 2.626.646 4.23.646q.348 0 .689-.015c.14-.006.21-.009.272-.028a.5.5 0 0 0 .154-.08c.053-.04.106-.109.212-.247.214-.277.442-.505.65-.683.652-.561 1.42-.93 2.109-1.18a12 12 0 0 1 1.733-.472c.253-.05.38-.074.466-.134a.5.5 0 0 0 .173-.21C14 6.355 14 6.233 14 5.988V5c0-.677-.38-1.193-.78-1.537-.403-.346-.928-.613-1.49-.817C10.6 2.235 9.105 2 7.5 2",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8 11.992a.496.496 0 0 0-.5-.492c-1.604 0-3.1-.235-4.23-.646-.562-.204-1.087-.47-1.49-.817a2.6 2.6 0 0 1-.415-.448.21.21 0 0 0-.168-.089.197.197 0 0 0-.197.197V11.5c0 .677.38 1.193.78 1.537.403.346.928.613 1.49.817 1.13.411 2.626.646 4.23.646h.012A.51.51 0 0 0 8 13.992zm0 5a.497.497 0 0 0-.5-.492c-1.604 0-3.1-.235-4.23-.646-.562-.204-1.087-.47-1.49-.817a2.6 2.6 0 0 1-.415-.448.21.21 0 0 0-.168-.089.197.197 0 0 0-.197.197V17c0 .677.38 1.193.78 1.537.403.346.928.613 1.49.817C4.4 19.765 5.895 20 7.5 20h.03c.32-.001.525-.228.496-.546l-.008-.086A4 4 0 0 1 8 19z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M14.207 8.169A15 15 0 0 1 16.5 8c1.604 0 3.1.235 4.23.646l.106.039c.521.199 1.006.453 1.384.778.4.344.78.86.78 1.537v2c0 .677-.38 1.193-.78 1.537-.403.346-.928.613-1.49.817-1.13.411-2.626.646-4.23.646s-3.1-.235-4.23-.646c-.562-.204-1.087-.47-1.49-.817-.4-.344-.78-.86-.78-1.537v-2c0-.677.38-1.193.78-1.537.403-.346.928-.613 1.49-.817q.105-.038.215-.075a10.4 10.4 0 0 1 1.722-.402",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10.197 16a.197.197 0 0 0-.197.197V18.5c0 .677.38 1.193.78 1.537.403.346.928.613 1.49.817 1.13.411 2.626.646 4.23.646s3.1-.235 4.23-.646c.562-.204 1.087-.47 1.49-.817.4-.344.78-.86.78-1.537v-2.303a.197.197 0 0 0-.197-.197.21.21 0 0 0-.168.089 2.6 2.6 0 0 1-.415.448c-.403.346-.928.613-1.49.817-1.13.411-2.626.646-4.23.646s-3.1-.235-4.23-.646c-.562-.204-1.087-.47-1.49-.817a2.6 2.6 0 0 1-.415-.448.21.21 0 0 0-.168-.089"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13 5c0 1.105-2.462 2-5.5 2S2 6.105 2 5m11 0c0-1.105-2.462-2-5.5-2S2 3.895 2 5m11 0v1.5M2 5v12c0 1.105 2.462 2 5.5 2m0-8q-.253 0-.5-.008C4.197 10.9 2 10.043 2 9m5.5 6C4.462 15 2 14.105 2 13m20-1.5c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2m11 0c0-1.105-2.462-2-5.5-2s-5.5.895-5.5 2m11 0V19c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2v-7.5m11 3.75c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Copy/CopyIcon.tsx
const CopyIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M17.146 4.051C16.529 4.001 15.736 4 14.6 4H7.5a1 1 0 1 1 0-2h7.143c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C22 7.4 22 8.273 22 9.357V16.5a1 1 0 1 1-2 0V9.4c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.161 5.5h8.178c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v8.178c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031H6.162c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A18 18 0 0 1 2 17.838V9.662c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296.375-.031.83-.031 1.356-.031",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7.5 3h7.1c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v7.1M6.2 21h8.1c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V9.7c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C15.98 6.5 15.42 6.5 14.3 6.5H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 8.02 3 8.58 3 9.7v8.1c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Command/CommandIcon.tsx
const CommandIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 6a4 4 0 1 1 8 0v2h4V6a4 4 0 1 1 4 4h-2v4h2a4 4 0 1 1-4 4v-2h-4v2a4 4 0 1 1-4-4h2v-4H6a4 4 0 0 1-4-4m6 2V6a2 2 0 1 0-2 2zm2 2v4h4v-4zm-2 6H6a2 2 0 1 0 2 2zm8 0v2a2 2 0 1 0 2-2zm0-8h2a2 2 0 1 0-2-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 9V6a3 3 0 1 0-3 3zm0 0v6m0-6h6m-6 6v3a3 3 0 1 1-3-3zm0 0h6m0 0h3a3 3 0 1 1-3 3zm0 0V9m0 0V6a3 3 0 1 1 3 3z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Compass/CompassIcon.tsx
const CompassIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13 2a1 1 0 1 0-2 0v1.145a3.502 3.502 0 0 0-1.549 5.753l-4.02 6.926a11 11 0 0 1-1.681-1.548 1 1 0 1 0-1.5 1.323 13 13 0 0 0 2.17 1.964l-2.285 3.935a1 1 0 1 0 1.73 1.004l2.265-3.9A12.95 12.95 0 0 0 12 20a12.94 12.94 0 0 0 5.87-1.398l2.265 3.9a1 1 0 0 0 1.73-1.004l-2.285-3.935a13 13 0 0 0 2.17-1.964 1 1 0 1 0-1.5-1.323 11 11 0 0 1-1.68 1.547L14.55 8.9A3.5 3.5 0 0 0 13 3.145zm-1 8q.425 0 .82-.097l4.044 6.966A10.95 10.95 0 0 1 12 18a10.96 10.96 0 0 1-4.864-1.131l4.044-6.966q.396.096.82.097",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 0V2m9 12.938A11.97 11.97 0 0 1 12 19a11.97 11.97 0 0 1-9-4.062m7.745-6.276L3 22M13.255 8.662 21 22"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CornerDown/CornerDownIcon.tsx
const CornerDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M6.4 5c1.697 0 2.909 0 3.86.078.938.077 1.533.224 2.01.467a5 5 0 0 1 2.185 2.185c.243.477.39 1.072.467 2.01.077.951.078 2.163.078 3.86v3.986l-3.293-3.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L17 17.586v-4.03c0-1.643 0-2.937-.085-3.978-.087-1.063-.267-1.95-.678-2.756a7 7 0 0 0-3.06-3.059c-.805-.41-1.692-.591-2.755-.678C9.381 3 8.087 3 6.444 3H3a1 1 0 0 0 0 2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 4h3.4c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C16 8.56 16 10.24 16 13.6V20m0 0-5-5m5 5 5-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Contrast/ContrastIcon.tsx
const ContrastIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m20 0c0 4.427-3.197 8.108-7.408 8.86-.453.08-.68.121-.933.03a1.1 1.1 0 0 1-.525-.44C12 20.218 12 19.945 12 19.4V4.6c0-.545 0-.818.134-1.05.106-.183.327-.368.525-.44.253-.091.48-.05.933.03C17.803 3.892 21 7.573 21 12",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 18.5a6.5 6.5 0 1 0 0-13z"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Container/ContainerIcon.tsx
const ContainerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.403 1.185a2 2 0 0 0-.806 0c-.307.063-.582.217-.8.34l-.06.033-6.426 3.571c-.409.227-.613.34-.681.49a.5.5 0 0 0-.001.412c.067.15.271.265.679.494l7.3 4.107c.143.08.214.12.29.136a.5.5 0 0 0 .204 0c.075-.016.147-.056.29-.136l7.3-4.107c.408-.229.611-.343.679-.494a.5.5 0 0 0-.001-.411c-.069-.15-.273-.264-.68-.49l-6.427-3.572-.06-.034c-.218-.122-.493-.276-.8-.339m9.593 7.705c0-.448 0-.672-.095-.803a.5.5 0 0 0-.35-.204c-.16-.018-.356.092-.747.312l-7.396 4.16c-.149.084-.223.125-.277.184a.5.5 0 0 0-.106.182c-.025.076-.025.161-.025.331v8.176c0 .447 0 .67.094.801a.5.5 0 0 0 .348.205c.16.019.355-.09.744-.306l6.477-3.597.063-.034c.23-.128.521-.288.745-.53.193-.21.339-.457.428-.728.103-.313.102-.644.101-.908v-.072c0-1.963-.003-5.303-.004-7.169M9.813 21.928c.39.216.585.325.745.306a.5.5 0 0 0 .348-.205c.094-.13.094-.354.094-.801v-8.176c0-.17 0-.255-.025-.331a.5.5 0 0 0-.106-.181c-.054-.06-.128-.101-.277-.185l-7.396-4.16c-.391-.22-.587-.33-.748-.312a.5.5 0 0 0-.349.204c-.094.13-.095.355-.095.803L2 16.06v.072c-.001.264-.002.595.1.908a2 2 0 0 0 .43.728c.222.242.513.402.744.53l.063.034z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-5.441V7.94c0-.342 0-.513-.05-.666a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.268a1 1 0 0 0-.403 0c-.15.031-.292.11-.576.268l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.94v8.118c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a1 1 0 0 0 .215-.364c.05-.152.05-.324.05-.666"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CornerDownLeft/CornerDownLeftIcon.tsx
const CornerDownLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21 4a1 1 0 1 0-2 0v1.4c0 1.697 0 2.909-.078 3.86-.077.938-.224 1.533-.467 2.01a5 5 0 0 1-2.185 2.185c-.477.243-1.072.39-2.01.467-.951.077-2.163.078-3.86.078H6.414l3.293-3.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L6.414 16h4.03c1.643 0 2.937 0 3.978-.085 1.063-.087 1.95-.267 2.756-.678a7 7 0 0 0 3.059-3.06c.41-.805.591-1.692.678-2.755C21 8.381 21 7.087 21 5.444z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 4v1.4c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C15.44 15 13.76 15 10.4 15H4m0 0 5-5m-5 5 5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CornerDownRight/CornerDownRightIcon.tsx
const CornerDownRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5 4a1 1 0 1 0-2 0v1.444c0 1.643 0 2.937.085 3.978.087 1.063.267 1.95.678 2.756a7 7 0 0 0 3.06 3.059c.805.41 1.692.591 2.755.678 1.041.085 2.335.085 3.978.085h4.03l-3.293 3.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5a1 1 0 1 0-1.414 1.414L17.586 14H13.6c-1.697 0-2.909 0-3.86-.078-.938-.077-1.533-.224-2.01-.467a5 5 0 0 1-2.185-2.185c-.243-.477-.39-1.072-.467-2.01C5.001 8.308 5 7.096 5 5.4z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 4v1.4c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C8.56 15 10.24 15 13.6 15H20m0 0-5-5m5 5-5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CornerUpLeft/CornerUpLeftIcon.tsx
const CornerUpLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M9.707 4.707a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L6.414 10H10.4c1.697 0 2.909 0 3.86.078.938.077 1.533.224 2.01.467a5 5 0 0 1 2.185 2.185c.243.477.39 1.072.467 2.01.077.951.078 2.163.078 3.86V20a1 1 0 1 0 2 0v-1.444c0-1.643 0-2.937-.085-3.978-.087-1.063-.267-1.95-.678-2.756a7 7 0 0 0-3.06-3.059c-.805-.41-1.692-.591-2.755-.678C13.381 8 12.087 8 10.444 8h-4.03z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 14 4 9m0 0 5-5M4 9h6.4c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C20 13.56 20 15.24 20 18.6V20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CornerUpRight/CornerUpRightIcon.tsx
const CornerUpRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15.707 3.293a1 1 0 1 0-1.414 1.414L17.586 8h-4.03c-1.643 0-2.937 0-3.978.085-1.063.087-1.95.267-2.756.678a7 7 0 0 0-3.059 3.06c-.41.805-.591 1.692-.678 2.755C3 15.619 3 16.913 3 18.556V20a1 1 0 1 0 2 0v-1.4c0-1.697 0-2.909.078-3.86.077-.938.224-1.533.467-2.01a5 5 0 0 1 2.185-2.185c.477-.243 1.072-.39 2.01-.467.951-.077 2.163-.078 3.86-.078h3.986l-3.293 3.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 20v-1.4c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C8.56 9 10.24 9 13.6 9H20m0 0-5 5m5-5-5-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardCheck/CreditCardCheckIcon.tsx
const CreditCardCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M22.707 15.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L18 18.586l3.293-3.293a1 1 0 0 1 1.414 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.161 4H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356a.84.84 0 0 1-.839.839H1.84A.84.84 0 0 1 1 8.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 4 4.635 4 5.161 4M2.6 11c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 11.76 1 12.04 1 12.6v3.239c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.374.031.83.031 1.356.031h6.812c.55 0 .826 0 .94-.064.136-.076.162-.106.22-.251.048-.121-.003-.51-.107-1.288a3 3 0 0 1 4.97-2.636l1.883-1.882c.7-.7 1.659-.982 2.568-.846.275.042.553-.154.553-.433 0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 11 21.96 11 21.4 11z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 18 2 2 4-4m0-6H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardDown/CreditCardDownIcon.tsx
const CreditCardDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20 15a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L20 18.586zM5.161 4H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356a.84.84 0 0 1-.839.839H1.84A.84.84 0 0 1 1 8.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 4 4.635 4 5.161 4"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M2.6 11c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 11.76 1 12.04 1 12.6v3.239c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.374.031.83.031 1.356.031h6.812c.55 0 .826 0 .94-.064.136-.076.162-.106.22-.251.048-.121-.003-.51-.107-1.288a3 3 0 0 1 .853-2.518A3 3 0 0 1 16 15a3 3 0 1 1 6 0c.392 0 .588 0 .67-.03.171-.062.238-.129.3-.3.03-.082.03-.228.03-.518V12.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 11 21.96 11 21.4 11z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 18 3 3m0 0 3-3m-3 3v-6m3-5H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCard/CreditCardIcon.tsx
const CreditCardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.839 4H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 7.18 1 7.635 1 8.161c0 .464.375.839.839.839H22.16a.84.84 0 0 0 .84-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C19.82 4 19.365 4 18.838 4"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1.546 11.109C1.76 11 2.04 11 2.6 11h18.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C23 11.76 23 12.04 23 12.6v3.239c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 16.82 1 16.365 1 15.839V12.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437M6 14a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 10H2m9 4H6M2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CornerUp/CornerUpIcon.tsx
const CornerUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M16.707 3.293a1 1 0 0 0-1.414 0l-5 5a1 1 0 1 0 1.414 1.414L15 6.414V10.4c0 1.697 0 2.909-.078 3.86-.077.938-.224 1.533-.467 2.01a5 5 0 0 1-2.185 2.185c-.477.243-1.072.39-2.01.467-.951.077-2.163.078-3.86.078H3a1 1 0 1 0 0 2h3.444c1.643 0 2.937 0 3.978-.085 1.063-.087 1.95-.267 2.756-.678a7 7 0 0 0 3.059-3.06c.41-.805.591-1.692.678-2.755.085-1.041.085-2.335.085-3.978v-4.03l3.293 3.293a1 1 0 0 0 1.414-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 20h3.4c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C16 15.44 16 13.76 16 10.4V4m0 0-5 5m5-5 5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Certificate/CertificateIcon.tsx
const CertificateIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5 1a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h.098l3.038 2.914a1 1 0 0 0 1.4-.014l2.475-2.475 2.475 2.475a1 1 0 0 0 1.401.012L18.904 20H19a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3zm10.875 16.79a4.5 4.5 0 0 1-1.91 1.76l1.24 1.24 1.868-1.803zm-3.868.21h.017a2.5 2.5 0 1 0-.035 0zm-3.193 2.793 1.236-1.236a4.5 4.5 0 0 1-1.925-1.768l-1.196 1.196zM8 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M7 8.5a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6.5 20H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-1.5M12 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0h.021L8.83 22.193 6 19.364l3.02-3.02M12 19l3.193 3.193 2.828-2.829-3.02-3.02M9 6h6M7 9.5h10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardEdit/CreditCardEditIcon.tsx
const CreditCardEditIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M19.293 13.293a2.414 2.414 0 0 1 3.414 3.414l-4.157 4.158-.027.026c-.099.1-.224.225-.372.328q-.194.135-.414.222a2.7 2.7 0 0 1-.48.127l-.036.008-2.025.405a1 1 0 0 1-1.177-1.177l.405-2.025.008-.037c.027-.137.061-.311.127-.48q.087-.218.222-.413c.103-.148.228-.273.328-.372l.026-.027z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.839 4H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 7.18 1 7.635 1 8.161c0 .464.375.839.839.839H22.16a.84.84 0 0 0 .84-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C19.82 4 19.365 4 18.838 4M1.546 11.109C1.76 11 2.04 11 2.6 11h14.993c.366 0 .544.62.286.879l-4.158 4.157-.019.02a5 5 0 0 0-.562.649q-.27.388-.443.828c-.138.352-.206.71-.229.827l-.005.027-.194.97c-.046.229-.069.344-.128.43a.5.5 0 0 1-.21.171c-.096.042-.213.042-.446.042H5.16c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 16.82 1 16.365 1 15.839V12.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M2 10h20V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H11m3.5 2 2.025-.405c.177-.035.265-.053.347-.085a1 1 0 0 0 .207-.111c.073-.05.136-.114.264-.242L21.5 16a1.414 1.414 0 1 0-2-2l-4.157 4.157a2 2 0 0 0-.242.264 1 1 0 0 0-.11.207c-.033.082-.05.17-.086.347z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardDownload/CreditCardDownloadIcon.tsx
const CreditCardDownloadIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13 15a1 1 0 1 0-2 0v4.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 19.586zM5.161 2H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356a.84.84 0 0 1-.839.839H1.84A.84.84 0 0 1 1 6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 2 4.635 2 5.161 2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M2.6 9c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 9.76 1 10.04 1 10.6v3.239c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.374.031.83.031 1.356.031h.444c.197 0 .296 0 .37-.024a.4.4 0 0 0 .18-.103c.059-.053.124-.164.254-.386A3 3 0 0 1 9 16v-1a3 3 0 1 1 6 0v1a2.99 2.99 0 0 1 2.591 1.487c.13.222.195.333.254.386.062.055.1.077.18.103.074.024.173.024.37.024h.444c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V10.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 9 21.96 9 21.4 9z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 17 3 3m0 0 3-3m-3 3v-7m10-4H2m3.5 9h-.3c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 18 19.92 18 18.8 18h-.3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardSearch/CreditCardSearchIcon.tsx
const CreditCardSearchIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18 14.5a4.5 4.5 0 1 0 2.396 8.31l.897.897a1 1 0 0 0 1.414-1.414l-.897-.897A4.5 4.5 0 0 0 18 14.5M15.5 19a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.161 3H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356a.84.84 0 0 1-.839.839H1.84A.84.84 0 0 1 1 7.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 3 4.635 3 5.161 3M2.6 10c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 10.76 1 11.04 1 11.6v3.239c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.374.031.83.031 1.356.031H10.7c.28 0 .419 0 .519-.047a.46.46 0 0 0 .214-.189c.058-.094.077-.25.116-.562a6.501 6.501 0 0 1 10.675-4.143c.287.246.431.37.52.371a.23.23 0 0 0 .2-.092c.056-.069.056-.245.056-.598V11.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 10 21.96 10 21.4 10z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m22 22-1.5-1.5M22 10H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h5.3m11-1a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardPlus/CreditCardPlusIcon.tsx
const CreditCardPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				d: "M20 15C20 14.448 19.552 14 19 14 18.448 14 18 14.448 18 15V17H16C15.448 17 15 17.448 15 18 15 18.552 15.448 19 16 19H18V21C18 21.552 18.448 22 19 22 19.552 22 20 21.552 20 21V19H22C22.552 19 23 18.552 23 18 23 17.448 22.552 17 22 17H20V15ZM5.161 4 18.839 4C19.366 4 19.821 4 20.195 4.031 20.59 4.063 20.984 4.134 21.362 4.327 21.927 4.615 22.385 5.074 22.673 5.638 22.866 6.016 22.937 6.41 22.969 6.805 23 7.18 23 7.634 23 8.161 23 8.625 22.625 9 22.161 9H1.839C1.375 9 1 8.625 1 8.161 1 7.634 1 7.18 1.031 6.805 1.063 6.41 1.134 6.016 1.327 5.638 1.615 5.074 2.074 4.615 2.638 4.327 3.016 4.134 3.41 4.063 3.805 4.031 4.18 4 4.634 4 5.161 4Z",
				fill: "currentColor"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				d: "M2.6 11C2.03995 11 1.75992 11 1.54601 11.109C1.35785 11.2049 1.20487 11.3578 1.10899 11.546C1 11.7599 1 12.0399 1 12.6V15.8385C0.999985 16.3656 0.999972 16.8205 1.03057 17.195C1.06287 17.5904 1.13419 17.9836 1.32698 18.362C1.6146 18.9265 2.07355 19.3854 2.63803 19.673C3.01641 19.8658 3.40963 19.9371 3.80498 19.9694C4.17949 20 4.63416 20 5.1612 20L11.9742 20C12.5239 20 12.7987 20 12.9126 19.9362C13.0488 19.8598 13.0749 19.83 13.1327 19.6849C13.1809 19.5636 13.1294 19.1753 13.0263 18.3987C13.0089 18.2682 13 18.1352 13 18C13 16.3431 14.3431 15 16 15C16 13.3431 17.3431 12 19 12C20.6569 12 22 13.3431 22 15C22.3917 15 22.5876 15 22.67 14.9702C22.8413 14.9083 22.9083 14.8413 22.9702 14.67C23 14.5876 23 14.4422 23 14.1513V12.6C23 12.04 23 11.7599 22.891 11.546C22.7951 11.3578 22.6422 11.2049 22.454 11.109C22.2401 11 21.9601 11 21.4 11H2.6Z",
				fill: "currentColor"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 21v-6m-3 3h6m0-8H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Clock/ClockIcon.tsx
const ClockIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m12-6a1 1 0 1 0-2 0v6a1 1 0 0 0 .553.894l4 2a1 1 0 1 0 .894-1.788L13 11.382z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 6v6l4 2m6-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Crop/CropIcon.tsx
const CropIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7 2a1 1 0 1 0-2 0v3H2a1 1 0 0 0 0 2h3v7.839c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2H9.2c-.577 0-.949 0-1.232-.024-.272-.022-.373-.06-.422-.085a1 1 0 0 1-.437-.437c-.025-.05-.063-.15-.085-.422C7 15.75 7 15.377 7 14.8z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M14.8 7c.577 0 .949 0 1.232.024.272.022.372.06.422.085a1 1 0 0 1 .437.437c.025.05.063.15.085.422C17 8.25 17 8.623 17 9.2V14a1 1 0 1 0 2 0V9.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 14.838 5H10a1 1 0 1 0 0 2z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10 6h4.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2V14M2 6h4m12 12v4m4-4H9.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.48 6 15.92 6 14.8V2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Cryptocurrency/CryptocurrencyIcon.tsx
const CryptocurrencyIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8.055 3.91a1 1 0 0 0-.877-1.797 11 11 0 0 0-6.07 11.418 1 1 0 0 0 1.98-.279 9 9 0 0 1 4.967-9.341m7.43-1.337a1 1 0 0 1 1.337-.46 11 11 0 0 1 6.07 11.417 1 1 0 0 1-1.98-.279 9 9 0 0 0-4.967-9.341 1 1 0 0 1-.46-1.337M5.313 19.503a1 1 0 0 1 1.397-.222 9 9 0 0 0 10.58 0 1 1 0 1 1 1.175 1.618 11 11 0 0 1-12.93 0 1 1 0 0 1-.222-1.396m7.663-13.927a1.5 1.5 0 0 0-.513-.296 1.5 1.5 0 0 0-.927 0 1.5 1.5 0 0 0-.512.296c-.096.081-.196.182-.28.266l-4.902 4.901c-.084.085-.185.185-.266.281-.094.111-.22.28-.296.512a1.5 1.5 0 0 0 0 .927c.076.233.202.402.296.513.081.096.182.196.266.28l4.901 4.902c.085.084.185.185.281.266.111.094.28.22.512.295a1.5 1.5 0 0 0 .927 0c.233-.075.402-.2.513-.295.096-.081.196-.182.28-.266l4.902-4.902c.084-.084.185-.184.266-.28.094-.111.22-.28.295-.513a1.5 1.5 0 0 0 0-.927 1.5 1.5 0 0 0-.295-.512c-.081-.096-.182-.196-.266-.28l-4.902-4.902c-.084-.084-.184-.185-.28-.266"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17.878 20.09a10 10 0 0 1-11.756 0M16.384 3.012a10 10 0 0 1 5.519 10.38m-19.806 0a10 10 0 0 1 5.52-10.38m3.817 3.554-4.868 4.868c-.198.198-.297.297-.334.412a.5.5 0 0 0 0 .309c.037.114.136.213.334.41l4.868 4.87c.198.197.297.296.412.333.1.033.208.033.309 0 .114-.037.213-.136.41-.334l4.87-4.868c.197-.198.296-.297.334-.412a.5.5 0 0 0 0-.309c-.038-.114-.137-.213-.335-.41l-4.868-4.87c-.198-.197-.297-.296-.412-.333a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardMinus/CreditCardMinusIcon.tsx
const CreditCardMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.839 4H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 7.18 1 7.635 1 8.161c0 .464.375.839.839.839H22.16a.84.84 0 0 0 .84-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C19.82 4 19.365 4 18.838 4M1.546 11.109C1.76 11 2.04 11 2.6 11h18.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C23 11.76 23 12.04 23 12.6v1.551c0 .291 0 .437-.03.519-.062.171-.129.238-.3.3-.082.03-.278.03-.67.03h-6a3 3 0 0 0-2.974 3.399c.103.776.155 1.165.107 1.286-.058.145-.084.175-.22.251-.114.064-.39.064-.939.064H5.161c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 16.82 1 16.365 1 15.839V12.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 18h6m0-8H2m20 3.5V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardShield/CreditCardShieldIcon.tsx
const CreditCardShieldIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m20.15 13.2 2.187.781a1 1 0 0 1 .663.942v2.502c0 1.54-1.056 2.69-1.86 3.36a9 9 0 0 1-1.707 1.116l-.002.001c-.273.13-.59.13-.862 0l-.165-.083a9 9 0 0 1-1.545-1.034c-.802-.67-1.859-1.82-1.859-3.36v-2.502a1 1 0 0 1 .663-.942l2.186-.781a3.4 3.4 0 0 1 2.3 0M18.839 3H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 6.18 1 6.635 1 7.161c0 .464.375.839.839.839H22.16a.84.84 0 0 0 .84-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C19.82 3 19.365 3 18.838 3"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M1.546 10.109C1.76 10 2.04 10 2.6 10h18.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C23 10.76 23 11.04 23 11.6c0 .24-.238.409-.465.328l-1.712-.612a5.42 5.42 0 0 0-3.648 0l-2.185.782A3 3 0 0 0 13 14.922v2.503q0 .265.025.517c.04.425.06.637.01.755a.45.45 0 0 1-.22.242c-.111.061-.294.061-.66.061H5.16c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 15.82 1 15.365 1 14.839V11.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 10H2m20 1V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19h6.3m6.5 2s3-1.43 3-3.575v-2.502l-2.188-.782a2.4 2.4 0 0 0-1.626 0L15 14.923v2.502C15 19.57 18 21 18 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardX/CreditCardXIcon.tsx
const CreditCardXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.207 15.293a1 1 0 0 0-1.414 1.414l1.793 1.793-1.793 1.793a1 1 0 0 0 1.414 1.414L19 19.914l1.793 1.793a1 1 0 0 0 1.414-1.414L20.414 18.5l1.793-1.793a1 1 0 0 0-1.414-1.414L19 17.086zM5.161 4H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356a.84.84 0 0 1-.839.839H1.84A.84.84 0 0 1 1 8.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 4 4.635 4 5.161 4"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M2.6 11c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 11.76 1 12.04 1 12.6v3.239c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.374.031.83.031 1.356.031h7.944c.197 0 .296 0 .37-.024a.4.4 0 0 0 .18-.103c.059-.053.124-.164.254-.386a3 3 0 0 1 .47-.608l.378-.379-.378-.379a3 3 0 1 1 4.242-4.242l.379.378.379-.378a3 3 0 0 1 2.882-.781c.345.09.739-.142.739-.498 0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 11 21.96 11 21.4 11z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16.5 16 5 5m0-5-5 5M22 10H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardUpload/CreditCardUploadIcon.tsx
const CreditCardUploadIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12.707 14.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L11 17.414V22a1 1 0 1 0 2 0v-4.586l1.293 1.293a1 1 0 0 0 1.414-1.414zM5.161 2H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356a.84.84 0 0 1-.839.839H1.84A.84.84 0 0 1 1 6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 2 4.635 2 5.161 2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M2.6 9c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 9.76 1 10.04 1 10.6v3.239c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.374.031.83.031 1.356.031H5.2c.272 0 .407 0 .499-.038a.4.4 0 0 0 .205-.157c.06-.078.108-.25.202-.596a3 3 0 0 1 .773-1.33l3-3a3 3 0 0 1 4.242 0l3 3a3 3 0 0 1 .774 1.33c.093.345.14.518.2.596a.4.4 0 0 0 .206.157c.092.038.227.038.499.038h.039c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V10.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 9 21.96 9 21.4 9z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 16 3-3m0 0 3 3m-3-3v7M22 9H2m3.5 9h-.3c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 18 19.92 18 18.8 18h-.3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Code/CodeIcon.tsx
const CodeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L20.586 12l-5.293-5.293a1 1 0 0 1 0-1.414m-6.586 0a1 1 0 0 1 0 1.414L3.414 12l5.293 5.293a1 1 0 1 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 18 6-6-6-6M8 6l-6 6 6 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyBitcoinCircle/CurrencyBitcoinCircleIcon.tsx
const CurrencyBitcoinCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15.5 14.25c0 .69-.56 1.25-1.25 1.25H10.5V13h3.75c.69 0 1.25.56 1.25 1.25M13.75 8.5H10.5V11h3.25a1.25 1.25 0 1 0 0-2.5"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m-2 4a1 1 0 0 1 1 1v.5h1V6a1 1 0 1 1 2 0v.51a3.25 3.25 0 0 1 2.318 5.233A3.25 3.25 0 0 1 14.25 17.5H14v.499a1 1 0 1 1-2 0v-.5h-1v.5a1 1 0 1 1-2 0v-.5H8a1 1 0 1 1 0-2h.5v-7H8a1 1 0 0 1 0-2h1V6a1 1 0 0 1 1-1",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.5 7.5h4.25a2.25 2.25 0 0 1 0 4.5H9.5h4.75a2.25 2.25 0 0 1 0 4.5H9.5m0-9H8m1.5 0v9m0 0H8M10 6v1.5m0 9V18m3-12v1.5m0 9V18m9-6c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyEthereum/CurrencyEthereumIcon.tsx
const CurrencyEthereumIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12.747 1.336a1 1 0 0 0-1.494 0l-8 9a1 1 0 0 0 .504 1.634l8 2a1 1 0 0 0 .486 0l8-2a1 1 0 0 0 .504-1.634z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.725 14.026a1 1 0 0 0-.958 1.655l6.5 7a1 1 0 0 0 1.466 0l6.5-7a1 1 0 0 0-.958-1.655L12 15.474z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m4 11 8 2 8-2M4 11l8-9m-8 9 8-2m8 2-8-9m8 9-8-2m0-7v7m-6.5 6 6.5 7 6.5-7-6.5 1.5z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyDollar/CurrencyDollarIcon.tsx
const CurrencyDollarIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13 2a1 1 0 1 0-2 0v1h-1a5 5 0 0 0 0 10h1v6h-1a3 3 0 0 1-3-3 1 1 0 1 0-2 0 5 5 0 0 0 5 5h1v1a1 1 0 1 0 2 0v-1h1a5 5 0 0 0 0-10h-1V5h1a3 3 0 0 1 3 3 1 1 0 1 0 2 0 5 5 0 0 0-5-5h-1zm-2 3h-1a3 3 0 0 0 0 6h1zm2 8v6h1a3 3 0 1 0 0-6z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 16a4 4 0 0 0 4 4h4a4 4 0 0 0 0-8h-4a4 4 0 0 1 0-8h4a4 4 0 0 1 4 4m-6-6v20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyEthereumCircle/CurrencyEthereumCircleIcon.tsx
const CurrencyEthereumCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.117 11.137 12 12.902l3.883-1.765L12 6.548z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m0 3a1 1 0 0 1 .764.354l5.5 6.5a1 1 0 0 1-.35 1.556l-5.5 2.5a1 1 0 0 1-.828 0l-5.5-2.5a1 1 0 0 1-.35-1.556l5.5-6.5A1 1 0 0 1 12 4M5.59 15.086a1 1 0 0 1 1.324-.497L12 16.901l5.086-2.312a1 1 0 0 1 .828 1.821l-5.5 2.5a1 1 0 0 1-.828 0l-5.5-2.5a1 1 0 0 1-.496-1.324",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6.5 15.5 12 18l5.5-2.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-15.5-.5L12 14l5.5-2.5L12 5z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardLock/CreditCardLockIcon.tsx
const CreditCardLockIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18.5 13a2.75 2.75 0 0 0-2.75 2.75v.778a1.9 1.9 0 0 0-.658.19 2 2 0 0 0-.874.874 2 2 0 0 0-.201.77c-.017.208-.017.454-.017.706v.864c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h3.864c.252 0 .498 0 .706-.017a2 2 0 0 0 .77-.201 2 2 0 0 0 .874-.874 2 2 0 0 0 .201-.77c.017-.208.017-.454.017-.706v-.864c0-.252 0-.498-.017-.706a2 2 0 0 0-.201-.77 2 2 0 0 0-.874-.874 1.9 1.9 0 0 0-.658-.19v-.778A2.75 2.75 0 0 0 18.5 13m.75 3.5v-.75a.75.75 0 0 0-1.5 0v.75z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.161 2H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356a.84.84 0 0 1-.839.839H1.84A.84.84 0 0 1 1 6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 2 4.635 2 5.161 2M2.6 9c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 9.76 1 10.04 1 10.6v3.239c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.374.031.83.031 1.356.031h6.174c.246 0 .369 0 .459-.036a.44.44 0 0 0 .203-.151c.06-.076.104-.22.19-.506.06-.198.14-.408.249-.623a4 4 0 0 1 1.35-1.515 4.75 4.75 0 0 1 8.554-2.216c.284.39.426.584.484.595a.14.14 0 0 0 .137-.045c.04-.043.04-.268.04-.717L23 10.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 9 21.96 9 21.4 9z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.25 17.5v-1.75a1.75 1.75 0 1 0-3.5 0v1.75M22 10H2m20 1V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H11m5.6 2.5h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 20.74 22 20.46 22 19.9v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C15 18.26 15 18.54 15 19.1v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyBitcoin/CurrencyBitcoinIcon.tsx
const CurrencyBitcoinIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.5 1a1 1 0 0 1 1 1v1h2V2a1 1 0 1 1 2 0v1.025a5 5 0 0 1 2.936 8.608A5 5 0 0 1 15 21h-.5v.999a1 1 0 1 1-2 0v-1h-2v1a1 1 0 1 1-2 0v-1h-3a1 1 0 1 1 0-2h1V5h-1a1 1 0 0 1 0-2h3V2a1 1 0 0 1 1-1m-1 4v6H14a3 3 0 1 0 0-6zm0 8v6H15a3 3 0 1 0 0-6z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.5 2v2m0 16v2m4-20v2m0 16v2m-6-18H14a4 4 0 0 1 0 8H7.5 15a4 4 0 0 1 0 8H7.5m0-16h-2m2 0v16m0 0h-2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ArrowChunkUp/ArrowChunkUpIcon.tsx
const ArrowChunkUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 19 11h-3v9.223c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.125.01-.268.01-.387.01H9.777c-.12 0-.261 0-.387-.01a1.5 1.5 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.5 1.5 0 0 1-.154-.571C8 20.485 8 20.342 8 20.223V11H5a1 1 0 0 1-.707-1.707z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.8 21c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C9 20.62 9 20.48 9 20.2V10H5l7-7 7 7h-4v10.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C14.62 21 14.48 21 14.2 21z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyEuroCircle/CurrencyEuroCircleIcon.tsx
const CurrencyEuroCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M8 12q0-.255.031-.5H11a1 1 0 1 0 0-2H8.877A4 4 0 0 1 12 8a3.98 3.98 0 0 1 2.666 1.018A1 1 0 0 0 16 7.528 6 6 0 0 0 6.544 9.5H6a1 1 0 0 0 0 2h.02a6 6 0 0 0 0 1H6a1 1 0 1 0 0 2h.544A6 6 0 0 0 16 16.472a1 1 0 1 0-1.334-1.49A3.98 3.98 0 0 1 12 16a4 4 0 0 1-3.123-1.5H11a1 1 0 1 0 0-2H8.031A4 4 0 0 1 8 12",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.333 8.273a5 5 0 1 0 0 7.454M6 13.5h5m-5-3h5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyRupeeCircle/CurrencyRupeeCircleIcon.tsx
const CurrencyRupeeCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M7.5 6.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-1.84c.28.465.47.977.575 1.5H15.5a1 1 0 1 1 0 2h-1.265a4.55 4.55 0 0 1-.972 2.052 4 4 0 0 1-2.126 1.314l3.496 2.86a1 1 0 0 1-1.266 1.548l-5.494-4.495-.031-.026A1 1 0 0 1 7.5 13.5v-.001a1 1 0 0 1 .547-.89A1 1 0 0 1 8.5 12.5H10c.822 0 1.375-.312 1.737-.74a2.4 2.4 0 0 0 .429-.76H8.5a1 1 0 1 1 0-2h3.666a2.4 2.4 0 0 0-.43-.76c-.361-.428-.914-.74-1.736-.74H8.5a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.5 10h7m-7-3.5h7M14 18l-5.5-4.5H10c4.445 0 4.445-7 0-7M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyPoundCircle/CurrencyPoundCircleIcon.tsx
const CurrencyPoundCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m-1.105 7.956c.002-.538.158-.838.323-1.017.178-.192.452-.337.826-.403.808-.141 1.695.147 2.06.493a1 1 0 1 0 1.377-1.45c-.898-.853-2.458-1.245-3.783-1.012-.693.121-1.406.427-1.95 1.016-.555.602-.852 1.412-.853 2.379v.013c.013 1.008.388 1.7.663 2.208l.017.033q.082.152.15.284H9a1 1 0 1 0 0 2h.898c-.152.761-.454 1.466-.774 2.046a9 9 0 0 1-.813 1.22l-.05.06-.01.011v.001A1 1 0 0 0 9 18.5h6a1 1 0 1 0 0-2h-4.118c.426-.774.873-1.814 1.045-3H14a1 1 0 1 0 0-2h-2.132c-.133-.496-.345-.887-.517-1.206l-.016-.03c-.27-.5-.432-.817-.44-1.308",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 17.5H9s2-2.256 2-5c0-1.5-1.085-2.013-1.105-3.538.002-3.018 3.635-2.857 4.898-1.658M9 12.5h5m8-.5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyRuble/CurrencyRubleIcon.tsx
const CurrencyRubleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.5 2.5a1 1 0 0 0-1 1v7h-1a1 1 0 1 0 0 2h1v2h-1a1 1 0 1 0 0 2h1v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2h-4v-2h5a5 5 0 0 0 0-10zm1 8h5a3 3 0 1 0 0-6h-5z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.5 11.5h6a4 4 0 0 0 0-8h-6zm0 0h-2m7 4h-7M8.5 4v16.5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyYen/CurrencyYenIcon.tsx
const CurrencyYenIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4.87 2.724a1 1 0 0 1 1.406.145L12 9.914l5.724-7.045a1 1 0 1 1 1.552 1.262L14.101 10.5H18a1 1 0 1 1 0 2h-5v2h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H7a1 1 0 1 1 0-2h4v-2H6a1 1 0 1 1 0-2h3.899L4.724 4.13a1 1 0 0 1 .145-1.406"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 20.5v-9m0 0 6.5-8m-6.5 8-6.5-8m12.5 8H6m11 4H7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyRupee/CurrencyRupeeIcon.tsx
const CurrencyRupeeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M6 2a1 1 0 0 0 0 2h3c1.395 0 2.368.513 3.003 1.227.437.492.738 1.107.887 1.773H6a1 1 0 0 0 0 2h6.89c-.15.666-.45 1.28-.887 1.773C11.368 11.487 10.395 12 9 12H6a.996.996 0 0 0-1 1 1 1 0 0 0 .308.722l.009.008 8.498 7.998a1 1 0 0 0 1.37-1.456L8.522 14H9c1.938 0 3.465-.737 4.498-1.898.784-.883 1.253-1.976 1.426-3.102H18a1 1 0 1 0 0-2h-3.076c-.166-1.083-.606-2.136-1.338-3H18a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 3h12M6 8h12m-3.5 13L6 13h3c6.667 0 6.667-10 0-10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyRubleCircle/CurrencyRubleCircleIcon.tsx
const CurrencyRubleCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10.5 10.5v-3H14a1.5 1.5 0 0 1 0 3z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M8.5 6.5a1 1 0 0 1 1-1H14a3.5 3.5 0 1 1 0 7h-3.5v1.25H13a1 1 0 1 1 0 2h-2.5v1.75a1 1 0 1 1-2 0v-1.75H8a1 1 0 1 1 0-2h.5V12.5H8a1 1 0 1 1 0-2h.5z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.5 6.5H14a2.5 2.5 0 0 1 0 5H9.5zm0 0v11m.25-6H8m5 3.25H8M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyYenCircle/CurrencyYenCircleIcon.tsx
const CurrencyYenCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M7.375 6.22a1 1 0 0 1 1.406.155L12 10.4l3.22-4.024a1 1 0 0 1 1.56 1.25L14.08 11H16a1 1 0 1 1 0 2h-3v1h2.5a1 1 0 1 1 0 2H13v2a1 1 0 1 1-2 0v-2H8.5a1 1 0 1 1 0-2H11v-1H8a1 1 0 1 1 0-2h1.92l-2.7-3.375a1 1 0 0 1 .155-1.406",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 18v-6m0 0 4-5m-4 5L8 7m8 5H8m7.5 3h-7M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CursorBox/CursorBoxIcon.tsx
const CursorBoxIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M16.241 2H7.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 22 6.954 22 7.758 22H9.5a1 1 0 1 0 0-2H7.8c-.857 0-1.439 0-1.889-.038-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h8.4c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C20 6.361 20 6.943 20 7.8v1.7a1 1 0 1 0 2 0V7.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C17.71 2 17.046 2 16.242 2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m12.793 10.54 8.294 2.746c.247.082.492.163.685.247.176.076.525.239.746.597a1.5 1.5 0 0 1 .117 1.342c-.156.391-.471.612-.63.717a9 9 0 0 1-.633.362l-3.134 1.687-1.687 3.134c-.124.23-.246.457-.362.632-.105.16-.326.475-.717.631a1.5 1.5 0 0 1-1.342-.117c-.358-.221-.521-.57-.597-.746a9 9 0 0 1-.247-.685l-2.746-8.294c-.07-.215-.144-.435-.188-.623-.042-.182-.107-.523.023-.888a1.5 1.5 0 0 1 .907-.907c.365-.13.706-.065.888-.023.188.044.408.117.623.188"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 9.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h1.7m7.886-3.289-1.698 3.154c-.278.516-.417.774-.586.84a.5.5 0 0 1-.447-.038c-.155-.096-.247-.374-.43-.93L11.5 12.512c-.16-.486-.241-.73-.183-.892a.5.5 0 0 1 .302-.302c.162-.058.406.022.892.183l8.226 2.724c.556.184.834.276.93.431a.5.5 0 0 1 .039.447c-.067.17-.325.308-.84.586l-3.155 1.698a1 1 0 0 0-.152.09.5.5 0 0 0-.082.083 1 1 0 0 0-.09.152"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Cursor/CursorIcon.tsx
const CursorIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4.9 2.62a8 8 0 0 0-.647-.213c-.183-.048-.536-.127-.915.004a1.5 1.5 0 0 0-.927.927c-.131.38-.052.733-.005.916.05.193.132.421.213.647L8.35 20.86c.1.28.196.549.292.756.08.175.263.558.66.774a1.5 1.5 0 0 0 1.4.018c.403-.206.595-.583.68-.756.101-.204.204-.47.312-.748l2.58-6.631 6.63-2.58c.278-.107.544-.21.749-.311.172-.085.55-.278.756-.681a1.5 1.5 0 0 0-.018-1.4c-.217-.397-.6-.58-.774-.66a10 10 0 0 0-.757-.292z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.506 10.776c.616-.24.925-.36 1.012-.53a.5.5 0 0 0-.006-.466c-.091-.167-.403-.28-1.026-.503L4.596 3.573c-.51-.183-.764-.274-.93-.217a.5.5 0 0 0-.31.31c-.057.166.034.42.217.93l5.704 15.89c.224.623.335.934.503 1.026a.5.5 0 0 0 .466.006c.17-.087.29-.395.53-1.012l2.596-6.678c.047-.12.07-.181.107-.232a.5.5 0 0 1 .117-.117c.05-.036.111-.06.232-.107z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/DataflowAlt1/DataflowAlt1Icon.tsx
const DataflowAlt1Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.83 3a3.001 3.001 0 1 0 0 2H11v10.241c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392.404.033.875.041 1.423.043a3.001 3.001 0 1 0 0-2c-.528-.002-.93-.01-1.26-.037-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C13 16.639 13 16.057 13 15.2V13h3.17a3.001 3.001 0 1 0 0-2H13V5h3.17a3.001 3.001 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 4v11.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C14.28 20 15.12 20 16.8 20h.2m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0M7 4h10M7 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0m10 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0m-5 8h5m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CursorClick/CursorClickIcon.tsx
const CursorClickIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M9 1a1 1 0 0 1 1 1v1.5a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1M3.293 3.293a1 1 0 0 1 1.414 0l1.06 1.06a1 1 0 0 1-1.413 1.415l-1.061-1.06a1 1 0 0 1 0-1.415m2.475 10.414a1 1 0 1 0-1.414-1.414l-1.061 1.06a1 1 0 1 0 1.414 1.415zm9-10.414a1 1 0 0 1 0 1.414l-1.06 1.06a1 1 0 1 1-1.415-1.413l1.06-1.061a1 1 0 0 1 1.415 0M2 8a1 1 0 0 0 0 2h1.5a1 1 0 1 0 0-2zm7.707-.52a7 7 0 0 0-.603-.169c-.182-.038-.512-.093-.865.037a1.5 1.5 0 0 0-.891.891c-.13.353-.075.683-.037.865.039.183.105.397.168.603l3.48 11.296c.079.256.157.508.237.706.072.177.23.537.59.767a1.5 1.5 0 0 0 1.352.132c.399-.155.623-.478.728-.638.118-.178.243-.41.37-.646l2.48-4.608 4.608-2.48c.236-.127.468-.252.646-.37.16-.105.483-.33.638-.728a1.5 1.5 0 0 0-.132-1.351c-.23-.361-.59-.519-.767-.59a9 9 0 0 0-.706-.238z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 3.5V2M5.06 5.06 4 4m1.06 9L4 14.06m9-9L14.06 4M3.5 9H2m13.865 7.19-2.492 4.627c-.285.529-.427.793-.598.86a.5.5 0 0 1-.451-.044c-.155-.099-.243-.386-.42-.96L8.445 9.445c-.144-.468-.216-.703-.158-.861a.5.5 0 0 1 .297-.297c.158-.058.393.014.861.158l11.228 3.459c.574.177.86.265.96.42a.5.5 0 0 1 .044.45c-.067.172-.331.314-.86.599l-4.627 2.492a1 1 0 0 0-.153.09.5.5 0 0 0-.082.082 1 1 0 0 0-.09.153"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Database/DatabaseIcon.tsx
const DatabaseIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M2.415 13.5c.12 0 .233.053.317.139q.168.17.35.314c.579.459 1.355.827 2.226 1.118C7.061 15.656 9.423 16 12 16s4.939-.344 6.692-.929c.87-.29 1.647-.66 2.226-1.118q.182-.143.35-.314a.45.45 0 0 1 .317-.139c.23 0 .415.186.415.415V19c0 .85-.513 1.502-1.082 1.953-.579.459-1.355.827-2.226 1.118-1.753.585-4.115.929-6.692.929s-4.939-.344-6.692-.929c-.87-.29-1.647-.66-2.226-1.118C2.513 20.502 2 19.849 2 19v-5.085c0-.23.186-.415.415-.415"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M20.912 3.047C21.482 3.496 22 4.148 22 5v5c0 .85-.513 1.502-1.082 1.953-.579.459-1.355.827-2.226 1.118-1.753.585-4.115.929-6.692.929s-4.939-.344-6.692-.929c-.87-.29-1.647-.66-2.226-1.118C2.513 11.502 2 10.849 2 10V5c0-.852.519-1.504 1.088-1.953.581-.458 1.36-.826 2.232-1.117C7.075 1.345 9.437 1 12 1s4.925.345 6.68.93c.873.29 1.651.66 2.232 1.117M4 5l.003-.015a.3.3 0 0 1 .032-.066c.043-.07.13-.174.291-.301.33-.26.87-.539 1.626-.79C7.454 3.326 9.592 3 12 3s4.546.327 6.048.827c.756.252 1.296.53 1.626.79.162.128.248.232.29.302q.03.05.033.066L20 5l-.003.015a.3.3 0 0 1-.032.066c-.043.07-.13.174-.291.301-.33.26-.87.539-1.626.79C16.546 6.674 14.408 7 12 7s-4.546-.327-6.048-.827c-.756-.252-1.296-.53-1.626-.79a1.2 1.2 0 0 1-.29-.302.3.3 0 0 1-.033-.066z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 5c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3V5m18 7c0 1.66-4 3-9 3s-9-1.34-9-3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Dice1/Dice1Icon.tsx
const Dice1Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 12h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21m4.45-9a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Diamond/DiamondIcon.tsx
const DiamondIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.613 2h-1.226l-2 6h5.226zm2 8H9.387L12 17.837zM7.28 8l2-6H7.233a1.5 1.5 0 0 0-1.152.54L2.215 7.18a.5.5 0 0 0 .384.82zm-5.065 2.82a.5.5 0 0 1 .384-.82h4.68l3.512 10.535c.076.23-.175.385-.325.194l-.155-.194zM16.72 10h4.68a.5.5 0 0 1 .385.82l-8.096 9.715-.155.194c-.15.19-.402.036-.325-.194zm5.065-2.82A.5.5 0 0 1 21.4 8h-4.68l-2-6h2.045a1.5 1.5 0 0 1 1.152.54z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M2.5 9h19M10 3 8 9l4 11.5L16 9l-2-6m-1.386 17.263 8.959-10.75c.152-.183.227-.274.256-.376a.5.5 0 0 0 0-.274c-.029-.102-.104-.193-.256-.375l-4.334-5.2a1 1 0 0 0-.186-.197.5.5 0 0 0-.158-.074C16.831 3 16.763 3 16.625 3h-9.25c-.138 0-.207 0-.271.017a.5.5 0 0 0-.158.074 1 1 0 0 0-.186.197l-4.334 5.2c-.151.182-.227.273-.256.375a.5.5 0 0 0 0 .274c.029.102.105.193.256.375l8.959 10.75c.211.254.316.38.443.427a.5.5 0 0 0 .343 0c.127-.047.232-.173.443-.427"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Dice3/Dice3Icon.tsx
const Dice3Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M15 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-3 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.25 7.75h.005M12 12h.005M7.75 16.25h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M12.25 12a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 16.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Dataflow/DataflowIcon.tsx
const DataflowIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.911 5.038c.33-.027.732-.035 1.26-.037A3.001 3.001 0 0 0 22 4a3 3 0 0 0-5.83-1 19 19 0 0 0-1.422.044c-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C11 7.29 11 7.954 11 8.758V11H7.83a3.001 3.001 0 1 0 0 2H11v2.241c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392.404.033.875.041 1.423.043a3.001 3.001 0 1 0 0-2c-.528-.002-.93-.01-1.26-.037-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C13 16.639 13 16.057 13 15.2V13h3.17a3.001 3.001 0 1 0 0-2H13V8.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 20h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C12 17.72 12 16.88 12 15.2V8.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C14.28 4 15.12 4 16.8 4h.2m0 16a2 2 0 1 0 4 0 2 2 0 0 0-4 0m0-16a2 2 0 1 0 4 0 2 2 0 0 0-4 0M7 12h10M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m10 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/DataflowAlt2/DataflowAlt2Icon.tsx
const DataflowAlt2Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M19.532 5.524C19.25 5.5 18.877 5.5 18.3 5.5H11a1 1 0 1 1 0-2h7.339c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v1.371c0 .439 0 .817-.021 1.13a3 3 0 0 1-.207.986 3 3 0 0 1-1.624 1.624 3 3 0 0 1-.986.207c-.313.021-.691.021-1.13.021H18.5a1 1 0 1 1 0-2c.48 0 .79 0 1.026-.017.228-.015.315-.042.357-.06a1 1 0 0 0 .54-.54c.018-.042.045-.129.06-.357C20.5 9.79 20.5 9.48 20.5 9V7.7c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085M5.468 11H5.5a1 1 0 1 1 0 2c-.48 0-.79 0-1.026.017-.228.015-.315.042-.357.06a1 1 0 0 0-.54.54c-.018.042-.045.129-.06.357A17 17 0 0 0 3.5 15v1.3c0 .577 0 .949.024 1.232.022.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085.283.023.655.024 1.232.024H13a1 1 0 1 1 0 2H5.661c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167a18 18 0 0 1-.031-1.356v-1.371c0-.439 0-.817.021-1.13.023-.33.072-.66.207-.986a3 3 0 0 1 1.624-1.624 3 3 0 0 1 .986-.207C4.65 11 5.029 11 5.468 11",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M10.277 8.5h3.446c.12 0 .261 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.125.01.268.01.387v3.446c0 .12 0 .261-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153 5 5 0 0 1-.387.01h-3.446c-.12 0-.261 0-.387-.01a1.5 1.5 0 0 1-.571-.154 1.5 1.5 0 0 1-.655-.655 1.5 1.5 0 0 1-.154-.571 5 5 0 0 1-.01-.387v-3.446c0-.12 0-.261.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01m7.5 7.5h3.446c.12 0 .262 0 .387.01.145.012.353.042.571.153a1.5 1.5 0 0 1 .656.656c.11.218.141.426.153.571.01.125.01.268.01.387v3.446c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.153.571 1.5 1.5 0 0 1-.656.656 1.5 1.5 0 0 1-.571.153 5 5 0 0 1-.387.01h-3.446c-.12 0-.262 0-.387-.01a1.5 1.5 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.5 1.5 0 0 1-.154-.571c-.01-.125-.01-.268-.01-.387v-3.446c0-.12 0-.262.01-.387a1.5 1.5 0 0 1 .153-.571 1.5 1.5 0 0 1 .656-.655 1.5 1.5 0 0 1 .571-.154c.125-.01.268-.01.387-.01m-15-15h3.446c.12 0 .262 0 .387.01.145.012.353.042.571.153a1.5 1.5 0 0 1 .656.656c.11.218.141.426.153.571.01.125.01.268.01.387v3.446c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.153.571 1.5 1.5 0 0 1-.656.656 1.5 1.5 0 0 1-.571.153C6.485 8 6.342 8 6.223 8H2.777c-.12 0-.262 0-.387-.01a1.5 1.5 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.5 1.5 0 0 1-.154-.571A5 5 0 0 1 1 6.223V2.777c0-.12 0-.262.01-.387a1.5 1.5 0 0 1 .153-.571 1.5 1.5 0 0 1 .656-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11 4.5h7.3c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108V9c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C19.898 12 19.432 12 18.5 12M13 19.5H5.7c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2.5 17.98 2.5 17.42 2.5 16.3V15c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C4.102 12 4.568 12 5.5 12m4.8 2.5h3.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-3.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C14.12 9.5 13.98 9.5 13.7 9.5h-3.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218c-.055.107-.055.247-.055.527v3.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055m7.5 7.5h3.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 21.62 22 21.48 22 21.2v-3.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C21.62 17 21.48 17 21.2 17h-3.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C17 17.38 17 17.52 17 17.8v3.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055M2.8 7h3.4c.28 0 .42 0 .527-.054a.5.5 0 0 0 .218-.219C7 6.62 7 6.48 7 6.2V2.8c0-.28 0-.42-.054-.527a.5.5 0 0 0-.219-.219C6.62 2 6.48 2 6.2 2H2.8c-.28 0-.42 0-.527.054a.5.5 0 0 0-.219.219C2 2.38 2 2.52 2 2.8v3.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C2.38 7 2.52 7 2.8 7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Dice2/Dice2Icon.tsx
const Dice2Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M15.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-7 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.25 8.75h.005m-6.505 6.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21m7.7-12.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M9 15.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Data/DataIcon.tsx
const DataIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18.777 9h2.446c.12 0 .262 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.125.01.268.01.387v10.446c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.153.571 1.5 1.5 0 0 1-.656.656 1.5 1.5 0 0 1-.571.153c-.125.01-.268.01-.387.01H10.777c-.12 0-.261 0-.387-.01a1.5 1.5 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.5 1.5 0 0 1-.154-.571 5 5 0 0 1-.01-.387v-2.446c0-.12 0-.262.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655 1.5 1.5 0 0 1 .571-.154c.125-.01.268-.01.387-.01H13v-2.223c0-.12 0-.261.01-.387a1.5 1.5 0 0 1 .154-.571 1.5 1.5 0 0 1 .655-.655 1.5 1.5 0 0 1 .571-.154c.125-.01.268-.01.387-.01H17v-2.223c0-.12 0-.261.01-.387a1.5 1.5 0 0 1 .153-.571 1.5 1.5 0 0 1 .656-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01m-8-4h2.446c.12 0 .261 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.126.01.268.01.387v2.446c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153 5 5 0 0 1-.387.01h-2.446c-.12 0-.261 0-.387-.01a1.5 1.5 0 0 1-.571-.154 1.5 1.5 0 0 1-.655-.655 1.5 1.5 0 0 1-.154-.571A5 5 0 0 1 9 9.223V6.777c0-.12 0-.261.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01m-7 6h2.446c.12 0 .262 0 .387.01.145.012.353.043.571.154a1.5 1.5 0 0 1 .656.655c.11.218.141.426.153.571.01.125.01.268.01.387v2.446c0 .12 0 .261-.01.387a1.5 1.5 0 0 1-.153.571 1.5 1.5 0 0 1-.656.656 1.5 1.5 0 0 1-.571.153c-.125.01-.268.01-.387.01H3.777c-.12 0-.262 0-.387-.01a1.5 1.5 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.5 1.5 0 0 1-.154-.571 5 5 0 0 1-.01-.387v-2.446c0-.12 0-.261.01-.387.012-.145.042-.353.154-.571a1.5 1.5 0 0 1 .655-.655 1.5 1.5 0 0 1 .571-.154c.125-.01.268-.01.387-.01m-1-10h2.446c.12 0 .262 0 .387.01.145.012.353.042.571.153a1.5 1.5 0 0 1 .656.656c.11.218.141.426.153.571.01.125.01.268.01.387v2.446c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.153.571 1.5 1.5 0 0 1-.656.656 1.5 1.5 0 0 1-.571.153C5.485 7 5.342 7 5.223 7H2.777c-.12 0-.262 0-.387-.01a1.5 1.5 0 0 1-.571-.153 1.5 1.5 0 0 1-.655-.656 1.5 1.5 0 0 1-.154-.571A5 5 0 0 1 1 5.223V2.777c0-.12 0-.262.01-.387a1.5 1.5 0 0 1 .153-.571 1.5 1.5 0 0 1 .656-.655c.218-.112.426-.142.571-.154.125-.01.268-.01.387-.01",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21.2 22c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 21.62 22 21.48 22 21.2V10.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C21.62 10 21.48 10 21.2 10h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C18 10.38 18 10.52 18 10.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C17.62 14 17.48 14 17.2 14h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C14 14.38 14 14.52 14 14.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C13.62 18 13.48 18 13.2 18h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C10 18.38 10 18.52 10 18.8v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055zM10 6.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C10.38 6 10.52 6 10.8 6h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C14 6.38 14 6.52 14 6.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C13.62 10 13.48 10 13.2 10h-2.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C10 9.62 10 9.48 10 9.2zm-7 6c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C3.38 12 3.52 12 3.8 12h2.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218C7 12.38 7 12.52 7 12.8v2.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C6.62 16 6.48 16 6.2 16H3.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218C3 15.62 3 15.48 3 15.2zm-1-10c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219C2.38 2 2.52 2 2.8 2h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C6 2.38 6 2.52 6 2.8v2.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C5.62 6 5.48 6 5.2 6H2.8c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219C2 5.62 2 5.48 2 5.2z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Dice5/Dice5Icon.tsx
const Dice5Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M15 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-3 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M9 7.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.25 7.75h.005m-.005 8.5h.005M7.75 7.75h.005M12 12h.005M7.75 16.25h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M12.25 12a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 16.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Dice4/Dice4Icon.tsx
const Dice4Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M6 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.25 7.75h.005m-.005 8.5h.005M7.75 7.75h.005m-.005 8.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Dice6/Dice6Icon.tsx
const Dice6Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M7.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m7.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m7.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.25 7.75h.005m-.005 4h.005m-.005 4.5h.005M7.75 7.75h.005m-.005 4h.005m-.005 4.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Delete/DeleteIcon.tsx
const DeleteIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.176 3.115C8.584 3 9.013 3 9.5 3h7.742c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.486.346 1.002.392 1.564C23 7.29 23 7.954 23 8.758v6.484c0 .804 0 1.469-.044 2.01-.046.562-.145 1.079-.392 1.564a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H9.498c-.486 0-.915.001-1.323-.115a3 3 0 0 1-.99-.495c-.337-.256-.594-.6-.886-.99l-4.38-5.84-.055-.073c-.198-.262-.447-.59-.55-.978a2 2 0 0 1 0-1.018c.103-.387.352-.716.55-.978l.055-.073L6.3 4.6c.292-.39.549-.733.887-.99a3 3 0 0 1 .99-.495m9.531 5.178a1 1 0 0 1 0 1.414L15.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L14 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L12.586 12l-2.293-2.293a1 1 0 1 1 1.414-1.414L14 10.586l2.293-2.293a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m17 9-6 6m0-6 6 6M2.72 12.96l4.32 5.76c.352.47.528.704.751.873.198.15.421.262.66.33C8.72 20 9.013 20 9.6 20h7.6c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H9.6c-.587 0-.88 0-1.15.077a2 2 0 0 0-.659.33c-.223.169-.399.404-.751.873l-4.32 5.76c-.258.344-.387.516-.437.705a1 1 0 0 0 0 .51c.05.189.179.36.437.705"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/DivideCircle/DivideCircleIcon.tsx
const DivideCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m-1.5 7a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M7 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 8h.01M12 16h.01M7 12h10m-4.5-4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m9.5-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/DotsVertical/DotsVerticalIcon.tsx
const DotsVerticalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0-7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Divide/DivideIcon.tsx
const DivideIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-7-6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 12h16m-7-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/DownloadCircle/DownloadCircleIcon.tsx
const DownloadCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m0 6a1 1 0 0 1 1 1v5.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V8a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m8 12 4 4m0 0 4-4m-4 4V8m10 4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/DotsHorizontal/DotsHorizontalIcon.tsx
const DotsHorizontalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/DotsGrid/DotsGridIcon.tsx
const DotsGridIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7-14a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0M3 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-14a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Download/DownloadIcon.tsx
const DownloadIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13 3a1 1 0 1 0-2 0v9.586L7.707 9.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L13 12.586z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M3 14a1 1 0 0 1 1 1v1.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V15a1 1 0 1 1 2 0v1.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V15a1 1 0 0 1 1-1"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 15v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V15m14-5-5 5m0 0-5-5m5 5V3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/EarthArrow/EarthArrowIcon.tsx
const EarthArrowIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M9.592 3.326A9 9 0 0 1 12 3a8.96 8.96 0 0 1 5.256 1.693c-.787.52-1.374 1.085-1.78 1.689-.622.922-.781 1.876-.653 2.747.125.845.514 1.567.922 2.101.395.518.88.951 1.308 1.165 1.076.538 2.318.807 3.247.946.84.126 2.62.546 2.686-.792Q23 12.276 23 12c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11q.276 0 .55-.014a1 1 0 1 0-.1-1.997q-.223.01-.45.011a9 9 0 0 1-8.034-4.939l.969-.559 3.572.669a1.5 1.5 0 0 0 1.776-1.481l-.014-3.153 1.826-3.126a1.5 1.5 0 0 0-.068-1.62z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M13.946 12.656a1 1 0 0 0-1.29 1.29l3.167 8.349a1 1 0 0 0 1.863.016l1.321-3.304 3.304-1.32a1 1 0 0 0-.017-1.864z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m2.687 15.645 1.908-1.101a.5.5 0 0 1 .342-.059l3.754.703a.5.5 0 0 0 .592-.494l-.014-3.29a.5.5 0 0 1 .068-.254l1.895-3.244a.5.5 0 0 0-.023-.54l-3.19-4.54M19 4.859C13.5 7.5 16.5 11 17.5 11.5c1.877.938 4.488 1 4.488 1Q22 12.251 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10q.251 0 .5-.012m4.258-.048-3.168-8.35 8.349 3.167-3.702 1.48z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Drop/DropIcon.tsx
const DropIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11.294 1.291q-.505.496-1 1.003a86 86 0 0 0-2.3 2.435 49 49 0 0 0-2.547 3.02c-.76.993-1.442 2.01-1.792 2.876a9 9 0 1 0 16.69 0c-.35-.865-1.032-1.883-1.792-2.876a49 49 0 0 0-2.548-3.02 86 86 0 0 0-3.3-3.438 1 1 0 0 0-1.41 0"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 14a8 8 0 1 1-15.418-3C5.768 8.068 12 2 12 2s6.232 6.068 7.419 9A8 8 0 0 1 20 14"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/EarthPin/EarthPinIcon.tsx
const EarthPinIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1c1.04 0 2.047.144 3.002.415A5 5 0 0 1 22 6c0 .39-.049.765-.137 1.126A10.96 10.96 0 0 1 23 12c0 6.075-4.925 11-11 11S1 18.075 1 12a11 11 0 0 1 .073-1.27C1.703 5.253 6.354 1 12 1M3.284 9.748a9.004 9.004 0 0 1 9.678-6.697A4.98 4.98 0 0 0 12 6c0 1.422.647 2.636 1.458 3.689.674.876 1.538 1.731 2.37 2.557l.465.461a1 1 0 0 0 1.414 0l.464-.461c.833-.826 1.697-1.681 2.371-2.557q.06-.076.116-.154A9 9 0 0 1 11.5 20.986V19.87l2.366-2.76a1.5 1.5 0 0 0-.395-2.279l-2.738-1.564-1.794-3.144a1.5 1.5 0 0 0-1.436-.75zM17 4.5A1.25 1.25 0 1 0 17 7a1.25 1.25 0 0 0 0-2.5",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 2.458A10 10 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-1.715-.432-3.33-1.193-4.74M17 5.75h.005M10.5 21.888v-2.203a.5.5 0 0 1 .12-.325l2.486-2.9a.5.5 0 0 0-.131-.76l-2.857-1.632a.5.5 0 0 1-.186-.187L8.07 10.62a.5.5 0 0 0-.478-.25l-5.528.492M21 6c0 2.21-2 4-4 6-2-2-4-3.79-4-6a4 4 0 0 1 8 0m-3.75-.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Eraser/EraserIcon.tsx
const EraserIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.764 1.438a4 4 0 0 1 2.472 0c.518.169.953.464 1.383.83.414.35.884.82 1.453 1.39l.27.27c.57.57 1.04 1.039 1.39 1.453.366.43.661.865.83 1.383a4 4 0 0 1 0 2.472c-.169.518-.464.953-.83 1.383-.35.414-.82.884-1.39 1.453-.205.205-.308.308-.414.372a1 1 0 0 1-1.028 0c-.106-.064-.208-.167-.414-.372l-6.558-6.558c-.205-.206-.308-.308-.371-.414a1 1 0 0 1 0-1.028c.063-.106.166-.209.371-.414.57-.57 1.039-1.04 1.453-1.39.43-.366.865-.661 1.383-.83m-4.047 5.693c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.229.074-.427.272-.823.668l-4.796 4.797c-.57.57-1.04 1.039-1.39 1.453-.366.43-.661.865-.83 1.383a4 4 0 0 0 0 2.472c.169.518.464.953.83 1.383.35.414.82.884 1.39 1.453l.757.757c.287.288.54.542.846.729a3 3 0 0 0 .867.36c.349.083.707.082 1.114.082H21a1 1 0 1 0 0-2h-8.586l4.455-4.454c.396-.396.594-.594.668-.823.065-.2.065-.417 0-.618-.074-.228-.272-.426-.668-.822z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m18 13-7-7m10 15H8m2.937-.937 8.668-8.669c1.189-1.188 1.782-1.782 2.005-2.467a3 3 0 0 0 0-1.854c-.223-.685-.816-1.279-2.005-2.467l-.211-.212c-1.188-1.188-1.782-1.782-2.467-2.004a3 3 0 0 0-1.854 0c-.686.222-1.28.816-2.468 2.004l-8.211 8.212c-1.188 1.188-1.782 1.782-2.005 2.467a3 3 0 0 0 0 1.854c.223.685.817 1.28 2.005 2.467l.668.669c.346.346.52.519.721.642q.27.165.578.24c.23.055.475.055.964.055h1.35c.488 0 .733 0 .963-.055.204-.05.4-.13.578-.24.202-.123.375-.296.72-.642"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/EditSquare/EditSquareIcon.tsx
const EditSquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.759 3H11a1 1 0 1 1 0 2H6.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C3 7.361 3 7.943 3 8.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C5.361 21 5.943 21 6.8 21h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.82.037-.45.038-1.031.038-1.888V13a1 1 0 1 1 2 0v4.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H6.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 18.71 1 18.046 1 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C5.29 3 5.954 3 6.758 3",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M17.793 1.793a3.121 3.121 0 1 1 4.414 4.414l-9.563 9.563-.059.059c-.287.288-.54.542-.846.729a3 3 0 0 1-.867.36c-.348.083-.707.082-1.114.082H8a1 1 0 0 1-1-1v-1.758c0-.407 0-.766.083-1.114a3 3 0 0 1 .36-.867c.186-.306.44-.56.728-.846l.06-.06z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V13M8 16h1.675c.489 0 .733 0 .963-.055.204-.05.4-.13.579-.24.201-.123.374-.296.72-.642L21.5 5.5a2.121 2.121 0 0 0-3-3l-9.563 9.563c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.579c-.055.23-.055.474-.055.963z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Edit/EditIcon.tsx
const EditIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21.707 2.293a3.83 3.83 0 0 0-5.414 0L15.13 3.454c-.396.396-.594.594-.668.823a1 1 0 0 0 0 .618c.074.228.272.426.668.822l3.152 3.152c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.229-.074.427-.272.823-.668l1.161-1.162a3.83 3.83 0 0 0 0-5.414m-4.837 10.253c.396-.396.594-.594.668-.823a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822L13.717 7.13c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.823.668l-8.417 8.42c-.246.245-.462.461-.631.718a3 3 0 0 0-.35.727c-.095.293-.128.597-.166.941l-.384 3.455a1 1 0 0 0 1.104 1.104l3.455-.384c.344-.038.648-.071.94-.166q.389-.125.728-.35c.257-.169.473-.385.718-.63z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m18 10-4-4M2.5 21.5l3.384-.376c.414-.046.62-.069.814-.131a2 2 0 0 0 .485-.234c.17-.111.317-.259.61-.553L21 7a2.828 2.828 0 1 0-4-4L3.794 16.206c-.294.294-.442.442-.553.611a2 2 0 0 0-.233.485c-.063.194-.086.4-.132.814z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Earth/EarthIcon.tsx
const EarthIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m13.894 12.58 2.64 1.132c.13.056.28.12.406.188.14.075.347.202.514.427a1.5 1.5 0 0 1 .294.989c-.018.28-.12.498-.197.639-.069.124-.16.26-.238.378-.49.736-.932 1.754-1.628 2.326a1.5 1.5 0 0 1-.517.276c-.872.265-2.46.313-3.357-.04a1.5 1.5 0 0 1-.601-.433c-.605-.723-.765-1.965-1.054-2.831l-.008-.023a2 2 0 0 1-.103-.44 1.5 1.5 0 0 1 .034-.469c.147-.635.558-1.299.887-1.849.07-.114.176-.269.346-.406a1.5 1.5 0 0 1 .781-.324c.218-.023.402.01.532.043a8.5 8.5 0 0 1 1.269.418"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M3.506 9.019A9 9 0 1 0 15.23 3.597c-.084 1.245.351 3.211-.693 4.172-1.095 1.008-3.055 1.445-4.393 2.04l-.889 1.184c-.07.093-.153.205-.235.298a1.5 1.5 0 0 1-.457.36 1.5 1.5 0 0 1-.903.14 1.5 1.5 0 0 1-.544-.206 5 5 0 0 1-.315-.212z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m3.076 7.483 4.288 3.063c.223.159.335.239.451.257a.5.5 0 0 0 .301-.046c.106-.053.188-.163.353-.382l.906-1.208c.047-.063.07-.094.097-.12a.5.5 0 0 1 .08-.064c.032-.02.067-.036.138-.068l3.869-1.719c.16-.071.24-.107.3-.162a.5.5 0 0 0 .124-.177c.032-.076.037-.164.05-.339l.282-4.249M13.5 13.5l2.616 1.121c.303.13.455.195.536.303a.5.5 0 0 1 .098.33c-.009.134-.1.271-.284.546l-1.229 1.844c-.086.13-.13.195-.187.242a.5.5 0 0 1-.172.092c-.071.022-.15.022-.306.022h-1.995c-.208 0-.311 0-.4-.035a.5.5 0 0 1-.2-.144c-.061-.073-.094-.171-.16-.368l-.712-2.139a1 1 0 0 1-.063-.233.5.5 0 0 1 .01-.156c.014-.057.042-.112.096-.221l.542-1.083c.11-.22.165-.33.25-.399a.5.5 0 0 1 .26-.108c.108-.011.225.028.458.105zM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/EyeHidden/EyeHiddenIcon.tsx
const EyeHiddenIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M2.293 2.293a1 1 0 0 1 1.414 0l18 18a1 1 0 1 1-1.414 1.414l-3.154-3.154C15.694 19.4 13.972 20 12 20c-2.86 0-5.194-1.265-6.922-2.707s-2.91-3.107-3.503-4.046l-.024-.038a2.3 2.3 0 0 1-.348-.762 2.2 2.2 0 0 1 0-.894c.078-.337.231-.578.349-.764l.024-.038c.603-.953 1.826-2.676 3.62-4.141L2.293 3.707a1 1 0 0 1 0-1.414m6.26 7.675a4 4 0 0 0 5.478 5.478l-1.513-1.514a2 2 0 0 1-2.45-2.45z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15.992 11.75a4 4 0 0 0-3.742-3.742L8.792 4.549A9.7 9.7 0 0 1 12 4c2.862 0 5.195 1.265 6.923 2.707 1.726 1.441 2.91 3.107 3.503 4.046l.024.038c.117.185.27.425.347.762.063.272.063.622 0 .894-.077.337-.23.577-.347.762l-.024.038a18.4 18.4 0 0 1-2.158 2.779z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10.743 5.092Q11.353 5.001 12 5c5.105 0 8.455 4.505 9.58 6.287.137.215.205.323.243.49a1.2 1.2 0 0 1 0 .447c-.038.166-.107.274-.244.492-.3.474-.757 1.141-1.363 1.865M6.724 6.715c-2.162 1.467-3.63 3.504-4.303 4.57-.137.217-.205.325-.243.492a1.2 1.2 0 0 0 0 .446c.038.167.106.274.242.49C3.546 14.495 6.895 19 12 19c2.059 0 3.832-.732 5.289-1.723M3 3l18 18M9.88 9.879a3 3 0 1 0 4.243 4.243"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Eye/EyeIcon.tsx
const EyeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 4C9.138 4 6.805 5.265 5.077 6.707s-2.91 3.107-3.503 4.046l-.024.038c-.118.185-.27.425-.347.762a2.2 2.2 0 0 0 0 .894c.077.337.23.577.347.762l.024.038c.593.939 1.776 2.605 3.503 4.046S9.138 20 12 20s5.195-1.265 6.923-2.707c1.726-1.441 2.91-3.107 3.503-4.046l.024-.038c.117-.185.27-.425.347-.762a2.2 2.2 0 0 0 0-.894c-.077-.337-.23-.577-.347-.762l-.024-.038c-.593-.939-1.777-2.605-3.503-4.046C17.195 5.265 14.862 4 12 4m0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M2.42 12.713c-.136-.215-.204-.323-.242-.49a1.2 1.2 0 0 1 0-.446c.038-.167.106-.274.242-.49C3.546 9.505 6.895 5 12 5s8.455 4.505 9.58 6.287c.137.215.205.323.243.49.029.125.029.322 0 .446-.038.167-.106.274-.242.49C20.455 14.495 17.105 19 12 19c-5.106 0-8.455-4.505-9.58-6.287"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FaceDown/FaceDownIcon.tsx
const FaceDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-6.1 7.8a1 1 0 0 0 1.397-.196l.005-.006.033-.041q.05-.061.16-.178c.148-.153.37-.362.656-.57.577-.42 1.375-.81 2.35-.81.974 0 1.771.39 2.348.81a5 5 0 0 1 .816.748l.034.041.004.006A1 1 0 0 0 16.8 15.4l-.103-.129a7 7 0 0 0-1.171-1.08c-.798-.58-2-1.191-3.526-1.191s-2.728.61-3.526 1.191a7 7 0 0 0-1.17 1.08L7.2 15.4a1 1 0 0 0 .2 1.4",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 16s-1.5-2-4-2-4 2-4 2m7-7h.01M9 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Equal/EqualIcon.tsx
const EqualIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4 9a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 9h14M5 15h14"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FastForward/FastForwardIcon.tsx
const FastForwardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.075 4.228a2 2 0 0 0-1.618.727c-.32.387-.393.864-.424 1.212C12 6.53 12 6.991 12 7.517v8.965c0 .527 0 .988.033 1.35.03.349.104.826.424 1.213a2 2 0 0 0 1.618.727c.501-.019.907-.281 1.188-.489.292-.216.637-.523 1.03-.873l5.052-4.49c.21-.187.413-.366.57-.532.17-.18.357-.412.467-.726a2 2 0 0 0 0-1.325 2 2 0 0 0-.468-.725c-.157-.166-.359-.345-.57-.533l-.025-.022-5.025-4.467c-.394-.35-.739-.657-1.031-.873-.281-.208-.687-.47-1.188-.489m-11 0a2 2 0 0 0-1.618.727c-.32.387-.393.864-.424 1.212C1 6.53 1 6.991 1 7.517v8.965c0 .527 0 .988.033 1.35.03.349.104.826.424 1.213a2 2 0 0 0 1.618.727c.501-.019.907-.281 1.188-.489.292-.216.637-.523 1.03-.873l5.052-4.49c.21-.187.412-.366.57-.532.17-.18.357-.412.467-.726a2 2 0 0 0 0-1.325 2 2 0 0 0-.468-.725c-.156-.166-.359-.345-.57-.533l-.025-.022L5.294 5.59c-.394-.35-.739-.657-1.031-.873-.281-.208-.687-.47-1.188-.489",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13 16.437c0 1.13 0 1.695.228 1.972a1 1 0 0 0 .81.364c.358-.014.78-.39 1.625-1.14l4.992-4.437c.465-.414.698-.62.783-.865a1 1 0 0 0 0-.662c-.085-.245-.318-.451-.783-.865l-4.992-4.437c-.845-.75-1.267-1.126-1.626-1.14a1 1 0 0 0-.809.364C13 5.868 13 6.433 13 7.563zm-11 0c0 1.13 0 1.695.228 1.972a1 1 0 0 0 .81.364c.358-.014.78-.39 1.625-1.14l4.992-4.437c.465-.414.698-.62.783-.865a1 1 0 0 0 0-.662c-.085-.245-.318-.451-.783-.865L4.663 6.367c-.845-.75-1.267-1.126-1.626-1.14a1 1 0 0 0-.809.364C2 5.868 2 6.433 2 7.563z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FaceId/FaceIdIcon.tsx
const FaceIdIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.759 2H8a1 1 0 1 1 0 2h-.2c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8V8a1 1 0 1 1-2 0v-.241c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2M3 15a1 1 0 0 1 1 1v.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20H8a1 1 0 1 1 0 2h-.241c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V16a1 1 0 0 1 1-1M18.089 4.038C17.639 4 17.057 4 16.2 4H16a1 1 0 1 1 0-2h.241c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758V8a1 1 0 1 1-2 0v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18M21 15a1 1 0 0 1 1 1v.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H16a1 1 0 1 1 0-2h.2c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V16a1 1 0 0 1 1-1M7.5 7a1 1 0 0 1 1 1v1.5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m9 0a1 1 0 0 1 1 1v1.5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m-4 0a1 1 0 0 1 1 1v3.1c0 1.352-1.148 2.5-2.5 2.5a1 1 0 1 1 0-2c.248 0 .5-.252.5-.5V8a1 1 0 0 1 1-1m-4.507 7.493a1 1 0 0 1 1.414 0 3.587 3.587 0 0 0 5.086 0 1 1 0 0 1 1.414 1.414 5.587 5.587 0 0 1-7.914 0 1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 3h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m5 13h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V16m18-8v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H16m5 13v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H16M7.5 8v1.5m9-1.5v1.5M11 12.6c.8 0 1.5-.7 1.5-1.5V8m2.7 7.2c-1.8 1.8-4.7 1.8-6.5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FaceNeutral/FaceNeutralIcon.tsx
const FaceNeutralIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m1.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M7 15a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m.5-6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 15h8m-1-6h.01M9 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FaceUp/FaceUpIcon.tsx
const FaceUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-6.1 4.2a1 1 0 0 1 1.397.196l.005.006.033.041q.05.061.16.178c.148.153.37.362.656.57.577.42 1.375.81 2.35.81.974 0 1.771-.39 2.348-.81a5 5 0 0 0 .816-.748l.034-.041.004-.006A1 1 0 0 1 16.8 14.6l-.103.129q-.089.107-.248.276a7 7 0 0 1-.923.804c-.798.58-2 1.191-3.526 1.191s-2.728-.61-3.526-1.191a7 7 0 0 1-1.17-1.08L7.2 14.6a1 1 0 0 1 .2-1.4",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 14s1.5 2 4 2 4-2 4-2m-1-5h.01M9 9h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/File/FileIcon.tsx
const FileIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V6.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1M8 6a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14 11H8m2 4H8m8-8H8m12-.2v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.28 20 5.12 20 6.8"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileCheck/FileCheckIcon.tsx
const FileCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h4.31a.5.5 0 0 0 .348-.841l-.037-.038a3 3 0 0 1 4.118-4.36l2.382-2.382a3 3 0 0 1 .608-.47c.222-.13.333-.195.386-.254a.4.4 0 0 0 .103-.18c.024-.074.024-.173.024-.37V6.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1M8 9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m1-9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M22.707 18.207a1 1 0 0 0-1.414-1.414L17.5 20.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 12.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m2-11H8m2 4H8m8-8H8m6.5 12 2 2 4.5-4.5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Feather/FeatherIcon.tsx
const FeatherIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M10.292 3.305a7 7 0 0 1 9.416 0c.124.113.26.248.477.465l.045.045c.217.218.352.353.465.477a7 7 0 0 1 0 9.417.92.92 0 0 1-.686.291H11a1 1 0 1 0 0 2h5.483c.606 0 .909 0 1.049.12a.5.5 0 0 1 .174.42c-.015.183-.23.397-.657.826l-1.873 1.872-.036.037c-.134.134-.303.304-.51.43a2 2 0 0 1-.577.24 2.8 2.8 0 0 1-.665.055h-6.82c-.252 0-.498 0-.706-.017a2.5 2.5 0 0 1-.374-.057l-2.78 2.781a1 1 0 0 1-1.415-1.414l2.78-2.78a2.5 2.5 0 0 1-.056-.375A9 9 0 0 1 4 17.432v-6.82c0-.19-.001-.43.055-.665a2 2 0 0 1 .24-.578c.126-.206.296-.375.43-.509l.036-.036L9.815 3.77c.218-.217.353-.352.476-.465"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 8 2 22m16-7H9m-2.4 4h6.737c.245 0 .367 0 .482-.028a1 1 0 0 0 .29-.12c.1-.061.187-.148.36-.32L19.5 13.5c.239-.239.358-.358.455-.464a6 6 0 0 0 0-8.072A15 15 0 0 0 19.5 4.5c-.239-.239-.358-.359-.464-.455a6 6 0 0 0-8.072 0c-.106.096-.225.216-.464.455L5.469 9.53c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C5 10.296 5 10.418 5 10.663V17.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C5.76 19 6.04 19 6.6 19"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyDollarCircle/CurrencyDollarCircleIcon.tsx
const CurrencyDollarCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m1 4.5a1 1 0 1 0-2 0V6a3.5 3.5 0 1 0 0 7h2a1.5 1.5 0 0 1 0 3h-2.167A1.333 1.333 0 0 1 9.5 14.667a1 1 0 1 0-2 0A3.333 3.333 0 0 0 10.833 18H11v.5a1 1 0 1 0 2 0V18a3.5 3.5 0 1 0 0-7h-2a1.5 1.5 0 0 1 0-3h2.167c.736 0 1.333.597 1.333 1.333a1 1 0 1 0 2 0A3.333 3.333 0 0 0 13.167 6H13z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.5 14.667A2.333 2.333 0 0 0 10.833 17H13a2.5 2.5 0 0 0 0-5h-2a2.5 2.5 0 0 1 0-5h2.167A2.333 2.333 0 0 1 15.5 9.333M12 5.5V7m0 10v1.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileDownload/FileDownloadIcon.tsx
const FileDownloadIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.7587 1H15.2413C16.0463 0.999988 16.7106 0.999979 17.2518 1.0442C17.8139 1.09012 18.3306 1.18868 18.816 1.43598C19.5686 1.81947 20.1805 2.43139 20.564 3.18404C20.8113 3.66938 20.9099 4.18608 20.9558 4.74818C21 5.28937 21 5.95372 21 6.75868V11.9742C21 12.5239 21 12.7987 20.9362 12.9126C20.8598 13.0488 20.83 13.0749 20.6849 13.1327C20.5636 13.1809 20.1753 13.1294 19.3987 13.0263C19.2682 13.0089 19.1352 13 19 13C17.3431 13 16 14.3431 16 16C15.2322 16 14.4645 16.2929 13.8787 16.8787C12.7071 18.0503 12.7071 19.9497 13.8787 21.1213L14.3968 21.6394C14.8232 22.0659 15.0364 22.2791 15.0509 22.4629C15.0635 22.6223 14.9988 22.7785 14.8773 22.8823C14.7371 23.0021 14.4359 23.0023 13.8334 23.0026C12.9003 23.003 11.9672 23.0022 11.0341 23.0013C10.2756 23.0007 9.51716 23 8.75868 23C7.95372 23 7.28937 23 6.74818 22.9558C6.18608 22.9099 5.66938 22.8113 5.18404 22.564C4.43139 22.1805 3.81947 21.5686 3.43598 20.816C3.18868 20.3306 3.09012 19.8139 3.0442 19.2518C2.99998 18.7106 2.99999 18.0463 3 17.2413V6.75869C2.99999 5.95373 2.99998 5.28936 3.0442 4.74818C3.09012 4.18608 3.18868 3.66938 3.43598 3.18404C3.81947 2.43139 4.43139 1.81947 5.18404 1.43598C5.66938 1.18868 6.18608 1.09012 6.74818 1.0442C7.28936 0.999979 7.95375 0.999988 8.7587 1ZM7 5C6.44772 5 6 5.44772 6 6C6 6.55229 6.44772 7 7 7H16C16.5523 7 17 6.55229 17 6C17 5.44772 16.5523 5 16 5H7ZM6 10C6 9.44771 6.44772 9 7 9H13C13.5523 9 14 9.44771 14 10C14 10.5523 13.5523 11 13 11H7C6.44772 11 6 10.5523 6 10ZM6 14C6 13.4477 6.44772 13 7 13H9C9.55229 13 10 13.4477 10 14C10 14.5523 9.55229 15 9 15H7C6.44772 15 6 14.5523 6 14Z",
				fill: "currentColor"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				d: "M19 15C19.5523 15 20 15.4477 20 16V19.5858L21.2929 18.2929C21.6834 17.9024 22.3166 17.9024 22.7071 18.2929C23.0976 18.6834 23.0976 19.3166 22.7071 19.7071L19.7071 22.7071C19.5196 22.8946 19.2652 23 19 23C18.7348 23 18.4804 22.8946 18.2929 22.7071L15.2929 19.7071C14.9024 19.3166 14.9024 18.6834 15.2929 18.2929C15.6834 17.9024 16.3166 17.9024 16.7071 18.2929L18 19.5858V16C18 15.4477 18.4477 15 19 15Z",
				fill: "currentColor"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 12.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7M14 11H8m2 4H8m8-8H8m7 12 3 3m0 0 3-3m-3 3v-6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileHeart/FileHeartIcon.tsx
const FileHeartIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8.759 1h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 5.29 21 5.954 21 6.758v4.36c0 .325 0 .489-.052.594a.44.44 0 0 1-.21.217c-.104.056-.299.062-.688.075a4.85 4.85 0 0 0-2.055.542c-1.573-.81-3.565-.802-5.196.552-2.073 1.723-2.407 4.699-.73 6.798.48.6 1.304 1.396 2.039 2.078.139.128.208.192.237.232a.497.497 0 0 1-.308.785c-.048.009-.14.009-.325.009H8.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V6.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 1 7.954 1 8.758 1M7 8a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m1-9a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.997 15.038c-1-1.136-2.667-1.442-3.92-.401-1.252 1.04-1.428 2.78-.445 4.01.745.933 2.866 2.807 3.85 3.66.18.156.27.234.374.264.09.027.19.027.281 0 .105-.03.194-.108.374-.263.984-.854 3.105-2.728 3.85-3.66.984-1.231.829-2.982-.445-4.011-1.274-1.03-2.92-.735-3.92.401"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m.5-11H8m1 4H8m8-8H8m8.997 7.83c-.8-.908-2.133-1.153-3.135-.32-1.002.832-1.143 2.223-.356 3.208.787.984 3.491 3.282 3.491 3.282s2.705-2.298 3.492-3.282a2.256 2.256 0 0 0-.356-3.209c-1.02-.823-2.336-.587-3.136.322"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileAttachment/FileAttachmentIcon.tsx
const FileAttachmentIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M4.096 14.932Q4.539 15 5 15a6 6 0 0 0 6-6V3.5q-.001-.593-.146-1.14c-.151-.58-.227-.87-.186-1.004a.43.43 0 0 1 .218-.283C11.006 1 11.251 1 11.74 1h3.501c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 5.29 21 5.954 21 6.758v10.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V15.79c0-.383 0-.574.065-.689a.45.45 0 0 1 .256-.22c.123-.047.34-.014.775.051M12.5 10a1 1 0 0 1 1-1H17a1 1 0 1 1 0 2h-3.5a1 1 0 0 1-1-1m-1 4a1 1 0 0 1 1-1H17a1 1 0 1 1 0 2h-4.5a1 1 0 0 1-1-1M9 17a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6 3.5a.5.5 0 0 1 1 0V9a2 2 0 1 1-4 0V5a1 1 0 0 0-2 0v4a4 4 0 0 0 8 0V3.5a2.5 2.5 0 0 0-5 0V9a1 1 0 1 0 2 0z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12.5 2h2.7c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.28 20 5.12 20 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2v-.7M16 13h-4.5M16 9h-3.5m3.5 8H8m-2-7V4.5a1.5 1.5 0 1 1 3 0V10a3 3 0 1 1-6 0V6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Figma/FigmaIcon.tsx
const FigmaIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4 5A4.5 4.5 0 0 1 8.5.5h7a4.5 4.5 0 0 1 2.829 8A4.5 4.5 0 0 1 13 15.742V19a4.5 4.5 0 1 1-7.329-3.5A4.5 4.5 0 0 1 4 12c0-1.414.652-2.675 1.671-3.5A4.5 4.5 0 0 1 4 5m7 9.5H8.5a2.5 2.5 0 0 1 0-5H11zm2-2.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0m2.5-4.5a2.5 2.5 0 0 0 0-5H13v5zm-7-5H11v5H8.5a2.5 2.5 0 0 1 0-5m2.5 14H8.5A2.5 2.5 0 1 0 11 19z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 1.5H8.5a3.5 3.5 0 1 0 0 7m3.5-7v7m0-7h3.5a3.5 3.5 0 1 1 0 7m-3.5 0H8.5m3.5 0v7m0-7h3.5m-7 0a3.5 3.5 0 1 0 0 7m3.5 0H8.5m3.5 0V19a3.5 3.5 0 1 1-3.5-3.5m7-7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/EqualNot/EqualNotIcon.tsx
const EqualNotIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M19.707 5.707a1 1 0 0 0-1.414-1.414L14.586 8H5a1 1 0 0 0 0 2h7.586l-4 4H5a1 1 0 1 0 0 2h1.586l-2.293 2.293a1 1 0 1 0 1.414 1.414L9.414 16H19a1 1 0 1 0 0-2h-7.586l4-4H19a1 1 0 1 0 0-2h-1.586z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 9h14M5 15h14m0-10L5 19"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileMinus/FileMinusIcon.tsx
const FileMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8.759 1h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 5.29 21 5.954 21 6.758V13.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C20.62 14 20.48 14 20.2 14H15a3 3 0 1 0 0 6h4.983c.189 0 .283 0 .377.04.17.073.315.31.303.494-.007.102-.038.162-.099.282a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V6.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 1 7.954 1 8.758 1M7 5a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15 16a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 11.941V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H14m0-11H8m2 4H8m8-8H8m7 10h6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FilePlus/FilePlusIcon.tsx
const FilePlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.7587 1H15.2413C16.0463 0.999988 16.7106 0.999979 17.2518 1.0442C17.8139 1.09012 18.3306 1.18868 18.816 1.43598C19.5686 1.81947 20.1805 2.43139 20.564 3.18404C20.8113 3.66938 20.9099 4.18608 20.9558 4.74818C21 5.28937 21 5.95372 21 6.75868V10.9742C21 11.5239 21 11.7987 20.9362 11.9126C20.8598 12.0488 20.83 12.0749 20.6849 12.1327C20.5636 12.1809 20.1753 12.1294 19.3987 12.0263C19.2682 12.0089 19.1352 12 19 12C17.3431 12 16 13.3431 16 15C14.3431 15 13 16.3431 13 18C13 19.6569 14.3431 21 16 21C16 21.162 16.0128 21.3209 16.0375 21.4759C16.1535 22.2036 16.2115 22.5675 16.1655 22.6908C16.112 22.8343 16.081 22.8712 15.9487 22.9482C15.8349 23.0145 15.5766 23.0177 15.06 23.0241C13.7933 23.0398 12.5248 23.0278 11.2573 23.0158C10.424 23.0079 9.59048 23 8.75868 23C7.95372 23 7.28937 23 6.74818 22.9558C6.18608 22.9099 5.66938 22.8113 5.18404 22.564C4.43139 22.1805 3.81947 21.5686 3.43598 20.816C3.18868 20.3306 3.09012 19.8139 3.0442 19.2518C2.99998 18.7106 2.99999 18.0463 3 17.2413V6.75869C2.99999 5.95373 2.99998 5.28936 3.0442 4.74818C3.09012 4.18608 3.18868 3.66938 3.43598 3.18404C3.81947 2.43139 4.43139 1.81947 5.18404 1.43598C5.66938 1.18868 6.18608 1.09012 6.74818 1.0442C7.28936 0.999979 7.95375 0.999988 8.7587 1ZM7 5C6.44772 5 6 5.44772 6 6C6 6.55229 6.44772 7 7 7H16C16.5523 7 17 6.55229 17 6C17 5.44772 16.5523 5 16 5H7ZM6 10C6 9.44771 6.44772 9 7 9H13C13.5523 9 14 9.44771 14 10C14 10.5523 13.5523 11 13 11H7C6.44772 11 6 10.5523 6 10ZM6 14C6 13.4477 6.44772 13 7 13H9C9.55229 13 10 13.4477 10 14C10 14.5523 9.55229 15 9 15H7C6.44772 15 6 14.5523 6 14Z",
				fill: "currentColor"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				d: "M19 14C19.5523 14 20 14.4477 20 15V17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H20V21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21V19H16C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17H18V15C18 14.4477 18.4477 14 19 14Z",
				fill: "currentColor"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 10.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m2-11H8m2 4H8m8-8H8m10 14v-6m-3 3h6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileLock/FileLockIcon.tsx
const FileLockIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8.759 1h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 5.29 21 5.954 21 6.758v4.015c0 .473 0 .709-.073.829a.43.43 0 0 1-.281.218c-.134.04-.41-.03-.963-.171a4.756 4.756 0 0 0-5.898 4.02 4 4 0 0 0-1.349 1.515 4 4 0 0 0-.412 1.515c-.024.294-.024.619-.024.848v.906c0 .23 0 .554.024.848q.015.201.05.4c.098.564.146.846.1.971a.42.42 0 0 1-.22.261c-.116.067-.345.067-.804.067H8.76c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V6.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 1 7.954 1 8.758 1M7 5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15.75 16.25a2.75 2.75 0 1 1 5.5 0v.778c.203.024.43.074.658.19a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C14 20.93 14 20.684 14 20.432v-.864c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 1.9 1.9 0 0 1 .658-.19zm3.5 0V17h-1.5v-.75a.75.75 0 0 1 1.5 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h1.7M13 11H8m3 4H8m8-8H8m11.25 10v-1.75a1.75 1.75 0 1 0-3.5 0V17m-.15 4h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 17.76 14 18.04 14 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CreditCardUp/CreditCardUpIcon.tsx
const CreditCardUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.707 14.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L18 17.414V21a1 1 0 1 0 2 0v-3.586l1.293 1.293a1 1 0 0 0 1.414-1.414zM18.839 4H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 7.18 1 7.635 1 8.161c0 .464.375.839.839.839H22.16a.84.84 0 0 0 .84-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C19.82 4 19.365 4 18.838 4"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M1.546 11.109C1.76 11 2.04 11 2.6 11h18.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C23 11.76 23 12.04 23 12.6v.226c0 .606 0 .909-.12 1.049a.5.5 0 0 1-.42.174c-.183-.015-.397-.229-.826-.657l-.513-.513a3 3 0 0 0-4.242 0l-3 3a3 3 0 0 0-.853 2.518c.104.778.155 1.167.107 1.288-.058.145-.084.175-.22.251-.114.064-.39.064-.94.064H5.16c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 16.82 1 16.365 1 15.839V12.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 18 3-3m0 0 3 3m-3-3v6m3-11H2m20 2V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 19 4.08 19 5.2 19H12"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileSearch/FileSearchIcon.tsx
const FileSearchIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h2.875c.709 0 1.063 0 1.195-.097a.44.44 0 0 0 .202-.356c.016-.163-.195-.515-.615-1.22a6.5 6.5 0 0 1 7.362-9.58c.482.136.723.204.86.165a.45.45 0 0 0 .288-.218c.075-.12.075-.34.075-.78V6.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1M7 5a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M13.5 18a4.5 4.5 0 1 1 8.31 2.396l.897.897a1 1 0 0 1-1.414 1.414l-.897-.897A4.5 4.5 0 0 1 13.5 18m4.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14 11H8m2 4H8m8-8H8m12 3.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h2.7M22 22l-1.5-1.5m1-2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileQuestion/FileQuestionIcon.tsx
const FileQuestionIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8.759 1h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 5.29 21 5.954 21 6.758v3.008c0 .434 0 .651-.07.77a.44.44 0 0 1-.275.219c-.13.043-.38-.014-.879-.126a5.24 5.24 0 0 0-3.814.595 5.25 5.25 0 0 0-2.292 2.783 3 3 0 0 0 1.953 3.864 3 3 0 0 0 .414 1.654A3 3 0 0 0 15.65 21c0 .349.06.683.169.995l.13.373c.102.375-.06.603-.447.63-.018.002-.099.002-.26.002H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V6.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 1 7.954 1 8.758 1M7 5a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.988 14.672a1.248 1.248 0 0 1 1.881 1.078v.002c0 .218-.177.52-.679.854a4.3 4.3 0 0 1-.879.443l-.008.003a1 1 0 0 0 .634 1.897h.001l.043-.016.092-.034a6.3 6.3 0 0 0 1.226-.63c.623-.414 1.57-1.237 1.57-2.516a3.248 3.248 0 0 0-6.312-1.083 1 1 0 1 0 1.886.664c.098-.278.291-.512.545-.662M18.65 20a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 9.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H14m0-11H8m2 4H8m8-8H8m8.5 8.002a2.249 2.249 0 0 1 4.37.75c0 1.499-2.25 2.248-2.25 2.248m.03 3h.01"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Filter/FilterIcon.tsx
const FilterIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.671 3H5.5a3.5 3.5 0 1 0 0 7h9.171a4.5 4.5 0 1 0 0-7m-1.415 2A4.5 4.5 0 0 0 13 6.5c0 .526.09 1.03.256 1.5H5.5a1.5 1.5 0 1 1 0-3zM6.5 13c1.072 0 2.056.375 2.829 1H18.5a3.5 3.5 0 1 1 0 7H9.329A4.5 4.5 0 1 1 6.5 13m4.5 4.5c0-.526-.09-1.03-.256-1.5H18.5a1.5 1.5 0 0 1 0 3h-7.756A4.5 4.5 0 0 0 11 17.5",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.05 9H5.5a2.5 2.5 0 0 1 0-5h9.55m-6.1 16h9.55a2.5 2.5 0 0 0 0-5H8.95M3 17.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0m18-11a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Fingerprint/FingerprintIcon.tsx
const FingerprintIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1.842 14.219c0-5.614 4.549-10.164 10.16-10.164s10.16 4.55 10.16 10.164a4.054 4.054 0 1 1-8.108 0 2.054 2.054 0 1 0-4.107 0A8.16 8.16 0 0 0 13.8 21.15a1 1 0 1 1-1.059 1.697 10.16 10.16 0 0 1-4.793-8.63 4.054 4.054 0 1 1 8.107 0 2.054 2.054 0 1 0 4.108 0 8.16 8.16 0 0 0-8.16-8.163 8.16 8.16 0 0 0-8.16 8.164c0 1.053.118 2.08.335 3.071a1 1 0 0 1-1.954.429 16.3 16.3 0 0 1-.381-3.5",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.999 9.11a5.11 5.11 0 0 0-5.107 5.109c0 2.393.75 4.607 2.027 6.428a1 1 0 1 1-1.638 1.148 13.16 13.16 0 0 1-2.389-7.576A7.11 7.11 0 0 1 12 7.109a7.11 7.11 0 0 1 7.106 7.11 1 1 0 0 1-2 0A5.11 5.11 0 0 0 12 9.109",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 13.219a1 1 0 0 1 1 1 5.11 5.11 0 0 0 5.107 5.109c.046 0 .078-.002.133-.006l.14-.009a1 1 0 0 1 .111 1.997l-.05.003a5 5 0 0 1-.334.015 7.11 7.11 0 0 1-7.106-7.11 1 1 0 0 1 1-1M2.724 5.202A12.33 12.33 0 0 1 12 1c3.7 0 7.013 1.632 9.276 4.202a1 1 0 1 1-1.501 1.322A10.33 10.33 0 0 0 12 3a10.33 10.33 0 0 0-7.775 3.524 1 1 0 1 1-1.501-1.322",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M8.1 21.221a12.16 12.16 0 0 1-2.208-7.002A6.11 6.11 0 0 1 12 8.109a6.11 6.11 0 0 1 6.106 6.11"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M8.1 21.221a12.16 12.16 0 0 1-2.207-7.002 6.11 6.11 0 0 1 6.106-6.11 6.11 6.11 0 0 1 6.106 6.11"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M18.436 20.312c-.11.006-.218.016-.329.016a6.11 6.11 0 0 1-6.106-6.11"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M18.436 20.312c-.11.006-.218.016-.329.016a6.11 6.11 0 0 1-6.106-6.11"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M13.27 22a9.16 9.16 0 0 1-4.323-7.781 3.054 3.054 0 1 1 6.107 0 3.054 3.054 0 1 0 6.108 0c0-5.062-4.102-9.164-9.16-9.164-5.059 0-9.16 4.102-9.16 9.164 0 1.128.126 2.226.358 3.286"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M13.27 22a9.16 9.16 0 0 1-4.323-7.781 3.054 3.054 0 1 1 6.107 0 3.054 3.054 0 1 0 6.108 0c0-5.062-4.102-9.164-9.16-9.164-5.059 0-9.16 4.102-9.16 9.164 0 1.128.126 2.226.358 3.286"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M20.526 5.863A11.33 11.33 0 0 0 12 2a11.33 11.33 0 0 0-8.525 3.863"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M20.526 5.863A11.33 11.33 0 0 0 12 2a11.33 11.33 0 0 0-8.525 3.863"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Flag/FlagIcon.tsx
const FlagIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M3 2.997a1 1 0 0 1 .293-.704s-.044.038.046-.044l.074-.064q.088-.073.235-.173c.198-.132.479-.29.856-.44C5.259 1.269 6.387 1 8 1c1.693 0 3.097.561 4.316 1.05l.055.022C13.64 2.579 14.72 3 16 3c1.387 0 2.26-.23 2.754-.428.248-.1.405-.192.488-.248a1 1 0 0 0 .073-.053A1 1 0 0 1 21 3v11.999a1 1 0 0 1-.293.708v.001a2 2 0 0 1-.12.107 3 3 0 0 1-.235.173c-.198.132-.479.29-.856.44-.755.303-1.883.572-3.496.572-1.693 0-3.097-.561-4.316-1.05l-.055-.021C10.36 15.42 9.28 15 8 15c-1.387 0-2.26.23-2.754.428a3 3 0 0 0-.246.11V22a1 1 0 1 1-2 0z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1v19"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FlagAlt2/FlagAlt2Icon.tsx
const FlagAlt2Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4.568 1.5c-.252 0-.498 0-.706.017a2 2 0 0 0-.77.201 2 2 0 0 0-.874.874c-.122.239-.17.476-.193.685C1.97 3.52 2 3.785 2 4.032V21a1 1 0 1 0 2 0v-9h5.5v1.432c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017H19.8c.177 0 .372 0 .537-.015a1.53 1.53 0 0 0 .736-.244 1.5 1.5 0 0 0 .634-.975 1.53 1.53 0 0 0-.076-.772 6 6 0 0 0-.205-.497l-1.32-2.972 1.224-2.448c.083-.167.173-.347.235-.506.066-.167.16-.452.11-.79a1.5 1.5 0 0 0-.624-1.01 1.54 1.54 0 0 0-.756-.256 7 7 0 0 0-.558-.015H14.5V4.068c0-.252 0-.498-.017-.706a2 2 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2 2 0 0 0-.77-.201c-.208-.017-.454-.017-.706-.017z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13.5 6.5h6.206c.428 0 .643 0 .772.09a.5.5 0 0 1 .208.337c.023.156-.073.347-.265.73l-1.252 2.505a1 1 0 0 0-.106.252.5.5 0 0 0-.004.175c.01.066.038.13.094.256l1.347 3.03c.167.375.25.562.223.714a.5.5 0 0 1-.211.325c-.128.086-.333.086-.743.086H12.1c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437c-.109-.214-.109-.494-.109-1.054V11M3 21V3.5M3 11h8.9c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054V4.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.74 2.5 12.46 2.5 11.9 2.5H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.26 3 3.54 3 4.1z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Flash/FlashIcon.tsx
const FlashIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M13.992 2.124a1 1 0 0 0-1.76-.764l-8.93 10.715c-.154.185-.31.373-.424.538-.108.155-.304.462-.31.864a1.5 1.5 0 0 0 .557 1.19c.313.253.674.298.863.315.199.018.443.018.684.018h6.195l-.86 6.876a1 1 0 0 0 1.761.764l8.93-10.715c.154-.185.31-.373.424-.538.108-.155.304-.462.31-.864a1.5 1.5 0 0 0-.557-1.19c-.313-.253-.674-.298-.863-.315C19.812 9 19.57 9 19.328 9h-6.195z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13 2 4.093 12.688c-.348.418-.523.628-.525.804a.5.5 0 0 0 .185.397c.138.111.41.111.955.111H12l-1 8 8.907-10.688c.348-.418.523-.628.525-.804a.5.5 0 0 0-.185-.397c-.138-.111-.41-.111-.955-.111H12z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FlagAlt1/FlagAlt1Icon.tsx
const FlagAlt1Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21.005 2.291a1.54 1.54 0 0 0-.79-.275C20.036 2 19.822 2 19.62 2H4a1 1 0 0 0-1 1v18a1 1 0 1 0 2 0v-7h14.62c.202 0 .416 0 .595-.016.183-.017.499-.061.79-.275a1.5 1.5 0 0 0 .605-1.07 1.54 1.54 0 0 0-.17-.818c-.078-.162-.189-.346-.292-.519L19.166 8l1.982-3.302c.104-.173.214-.357.292-.519.08-.165.204-.459.17-.818a1.5 1.5 0 0 0-.605-1.07"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 13h15.587c.462 0 .694 0 .826-.097a.5.5 0 0 0 .202-.357c.015-.163-.104-.361-.342-.758l-2.026-3.376c-.09-.15-.135-.225-.152-.305a.5.5 0 0 1 0-.214c.017-.08.062-.155.152-.305l2.026-3.376c.238-.397.357-.595.342-.758a.5.5 0 0 0-.202-.357C20.28 3 20.049 3 19.587 3H4v18"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileShield/FileShieldIcon.tsx
const FileShieldIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8.759 1h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 5.29 21 5.954 21 6.758v4.844c0 .382 0 .573-.08.697a.5.5 0 0 1-.306.215c-.143.034-.323-.03-.683-.159l-.107-.038h-.001l-.001-.001a5.4 5.4 0 0 0-3.646 0l-2.186.782A3 3 0 0 0 12 15.923v2.502c0 1.2.393 2.209.901 3.017.391.621.587.932.574 1.097a.45.45 0 0 1-.2.362c-.133.099-.457.099-1.105.099H8.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242V6.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 1 7.954 1 8.758 1M7 9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m1-9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M21.337 14.981 19.15 14.2a3.4 3.4 0 0 0-2.3 0l-2.187.781a1 1 0 0 0-.663.942v2.502c0 1.539 1.056 2.69 1.86 3.36a9 9 0 0 0 1.71 1.117c.158.076.743.058.911-.025a9 9 0 0 0 1.66-1.093c.803-.67 1.859-1.82 1.859-3.359v-2.502a1 1 0 0 0-.663-.942"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14 11H8m2 4H8m8-8H8m12 3V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h3.7m5.5-1s3-1.43 3-3.575v-2.502l-2.188-.782a2.4 2.4 0 0 0-1.626 0L15 14.923v2.502C15 19.57 18 21 18 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FlashOff/FlashOffIcon.tsx
const FlashOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l4.354 4.354-3.345 4.014c-.154.185-.31.373-.424.538-.108.155-.304.462-.31.864a1.5 1.5 0 0 0 .557 1.19c.313.253.674.298.863.315.2.018.443.018.684.018h6.195l-.86 6.876a1 1 0 0 0 1.761.764l4.3-5.159 4.225 4.226a1 1 0 0 0 1.414-1.414z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m18.639 14.396 2.059-2.471c.154-.185.31-.373.424-.538.108-.155.304-.462.31-.864a1.5 1.5 0 0 0-.557-1.19c-.313-.253-.674-.298-.863-.315C19.812 9 19.57 9 19.328 9h-6.085zm-5.494-5.494.847-6.778a1 1 0 0 0-1.76-.764L9.218 4.976z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m8 8-3.907 4.688c-.348.418-.523.628-.525.804a.5.5 0 0 0 .185.397c.138.111.41.111.955.111H12l-1 8 5-6m-.35-6h3.642c.545 0 .817 0 .955.111a.5.5 0 0 1 .185.396c-.002.177-.177.387-.525.805L18.55 12.94m-7.977-8.027L13 2l-.6 4.798M21 21 3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FlipForward/FlipForwardIcon.tsx
const FlipForwardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.707 4.293a1 1 0 1 0-1.414 1.414L18.586 8H7.5a5.5 5.5 0 1 0 0 11H12a1 1 0 1 0 0-2H7.5a3.5 3.5 0 1 1 0-7h11.086l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 9H7.5a4.5 4.5 0 1 0 0 9H12m9-9-4-4m4 4-4 4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderCheck/FolderCheckIcon.tsx
const FolderCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231m6.117 8.152a1 1 0 0 0-1.414-1.414L11 14.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm7 7 2 2 4.5-4.5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderDownload/FolderDownloadIcon.tsx
const FolderDownloadIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231M12 10a1 1 0 0 1 1 1v3.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 14.586V11a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm7 7 3 3m0 0 3-3m-3 3v-6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderClosed/FolderClosedIcon.tsx
const FolderClosedIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 11a3 3 0 0 0-1.293.292l4 4.001A3 3 0 0 0 12 11m-3 3c0-.463.105-.902.292-1.293l4.001 4A3 3 0 0 1 9 14"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231M7 14a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm7.5 4.5 5 5M16 14a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderLock/FolderLockIcon.tsx
const FolderLockIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 11a.75.75 0 0 0-.75.75v.75h1.5v-.75A.75.75 0 0 0 12 11m-2.5 4.7c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h3.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218c-.107-.055-.247-.055-.527-.055h-3.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218c-.055.107-.055.247-.055.527z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231m-.84 7.695a2.75 2.75 0 1 1 5.5 0v.778c.203.024.43.074.658.19a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77 9 9 0 0 1-.017-.706v-.864c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874c.228-.116.456-.166.658-.19z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm8.1 10.5h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8.5 14.26 8.5 14.54 8.5 15.1v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109m3.65-4v-1.75a1.75 1.75 0 1 0-3.5 0v1.75z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Folder/FolderIcon.tsx
const FolderIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 6.162c0-.527 0-.982.03-1.357.033-.395.104-.788.297-1.167a3 3 0 0 1 1.311-1.31c.378-.194.772-.265 1.167-.297C4.18 2 4.635 2 5.161 2h3.986c.593-.002 1.115-.002 1.595.163a3 3 0 0 1 1.121.693c.363.355.596.822.86 1.354L13.618 6h3.623c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v4.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H6.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 17.71 1 17.046 1 16.242zM9.022 4c.79 0 .947.013 1.068.055a1 1 0 0 1 .374.23c.09.09.173.224.526.931l.392.784H3c0-.465.004-.783.024-1.032.022-.272.06-.372.085-.422a1 1 0 0 1 .437-.437c.05-.025.15-.063.422-.085C4.25 4.001 4.623 4 5.2 4z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderPlus/FolderPlusIcon.tsx
const FolderPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231M12 10a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm10 10v-6m-3 3h6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderMinus/FolderMinusIcon.tsx
const FolderMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231M9 13a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm7 7h6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderQuestion/FolderQuestionIcon.tsx
const FolderQuestionIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231m1.249 7.367a1.248 1.248 0 0 1 1.88 1.078v.002c0 .218-.177.52-.678.854a4.3 4.3 0 0 1-.88.443l-.009.003a1 1 0 0 0 .635 1.897l.137-.05a6.3 6.3 0 0 0 1.226-.63c.622-.414 1.57-1.237 1.57-2.517a3.248 3.248 0 0 0-6.313-1.082 1 1 0 0 0 1.886.664 1.25 1.25 0 0 1 .546-.662M12 16.75a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm7.85 4.752a2.249 2.249 0 0 1 4.37.75c0 1.499-2.249 2.248-2.249 2.248m.029 3h.01"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderShield/FolderShieldIcon.tsx
const FolderShieldIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12.86 15.749a7 7 0 0 1-.86.609 7 7 0 0 1-.86-.61c-.696-.58-1.14-1.217-1.14-1.823v-1.798l1.524-.545c.307-.11.644-.11.952 0l1.524.545v1.798c0 .606-.444 1.242-1.14 1.824"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231m5.246 6.426L13.15 9.7a3.4 3.4 0 0 0-2.3 0l-2.187.781a1 1 0 0 0-.663.942v2.502c0 1.539 1.056 2.69 1.86 3.36a9 9 0 0 0 1.71 1.117c.271.13.588.13.86 0 0 0 .153-.063.55-.3a9 9 0 0 0 1.16-.817c.804-.67 1.86-1.821 1.86-3.36v-2.502a1 1 0 0 0-.664-.942",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm10 10.5s3-1.43 3-3.575v-2.502l-2.188-.782a2.4 2.4 0 0 0-1.626 0L9 11.423v2.502c0 2.145 3 3.575 3 3.575"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderSearch/FolderSearchIcon.tsx
const FolderSearchIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.5 11a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231M7 13.5a4.5 4.5 0 1 1 8.31 2.396l.897.897a1 1 0 0 1-1.414 1.414l-.897-.897A4.5 4.5 0 0 1 7 13.5",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm13.5 10.5L14 16m1-2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FolderX/FolderXIcon.tsx
const FolderXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 6.162v10.08c0 .804 0 1.469.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-3.624l-.895-1.79c-.264-.53-.497-.998-.86-1.353a3 3 0 0 0-1.12-.693C10.262 2 9.74 2 9.146 2H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.379-.264.772-.296 1.167C1 5.18 1 5.635 1 6.162m9.09-2.107C9.97 4.013 9.813 4 9.022 4H5.2c-.577 0-.949.001-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3.004 5.218 3 5.535 3 6h8.382l-.392-.784c-.353-.707-.435-.84-.526-.93a1 1 0 0 0-.374-.231m-1.297 6.738a1 1 0 0 1 1.414 0L12 12.586l1.793-1.793a1 1 0 0 1 1.414 1.414L13.414 14l1.793 1.793a1 1 0 0 1-1.414 1.414L12 15.414l-1.793 1.793a1 1 0 0 1-1.414-1.414L10.586 14l-1.793-1.793a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7-1.116-2.231c-.32-.642-.481-.963-.72-1.198a2 2 0 0 0-.748-.462C10.1 3 9.74 3 9.022 3H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.52 2 5.08 2 6.2V7m0 0h15.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2zm7.5 4.5 5 5m0-5-5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyEuro/CurrencyEuroIcon.tsx
const CurrencyEuroIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M6.624 9A7.5 7.5 0 0 1 13.5 4.5c1.851 0 3.544.67 4.853 1.781a1 1 0 1 0 1.294-1.524A9.504 9.504 0 0 0 4.483 9H3a1 1 0 0 0 0 2h1.052a9.6 9.6 0 0 0 0 2H3a1 1 0 1 0 0 2h1.483a9.504 9.504 0 0 0 15.164 4.243 1 1 0 1 0-1.294-1.524A7.47 7.47 0 0 1 13.5 19.5 7.5 7.5 0 0 1 6.624 15H13a1 1 0 1 0 0-2H6.066a7.6 7.6 0 0 1 0-2H13a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 5.519a8.5 8.5 0 1 0 0 12.962M3 14h10M3 10h10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CurrencyPound/CurrencyPoundIcon.tsx
const CurrencyPoundIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M9.528 5.354c-.362.392-.643.995-.644 1.945.012.845.365 1.449.893 2.354l.04.069c.427.732.918 1.607 1.105 2.778H15a1 1 0 0 1 0 2h-4.057c-.225 1.945-1.068 3.54-1.88 4.673q-.123.17-.243.327h8.68a1 1 0 0 1 0 2h-11a1 1 0 0 1-.62-1.784l.001-.001.02-.017.091-.078c.082-.071.203-.181.351-.328.297-.294.696-.729 1.094-1.284.653-.91 1.278-2.104 1.488-3.508H6.5a1 1 0 1 1 0-2h2.384c-.155-.639-.45-1.18-.795-1.77l-.098-.167c-.486-.827-1.09-1.854-1.107-3.245v-.013c0-1.379.422-2.492 1.174-3.307.74-.802 1.722-1.23 2.706-1.403 1.906-.335 4.134.242 5.377 1.423a1 1 0 0 1-1.377 1.45c-.71-.674-2.265-1.147-3.654-.904-.665.117-1.208.385-1.582.79"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17.5 20.5h-11s3.5-2.759 3.5-7c0-2.828-2.086-3.839-2.116-6.195.002-4.664 5.617-4.416 7.568-2.562M6.5 13.5H15"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Globe/GlobeIcon.tsx
const GlobeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.51 2.076a1 1 0 0 1 1.415 0c4.1 4.1 4.1 10.748 0 14.849A10.45 10.45 0 0 1 13 19.893V21h4a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h4v-1.012a10.46 10.46 0 0 1-6.184-2.39l-1.448 1.448a1 1 0 0 1-1.414-1.414l3.94-3.94a7 7 0 1 1 1.414 1.414l-1.07 1.07A8.501 8.501 0 0 0 17.51 3.49a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m2.661 18.339 4.594-4.594M18.218 2.782A9.5 9.5 0 1 1 4.783 16.217M17 22H7m5 0v-3m5.5-9.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Funnel/FunnelIcon.tsx
const FunnelIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4.533 2h14.934c.528 0 .991 0 1.355.033.349.031.827.105 1.215.425a2 2 0 0 1 .725 1.621c-.02.503-.284.909-.494 1.19-.218.292-.526.637-.879 1.031l-5.736 6.411-.149.17-.002.002v.003a6 6 0 0 0-.002.225v5.385c.002.138.005.423-.095.69a1.5 1.5 0 0 1-.396.586c-.21.19-.477.294-.605.344l-.036.014-3.427 1.37c-.16.064-.335.135-.49.181a1.5 1.5 0 0 1-.756.05 1.5 1.5 0 0 1-.945-.64 1.5 1.5 0 0 1-.236-.721 6 6 0 0 1-.014-.522v-6.737c0-.12 0-.181-.002-.225v-.003l-.002-.003a6 6 0 0 0-.149-.169L2.641 6.334 2.61 6.3a17 17 0 0 1-.88-1.032c-.209-.28-.473-.686-.493-1.189a2 2 0 0 1 .725-1.621c.388-.32.866-.394 1.215-.425C3.542 2 4.005 2 4.533 2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3.386 5.667C2.63 4.822 2.25 4.399 2.237 4.04a1 1 0 0 1 .363-.811C2.877 3 3.444 3 4.578 3h14.843c1.134 0 1.702 0 1.979.229a1 1 0 0 1 .362.81c-.014.36-.392.783-1.148 1.628l-5.707 6.377c-.15.169-.226.253-.28.35a1 1 0 0 0-.103.27c-.024.108-.024.221-.024.447v5.347c0 .196 0 .294-.032.378a.5.5 0 0 1-.132.196c-.067.06-.158.096-.34.17l-3.4 1.36c-.367.146-.55.22-.698.189a.5.5 0 0 1-.315-.213c-.083-.126-.083-.324-.083-.72v-6.707c0-.226 0-.339-.024-.446a1 1 0 0 0-.104-.272c-.054-.096-.13-.18-.28-.349z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Glasses/GlassesIcon.tsx
const GlassesIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2.464 8.464a5 5 0 0 1 8.195 1.718 5 5 0 0 1 2.682 0 5 5 0 1 1-.338 1.99 3 3 0 0 0-2.006 0 5 5 0 1 1-8.533-3.707"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10 11.535a4.01 4.01 0 0 1 4 0M8.828 9.172a4 4 0 1 1-5.657 5.656 4 4 0 0 1 5.657-5.656m12 0a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Graduation/GraduationIcon.tsx
const GraduationIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M22.447 9.394a1 1 0 0 0 0-1.788L12.78 2.772a2 2 0 0 0-.502-.187 1.5 1.5 0 0 0-.554 0c-.216.04-.41.139-.502.187L1.553 7.606a1 1 0 0 0 0 1.788l9.73 4.879c.263.131.394.197.532.223a1 1 0 0 0 .37 0c.138-.026.27-.092.532-.223z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.997 14.165c0-.43 0-.644-.09-.773a.5.5 0 0 0-.337-.208c-.156-.023-.348.073-.732.265l-6.059 3.03c-.093.047-.286.146-.502.186a1.5 1.5 0 0 1-.554 0 2 2 0 0 1-.502-.186l-6.06-3.03c-.383-.192-.575-.288-.73-.265a.5.5 0 0 0-.337.208c-.09.13-.09.344-.09.773q0 .96-.004 1.922c-.001.276-.003.623.11.947a2 2 0 0 0 .461.747c.24.245.551.4.798.522q2.766 1.373 5.523 2.761c.203.102.458.23.74.284.243.045.493.045.737 0 .281-.053.536-.182.739-.284a883 883 0 0 1 5.523-2.761c.247-.123.558-.277.798-.522a2 2 0 0 0 .462-.747c.112-.324.11-.671.11-.947q-.004-.96-.004-1.922"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 10v6.011c0 .36 0 .539.055.697a1 1 0 0 0 .23.374c.118.12.278.2.6.36l5.4 2.7c.262.131.393.197.53.223q.186.034.37 0c.137-.026.268-.091.53-.223l5.4-2.7c.322-.16.482-.24.6-.36a1 1 0 0 0 .23-.374c.055-.158.055-.338.055-.697v-6.01M2 8.5l9.642-4.822c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 8.5l-9.642 4.821a1 1 0 0 1-.266.111.5.5 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Hand/HandIcon.tsx
const HandIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 3c-.405 0-.7.317-.7.667v7.222a1 1 0 1 1-2 0V4.778a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v9.444a1 1 0 1 1-2 0v-2.778a.684.684 0 0 0-.7-.666c-.405 0-.7.317-.7.666v2.223C4.5 17.698 7.84 21 12 21s7.5-3.302 7.5-7.333V8.11a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v2.778a1 1 0 1 1-2 0v-6.11a.684.684 0 0 0-.7-.667c-.405 0-.7.317-.7.667v6.11a1 1 0 1 1-2 0v-7.22A.684.684 0 0 0 12 3m2.336-.673A2.71 2.71 0 0 0 12 1c-.988 0-1.865.529-2.336 1.327A2.7 2.7 0 0 0 8.6 2.11c-1.472 0-2.7 1.175-2.7 2.667v4.09a2.7 2.7 0 0 0-.7-.09c-1.472 0-2.7 1.175-2.7 2.666v2.223C2.5 18.84 6.772 23 12 23s9.5-4.16 9.5-9.333V8.11c0-1.491-1.228-2.667-2.7-2.667q-.363.001-.7.091v-.757c0-1.492-1.228-2.667-2.7-2.667a2.7 2.7 0 0 0-1.064.216",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6.9 11.444v2.778m0-2.778V4.778c0-.92.761-1.667 1.7-1.667s1.7.746 1.7 1.667m-3.4 6.666c0-.92-.761-1.666-1.7-1.666s-1.7.746-1.7 1.666v2.223C3.5 18.269 7.306 22 12 22s8.5-3.731 8.5-8.333V8.11c0-.92-.761-1.667-1.7-1.667s-1.7.747-1.7 1.667m-6.8-3.333v6.11m0-6.11v-1.11C10.3 2.747 11.061 2 12 2s1.7.746 1.7 1.667v1.11m0 0v6.112m0-6.111c0-.92.761-1.667 1.7-1.667s1.7.746 1.7 1.667V8.11m0 0v2.778"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Heading/HeadingIcon.tsx
const HeadingIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4 3a1 1 0 0 0 0 2h1v14H4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H7v-6h10v6h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1V5h1a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2h1v6H7V5h1a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 4v16M18 4v16M8 4H4m14 8H6m2 8H4m16 0h-4m4-16h-4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/GoogleChrome/GoogleChromeIcon.tsx
const GoogleChromeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m7.376 10.095-2.75-4.612c-.22-.37-.33-.554-.355-.766-.02-.173.016-.39.09-.547.093-.193.236-.315.523-.559A10.96 10.96 0 0 1 12 1a10.99 10.99 0 0 1 9.138 4.874c.218.324.327.487.317.655a.53.53 0 0 1-.197.37C21.124 7 20.914 7 20.493 7H12a5 5 0 0 0-4.624 3.095M1 12c0-1.689.38-3.288 1.06-4.718.168-.353.252-.529.4-.606a.53.53 0 0 1 .419-.02c.156.063.263.244.478.604l4.238 7.108a5 5 0 0 0 5.011 2.596l-2.675 4.661c-.213.372-.32.559-.493.684-.14.102-.349.178-.522.19-.213.014-.39-.052-.741-.182C3.985 20.763 1 16.73 1 12m10.727 10.515A.32.32 0 0 0 12 23c6.075 0 11-4.925 11-11q0-.931-.15-1.82c-.062-.37-.092-.555-.21-.734a1.1 1.1 0 0 0-.424-.358C22.02 9 21.806 9 21.376 9H16c.628.836 1 1.874 1 3 0 .98-.282 1.893-.768 2.665z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 0h9.17M3.95 6.06 8.54 14m2.34 7.94L15.46 14M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Headphones/HeadphonesIcon.tsx
const HeadphonesIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10v6.5a3.5 3.5 0 1 1-7 0v-2a3.5 3.5 0 0 1 5-3.163V12a8 8 0 1 0-16 0v1.337A3.5 3.5 0 0 1 9 16.5v2a3.5 3.5 0 1 1-7 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 18v-6a9 9 0 1 0-18 0v6m2.5 3A2.5 2.5 0 0 1 3 18.5v-2a2.5 2.5 0 0 1 5 0v2A2.5 2.5 0 0 1 5.5 21m13 0a2.5 2.5 0 0 1-2.5-2.5v-2a2.5 2.5 0 0 1 5 0v2a2.5 2.5 0 0 1-2.5 2.5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/HardDrive/HardDriveIcon.tsx
const HardDriveIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.814 3c-.928 0-1.627-.001-2.264.219a4 4 0 0 0-1.495.923c-.481.472-.794 1.098-1.208 1.928-.633 1.267-1.292 2.524-1.917 3.797-.181.369-.272.553-.248.708a.5.5 0 0 0 .208.335c.129.09.337.09.753.09h18.714c.416 0 .624 0 .753-.09a.5.5 0 0 0 .208-.335c.024-.155-.067-.34-.248-.708-.625-1.273-1.283-2.53-1.917-3.797-.414-.83-.727-1.456-1.208-1.928a4 4 0 0 0-1.495-.923c-.637-.22-1.336-.22-2.264-.22z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M23 14.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 13 21.96 13 21.4 13H2.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C.999 13.76 1 14.04 1 14.6v.641c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 21 5.954 21 6.758 21h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01zM6 15a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M2.5 12h19M6 16h4M8.967 4h6.066c1.077 0 1.616 0 2.091.164a3 3 0 0 1 1.121.693c.36.352.6.833 1.082 1.796l2.166 4.334c.19.377.284.566.35.765q.09.263.128.54c.029.207.029.418.029.841V15.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 20 18.88 20 17.2 20H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.72 2 16.88 2 15.2v-2.067c0-.422 0-.634.029-.84q.038-.277.128-.541c.066-.199.16-.388.35-.766l2.166-4.333c.482-.963.723-1.444 1.082-1.796a3 3 0 0 1 1.12-.693C7.352 4 7.89 4 8.968 4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/HeadingSquare/HeadingSquareIcon.tsx
const HeadingSquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2M9 7a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0v-4h6v4a1 1 0 1 0 2 0V7a1 1 0 1 0-2 0v4H9z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 7v10m8-10v10m0-5H8m-.2 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/HeartHand/HeartHandIcon.tsx
const HeartHandIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M17.535 2.306c-.957-1.11-2.524-1.633-4.085-.888-1.815.866-2.609 2.946-1.84 4.773.388.92 1.436 2.596 2.127 3.67l.016.024c.117.182.235.364.35.514.13.17.295.35.53.497.332.206.732.314 1.122.3.277-.008.51-.082.708-.164.174-.073.368-.172.56-.27l.026-.014c1.135-.585 2.88-1.512 3.676-2.115 1.569-1.188 1.967-3.395.786-5.064-.993-1.405-2.593-1.746-3.976-1.263",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.709 15.893c0 .792-.523 1.46-1.245 1.685l.464-.022c.507 0 1-.16 1.405-.456l2.829-2.063a1.81 1.81 0 0 1 2.318.16 1.69 1.69 0 0 1 0 2.44l-2.427 2.361a4.73 4.73 0 0 1-2.393 1.246l-3.431.668a4.8 4.8 0 0 1-2.055-.048l-3.103-.754a4.8 4.8 0 0 0-1.134-.137c-.407 0-.61 0-.773-.058a1 1 0 0 1-.606-.606c-.058-.163-.058-.366-.058-.773v-3.429c0-.285 0-.428.037-.56a1 1 0 0 1 .157-.324c.081-.11.194-.199.419-.375l1.185-.93S11.263 13 12.348 13q.677 0 1.334.163l2.684.667c.79.196 1.343.901 1.343 1.71z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.474 13h.052c.21 0 .415 0 .59.012.19.013.415.043.65.14a2 2 0 0 1 1.082 1.083c.097.234.127.46.14.65.012.174.012.379.012.588v5.053c0 .21 0 .415-.012.59a2 2 0 0 1-.14.65 2 2 0 0 1-1.083 1.082c-.234.097-.46.127-.65.14-.174.012-.378.012-.589.012h-.052c-.21 0-.415 0-.59-.012a2 2 0 0 1-.65-.14 2 2 0 0 1-1.082-1.083 2 2 0 0 1-.14-.65C1 20.941 1 20.737 1 20.527v-5.054c0-.21 0-.414.012-.588a2 2 0 0 1 .14-.65 2 2 0 0 1 1.083-1.083 2 2 0 0 1 .65-.14C3.059 13 3.263 13 3.474 13",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 20.087h2.61q.512 0 1.009.122l2.758.67a4.3 4.3 0 0 0 1.826.042l3.05-.593a4.2 4.2 0 0 0 2.127-1.108l2.158-2.098a1.503 1.503 0 0 0 0-2.169 1.61 1.61 0 0 0-2.06-.143l-2.515 1.835a2.12 2.12 0 0 1-1.25.405h-2.427 1.545c.871 0 1.577-.687 1.577-1.534v-.307a1.54 1.54 0 0 0-1.194-1.487l-2.385-.58A5 5 0 0 0 11.643 13c-.965 0-2.711.799-2.711.799L6 15.025M2 14.6v5.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.11a1 1 0 0 0 .437-.436C6 21.24 6 20.96 6 20.4v-5.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.11-.494-.11-1.054-.11h-.8c-.56 0-.84 0-1.054.11a1 1 0 0 0-.437.437C2 13.76 2 14.04 2 14.6M17.191 3.592c-.596-1.249-1.972-1.91-3.31-1.272-1.339.639-1.909 2.153-1.348 3.483.346.821 1.338 2.417 2.045 3.516.261.406.392.609.583.728.164.102.369.157.561.15.225-.007.44-.118.87-.339 1.161-.598 2.818-1.484 3.529-2.022a2.66 2.66 0 0 0 .574-3.69c-.861-1.217-2.362-1.337-3.504-.554"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Grid/GridIcon.tsx
const GridIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4.568 2h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201C8.93 11 8.684 11 8.432 11H4.568c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C2 8.93 2 8.684 2 8.432V4.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C4.07 2 4.316 2 4.568 2m0 11h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201C8.93 22 8.684 22 8.432 22H4.568c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C2 19.93 2 19.684 2 19.432v-3.864c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C4.07 13 4.316 13 4.568 13m11-11h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C13 8.93 13 8.684 13 8.432V4.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C15.07 2 15.316 2 15.568 2m0 11h3.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v3.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C13 19.93 13 19.684 13 19.432v-3.864c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201c.208-.017.454-.017.706-.017",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 10 4.04 10 4.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 9.24 10 8.96 10 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 3 8.96 3 8.4 3m11 0h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 3.76 14 4.04 14 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 10 15.04 10 15.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 9.24 21 8.96 21 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3m0 11h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 14.76 14 15.04 14 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 14 19.96 14 19.4 14m-11 0H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 14.76 3 15.04 3 15.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 20.24 10 19.96 10 19.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 14 8.96 14 8.4 14"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Heart/HeartIcon.tsx
const HeartIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.993 3.717c-2.34-2.045-5.8-2.463-8.488-.167-2.907 2.483-3.329 6.666-1.03 9.624.872 1.123 2.575 2.81 4.212 4.354a185 185 0 0 0 4.138 3.775c.076.068.172.153.263.221.11.083.267.185.477.248.278.083.578.083.857 0 .21-.063.367-.165.476-.247a5 5 0 0 0 .28-.235c.814-.722 2.466-2.199 4.122-3.762 1.636-1.544 3.34-3.231 4.212-4.354 2.29-2.946 1.933-7.161-1.041-9.633-2.717-2.258-6.14-1.87-8.478.176",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11.993 5.136c-2-2.338-5.333-2.966-7.838-.826s-2.858 5.719-.89 8.25c1.635 2.105 6.585 6.544 8.207 7.98.182.162.272.242.378.274a.5.5 0 0 0 .286 0c.106-.032.197-.112.378-.273 1.623-1.437 6.573-5.876 8.208-7.98 1.967-2.532 1.658-6.133-.89-8.251s-5.84-1.512-7.839.826",
			clipRule: "evenodd"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/HeartCircle/HeartCircleIcon.tsx
const HeartCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M8.077 8.655c1.253-1.07 2.92-.756 3.92.413 1-1.169 2.645-1.472 3.919-.413s1.429 2.86.445 4.125c-.63.81-2.243 2.314-3.322 3.29-.358.325-.538.487-.752.552a1 1 0 0 1-.58 0c-.215-.065-.394-.227-.753-.552-1.078-.976-2.692-2.48-3.322-3.29-.984-1.265-.807-3.055.445-4.125",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M11.997 9.068c-1-1.169-2.667-1.483-3.92-.413-1.252 1.07-1.429 2.86-.445 4.125.63.81 2.244 2.314 3.322 3.29.359.325.538.487.753.552.184.056.395.056.58 0 .214-.065.393-.227.752-.552 1.079-.976 2.692-2.48 3.322-3.29.984-1.265.829-3.066-.445-4.125s-2.92-.756-3.92.413",
				clipRule: "evenodd"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Hearts/HeartsIcon.tsx
const HeartsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M16.992 10.546c-.845-2.2-2.991-3.75-5.659-3.255-2.95.547-4.883 3.228-4.48 6.145.144 1.043.597 2.715 1.061 4.279.472 1.588.98 3.144 1.263 3.995l.007.02c.032.097.073.218.117.324.054.126.139.294.29.453.2.212.46.362.743.43.214.05.402.04.538.023a5 5 0 0 0 .36-.064c.877-.18 2.48-.519 4.09-.904 1.588-.38 3.262-.823 4.238-1.22 2.713-1.105 4.129-4.115 3.076-6.965-.938-2.54-3.32-3.631-5.644-3.261",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M14.595 1.493c-2.46-1.133-4.914-.22-6.297 1.685-2.152-.958-4.766-.536-6.302 1.7C.297 7.35.826 10.613 3.172 12.391c.42.318 1.007.694 1.671 1.088-.419-3.897 2.214-7.429 6.125-8.155 2.805-.52 5.164.584 6.662 2.403a5.42 5.42 0 0 0-3.035-6.234"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.546 9.925c.373-.664.685-1.263.878-1.72.933-2.216.01-4.764-2.247-5.804s-4.524.038-5.518 2.12c-1.902-1.305-4.44-1.114-5.84.923-1.398 2.037-.96 4.698.957 6.15.87.659 2.59 1.63 4.21 2.494m8.311-2.338c-.422-2.268-2.352-3.927-4.781-3.476-2.43.451-4.001 2.643-3.673 5.025.264 1.914 1.72 6.404 2.283 8.095.077.23.116.346.192.427a.5.5 0 0 0 .248.143c.107.025.226 0 .465-.048 1.745-.358 6.362-1.342 8.152-2.07 2.227-.907 3.376-3.362 2.515-5.693s-3.226-3.171-5.4-2.403"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Help/HelpIcon.tsx
const HelpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m-1.093 7.271a2 2 0 0 1 3.013 1.727V10c0 .47-.365.958-1.055 1.418a6 6 0 0 1-1.262.634 1 1 0 0 0 .633 1.897l.169-.061a8 8 0 0 0 1.57-.806c.81-.54 1.944-1.55 1.945-3.081a4 4 0 0 0-7.773-1.333 1 1 0 0 0 1.886.664 2 2 0 0 1 .874-1.06M12 16a1 1 0 1 0 0 2h.01a1 1 0 0 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/HexagonAlt/HexagonAltIcon.tsx
const HexagonAltIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7.942 2h-.073c-.263-.001-.595-.002-.908.1a2 2 0 0 0-.728.43c-.242.222-.402.513-.53.744l-.034.063-4.111 7.4-.034.06c-.122.218-.276.493-.339.8a2 2 0 0 0 0 .806c.063.307.217.582.34.8l.033.06 4.11 7.4.036.063c.127.23.287.521.53.745.209.193.457.339.727.428.313.103.645.102.908.101h8.262c.264.001.595.002.908-.101.27-.09.519-.235.728-.428.242-.224.402-.514.53-.745l.034-.063 4.112-7.4.033-.06c.122-.218.276-.493.34-.8.054-.266.054-.54 0-.806-.064-.307-.218-.582-.34-.8l-.033-.06-4.112-7.4-.034-.063c-.128-.231-.288-.522-.53-.745a2 2 0 0 0-.728-.428c-.313-.103-.644-.102-.908-.101z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21.568 11.223c.157.284.236.425.267.575a1 1 0 0 1 0 .403c-.03.15-.11.292-.267.576l-4.111 7.4c-.167.3-.25.45-.368.558a1 1 0 0 1-.364.215c-.153.05-.324.05-.667.05H7.941c-.343 0-.514 0-.667-.05a1 1 0 0 1-.364-.215c-.118-.109-.201-.258-.368-.558l-4.11-7.4c-.158-.284-.237-.425-.268-.575a1 1 0 0 1 0-.403c.03-.15.11-.292.267-.576l4.111-7.4c.167-.3.25-.45.368-.558a1 1 0 0 1 .364-.215C7.427 3 7.598 3 7.941 3h8.117c.343 0 .514 0 .667.05a1 1 0 0 1 .364.215c.118.109.201.258.368.558z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Hexagon/HexagonIcon.tsx
const HexagonIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.597 1.185a2 2 0 0 1 .806 0c.307.063.582.217.8.34l.06.033 7.4 4.11.063.036c.23.127.521.287.745.53.193.209.339.457.428.727.103.313.102.645.101.908v8.262c.001.264.002.595-.101.908-.09.27-.235.519-.428.728-.224.242-.514.402-.745.53l-.063.034-7.4 4.112-.06.033c-.218.122-.493.276-.8.34-.266.054-.54.054-.806 0-.307-.064-.582-.218-.8-.34l-.06-.033-7.4-4.112-.063-.034c-.231-.128-.522-.288-.745-.53a2 2 0 0 1-.428-.728c-.103-.313-.102-.644-.101-.908V7.869c-.001-.263-.002-.595.1-.908a2 2 0 0 1 .43-.728c.222-.242.513-.402.744-.53l.063-.034 7.4-4.111.06-.034c.218-.122.493-.276.8-.339",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11.223 2.432c.284-.158.425-.237.575-.268a1 1 0 0 1 .403 0c.15.031.292.11.576.268l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.152.05.324.05.666v8.118c0 .342 0 .514-.05.666a1 1 0 0 1-.215.364c-.109.119-.258.202-.558.368l-7.4 4.111c-.284.158-.425.237-.575.267a1 1 0 0 1-.403 0c-.15-.03-.292-.11-.576-.267l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.058V7.941c0-.342 0-.514.05-.666a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Home/HomeIcon.tsx
const HomeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.477 1.336a2 2 0 0 1 1.046 0c.397.108.732.37.999.58 2.303 1.809 4.62 3.599 6.934 5.394.377.292.709.55.956.884.217.294.379.624.477.975.112.4.111.82.111 1.298-.003 2.457 0 4.914 0 7.372 0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.802.066-1.615.03-2.418.031-.12 0-.262 0-.387-.01a1.5 1.5 0 0 1-.571-.153 1.5 1.5 0 0 1-.656-.656 1.5 1.5 0 0 1-.153-.571 5 5 0 0 1-.01-.387l.008-5.596c0-.56.001-.841-.108-1.056a1 1 0 0 0-.437-.437c-.214-.11-.494-.11-1.055-.11h-2.8c-.56 0-.84 0-1.053.11a1 1 0 0 0-.437.436c-.109.213-.11.493-.11 1.052L9 20.223c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-.804 0-1.617.035-2.418-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.297-1.167C2 18.82 2 18.365 2 17.838q.002-3.686 0-7.371c0-.477-.001-.897.11-1.298a3 3 0 0 1 .478-.975c.247-.334.579-.592.956-.884 2.313-1.795 4.631-3.585 6.934-5.394.267-.21.602-.472 1-.58",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12.982 2.764c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0c-.194.052-.37.189-.721.462L4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 0 0-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C9 20.62 9 20.48 9 20.2v-6.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 12.76 15 13.04 15 13.6v6.6c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h2c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2 2 0 0 0-.318-.65c-.163-.22-.39-.397-.843-.75z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/INC/INCIcon.tsx
const INCIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.161 2h9.678c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V20h1a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h1V6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C6.18 2 6.635 2 7.161 2m.089 4a1 1 0 0 0 0 2H10a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2H10a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1H10a1 1 0 1 1 0 2H7.25a1 1 0 0 1-1-1M14 6a1 1 0 1 0 0 2h2.75a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h2.75a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h2.75a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7.5 7h2.75M7.5 11h2.75M7.5 15h2.75m3.5-8h2.75m-2.75 4h2.75m-2.75 4h2.75m3.5 6V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 3 17.92 3 16.8 3H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 4.52 4 5.08 4 6.2V21m18 0H2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Image/ImageIcon.tsx
const ImageIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8.5 5.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01a5 5 0 0 1-.154.943 3.3 3.3 0 0 1-.238.622 4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H6.893c-.27 0-.536 0-.75-.019l-.022-.002q-.195-.01-.374-.023c-.562-.046-1.079-.145-1.564-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2M20 7.8v4.786l-2.184-2.184a9 9 0 0 0-.511-.488 2 2 0 0 0-.687-.402 2 2 0 0 0-1.236 0c-.29.094-.512.254-.686.402-.16.135-.333.31-.512.488l-8.552 8.551c-.19.192-.379.38-.517.544-.042.051-.1.121-.158.21a2 2 0 0 1-.739-.799c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h8.4c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C20 6.361 20 6.943 20 7.8",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.2 21H6.931c-.605 0-.908 0-1.049-.12a.5.5 0 0 1-.173-.42c.014-.183.228-.397.657-.826l8.503-8.503c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L21 15v1.2M16.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2M16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Hourglass/HourglassIcon.tsx
const HourglassIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m15.414 12 1.35-1.35A11.05 11.05 0 0 0 20 2.837 1.837 1.837 0 0 0 18.163 1H5.837A1.837 1.837 0 0 0 4 2.837a11.05 11.05 0 0 0 3.236 7.813L8.586 12l-1.35 1.35A11.05 11.05 0 0 0 4 21.163C4 22.177 4.823 23 5.837 23h12.326A1.837 1.837 0 0 0 20 21.163a11.05 11.05 0 0 0-3.236-7.813zM13 10.999c.176 0 .264 0 .353-.016.135-.025.274-.083.387-.16.075-.052.137-.114.26-.237l1.35-1.35a9.05 9.05 0 0 0 2.473-4.619c.092-.458.138-.687.05-.944a1.1 1.1 0 0 0-.44-.535C17.2 3 16.923 3 16.37 3H7.63c-.552 0-.829 0-1.063.138a1.1 1.1 0 0 0-.44.535c-.088.257-.042.486.05.944a9.05 9.05 0 0 0 2.473 4.62L10 10.585c.122.122.183.183.257.234.114.079.254.137.39.162.089.016.176.016.35.016z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18.163 2H5.837A.837.837 0 0 0 5 2.837a10.05 10.05 0 0 0 2.943 7.106l1.22 1.22c.12.12.181.181.224.24a1 1 0 0 1 0 1.195 3 3 0 0 1-.224.24l-1.22 1.219A10.05 10.05 0 0 0 5 21.163c0 .462.375.837.837.837h12.326a.837.837 0 0 0 .837-.837 10.05 10.05 0 0 0-2.943-7.106l-1.22-1.22c-.12-.12-.181-.181-.224-.24a1 1 0 0 1 0-1.195c.043-.058.103-.118.224-.24l1.22-1.219A10.05 10.05 0 0 0 19 2.837.837.837 0 0 0 18.163 2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FlipBackward/FlipBackwardIcon.tsx
const FlipBackwardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7.707 5.707a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L5.414 10H16.5a3.5 3.5 0 1 1 0 7H12a1 1 0 1 0 0 2h4.5a5.5 5.5 0 1 0 0-11H5.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 9h13.5a4.5 4.5 0 1 1 0 9H12M3 9l4-4M3 9l4 4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImageCheck/ImageCheckIcon.tsx
const ImageCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M22.707 2.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L18 5.586l3.293-3.293a1 1 0 0 1 1.414 0M5.5 8.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.5 2H7.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392q.264.021.566.03c.209.014.46.014.717.014h10.107c.795 0 1.386 0 1.897-.136a4 4 0 0 0 2.829-2.829c.175-.654.136-1.355.136-2.026q.002-.284 0-.567c0-.47.001-.883-.108-1.277a3 3 0 0 0-.463-.964c-.24-.332-.563-.59-.93-.882l-2.83-2.265a9 9 0 0 0-.491-.374 2 2 0 0 0-.64-.303 2 2 0 0 0-1.114.035 2 2 0 0 0-.62.342 9 9 0 0 0-.466.405L5.83 18.894c-.213.194-.42.381-.571.546-.06.065-.153.168-.24.303a2 2 0 0 1-.801-.835c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h4.7a1 1 0 1 0 0-2",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 5 2 2 4-4m-9.5 0H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.396 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2 2 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImageIndentRight/ImageIndentRightIcon.tsx
const ImageIndentRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M3 3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2zm0 16a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zM2 9.25a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1m1 4.5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM14.568 7c-.252 0-.498 0-.706.017a2 2 0 0 0-.77.201 2 2 0 0 0-.874.874 2 2 0 0 0-.201.77C12 9.07 12 9.316 12 9.568v4.864c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h4.864c.252 0 .498 0 .706-.017a2 2 0 0 0 .77-.201 2 2 0 0 0 .874-.874 2 2 0 0 0 .201-.77c.017-.208.017-.454.017-.706V9.568c0-.252 0-.498-.017-.706a2 2 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2 2 0 0 0-.77-.201C19.93 7 19.684 7 19.432 7z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 16 14.04 16 14.6 16"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImageIndentLeft/ImageIndentLeftIcon.tsx
const ImageIndentLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M3 3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2zm12 5.25a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-1 6.5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1M3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zM4.568 7c-.252 0-.498 0-.706.017a2 2 0 0 0-.77.201 2 2 0 0 0-.874.874 2 2 0 0 0-.201.77C2 9.07 2 9.316 2 9.568v4.864c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h4.864c.252 0 .498 0 .706-.017a2 2 0 0 0 .77-.201 2 2 0 0 0 .874-.874 2 2 0 0 0 .201-.77c.017-.208.017-.454.017-.706V9.568c0-.252 0-.498-.017-.706a2 2 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2 2 0 0 0-.77-.201C9.93 7 9.684 7 9.432 7z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 9.25h-6M21 4H3m18 10.75h-6M21 20H3m1.6-4h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 15.24 11 14.96 11 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 8 9.96 8 9.4 8H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 8.76 3 9.04 3 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 16 4.04 16 4.6 16"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImageLeft/ImageLeftIcon.tsx
const ImageLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.5 8.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.5 2H7.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392q.264.021.566.03c.209.014.46.014.717.014h10.107c.795 0 1.386 0 1.897-.136a4 4 0 0 0 2.829-2.829c.175-.654.136-1.355.136-2.026q.002-.284 0-.567c0-.47.001-.883-.108-1.277a3 3 0 0 0-.463-.964c-.24-.332-.563-.59-.93-.882l-2.83-2.265a9 9 0 0 0-.491-.374 2 2 0 0 0-.64-.303 2 2 0 0 0-1.114.035 2 2 0 0 0-.62.342 9 9 0 0 0-.466.405L5.83 18.894c-.213.194-.42.381-.571.546-.06.065-.153.168-.24.303a2 2 0 0 1-.801-.835c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h4.7a1 1 0 1 0 0-2",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.707 2.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 1 0 1.414-1.414L18.414 6H22a1 1 0 1 0 0-2h-3.586z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m19 8-3-3m0 0 3-3m-3 3h6m-9.5-2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.396 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2 2 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImagePlus/ImagePlusIcon.tsx
const ImagePlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.5 8.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.5 2H7.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392q.264.021.566.03c.209.014.46.014.717.014h10.107c.795 0 1.386 0 1.897-.136a4 4 0 0 0 2.829-2.829c.175-.654.136-1.355.136-2.026q.002-.284 0-.567c0-.47.001-.883-.108-1.277a3 3 0 0 0-.463-.964c-.24-.332-.563-.59-.93-.882l-2.83-2.265a9 9 0 0 0-.491-.374 2 2 0 0 0-.64-.303 2 2 0 0 0-1.114.035 2 2 0 0 0-.62.342 9 9 0 0 0-.466.405L5.83 18.894c-.213.194-.42.381-.571.546-.06.065-.153.168-.24.303a2 2 0 0 1-.801-.835c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h4.7a1 1 0 1 0 0-2",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20 2a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V6h2a1 1 0 1 0 0-2h-2z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12.5 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.396 21 17.93 21 17m-2-9V2m-3 3h6M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2 2 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImageDown/ImageDownIcon.tsx
const ImageDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.5 8.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.5 2H7.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392q.264.021.566.03c.209.014.46.014.717.014h10.107c.795 0 1.386 0 1.897-.136a4 4 0 0 0 2.829-2.829c.175-.654.136-1.355.136-2.026q.002-.284 0-.567c0-.47.001-.883-.108-1.277a3 3 0 0 0-.463-.964c-.24-.332-.563-.59-.93-.882l-2.83-2.265a9 9 0 0 0-.491-.374 2 2 0 0 0-.64-.303 2 2 0 0 0-1.114.035 2 2 0 0 0-.62.342 9 9 0 0 0-.466.405L5.83 18.894c-.213.194-.42.381-.571.546-.06.065-.153.168-.24.303a2 2 0 0 1-.801-.835c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h4.7a1 1 0 1 0 0-2",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20 2a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L20 5.586z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 5 3 3m0 0 3-3m-3 3V2m-6.5 1H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.396 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2 2 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImageUp/ImageUpIcon.tsx
const ImageUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.5 8.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.5 2H7.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392q.264.021.566.03c.209.014.46.014.717.014h10.107c.795 0 1.386 0 1.897-.136a4 4 0 0 0 2.829-2.829c.175-.654.136-1.355.136-2.026q.002-.284 0-.567c0-.47.001-.883-.108-1.277a3 3 0 0 0-.463-.964c-.24-.332-.563-.59-.93-.882l-2.83-2.265a9 9 0 0 0-.491-.374 2 2 0 0 0-.64-.303 2 2 0 0 0-1.114.035 2 2 0 0 0-.62.342 9 9 0 0 0-.466.405L5.83 18.894c-.213.194-.42.381-.571.546-.06.065-.153.168-.24.303a2 2 0 0 1-.801-.835c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h4.7a1 1 0 1 0 0-2",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.707 1.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L18 4.414V8a1 1 0 1 0 2 0V4.414l1.293 1.293a1 1 0 1 0 1.414-1.414z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 5 3-3m0 0 3 3m-3-3v6m-6.5-5H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.396 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2 2 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImageRight/ImageRightIcon.tsx
const ImageRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.5 8.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.5 2H7.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392q.264.021.566.03c.209.014.46.014.717.014h10.107c.795 0 1.386 0 1.897-.136a4 4 0 0 0 2.829-2.829c.175-.654.136-1.355.136-2.026q.002-.284 0-.567c0-.47.001-.883-.108-1.277a3 3 0 0 0-.463-.964c-.24-.332-.563-.59-.93-.882l-2.83-2.265a9 9 0 0 0-.491-.374 2 2 0 0 0-.64-.303 2 2 0 0 0-1.114.035 2 2 0 0 0-.62.342 9 9 0 0 0-.466.405L5.83 18.894c-.213.194-.42.381-.571.546-.06.065-.153.168-.24.303a2 2 0 0 1-.801-.835c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h4.7a1 1 0 1 0 0-2",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.707 1.293a1 1 0 1 0-1.414 1.414L19.586 4H16a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m19 8 3-3m0 0-3-3m3 3h-6m-3.5-2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.396 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2 2 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/IndentLeft/IndentLeftIcon.tsx
const IndentLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4.852 2.139a8 8 0 0 0-.532-.377c-.16-.099-.463-.27-.851-.262a1.5 1.5 0 0 0-1.15.575c-.24.306-.285.651-.302.838C2 3.105 2 3.338 2 3.565v5.87c0 .227 0 .46.017.652.017.187.063.532.302.838a1.5 1.5 0 0 0 1.15.575c.388.008.691-.163.85-.262a7 7 0 0 0 .533-.377L8.77 7.923c.125-.093.266-.199.379-.3.124-.112.307-.299.417-.58a1.5 1.5 0 0 0 0-1.087 1.5 1.5 0 0 0-.417-.579 6 6 0 0 0-.379-.3zM12 3a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm0 5.25a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm-10 6.5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 9.25h-9M21 4H3m18 10.75h-9M21 20H3M4.28 8.56l3.867 2.9c.29.217.434.326.486.459a.5.5 0 0 1 0 .362c-.052.133-.197.242-.486.459l-3.867 2.9c-.412.309-.618.463-.79.46a.5.5 0 0 1-.384-.192C3 15.773 3 15.515 3 15V9.2c0-.515 0-.772.106-.908A.5.5 0 0 1 3.49 8.1c.172-.003.378.151.79.46"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Infinity/InfinityIcon.tsx
const InfinityIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.439 7c-1.475 0-2.622.66-3.374 1.643C1.335 9.599 1 10.824 1 12s.335 2.401 1.065 3.357C2.817 16.341 3.964 17 5.44 17c2.87 0 4.903-1.794 6.56-3.534C13.658 15.206 15.693 17 18.562 17c1.475 0 2.622-.66 3.374-1.643C22.665 14.401 23 13.176 23 12s-.335-2.401-1.065-3.357C21.183 7.659 20.035 7 18.56 7c-2.87 0-4.904 1.794-6.561 3.534C10.342 8.794 8.308 7 5.439 7m0 8c-.818 0-1.39-.34-1.785-.857C3.24 13.599 3 12.824 3 12s.239-1.599.654-2.143C4.05 9.341 4.621 9 5.44 9c2.04 0 3.547 1.273 5.192 3-1.645 1.727-3.153 3-5.192 3m13.122 0c.818 0 1.39-.34 1.785-.857.415-.544.654-1.319.654-2.143s-.239-1.599-.654-2.143C19.95 9.341 19.379 9 18.56 9c-2.04 0-3.548 1.273-5.192 3 1.644 1.727 3.153 3 5.192 3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.74-8-4.584 0-4.584 8 0 8 5.607 0 7.645-8 12.74-8"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/IndentRight/IndentRightIcon.tsx
const IndentRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M20.531 1.5c-.388-.008-.691.163-.85.262-.165.1-.352.24-.533.377L15.23 5.077a6 6 0 0 0-.379.3 1.5 1.5 0 0 0-.417.58 1.5 1.5 0 0 0 0 1.087c.11.28.293.467.417.579.113.101.254.207.379.3l3.917 2.938c.181.136.368.276.532.377.16.099.463.27.851.262a1.5 1.5 0 0 0 1.15-.575c.24-.306.284-.651.302-.838.017-.192.017-.425.017-.652v-5.87c0-.227 0-.46-.017-.652-.018-.187-.063-.532-.302-.838a1.5 1.5 0 0 0-1.15-.575M3 3a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm0 5.25a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm-1 6.5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 9.25H3M12 4H3m18 10.75H3M21 20H3M19.72 2.96l-3.867 2.9c-.29.217-.434.326-.486.459a.5.5 0 0 0 0 .362c.052.133.197.242.486.459l3.867 2.9c.412.309.618.463.79.46a.5.5 0 0 0 .384-.192C21 10.172 21 9.915 21 9.4V3.6c0-.515 0-.773-.106-.908a.5.5 0 0 0-.384-.192c-.172-.004-.378.151-.79.46"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Gift/GiftIcon.tsx
const GiftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.67 5a3.03 3.03 0 0 1 .692-3.115A2.95 2.95 0 0 1 8.464 1C10.26 1 11.373 2.218 12 3.272 12.627 2.218 13.741 1 15.536 1c.792 0 1.548.32 2.102.885A3.02 3.02 0 0 1 18.33 5h2.197c.21 0 .414 0 .588.012.19.013.416.043.65.14a2 2 0 0 1 1.083 1.083c.097.234.127.46.14.65.012.174.012.378.012.588v.054c0 .21 0 .414-.012.588a2 2 0 0 1-.14.65 2 2 0 0 1-1.083 1.083 2 2 0 0 1-.65.14c-.174.012-.378.012-.588.012H3.473c-.21 0-.415 0-.59-.012a2 2 0 0 1-.65-.14 2 2 0 0 1-1.082-1.083 2 2 0 0 1-.14-.65C1 7.941 1 7.737 1 7.527v-.054c0-.21 0-.414.012-.588.013-.19.043-.416.14-.65a2 2 0 0 1 1.083-1.083c.234-.097.46-.127.65-.14A9 9 0 0 1 3.474 5zm2.794-2c-.25 0-.493.1-.675.286A1.02 1.02 0 0 0 7.5 4c0 .271.106.527.289.714A.95.95 0 0 0 8.464 5h2.17a6 6 0 0 0-.25-.525C9.898 3.575 9.274 3 8.464 3m4.902 2c.072-.171.155-.349.25-.525.486-.9 1.11-1.475 1.92-1.475.25 0 .493.1.675.286.183.187.289.443.289.714s-.106.527-.289.714a.95.95 0 0 1-.675.286z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M3 13a1 1 0 0 1 1-1h6.2c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v9.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C10.62 23 10.48 23 10.2 23H7.161c-.527 0-.982 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C3 19.82 3 19.365 3 18.838zm15.195 9.97c-.375.03-.83.03-1.357.03H13.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C13 22.62 13 22.48 13 22.2v-9.4c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C13.38 12 13.52 12 13.8 12H20a1 1 0 0 1 1 1v5.839c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 6v16m0-16H8.464c-.52 0-1.02-.21-1.389-.586A2.02 2.02 0 0 1 6.5 4c0-.53.207-1.04.575-1.414A1.95 1.95 0 0 1 8.465 2C11.214 2 12 6 12 6m0 0h3.536c.52 0 1.02-.21 1.389-.586.368-.375.575-.884.575-1.414s-.207-1.04-.575-1.414A1.95 1.95 0 0 0 15.535 2C12.786 2 12 6 12 6m8 5v7.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 22 17.92 22 16.8 22H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 20.48 4 19.92 4 18.8V11M2 7.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 11 3.04 11 3.6 11h16.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 10.24 22 9.96 22 9.4V7.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 6 20.96 6 20.4 6H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 6.76 2 7.04 2 7.6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Info/InfoIcon.tsx
const InfoIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m0 6a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm1 5a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/IntersectCircle/IntersectCircleIcon.tsx
const IntersectCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M1 9a8 8 0 0 1 15.797-1.797 8 8 0 0 0-9.595 9.595A8 8 0 0 1 1 9"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7.203 16.797a8 8 0 0 0 9.595-9.595 8 8 0 1 1-9.595 9.595"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M15 22a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Italic/ItalicIcon.tsx
const ItalicIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15.031 3H19a1 1 0 1 1 0 2h-3.307l-5.25 14H14a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h3.307l5.25-14H10a1 1 0 0 1 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 4h-9m4 16H5M15 4 9 20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Input/InputIcon.tsx
const InputIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M16 4h-1.5a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2H18v2h.838c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.357v3.676c0 .528 0 .982-.03 1.357-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H18v2h1.5a1 1 0 1 1 0 2h-5a1 1 0 1 1 0-2H16z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.161 6H13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5.161c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 14.82 1 14.365 1 13.839v-3.677c0-.528 0-.982.03-1.357.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 6 4.635 6 5.161 6"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 8.52 2 9.08 2 10.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 17 4.08 17 5.2 17H13m4-10h1.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 8.52 22 9.08 22 10.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 17 19.92 17 18.8 17H17m0 4V3m2.5 0h-5m5 18h-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ImageX/ImageXIcon.tsx
const ImageXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.5 8.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.5 2H7.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392q.264.021.566.03c.209.014.46.014.717.014h10.107c.795 0 1.386 0 1.897-.136a4 4 0 0 0 2.829-2.829c.175-.654.136-1.355.136-2.026q.002-.284 0-.567c0-.47.001-.883-.108-1.277a3 3 0 0 0-.463-.964c-.24-.332-.563-.59-.93-.882l-2.83-2.265a9 9 0 0 0-.491-.374 2 2 0 0 0-.64-.303 2 2 0 0 0-1.114.035 2 2 0 0 0-.62.342 9 9 0 0 0-.466.405L5.83 18.894c-.213.194-.42.381-.571.546-.06.065-.153.168-.24.303a2 2 0 0 1-.801-.835c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4h4.7a1 1 0 1 0 0-2",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.207 1.793a1 1 0 1 0-1.414 1.414L17.586 5l-1.793 1.793a1 1 0 0 0 1.414 1.414L19 6.414l1.793 1.793a1 1 0 1 0 1.414-1.414L20.414 5l1.793-1.793a1 1 0 0 0-1.414-1.414L19 3.586z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16.5 2.5 5 5m0-5-5 5m-4-4.5H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21H17c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.396 21 17.93 21 17M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4.49 3.418-8.459 7.69c-.476.433-.714.649-.735.836a.5.5 0 0 0 .167.431C6.105 21 6.426 21 7.07 21h9.387c1.44 0 2.159 0 2.724-.242a3 3 0 0 0 1.578-1.578c.242-.565.242-1.285.242-2.724 0-.484 0-.726-.053-.952a2 2 0 0 0-.374-.778c-.143-.182-.332-.333-.71-.636l-2.797-2.237c-.379-.303-.568-.454-.776-.508a1 1 0 0 0-.557.018c-.205.066-.384.23-.743.555"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ItalicSquare/ItalicSquareIcon.tsx
const ItalicSquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2m7.17 5.371a1 1 0 0 0-1.857-.743l-4 10a1 1 0 0 0 1.857.743z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m14 7-4 10m-2.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LLC/LLCIcon.tsx
const LLCIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6.161 2H17.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V7c0 .926-.997 2-2.667 2s-2.666-1.074-2.666-2a1 1 0 1 0-2 0c0 .926-.997 2-2.667 2S9.333 7.926 9.333 7a1 1 0 1 0-2 0c0 .926-.997 2-2.666 2S2 7.926 2 7v-.839c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C5.18 2 5.635 2 6.161 2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M19.333 11A5.3 5.3 0 0 0 22 10.282v7.557c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H6.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A18 18 0 0 1 2 17.839v-7.557A5.3 5.3 0 0 0 4.667 11c1.405 0 2.778-.562 3.666-1.514C9.222 10.438 10.595 11 12 11s2.778-.562 3.667-1.514c.888.952 2.26 1.514 3.666 1.514M10.6 14h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 14.76 15 15.04 15 15.6V20H9v-4.4c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 14 10.04 14 10.6 14",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 21v-5.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 14 13.96 14 13.4 14h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 14.76 9 15.04 9 15.6V21M3 7a3 3 0 0 0 6 0 3 3 0 1 0 6 0 3 3 0 1 0 6 0M6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Key/KeyIcon.tsx
const KeyIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15 2a7 7 0 0 0-6.937 7.94 15 15 0 0 1 .063.514l-.01.01a9 9 0 0 1-.244.25l-5.11 5.11-.036.036a2.8 2.8 0 0 0-.431.51c-.11.178-.19.373-.24.577a2.8 2.8 0 0 0-.055.665v1.82c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.272.138.541.182.77.201.208.017.454.017.706.017H7a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 .707-.293l1.58-1.579a7 7 0 0 1 .25-.245l.01-.008.044.003c.103.01.244.029.469.06q.463.061.94.062a7 7 0 1 0 0-14m0 6a1 1 0 0 1 .707.293c.196.195.293.45.293.707a1 1 0 0 0 2 0c0-.766-.293-1.536-.878-2.122A3 3 0 0 0 15 6a1 1 0 0 0 0 2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 9a2 2 0 0 0-.586-1.414A2 2 0 0 0 15 7m0 8a6 6 0 1 0-5.946-5.193c.058.434.087.651.068.789a.85.85 0 0 1-.117.346c-.068.121-.187.24-.426.479l-5.11 5.11c-.173.173-.26.26-.322.36a1 1 0 0 0-.12.29C3 17.296 3 17.418 3 17.663V19.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H7v-2h2v-2h2l1.58-1.58c.238-.238.357-.357.478-.425a.85.85 0 0 1 .346-.117c.138-.02.355.01.789.068Q14.589 15 15 15"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Keyboard/KeyboardIcon.tsx
const KeyboardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18.839 5H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 8.18 1 8.635 1 9.161v5.678c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H18.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V9.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 18.838 5M5 10a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m2 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m3-5a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2zm1 5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1m3-5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm1 5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1m3-5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 10h.01M8 14h.01M10 10h.01M12 14h.01M14 10h.01M16 14h.01M18 10h.01M5.2 18h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V9.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 6 19.92 6 18.8 6H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 7.52 2 8.08 2 9.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 18 4.08 18 5.2 18"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Laptop/LaptopIcon.tsx
const LaptopIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M6.161 3h11.677c.528 0 .982 0 1.357.03.395.033.788.104 1.167.297a3 3 0 0 1 1.31 1.311c.194.378.265.772.297 1.167.03.375.03.83.03 1.356V13.4c0 .56 0 .84-.108 1.054a1 1 0 0 1-.437.437C21.24 15 20.96 15 20.4 15h-4.788c-.19 0-.43-.001-.665.055a2 2 0 0 0-.578.24c-.206.126-.375.296-.509.43a.94.94 0 0 1-.669.273H10.81a.94.94 0 0 1-.67-.273 2.8 2.8 0 0 0-.508-.43 2 2 0 0 0-.578-.24A2.8 2.8 0 0 0 8.388 15H3.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437c-.11-.214-.11-.494-.11-1.054V7.16c0-.527 0-.981.031-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.31-1.311c.38-.193.773-.264 1.168-.296C5.179 3 5.635 3 6.16 3M2.534 17c-.542 0-.813 0-1.043.13a1.1 1.1 0 0 0-.44.511c-.095.247-.062.461.002.89q.02.136.049.245a3 3 0 0 0 2.121 2.122C3.61 21 4.047 21 4.555 21h14.89c.508 0 .946.001 1.331-.102a3 3 0 0 0 2.122-2.122q.028-.11.048-.244c.064-.43.096-.646.001-.892a1.1 1.1 0 0 0-.44-.51c-.23-.13-.501-.13-1.044-.129l-5.667.004a.92.92 0 0 0-.656.27c-.134.134-.303.304-.51.43a2 2 0 0 1-.577.24c-.236.056-.475.055-.665.055h-2.776c-.19 0-.43.001-.665-.055q-.308-.075-.578-.24c-.206-.126-.375-.296-.509-.43a.94.94 0 0 0-.669-.273z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 16V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 4 5.08 4 6.2 4h11.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 5.52 21 6.08 21 7.2V16h-5.337c-.245 0-.367 0-.482.028a1 1 0 0 0-.29.12c-.1.061-.187.148-.36.32l-.062.063c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12c-.115.027-.237.027-.482.027h-2.674c-.245 0-.367 0-.482-.028a1 1 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32l-.062-.063c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C8.704 16 8.582 16 8.337 16zm0 0a1 1 0 0 0-1 1v.333c0 .62 0 .93.068 1.185a2 2 0 0 0 1.414 1.414c.255.068.565.068 1.185.068h14.666c.62 0 .93 0 1.185-.068a2 2 0 0 0 1.414-1.414c.068-.255.068-.565.068-1.185 0-.31 0-.465-.034-.592a1 1 0 0 0-.707-.707C21.132 16 20.977 16 20.667 16H20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayersThreeAlt/LayersThreeAltIcon.tsx
const LayersThreeAltIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.723 1.085a1.5 1.5 0 0 1 .554 0 1.9 1.9 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014a2 2 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0 2 2 0 0 1-.502-.186l-.026-.013-9.642-4.822a1 1 0 0 1 0-1.788l9.642-4.821.026-.013a2 2 0 0 1 .502-.187",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m2.528 10.618-.975.487a1 1 0 0 0 0 1.79l9.642 4.82.026.014c.093.047.286.146.502.186a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.186l.026-.014 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.887-.011.005a6 6 0 0 1-.29.138 3.5 3.5 0 0 1-2.043.233 3.5 3.5 0 0 1-.754-.233 6 6 0 0 1-.289-.138l-.011-.005z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m2.528 15.618-.975.487a1 1 0 0 0 0 1.79l9.642 4.82.026.014c.093.047.286.146.502.186a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.186l.026-.014 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.886-.011.006c-.05.025-.17.085-.29.137a3.5 3.5 0 0 1-2.043.234 3.5 3.5 0 0 1-.754-.234 6 6 0 0 1-.289-.137l-.011-.006z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 9.5 2 12l9.642 4.821c.131.066.197.098.266.111q.091.018.184 0c.069-.012.135-.045.266-.11L22 12l-5-2.5m-10 5L2 17l9.642 4.821c.131.066.197.098.266.111q.091.018.184 0c.069-.012.135-.045.266-.11L22 17l-5-2.5M2 7l9.642-4.821c.131-.066.197-.099.266-.111a.5.5 0 0 1 .184 0c.069.012.135.045.266.11L22 7l-9.642 4.821a1 1 0 0 1-.266.111.5.5 0 0 1-.184 0 1 1 0 0 1-.266-.11z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayersThree/LayersThreeIcon.tsx
const LayersThreeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1.106 11.553a1 1 0 0 1 1.341-.447L12 15.882l9.553-4.776a1 1 0 0 1 .894 1.789l-9.642 4.82-.026.014a2 2 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0 2 2 0 0 1-.502-.186l-.026-.013-9.642-4.821a1 1 0 0 1-.447-1.342",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1.106 16.553a1 1 0 0 1 1.341-.447L12 20.882l9.553-4.776a1 1 0 0 1 .894 1.788l-9.642 4.822-.026.013a2 2 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0 2 2 0 0 1-.502-.186l-.026-.013-9.642-4.821a1 1 0 0 1-.447-1.342M11.723 1.085a1.5 1.5 0 0 1 .554 0 1.9 1.9 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014a2 2 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0 2 2 0 0 1-.502-.186l-.026-.013-9.642-4.822a1 1 0 0 1 0-1.788l9.642-4.821.026-.013a2 2 0 0 1 .502-.187",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m2 12 9.642 4.821c.131.066.197.098.266.111q.091.018.184 0c.069-.012.135-.045.266-.11L22 12M2 17l9.642 4.821c.131.066.197.098.266.111q.091.018.184 0c.069-.012.135-.045.266-.11L22 17M2 7l9.642-4.821c.131-.066.197-.099.266-.111a.5.5 0 0 1 .184 0c.069.012.135.045.266.11L22 7l-9.642 4.821a1 1 0 0 1-.266.111.5.5 0 0 1-.184 0 1 1 0 0 1-.266-.11z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayerSingle/LayerSingleIcon.tsx
const LayerSingleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.723 6.085a1.5 1.5 0 0 1 .554 0 1.9 1.9 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014a2 2 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0 2 2 0 0 1-.502-.186l-.026-.013-9.642-4.821a1 1 0 0 1 0-1.79l9.642-4.82.026-.013a2 2 0 0 1 .502-.187",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12.358 7.179a1 1 0 0 0-.266-.111.5.5 0 0 0-.184 0 1 1 0 0 0-.266.11L2 12l9.642 4.821c.131.066.197.098.266.111q.091.018.184 0c.069-.012.135-.045.266-.11L22 12z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutAlt01/LayoutAlt01Icon.tsx
const LayoutAlt01Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 8 3.04 8 3.6 8h16.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 7.24 22 6.96 22 6.4v-.239c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M22 11.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 10 20.96 10 20.4 10h-8.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 10.76 10 11.04 10 11.6v8.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 22 11.04 22 11.6 22h6.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356zM6.4 22c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 21.24 8 20.96 8 20.4v-8.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 10 6.96 10 6.4 10H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.76 2 11.04 2 11.6v6.239c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 9h18M9 9v12M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutAlt02/LayoutAlt02Icon.tsx
const LayoutAlt02Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 2 6.96 2 6.4 2h-.239c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H6.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 21.24 8 20.96 8 20.4z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M10 20.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 22 11.04 22 11.6 22h6.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.839 2H11.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 2.76 10 3.04 10 3.6zM12 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17.5 11h-5m5 4h-5m5-8h-5M9 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutAlt03/LayoutAlt03Icon.tsx
const LayoutAlt03Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161c0 .464.375.839.839.839H21.16a.84.84 0 0 0 .84-.839c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M22 10.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 9 20.96 9 20.4 9H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v7.239c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356zM5.5 13a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17.5 17h-11m11-4h-11M3 9h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayersTwoAlt/LayersTwoAltIcon.tsx
const LayersTwoAltIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.723 3.576a1.5 1.5 0 0 1 .554 0 1.9 1.9 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014a2 2 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0 1.9 1.9 0 0 1-.528-.2l-9.642-4.82a1 1 0 0 1 0-1.79l9.642-4.82.026-.013a2 2 0 0 1 .502-.187",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m2.528 13.109-.975.488a1 1 0 0 0 0 1.788l9.642 4.821.026.013c.093.048.286.147.502.187a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.187l.026-.013 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.887-.011.005c-.05.025-.17.085-.29.137a3.5 3.5 0 0 1-2.043.234 3.5 3.5 0 0 1-.754-.233 6 6 0 0 1-.289-.138l-.011-.006z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m7 12-5 2.5 9.642 4.821c.131.066.197.098.266.111q.091.018.184 0c.069-.012.135-.045.266-.11L22 14.5 17 12M2 9.5l9.642-4.821c.131-.066.197-.099.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 9.5l-9.642 4.821a1 1 0 0 1-.266.111.5.5 0 0 1-.184 0 1 1 0 0 1-.266-.11z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/IntersectSquare/IntersectSquareIcon.tsx
const IntersectSquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5.161 1h7.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V7h-5.838c-.528 0-.982 0-1.357.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C7 10.18 7 10.635 7 11.161V17H5.161c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 13.82 1 13.365 1 12.839V5.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 1 4.635 1 5.161 1M7 17h5.839c.527 0 .981 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V7h1.838c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.357v7.677c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031h-7.677c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A18 18 0 0 1 7 18.838z"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 3.52 16 4.08 16 5.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 16 13.92 16 12.8 16H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 14.48 2 13.92 2 12.8z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M8 11.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 8 10.08 8 11.2 8h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 9.52 22 10.08 22 11.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 22 19.92 22 18.8 22h-7.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C8 20.48 8 19.92 8 18.8z"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutBottom/LayoutBottomIcon.tsx
const LayoutBottomIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V12.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 14 3.04 14 3.6 14h16.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 13.24 22 12.96 22 12.4V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M22 17.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 16 20.96 16 20.4 16H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 16.76 2 17.04 2 17.6v.238c0 .528 0 .982.03 1.357.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 15h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutGrid02/LayoutGrid02Icon.tsx
const LayoutGrid02Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 2 9.96 2 9.4 2H6.161c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161c0 .315 0 .473.035.602a1 1 0 0 0 .702.702c.13.035.287.035.602.035H9.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 6.74 11 6.46 11 5.9zM3.6 9.5c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.26 2 10.54 2 11.1v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h5.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 13.74 11 13.46 11 12.9v-1.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 9.5 9.96 9.5 9.4 9.5zm-.261 7c-.315 0-.473 0-.602.035a1 1 0 0 0-.702.702C2 17.367 2 17.524 2 17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H9.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 21.24 11 20.96 11 20.4v-2.3c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 16.5 9.96 16.5 9.4 16.5zM13 20.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 22 14.04 22 14.6 22h3.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356 0-.315 0-.473-.035-.602a1 1 0 0 0-.702-.702c-.13-.035-.287-.035-.602-.035H14.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 17.26 13 17.54 13 18.1zm7.4-5.9c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 13.74 22 13.46 22 12.9v-1.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 9.5 20.96 9.5 20.4 9.5h-5.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 10.26 13 10.54 13 11.1v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109zM22 6.161c0 .315 0 .473-.035.602a1 1 0 0 1-.702.702c-.13.035-.287.035-.602.035H14.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C13 6.74 13 6.46 13 5.9V3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C13.76 2 14.04 2 14.6 2h3.239c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 9h18M3 15h18M12 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutRight/LayoutRightIcon.tsx
const LayoutRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 2 12.96 2 12.4 2H6.161c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H12.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 21.24 14 20.96 14 20.4zm2 16.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C16.76 22 17.04 22 17.6 22h.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.839 2H17.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C16 2.76 16 3.04 16 3.6z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutGrid01/LayoutGrid01Icon.tsx
const LayoutGrid01Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 2 9.96 2 9.4 2H6.161c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V9.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 11 3.04 11 3.6 11h5.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 10.24 11 9.96 11 9.4zM3.6 13c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.76 2 14.04 2 14.6v3.239c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H9.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 21.24 11 20.96 11 20.4v-5.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 13 9.96 13 9.4 13zm9.4 7.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 22 14.04 22 14.6 22h3.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V14.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 13 20.96 13 20.4 13h-5.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 13.76 13 14.04 13 14.6zm9-11c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C21.24 11 20.96 11 20.4 11h-5.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C13 10.24 13 9.96 13 9.4V3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C13.76 2 14.04 2 14.6 2h3.239c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 12h18m-9-9v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutLeft/LayoutLeftIcon.tsx
const LayoutLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 2 6.96 2 6.4 2h-.239c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H6.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 21.24 8 20.96 8 20.4zm2 16.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 22 11.04 22 11.6 22h6.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.839 2H11.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 2.76 10 3.04 10 3.6z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayersTwo/LayersTwoIcon.tsx
const LayersTwoIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.723 3.576a1.5 1.5 0 0 1 .554 0 1.9 1.9 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014a2 2 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0 1.9 1.9 0 0 1-.528-.2l-9.642-4.82a1 1 0 0 1 0-1.79l9.642-4.82.026-.013a2 2 0 0 1 .502-.187",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m2.528 13.109-.975.488a1 1 0 0 0 0 1.788l9.642 4.821.026.013c.093.048.286.147.502.187a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.187l.026-.013 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.887-.011.005c-.05.025-.17.085-.29.137a3.5 3.5 0 0 1-2.043.234 3.5 3.5 0 0 1-.754-.233 6 6 0 0 1-.289-.138l-.011-.006z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m2 14.5 9.642 4.821c.131.066.197.098.266.111q.091.018.184 0c.069-.012.135-.045.266-.11L22 14.5m-20-5 9.642-4.821c.131-.066.197-.099.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 9.5l-9.642 4.821a1 1 0 0 1-.266.111.5.5 0 0 1-.184 0 1 1 0 0 1-.266-.11z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutAlt04/LayoutAlt04Icon.tsx
const LayoutAlt04Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 2 9.96 2 9.4 2H6.161c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V17.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H9.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 21.24 11 20.96 11 20.4zm2 16.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 22 14.04 22 14.6 22h3.239c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V14.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 13 20.96 13 20.4 13h-5.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 13.76 13 14.04 13 14.6zm7.4-9.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 10.24 22 9.96 22 9.4V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.839 2H14.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 2.76 13 3.04 13 3.6v5.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 11 14.04 11 14.6 11z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 12h9m-9-9v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LayoutTop/LayoutTopIcon.tsx
const LayoutTopIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 8 3.04 8 3.6 8h16.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C22 7.24 22 6.96 22 6.4v-.239c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2M22 11.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.24 10 20.96 10 20.4 10H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.76 2 11.04 2 11.6v6.239c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 9h18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LightningCircle/LightningCircleIcon.tsx
const LightningCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M7.362 12.247 12 5.5v5h3.98c.492 0 .738 0 .873.102a.5.5 0 0 1 .196.373c.008.169-.131.372-.41.778L12 18.5v-5H8.02c-.492 0-.739 0-.873-.102a.5.5 0 0 1-.196-.373c-.008-.169.131-.372.41-.778",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "m12 5.5-4.638 6.747c-.28.406-.42.609-.41.778a.5.5 0 0 0 .195.373c.135.102.38.102.874.102H12v5l4.638-6.747c.28-.406.42-.609.41-.778a.5.5 0 0 0-.195-.373c-.135-.102-.38-.102-.874-.102H12z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LightbulbOn/LightbulbOnIcon.tsx
const LightbulbOnIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 5a7 7 0 0 0-3 13.326V20a3 3 0 1 0 6 0v-1.674A7 7 0 0 0 12 5m0-4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1M1 12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1m3.193-7.807a1 1 0 0 1 1.414 0l.6.6a1 1 0 0 1-1.414 1.414l-.6-.6a1 1 0 0 1 0-1.414m15.614 0a1 1 0 0 1 0 1.414l-.6.6a1 1 0 1 1-1.414-1.414l.6-.6a1 1 0 0 1 1.414 0M20 12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10 17.659V20a2 2 0 1 0 4 0v-2.341M12 2v1m-9 9H2m3.5-6.5-.6-.6m13.6.6.6-.6M22 12h-1m-3 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Lightning/LightningIcon.tsx
const LightningIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13.398 1.083a1 1 0 0 1 .594 1.041L13.132 9h6.196c.24 0 .485 0 .684.018.189.017.55.062.863.315a1.5 1.5 0 0 1 .557 1.19c-.006.402-.202.709-.31.864-.114.165-.27.353-.424.538l-8.93 10.715a1 1 0 0 1-1.76-.764l.86-6.876H4.671c-.24 0-.485 0-.684-.018-.189-.017-.55-.062-.863-.315a1.5 1.5 0 0 1-.557-1.19c.006-.402.202-.709.31-.864.114-.165.27-.353.424-.538l.023-.027L12.232 1.36a1 1 0 0 1 1.166-.277",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13 2 4.093 12.688c-.348.418-.523.628-.525.804a.5.5 0 0 0 .185.397c.138.111.41.111.955.111H12l-1 8 8.907-10.688c.348-.418.523-.628.525-.804a.5.5 0 0 0-.185-.397c-.138-.111-.41-.111-.955-.111H12z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LightningOff/LightningOffIcon.tsx
const LightningOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l4.354 4.354-3.345 4.014c-.154.185-.31.373-.424.538-.108.155-.304.462-.31.864a1.5 1.5 0 0 0 .557 1.19c.313.253.674.298.863.315.2.018.443.018.684.018h6.195l-.86 6.876a1 1 0 0 0 1.761.764l4.3-5.159 4.225 4.226a1 1 0 0 0 1.414-1.414z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m18.639 14.396 2.059-2.471c.154-.185.31-.373.424-.538.108-.155.304-.462.31-.864a1.5 1.5 0 0 0-.557-1.19c-.313-.253-.674-.298-.863-.315C19.812 9 19.57 9 19.328 9h-6.085zm-5.494-5.494.847-6.778a1 1 0 0 0-1.76-.764L9.218 4.976z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m8 8-3.907 4.688c-.348.418-.523.628-.525.804a.5.5 0 0 0 .185.397c.138.111.41.111.955.111H12l-1 8 5-6m-.35-6h3.642c.545 0 .817 0 .955.111a.5.5 0 0 1 .185.396c-.002.177-.177.387-.525.805L18.55 12.94m-7.977-8.027L13 2l-.6 4.798M21 21 3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LightbulbOff/LightbulbOffIcon.tsx
const LightbulbOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.5 22a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1M4 9a8 8 0 1 1 12 6.93v.102c0 .439 0 .817-.021 1.13-.023.33-.072.66-.207.986a3 3 0 0 1-1.624 1.624 3.1 3.1 0 0 1-.986.207c-.313.021-.691.021-1.13.021h-.064c-.439 0-.817 0-1.13-.021a3.1 3.1 0 0 1-.986-.207 3 3 0 0 1-1.624-1.624 3 3 0 0 1-.207-.986C8 16.85 8 16.471 8 16.032v-.102A8 8 0 0 1 4 9",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.5 22h5m.5-6.674a7 7 0 1 0-6 0V16c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 19 11.068 19 12 19s1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 17.398 15 16.932 15 16z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Link/LinkIcon.tsx
const LinkIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.775 2.75a6 6 0 0 1 8.484 8.485l-.012.012-3 3a6 6 0 0 1-9.048-.648 1 1 0 1 1 1.602-1.198 4 4 0 0 0 6.032.432l2.993-2.994a4 4 0 0 0-5.656-5.655L12.455 5.89a1 1 0 0 1-1.41-1.418l1.72-1.71z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M7.9 8.373a6 6 0 0 1 6.9 2.028 1 1 0 1 1-1.6 1.198 4 4 0 0 0-6.033-.432L4.174 14.16a4 4 0 0 0 5.655 5.655l1.704-1.703a1 1 0 1 1 1.414 1.414l-1.71 1.71-.012.012a6 6 0 0 1-8.484-8.484l.012-.012 3-3a6 6 0 0 1 2.146-1.38",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LinkExternal/LinkExternalIcon.tsx
const LinkExternalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7.759 2H10a1 1 0 1 1 0 2H7.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V14a1 1 0 1 1 2 0v2.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M14 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V5.414l-7.293 7.293a1 1 0 0 1-1.414-1.414L18.586 4H15a1 1 0 0 1-1-1"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 9V3m0 0h-6m6 0-9 9m-2-9H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V14"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LightningFast/LightningFastIcon.tsx
const LightningFastIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2.5 17.5a1 1 0 0 1 1-1H9a1 1 0 1 1 0 2H3.5a1 1 0 0 1-1-1M1 12a1 1 0 0 1 1-1h4.5a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1m2-5.5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1m14.368-4.43a1 1 0 0 1 .623 1.062L17.142 9.5h3.838c.22 0 .45 0 .639.017.185.017.524.062.826.296a1.5 1.5 0 0 1 .582 1.131c.014.382-.145.683-.24.845a8 8 0 0 1-.357.53l-.02.027-6.596 9.235a1 1 0 0 1-1.805-.713l.849-6.368H11.02c-.22 0-.45 0-.638-.017-.186-.017-.525-.062-.827-.296a1.5 1.5 0 0 1-.582-1.131c-.015-.382.145-.683.24-.844a7 7 0 0 1 .357-.53l.02-.028 6.596-9.235a1 1 0 0 1 1.182-.349",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 17.5H3.5m3-5.5H2m7-5.5H4M17 3l-6.596 9.235c-.292.409-.438.613-.432.784a.5.5 0 0 0 .194.377c.135.104.386.104.889.104H16L15 21l6.596-9.235c.292-.409.438-.613.432-.784a.5.5 0 0 0-.194-.377c-.135-.104-.386-.104-.889-.104H16z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LocationPin/LocationPinIcon.tsx
const LocationPinIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3 10a9 9 0 0 1 18 0c0 2.526-1.147 4.74-2.708 6.767-1.304 1.694-2.974 3.349-4.641 5.002l-.002.001-.942.937a1 1 0 0 1-1.414 0l-.944-.938c-1.668-1.653-3.337-3.308-4.641-5.002C4.147 14.74 3 12.527 3 10m12 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 22c4-4 8-7.582 8-12a8 8 0 1 0-16 0c0 4.418 4 8 8 12"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LinkBroken/LinkBrokenIcon.tsx
const LinkBrokenIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9 1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1m6 18a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1M2 8h2a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2m17 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1M2.793 2.793a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1-1.414 1.414L2.793 4.207a1 1 0 0 1 0-1.414m15.586 15.586a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1-1.414 1.414l-1.414-1.414a1 1 0 0 1 0-1.414M13.414 3.515a5 5 0 0 1 7.071 7.07l-2.121 2.122a1 1 0 0 1-1.414-1.414l2.121-2.121a3 3 0 0 0-4.243-4.243l-2.12 2.121a1 1 0 1 1-1.415-1.414zM7.05 11.293a1 1 0 0 1 0 1.414l-2.12 2.121a3 3 0 0 0 4.243 4.243l2.12-2.121a1 1 0 0 1 1.415 1.414l-2.121 2.121a5 5 0 0 1-7.071-7.07l2.121-2.122a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 4V2m6 18v2M4 9H2m18 6h2M4.914 4.914 3.5 3.5m15.586 15.586L20.5 20.5M12 17.657l-2.121 2.121a4 4 0 1 1-5.657-5.657L6.343 12m11.314 0 2.121-2.121a4 4 0 1 0-5.657-5.657L12 6.343"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Lock/LockIcon.tsx
const LockIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6 8a6 6 0 1 1 12 0v1.15c.283.062.554.152.816.286a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v1.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 17.71 3 17.046 3 16.242v-1.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.262-.134.533-.224.816-.286zm10 0v1.002H8V8a4 4 0 1 1 8 0m-3 6.5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 10V8A5 5 0 0 0 7 8v2m5 4.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 21 7.12 21 8.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LockUnlocked/LockUnlockedIcon.tsx
const LockUnlockedIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6 8a6 6 0 0 1 11.5-2.4 1 1 0 0 1-1.832.8A4.001 4.001 0 0 0 8 8v1.002q.356-.003.759-.002h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v1.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 17.71 3 17.046 3 16.242v-1.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.262-.134.533-.224.816-.286zm7 6.5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 10V8a5 5 0 0 1 9.584-2M12 14.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 21 7.12 21 8.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LuggageBriefcase/LuggageBriefcaseIcon.tsx
const LuggageBriefcaseIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.862 2c-.795 0-1.386 0-1.897.136a4 4 0 0 0-2.829 2.829c-.082.307-.115.643-.128 1.035h-.25c-.804 0-1.469 0-2.01.044-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 10.29 1 10.954 1 11.758v4.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392.483.04.967.046 1.452.046.28 0 .42 0 .527-.054a.5.5 0 0 0 .219-.219C7 21.622 7 21.481 7 21.2V9a1 1 0 0 1 2 0v12.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C9.38 22 9.52 22 9.8 22h4.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C15 21.62 15 21.48 15 21.2V20a1 1 0 1 1 2 0v1.2c0 .281 0 .422.055.53a.5.5 0 0 0 .218.218c.107.054.247.054.527.054.485 0 .97-.007 1.452-.046.562-.046 1.079-.145 1.564-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6h-.25c-.013-.392-.046-.728-.128-1.035a4 4 0 0 0-2.829-2.829C13.524 2 12.933 2 12.138 2zm3.128 4a2.3 2.3 0 0 0-.058-.518 2 2 0 0 0-1.414-1.414C13.295 4.008 12.994 4 12 4s-1.295.009-1.518.068a2 2 0 0 0-1.414 1.414c-.032.12-.049.26-.058.518zM12 14.3c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218c.107-.055.247-.055.527-.055h4.9c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218c-.107.055-.247.055-.527.055h-4.9c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C12 17.12 12 16.98 12 16.7zM16 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 21V7c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.121-2.122C10.606 3 11.07 3 12 3s1.395 0 1.777.102a3 3 0 0 1 2.12 2.122C16 5.605 16 6.07 16 7v6.5m0 4V21m-9.2 0h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2v-4.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 7 18.88 7 17.2 7H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.28 2 10.12 2 11.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21m6-3.5h4.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-2.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218c-.107-.055-.247-.055-.527-.055h-4.9c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ListNumbers/ListNumbersIcon.tsx
const ListNumbersIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M21 12H9m12-6H9m12 12H9"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.412 10V6.28l.016-.408q-.272.248-.608.432a2.5 2.5 0 0 1-.688.256l-.144-.928q.185-.015.408-.104a4 4 0 0 0 .896-.504q.2-.152.304-.304h.896V10zm-1.755 9v-.744q.72-.488 1.216-.88.504-.4.808-.736a2.5 2.5 0 0 0 .448-.648 1.4 1.4 0 0 0 .144-.608.83.83 0 0 0-.224-.6q-.225-.24-.632-.24-.449 0-.704.304-.248.304-.272.864l-.952-.36q.039-.545.288-.92.255-.383.688-.584.44-.208 1.008-.208.487 0 .84.136.36.136.592.376.24.232.36.536t.12.632q0 .512-.256.968-.249.456-.768.904-.52.448-1.32.944v.008l.288-.016q.176-.008.36-.008a8 8 0 0 1 .32-.008h1.456V19z"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M21 12H9m12-6H9m12 12H9"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.412 10V6.28l.016-.408q-.272.248-.608.432a2.5 2.5 0 0 1-.688.256l-.144-.928a1.5 1.5 0 0 0 .408-.104 4 4 0 0 0 .896-.504q.2-.152.304-.304h.896V10zm-1.755 9v-.744q.72-.488 1.216-.88.504-.4.808-.736a2.5 2.5 0 0 0 .448-.648 1.4 1.4 0 0 0 .144-.608.83.83 0 0 0-.224-.6q-.225-.24-.632-.24-.449 0-.704.304-.249.304-.272.864l-.952-.36q.039-.545.288-.92.256-.383.688-.584.44-.208 1.008-.208.487 0 .84.136.36.136.592.376.24.232.36.536t.12.632q0 .512-.256.968-.249.456-.768.904-.52.448-1.32.944v.008l.288-.016q.176-.008.36-.008a8 8 0 0 1 .32-.008h1.456V19z"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ListBullet/ListBulletIcon.tsx
const ListBulletIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0-6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m-6-6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0-6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 12H9m12-6H9m12 12H9m-4-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LogIn/LogInIcon.tsx
const LogInIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7.965 2.136C8.476 2 9.067 2 9.862 2h6.38c.804 0 1.469 0 2.01.044.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044h-6.38c-.795 0-1.386 0-1.897-.136a4 4 0 0 1-2.829-2.829C5 18.524 5 17.933 5 17.138V16.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C5.76 15 6.04 15 6.6 15h1.44c.371 0 .556 0 .661.052a.4.4 0 0 1 .218.21c.056.103.065.351.083.85a3 3 0 0 0 5.12 2.01l4-4A3 3 0 0 0 19 12.013v-.024a3 3 0 0 0-.879-2.111l-4-4a3 3 0 0 0-5.119 2.01c-.018.498-.027.746-.083.85a.4.4 0 0 1-.218.209C8.596 9 8.411 9 8.041 9H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437c-.11-.214-.11-.494-.11-1.054v-.538c0-.795 0-1.386.137-1.897a4 4 0 0 1 2.829-2.829"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.293 7.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.586 13H3a1 1 0 1 1 0-2h10.586l-2.293-2.293a1 1 0 0 1 0-1.414"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 17c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C8.605 21 9.07 21 10 21h6.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H10c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122C6 5.605 6 6.07 6 7m6 1 4 4m0 0-4 4m4-4H3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Luggage/LuggageIcon.tsx
const LuggageIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.965 2.136C10.476 2 11.067 2 11.862 2h.276c.795 0 1.386 0 1.897.136a4 4 0 0 1 2.829 2.829c.082.307.115.643.128 1.035h.25c.804 0 1.469 0 2.01.044.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v4.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H6.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 17.71 1 17.046 1 16.242v-4.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C5.29 6 5.954 6 6.758 6h.25c.013-.392.046-.728.128-1.035a4 4 0 0 1 2.829-2.829m4.967 3.346c.032.12.049.26.058.518H9.01c.01-.258.026-.399.058-.518a2 2 0 0 1 1.414-1.414C10.705 4.008 11.006 4 12 4s1.295.009 1.518.068a2 2 0 0 1 1.414 1.414m-2.877 8.291C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h4.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-2.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218c-.107-.055-.247-.055-.527-.055h-4.9c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 7c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.121-2.122C13.395 3 12.93 3 12 3s-1.395 0-1.777.102a3 3 0 0 0-2.12 2.122C8 5.605 8 6.07 8 7m4.8 10.5h4.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-2.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218c-.107-.055-.247-.055-.527-.055h-4.9c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055m-6 3.5h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2v-4.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 7 18.88 7 17.2 7H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.28 2 10.12 2 11.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LogOut/LogOutIcon.tsx
const LogOutIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.138 2c.795 0 1.386 0 1.897.136a4 4 0 0 1 2.829 2.829C13 5.476 13 6.067 13 6.862V7.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C12.24 9 11.96 9 11.4 9H9a3 3 0 1 0 0 6h2.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437c.11.214.11.494.11 1.054v.538c0 .795 0 1.386-.137 1.897a4 4 0 0 1-2.829 2.829C9.524 22 8.933 22 8.138 22h-.672c-.67 0-1.223 0-1.676-.03-.469-.033-.903-.101-1.32-.274a4 4 0 0 1-2.166-2.165c-.173-.418-.241-.852-.273-1.322C2 17.757 2 17.205 2 16.534V7.466c0-.67 0-1.223.03-1.676.033-.469.101-.903.274-1.32A4 4 0 0 1 4.47 2.303c.418-.173.852-.241 1.321-.273C6.243 2 6.796 2 7.466 2z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L18.586 13H9a1 1 0 1 1 0-2h9.586l-3.293-3.293a1 1 0 0 1 0-1.414"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 17 5-5m0 0-5-5m5 5H9m3 5c0 .93 0 1.395-.102 1.776a3 3 0 0 1-2.122 2.122C9.395 21 8.93 21 8 21h-.5c-1.398 0-2.097 0-2.648-.228a3 3 0 0 1-1.624-1.624C3 18.597 3 17.898 3 16.5v-9c0-1.398 0-2.097.228-2.648a3 3 0 0 1 1.624-1.624C5.403 3 6.102 3 7.5 3H8c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C12 5.605 12 6.07 12 7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/MagicWand/MagicWandIcon.tsx
const MagicWandIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M14.01 2a1 1 0 1 1 2 0v1.5a1 1 0 1 1-2 0zm5.293 1.293a1 1 0 1 1 1.414 1.414l-1.06 1.06a1 1 0 0 1-1.415-1.413zm-1.061 9a1 1 0 0 0 0 1.414l1.06 1.06a1 1 0 0 0 1.415-1.413l-1.06-1.061a1 1 0 0 0-1.415 0m-9-7.586a1 1 0 1 1 1.414-1.414l1.061 1.06a1 1 0 0 1-1.414 1.415zM22.01 8h-1.5a1 1 0 1 0 0 2h1.5a1 1 0 1 0 0-2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.882 7.012a2 2 0 0 1 1.236 0c.29.094.511.254.686.402.16.135.333.31.512.488l.782.782c.179.178.352.352.488.511.148.175.308.397.402.687.13.402.13.834 0 1.236-.094.29-.254.511-.402.686-.136.16-.31.333-.488.512l-9.282 9.282c-.179.179-.352.353-.512.488a2 2 0 0 1-.686.402c-.402.13-.835.13-1.236 0a2 2 0 0 1-.687-.402c-.159-.135-.333-.31-.511-.488l-.782-.782a9 9 0 0 1-.488-.512 2 2 0 0 1-.402-.686 2 2 0 0 1 0-1.236 2 2 0 0 1 .402-.687c.135-.159.31-.333.488-.511l9.282-9.282c.178-.179.352-.353.511-.488a2 2 0 0 1 .687-.402m-.043 5.336c-.114-.037-.213-.136-.411-.334l-.442-.442c-.198-.198-.297-.297-.334-.412a.5.5 0 0 1 0-.309c.037-.114.136-.213.335-.411l.947-.945c.198-.198.297-.297.411-.334a.5.5 0 0 1 .31 0c.113.038.212.136.41.334l.44.44c.197.198.296.297.333.41a.5.5 0 0 1 0 .31c-.037.114-.135.213-.333.41l-.945.948c-.198.198-.297.298-.412.335a.5.5 0 0 1-.309 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 14-3-3m5.01-7.5V2m3.94 3.06L20.01 4m-1.06 9 1.06 1.06m-9-9L9.95 4m10.56 5h1.5M6.131 20.869l9.238-9.238c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822l-.738-.738c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668L3.13 17.87c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l.738.738c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/MailClosed/MailClosedIcon.tsx
const MailClosedIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M2.134 8.181c-.3-.214-.45-.32-.581-.335a.51.51 0 0 0-.488.251C1 8.212 1 8.394 1 8.76v6.482c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 21 5.954 21 6.758 21h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.758c0-.179 0-.268-.016-.33a.503.503 0 0 0-.655-.344c-.06.022-.135.074-.284.177l-7.742 5.36c-.549.381-1.03.716-1.578.849a3 3 0 0 1-1.457-.011c-.545-.14-1.022-.483-1.565-.872z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M22.133 5.769c.184-.128.277-.192.333-.295a.56.56 0 0 0 .06-.297c-.014-.116-.063-.193-.162-.347a4.03 4.03 0 0 0-1.548-1.394c-.485-.247-1.002-.346-1.564-.392C18.71 3 18.046 3 17.242 3H6.758c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.41 1.197c-.115.158-.173.237-.192.356a.56.56 0 0 0 .05.308c.055.107.15.176.343.313l8.775 6.268c.727.52.882.61 1.018.645a1 1 0 0 0 .486.004c.137-.033.292-.121 1.027-.63z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m2 7 8.165 5.715c.661.463.992.695 1.351.784a2 2 0 0 0 .968 0c.36-.09.69-.32 1.351-.784L22 7M6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Mark/MarkIcon.tsx
const MarkIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M13 2a1 1 0 1 0-2 0v1.055A9.004 9.004 0 0 0 3.055 11H2a1 1 0 1 0 0 2h1.055A9.004 9.004 0 0 0 11 20.945V22a1 1 0 1 0 2 0v-1.055A9.004 9.004 0 0 0 20.945 13H22a1 1 0 1 0 0-2h-1.055A9.004 9.004 0 0 0 13 3.055zM7 12a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 12a8 8 0 0 1-8 8m8-8a8 8 0 0 0-8-8m8 8h2m-10 8a8 8 0 0 1-8-8m8 8v2M4 12a8 8 0 0 1 8-8m-8 8H2m10-8V2m3 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/MailOpen/MailOpenIcon.tsx
const MailOpenIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12.686.965a3 3 0 0 0-1.371 0c-.516.12-.973.419-1.494.759C7.565 3.19 5.304 4.647 3.052 6.118c-.34.222-.51.334-.57.475a.5.5 0 0 0 0 .386c.06.142.23.253.57.476l7.744 5.063c.698.457.845.535.975.566a1 1 0 0 0 .459 0c.13-.03.276-.11.974-.566l7.743-5.063c.341-.223.512-.334.57-.476a.5.5 0 0 0 0-.386c-.059-.141-.229-.253-.57-.475-2.251-1.471-4.512-2.928-6.768-4.394-.52-.34-.978-.638-1.494-.76"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M22.997 9.982c0-.48 0-.72-.1-.854a.5.5 0 0 0-.367-.198c-.167-.011-.368.12-.77.384l-7.572 4.95c-.522.343-.982.644-1.5.766a3 3 0 0 1-1.377 0c-.517-.122-.976-.423-1.5-.766l-7.57-4.95c-.403-.264-.604-.395-.77-.384a.5.5 0 0 0-.367.198c-.1.134-.101.374-.101.854L1 16.242c0 .804 0 1.468.044 2.01.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13.744 2.634 7.528 4.893c.266.173.399.26.495.374a1 1 0 0 1 .189.348c.044.143.044.302.044.62V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 21 18.88 21 17.2 21H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.72 2 17.88 2 16.2V8.868c0-.317 0-.476.044-.62a1 1 0 0 1 .189-.347c.096-.115.229-.201.495-.374l7.528-4.893m3.488 0c-.631-.41-.947-.616-1.287-.696a2 2 0 0 0-.914 0c-.34.08-.656.285-1.287.696m3.488 0 7.224 4.695c.344.224.516.336.576.477a.5.5 0 0 1 0 .388c-.06.141-.232.253-.576.477l-7.224 4.695c-.631.41-.947.616-1.287.696-.3.07-.613.07-.914 0-.34-.08-.656-.285-1.287-.696L3.032 8.671c-.344-.224-.516-.336-.576-.477a.5.5 0 0 1 0-.388c.06-.141.232-.253.576-.477l7.224-4.695"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Maximize/MaximizeIcon.tsx
const MaximizeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L18.586 4H15a1 1 0 0 1-1-1M5.414 20l5.293-5.293a1 1 0 0 0-1.414-1.414L4 18.586V15a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m14 10 7-7m0 0h-6m6 0v6m-11 5-7 7m0 0h6m-6 0v-6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Map/MapIcon.tsx
const MapIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8 2.798c0-.452 0-.679-.095-.81a.5.5 0 0 0-.351-.204c-.161-.017-.358.095-.75.32l-5.3 3.028A1 1 0 0 0 1 6v16a1 1 0 0 0 1.496.868l4.698-2.684c.293-.168.44-.252.547-.37a1 1 0 0 0 .21-.36c.049-.152.049-.321.049-.66zm2 15.997c0 .338 0 .507.05.658a1 1 0 0 0 .209.361c.107.118.254.202.547.37l2.997 1.712c.393.225.59.337.75.32a.5.5 0 0 0 .352-.204c.095-.131.095-.358.095-.81V5.205c0-.338 0-.507-.05-.658a1 1 0 0 0-.209-.361c-.107-.118-.254-.202-.547-.37l-2.997-1.712c-.393-.225-.59-.337-.75-.32a.5.5 0 0 0-.352.204c-.095.131-.095.358-.095.81zM23 2a1 1 0 0 0-1.555-.832l-3.733 2.489c-.26.173-.39.26-.485.375a1 1 0 0 0-.184.344C17 4.518 17 4.675 17 4.988V21.04c0 .486 0 .729.101.863a.5.5 0 0 0 .37.197c.167.01.369-.125.773-.394l4.31-2.874A1 1 0 0 0 23 18z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 18-7 4V6l7-4m0 16 7 4m-7-4V2m7 20 6-4V2l-6 4m0 16V6m0 0L9 2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Microphone/MicrophoneIcon.tsx
const MicrophoneIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1a4 4 0 0 0-4 4v7a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6 10a1 1 0 1 0-2 0v2a8 8 0 0 0 7.002 7.938L11 20v1H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-1l-.002-.062A8 8 0 0 0 20 12v-2a1 1 0 1 0-2 0v2a6 6 0 0 1-12 0z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 10v2a7 7 0 0 1-7 7m-7-9v2a7 7 0 0 0 7 7m0 0v3m-4 0h8m-4-7a3 3 0 0 1-3-3V5a3 3 0 1 1 6 0v7a3 3 0 0 1-3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Menu/MenuIcon.tsx
const MenuIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0-6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m0 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 12h18M3 6h18M3 18h18"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Inbox/InboxIcon.tsx
const InboxIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8.814 3c-.928 0-1.627 0-2.264.22a4 4 0 0 0-1.495.923c-.481.472-.794 1.098-1.208 1.928L1.963 9.844c-.191.382-.287.574-.263.73a.5.5 0 0 0 .208.336c.129.09.343.09.771.09h3.203a2.81 2.81 0 0 1 2.512 1.553.81.81 0 0 0 .724.447h5.764a.81.81 0 0 0 .724-.447A2.81 2.81 0 0 1 18.118 11h3.203c.428 0 .642 0 .771-.09a.5.5 0 0 0 .209-.337c.023-.155-.073-.347-.264-.73L20.153 6.07c-.414-.83-.727-1.456-1.208-1.928a4 4 0 0 0-1.495-.923c-.637-.22-1.336-.22-2.264-.219zM23 14.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 13 21.96 13 21.4 13h-3.282a.81.81 0 0 0-.724.447A2.81 2.81 0 0 1 14.882 15H9.118a2.81 2.81 0 0 1-2.512-1.553.81.81 0 0 0-.724-.447H2.6c-.56 0-.84 0-1.054.11a1 1 0 0 0-.437.436C.999 13.76 1 14.04 1 14.6v.641c0 .805 0 1.47.044 2.011.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 21 5.954 21 6.758 21h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M2.5 12h3.382c.685 0 1.312.387 1.618 1s.933 1 1.618 1h5.764c.685 0 1.312-.387 1.618-1s.933-1 1.618-1H21.5M8.967 4h6.066c1.077 0 1.616 0 2.091.164a3 3 0 0 1 1.121.693c.36.352.6.833 1.082 1.796l2.166 4.334c.19.377.284.566.35.765q.09.263.128.54c.029.207.029.418.029.841V15.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 20 18.88 20 17.2 20H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.72 2 16.88 2 15.2v-2.067c0-.422 0-.634.029-.84q.038-.277.128-.541c.066-.199.16-.388.35-.766l2.166-4.333c.482-.963.723-1.444 1.082-1.796a3 3 0 0 1 1.12-.693C7.352 4 7.89 4 8.968 4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Minimize/MinimizeIcon.tsx
const MinimizeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m16.414 9 5.293-5.293a1 1 0 0 0-1.414-1.414L15 7.586V4a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2zM9 20v-3.586l-5.293 5.293a1 1 0 0 1-1.414-1.414L7.586 15H4a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 14h6m0 0v6m0-6-7 7m17-11h-6m0 0V4m0 6 7-7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/MinusCircle/MinusCircleIcon.tsx
const MinusCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 12h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Moon/MoonIcon.tsx
const MoonIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M9.067 2.412A1 1 0 0 0 7.744 1.09 11.46 11.46 0 0 0 1 11.538C1 17.868 6.132 23 12.462 23c4.65 0 8.652-2.769 10.45-6.744a1 1 0 0 0-1.324-1.323 9.4 9.4 0 0 1-3.895.836 9.46 9.46 0 0 1-9.462-9.462c0-1.39.3-2.708.836-3.895"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 15.844a10.4 10.4 0 0 1-4.306.925c-5.779 0-10.463-4.684-10.463-10.462 0-1.536.33-2.994.925-4.307A10.46 10.46 0 0 0 2 11.538C2 17.316 6.684 22 12.462 22c4.243 0 7.896-2.526 9.538-6.156"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/LuggageSuitcase/LuggageSuitcaseIcon.tsx
const LuggageSuitcaseIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392l.252.017V22a1 1 0 1 0 2 0v-1h6v1a1 1 0 1 0 2 0v-1.027q.13-.007.252-.017c.562-.046 1.079-.145 1.564-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V6.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1M9.5 6a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m6 1a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 22v-2m1.5-5V7M16 22v-2m-1.5-5V7M8.8 20h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.72 20 16.88 20 15.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 20 7.12 20 8.8 20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Mouse/MouseIcon.tsx
const MouseIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1a8 8 0 0 0-8 8v6a8 8 0 1 0 16 0V9a8 8 0 0 0-8-8m1 5a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 9V6m0 16a7 7 0 0 1-7-7V9a7 7 0 0 1 14 0v6a7 7 0 0 1-7 7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Minus/MinusIcon.tsx
const MinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 12h14"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/FileX/FileXIcon.tsx
const FileXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15.241 1H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h4.282c.371 0 .556 0 .661-.052a.4.4 0 0 0 .218-.21c.056-.103.065-.351.083-.85a3 3 0 0 1 .877-2.01l.378-.378-.378-.379a3 3 0 1 1 4.242-4.242l.379.378.379-.378a3 3 0 0 1 .608-.47c.222-.13.333-.195.386-.254a.4.4 0 0 0 .103-.18c.024-.074.024-.173.024-.37V6.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 1 16.046 1 15.242 1M7 5a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M16.293 17.707a1 1 0 0 1 1.414-1.414l1.793 1.793 1.793-1.793a1 1 0 0 1 1.414 1.414L20.914 19.5l1.793 1.793a1 1 0 0 1-1.414 1.414L19.5 20.914l-1.793 1.793a1 1 0 0 1-1.414-1.414l1.793-1.793z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14 11H8m2 4H8m8-8H8m12 5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m4-6 5 5m0-5-5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Move/MoveIcon.tsx
const MoveIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.707 1.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L11 4.414V11H4.414l1.293-1.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L4.414 13H11v6.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 19.586V13h6.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L19.586 11H13V4.414l1.293 1.293a1 1 0 1 0 1.414-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m5 9-3 3m0 0 3 3m-3-3h20M9 5l3-3m0 0 3 3m-3-3v20m3-3-3 3m0 0-3-3M19 9l3 3m0 0-3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Microscope/MicroscopeIcon.tsx
const MicroscopeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3 5.5a4.5 4.5 0 0 1 8.979-.443 9 9 0 0 1 4.397 17.288 1 1 0 0 1-.751-1.854A7.002 7.002 0 0 0 12 7.071v5.693c.475.425.813.999.943 1.65.13.66.131 1.51 0 2.171a3 3 0 0 1-2.357 2.357c-.293.059-.621.058-1.002.058H5.416c-.38 0-.708 0-1.001-.058a3 3 0 0 1-2.357-2.357 6 6 0 0 1 0-2.17c.13-.652.467-1.226.942-1.65z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M3 21a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 22h9M11 6.252a8 8 0 0 1 5 15.166M5.5 13h4c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89s0 .697-.038.89a2 2 0 0 1-1.572 1.572C10.197 18 9.965 18 9.5 18h-4c-.465 0-.697 0-.89-.038a2 2 0 0 1-1.572-1.572C3 16.197 3 15.965 3 15.5s0-.697.038-.89a2 2 0 0 1 1.572-1.572C4.803 13 5.035 13 5.5 13M4 5.5V13h7V5.5a3.5 3.5 0 1 0-7 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/NoCodeCircle/NoCodeCircleIcon.tsx
const NoCodeCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m1.98 6.196a1 1 0 0 0-1.96-.392l-2 10a1 1 0 0 0 1.96.392zM9.208 8.293a1 1 0 0 1 0 1.414L6.914 12l2.293 2.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0m5.586 0a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L17.086 12l-2.293-2.293a1 1 0 0 1 0-1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m15.5 15 3-3-3-3m-7 0-3 3 3 3M13 7l-2 10m11-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/NavigationPointerOff/NavigationPointerOffIcon.tsx
const NavigationPointerOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.707 2.293a1 1 0 0 0-1.414 1.414L5.825 7.24l-2.81 1.096a10 10 0 0 0-.725.304c-.173.085-.54.275-.744.669a1.5 1.5 0 0 0 .001 1.384c.205.393.572.583.744.668.2.098.458.199.725.303l6.711 2.61 2.61 6.71c.104.268.205.526.303.726.085.172.274.539.668.744a1.5 1.5 0 0 0 1.384 0c.394-.204.584-.57.669-.743.098-.2.2-.457.303-.724l1.097-2.81 3.532 3.531a1 1 0 0 0 1.414-1.414z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.349 14.106 22.282 4.03c.093-.24.186-.477.244-.677.053-.183.149-.551.017-.947a1.5 1.5 0 0 0-.948-.947c-.396-.133-.764-.037-.947.016-.2.058-.438.151-.677.244L9.894 5.651z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11.337 6.161 20.3 2.663c.537-.21.806-.314.978-.257a.5.5 0 0 1 .316.316c.057.172-.048.44-.258.977l-3.509 8.992m-1.441 3.695-1.64 4.201c-.232.595-.348.893-.515.98a.5.5 0 0 1-.462 0c-.167-.088-.282-.385-.514-.98l-2.628-6.759a1 1 0 0 0-.107-.232.5.5 0 0 0-.116-.117 1 1 0 0 0-.232-.106l-6.759-2.628c-.595-.232-.893-.348-.98-.515a.5.5 0 0 1 0-.461c.087-.167.385-.283.98-.515l4.204-1.641M21 21 3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/NoCode/NoCodeIcon.tsx
const NoCodeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M16.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L20.586 12l-4.293-4.293a1 1 0 0 1 0-1.414m-8.586 0a1 1 0 0 1 0 1.414L3.414 12l4.293 4.293a1 1 0 1 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0m6.51-4.269a1 1 0 0 1 .76 1.193l-4 18a1 1 0 1 1-1.953-.434l4-18a1 1 0 0 1 1.193-.759",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m17 17 5-5-5-5M7 7l-5 5 5 5m7-14-4 18"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/NavigationPointer/NavigationPointerIcon.tsx
const NavigationPointerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21.595 1.458c-.396-.133-.764-.037-.947.016-.2.058-.438.151-.677.244L3.014 8.336a10 10 0 0 0-.724.303c-.173.085-.54.275-.744.669a1.5 1.5 0 0 0 .001 1.384c.205.394.572.583.744.668.2.098.458.199.725.303l6.711 2.61 2.61 6.71c.104.268.205.526.303.726.085.172.274.539.668.744a1.5 1.5 0 0 0 1.384 0c.394-.204.584-.57.669-.742.098-.2.2-.458.303-.725l6.618-16.957c.093-.24.186-.477.244-.677.053-.183.149-.551.017-.947a1.5 1.5 0 0 0-.948-.947"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3.413 10.745c-.595-.232-.893-.348-.98-.515a.5.5 0 0 1 0-.461c.087-.167.385-.283.98-.515L20.3 2.664c.537-.21.806-.315.978-.258a.5.5 0 0 1 .316.316c.057.172-.048.44-.258.977l-6.59 16.888c-.232.595-.348.893-.515.98a.5.5 0 0 1-.462 0c-.167-.088-.282-.385-.514-.98l-2.628-6.759a1 1 0 0 0-.107-.232.5.5 0 0 0-.116-.117 1 1 0 0 0-.232-.106z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Music/MusicIcon.tsx
const MusicIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M19.968 4.199c-.138.01-.329.042-.667.098l-8.8 1.467a8 8 0 0 0-.482.088l-.01.003v.01a8 8 0 0 0-.009.49v11.649a4 4 0 1 1-2-3.469V6.327c0-.216 0-.43.014-.613a2 2 0 0 1 .161-.685 2 2 0 0 1 .718-.847 2 2 0 0 1 .649-.272c.178-.044.39-.079.603-.115l8.862-1.477a10 10 0 0 1 .804-.113 2.04 2.04 0 0 1 .885.1 2 2 0 0 1 1.039.88c.17.298.223.604.245.858.02.235.02.516.02.81V16a1 1 0 0 1-.013.163A4 4 0 1 1 20 12.541V4.889c0-.343 0-.536-.013-.674l-.002-.017z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 18V6.355c0-.481 0-.722.088-.917a1 1 0 0 1 .358-.424c.178-.118.416-.158.891-.237l8.8-1.466c.64-.107.961-.16 1.211-.068a1 1 0 0 1 .52.44c.132.231.132.556.132 1.206V16M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0m12-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Notification/NotificationIcon.tsx
const NotificationIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M21.121 2.879A3 3 0 1 1 16.88 7.12a3 3 0 0 1 4.24-4.24"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M21 10.806c0-.41 0-.614-.066-.73a.44.44 0 0 0-.26-.22c-.125-.046-.364-.005-.842.075a5 5 0 0 1-4.368-1.395 5 5 0 0 1-1.395-4.368c.08-.478.12-.717.074-.842a.44.44 0 0 0-.22-.26C13.808 3 13.603 3 13.194 3H7.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 7.29 2 7.954 2 8.758v7.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 22 6.954 22 7.758 22h7.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01zM6 13a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2V13m-7 4H7m8-4H7m13.121-9.121A3 3 0 1 1 15.88 8.12a3 3 0 0 1 4.24-4.24"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Octagon/OctagonIcon.tsx
const OctagonIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8.523 1h-.051c-.19 0-.43-.001-.665.055a2 2 0 0 0-.578.24c-.206.126-.375.296-.509.43l-.036.036-4.923 4.923-.036.036a2.8 2.8 0 0 0-.43.51 2 2 0 0 0-.24.577C1 8.043 1 8.282 1 8.472v7.056c0 .19-.001.43.055.665q.075.308.24.578c.126.206.296.375.43.509l.036.036 4.923 4.922.036.037c.134.134.303.304.51.43a2 2 0 0 0 .577.24c.236.056.475.055.665.055h7.056c.19 0 .43.001.665-.055q.308-.075.578-.24c.206-.126.375-.296.509-.43l.036-.037 4.922-4.922.037-.036c.134-.134.304-.303.43-.51q.165-.269.24-.577c.056-.236.055-.475.055-.665V8.472c0-.19.001-.43-.055-.665a2 2 0 0 0-.24-.578c-.126-.206-.296-.375-.43-.509l-.037-.036-4.922-4.923-.036-.036c-.134-.134-.303-.304-.51-.43a2 2 0 0 0-.577-.24C15.957 1 15.718 1 15.528 1z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7.391 2.469c.173-.173.26-.26.36-.322a1 1 0 0 1 .29-.12C8.156 2 8.278 2 8.523 2h6.954c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l4.922 4.923c.173.173.26.26.322.36q.082.136.12.29c.027.115.027.237.027.482v6.954c0 .245 0 .367-.028.482a1 1 0 0 1-.12.29c-.061.1-.148.187-.32.36l-4.923 4.922c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12c-.115.027-.237.027-.482.027H8.523c-.245 0-.367 0-.482-.028a1 1 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32L2.47 16.608c-.173-.173-.26-.26-.322-.36a1 1 0 0 1-.12-.29C2 15.844 2 15.722 2 15.477V8.523c0-.245 0-.367.028-.482a1 1 0 0 1 .12-.29c.061-.1.148-.187.32-.36z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PackagePlus/PackagePlusIcon.tsx
const PackagePlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				d: "M21 15.001C21 14.448 20.552 14.001 20 14.001 19.448 14.001 19 14.448 19 15.001V17.001H17C16.448 17.001 16 17.448 16 18.001 16 18.553 16.448 19.001 17 19.001H19V21.001C19 21.553 19.448 22.001 20 22.001 20.552 22.001 21 21.553 21 21.001V19.001H23C23.552 19.001 24 18.553 24 18.001 24 17.448 23.552 17.001 23 17.001H21V15.001ZM11.597 1.186C11.863 1.131 12.137 1.131 12.403 1.186 12.71 1.249 12.985 1.403 13.203 1.525L13.263 1.558C15.026 2.538 18.008 4.195 19.689 5.13 20.097 5.357 20.302 5.47 20.37 5.62 20.429 5.751 20.43 5.901 20.371 6.032 20.303 6.182 20.1 6.297 19.692 6.526L17.363 7.836 8.4 2.857 10.737 1.558 10.797 1.525C11.015 1.403 11.29 1.249 11.597 1.186ZM6.342 4.001 15.317 8.987 12.392 10.632C12.249 10.713 12.178 10.753 12.102 10.769 12.035 10.783 11.965 10.783 11.898 10.769 11.822 10.753 11.751 10.713 11.608 10.632L4.308 6.526C3.9 6.297 3.696 6.182 3.629 6.032 3.57 5.901 3.571 5.751 3.63 5.62 3.698 5.47 3.902 5.357 4.311 5.13L6.342 4.001Z",
				fill: "currentColor"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				d: "M21.996 8.891C21.995 8.442 21.995 8.218 21.901 8.087 21.818 7.973 21.691 7.899 21.551 7.883 21.391 7.865 21.195 7.975 20.804 8.195L13.408 12.356C13.259 12.439 13.185 12.481 13.131 12.54 13.083 12.592 13.047 12.654 13.025 12.721 13 12.797 13 12.883 13 13.053V21.228C13 21.675 13 21.899 13.094 22.03 13.176 22.144 13.302 22.218 13.442 22.235 13.602 22.253 13.797 22.145 14.186 21.929 14.278 21.878 14.373 21.825 14.472 21.77 14.971 21.493 15.221 21.354 15.29 21.242 15.372 21.108 15.38 21.071 15.359 20.914 15.342 20.784 15.096 20.458 14.603 19.805 14.224 19.303 14 18.678 14 18.001 14 16.344 15.343 15.001 17 15.001 17 13.344 18.343 12.001 20 12.001 20.134 12.001 20.267 12.009 20.397 12.027 21.174 12.129 21.562 12.181 21.683 12.132 21.828 12.074 21.858 12.048 21.934 11.912 21.998 11.798 21.998 11.523 21.997 10.973 21.997 10.194 21.996 9.471 21.996 8.891ZM9.813 21.929C10.203 22.145 10.398 22.253 10.558 22.235 10.698 22.218 10.824 22.144 10.906 22.03 11 21.899 11 21.675 11 21.228V13.053C11 12.883 11 12.798 10.975 12.721 10.953 12.654 10.917 12.592 10.869 12.54 10.815 12.481 10.741 12.439 10.592 12.356L3.196 8.195C2.805 7.975 2.609 7.865 2.448 7.883 2.308 7.899 2.182 7.973 2.099 8.087 2.005 8.218 2.004 8.442 2.004 8.891 2.002 10.757 2 14.096 2 16.059L2 16.131C1.999 16.395 1.998 16.727 2.101 17.04 2.19 17.31 2.336 17.558 2.529 17.768 2.752 18.01 3.043 18.17 3.274 18.297L3.337 18.332C5.118 19.322 8.147 21.003 9.813 21.929Z",
				fill: "currentColor"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m2-.611-1.223.68c-.284.157-.425.236-.575.267q-.201.04-.403 0c-.15-.031-.292-.11-.576-.268l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.94c0-.342 0-.513.05-.666a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111c.284-.158.425-.237.576-.268a1 1 0 0 1 .402 0c.15.031.292.11.576.268l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.152.05.324.05.666v4.56m-13.5-8 9 5M19 21v-6m-3 3h6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PackageSearch/PackageSearchIcon.tsx
const PackageSearchIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M20 14a4 4 0 1 0 1.705 7.62l.588.587a1 1 0 0 0 1.414-1.414l-.459-.459A4 4 0 0 0 20 14m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.597 1.185a2 2 0 0 1 .806 0c.307.063.582.217.8.34l.06.033 6.426 3.571c.408.227.613.34.68.49a.5.5 0 0 1 .002.412c-.068.15-.271.265-.679.494l-2.329 1.31L8.4 2.857l2.337-1.298.06-.034c.218-.122.493-.276.8-.339M6.342 4l8.975 4.987-2.925 1.645c-.143.08-.214.12-.29.136a.5.5 0 0 1-.204 0c-.076-.016-.147-.056-.29-.136l-7.3-4.107c-.408-.229-.612-.343-.679-.494a.5.5 0 0 1 .001-.411c.068-.15.272-.264.68-.49zm15.654 4.89c0-.448 0-.672-.095-.803a.5.5 0 0 0-.35-.204c-.16-.018-.356.092-.747.312l-7.396 4.16c-.149.084-.223.125-.277.184a.5.5 0 0 0-.106.182c-.025.076-.025.161-.025.331v8.176c0 .447 0 .67.094.801a.5.5 0 0 0 .348.205c.16.019.355-.09.744-.306l.117-.065c.268-.148.402-.223.468-.319a.46.46 0 0 0 .09-.287c-.001-.116-.08-.273-.235-.586a6 6 0 0 1 6.276-8.604c.435.066.652.099.775.051a.45.45 0 0 0 .256-.22c.065-.115.065-.306.065-.689zM9.813 21.928c.39.216.585.325.745.306a.5.5 0 0 0 .348-.205c.094-.13.094-.354.094-.801v-8.176c0-.17 0-.255-.025-.331a.5.5 0 0 0-.106-.181c-.054-.06-.128-.101-.277-.185l-7.396-4.16c-.391-.22-.587-.33-.748-.312a.5.5 0 0 0-.349.204c-.094.13-.095.355-.095.803L2 16.06v.072c-.001.264-.002.595.1.908a2 2 0 0 0 .43.728c.222.242.513.402.744.53l.063.034z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-9.5V7.941c0-.342 0-.513-.05-.666a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.268a1 1 0 0 0-.403 0c-.15.031-.292.11-.576.268l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.94v8.118c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l.223-.123M7.5 4.5l9 5m5.5 12-1-1m1-2.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PackageCheck/PackageCheckIcon.tsx
const PackageCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M23.707 15.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L19 18.586l3.293-3.293a1 1 0 0 1 1.414 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.597 1.185a2 2 0 0 1 .806 0c.307.063.582.217.8.34l.06.033 6.426 3.571c.408.227.613.34.68.49a.5.5 0 0 1 .002.412c-.068.15-.271.265-.679.494l-2.329 1.31L8.4 2.857l2.337-1.298.06-.034c.218-.122.493-.276.8-.339M6.342 4l8.975 4.987-2.925 1.645c-.143.08-.214.12-.29.136a.5.5 0 0 1-.204 0c-.076-.016-.147-.056-.29-.136l-7.3-4.107c-.408-.229-.612-.343-.679-.494a.5.5 0 0 1 .001-.411c.068-.15.272-.264.68-.49zm15.654 4.89c0-.448 0-.672-.095-.803a.5.5 0 0 0-.35-.204c-.16-.018-.356.092-.747.312l-7.396 4.16c-.149.084-.223.125-.277.184a.5.5 0 0 0-.106.182c-.025.076-.025.161-.025.331v8.176c0 .447 0 .67.094.801a.5.5 0 0 0 .348.205c.16.019.355-.09.744-.306l.68-.377c.315-.175.472-.262.541-.387a.5.5 0 0 0 .05-.358c-.032-.138-.16-.266-.414-.52l-.164-.165a3 3 0 0 1 4.118-4.36l1.882-1.882a3 3 0 0 1 .607-.47c.222-.13.333-.195.386-.254a.4.4 0 0 0 .102-.18c.025-.074.025-.173.024-.37zM9.813 21.928c.39.216.585.325.745.306a.5.5 0 0 0 .348-.205c.094-.13.094-.354.094-.801v-8.176c0-.17 0-.255-.025-.331a.5.5 0 0 0-.106-.181c-.054-.06-.128-.101-.277-.185l-7.396-4.16c-.391-.22-.587-.33-.748-.312a.5.5 0 0 0-.349.204c-.094.13-.095.355-.095.803L2 16.06v.072c-.001.264-.002.595.1.908a2 2 0 0 0 .43.728c.222.242.513.402.744.53l.063.034z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m2-.611-1.223.68c-.284.157-.425.236-.575.267q-.201.04-.403 0c-.15-.031-.292-.11-.576-.268l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.94c0-.342 0-.513.05-.666a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111c.284-.158.425-.237.576-.268a1 1 0 0 1 .402 0c.15.031.292.11.576.268l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.152.05.324.05.666v4.56m-13.5-8 9 5M16 18l2 2 4-4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PackageMinus/PackageMinusIcon.tsx
const PackageMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M16 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.597 1.185a2 2 0 0 1 .806 0c.307.063.582.217.8.34l.06.033 6.426 3.571c.408.227.613.34.68.49a.5.5 0 0 1 .002.412c-.068.15-.271.265-.679.494l-2.329 1.31L8.4 2.857l2.337-1.298.06-.034c.218-.122.493-.276.8-.339M6.342 4l8.975 4.987-2.925 1.645c-.143.08-.214.12-.29.136a.5.5 0 0 1-.204 0c-.076-.016-.147-.056-.29-.136l-7.3-4.107c-.408-.229-.612-.343-.679-.494a.5.5 0 0 1 .001-.411c.068-.15.272-.264.68-.49zm15.654 4.89c0-.448 0-.672-.095-.803a.5.5 0 0 0-.35-.204c-.16-.018-.356.092-.747.312l-7.396 4.16c-.149.084-.223.125-.277.184a.5.5 0 0 0-.106.182c-.025.076-.025.161-.025.331v8.176c0 .447 0 .67.094.801a.5.5 0 0 0 .348.205c.16.019.355-.09.744-.306l.286-.158c.5-.278.749-.416.818-.528.082-.135.09-.171.07-.328-.018-.13-.264-.457-.757-1.11A3 3 0 0 1 17 15h4.2c.28.001.42.001.527-.054a.5.5 0 0 0 .218-.218C22 14.62 22 14.48 22 14.2c0-1.819-.002-3.953-.003-5.31M9.813 21.928c.39.216.585.325.745.306a.5.5 0 0 0 .348-.205c.094-.13.094-.354.094-.801v-8.176c0-.17 0-.255-.025-.331a.5.5 0 0 0-.106-.181c-.054-.06-.128-.101-.277-.185l-7.396-4.16c-.391-.22-.587-.33-.748-.312a.5.5 0 0 0-.349.204c-.094.13-.095.355-.095.803L2 16.06v.072c-.001.264-.002.595.1.908a2 2 0 0 0 .43.728c.222.242.513.402.744.53l.063.034z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m2-.611-1.223.68c-.284.157-.425.236-.575.267q-.201.04-.403 0c-.15-.031-.292-.11-.576-.268l-7.4-4.11c-.3-.167-.45-.25-.558-.369a1 1 0 0 1-.215-.364C3 16.573 3 16.401 3 16.06V7.94c0-.342 0-.513.05-.666a1 1 0 0 1 .215-.364c.109-.119.258-.202.558-.368l7.4-4.111c.284-.158.425-.237.576-.268a1 1 0 0 1 .402 0c.15.031.292.11.576.268l7.4 4.11c.3.167.45.25.558.369a1 1 0 0 1 .215.364c.05.152.05.324.05.666V13M7.5 4.5l9 5M16 18h6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PackageX/PackageXIcon.tsx
const PackageXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.207 15.293a1 1 0 0 0-1.414 1.414l1.793 1.793-1.793 1.793a1 1 0 1 0 1.414 1.414L20 19.914l1.793 1.793a1 1 0 0 0 1.414-1.414L21.414 18.5l1.793-1.793a1 1 0 0 0-1.414-1.414L20 17.086zm-6.61-14.108a2 2 0 0 1 .806 0c.307.063.582.217.8.34l.06.033 6.426 3.571c.408.227.613.34.68.49a.5.5 0 0 1 .002.412c-.068.15-.271.265-.679.494l-2.329 1.31L8.4 2.857l2.337-1.298.06-.034c.218-.122.493-.276.8-.339M6.342 4l8.975 4.987-2.925 1.645c-.143.08-.214.12-.29.136a.5.5 0 0 1-.204 0c-.076-.016-.147-.056-.29-.136l-7.3-4.107c-.408-.229-.612-.343-.679-.494a.5.5 0 0 1 .001-.411c.068-.15.272-.264.68-.49z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M21.996 8.89c0-.448 0-.672-.095-.803a.5.5 0 0 0-.35-.204c-.16-.018-.356.092-.747.312l-7.396 4.16c-.149.084-.223.125-.277.184a.5.5 0 0 0-.106.182c-.025.076-.025.161-.025.331v8.176c0 .447 0 .67.094.801a.5.5 0 0 0 .348.205c.16.019.355-.09.744-.306.071-.04.107-.059.13-.075a.45.45 0 0 0 .21-.394c0-.028-.005-.085-.015-.2a3 3 0 0 1 .868-2.38l.378-.379-.378-.379a3 3 0 1 1 4.242-4.242l.379.378.379-.378c.287-.287.617-.504.97-.65.283-.117.424-.176.49-.236a.4.4 0 0 0 .129-.195c.03-.084.03-.2.03-.433zM9.813 21.928c.39.216.585.325.745.306a.5.5 0 0 0 .348-.205c.094-.13.094-.354.094-.801v-8.176c0-.17 0-.255-.025-.331a.5.5 0 0 0-.106-.181c-.054-.06-.128-.101-.277-.185l-7.396-4.16c-.391-.22-.587-.33-.748-.312a.5.5 0 0 0-.349.204c-.094.13-.095.355-.095.803L2 16.06v.072c-.001.264-.002.595.1.908a2 2 0 0 0 .43.728c.222.242.513.402.744.53l.063.034z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-9V7.941c0-.342 0-.514-.05-.666a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.268a1 1 0 0 0-.403 0c-.15.031-.292.11-.576.268l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.427 3 7.599 3 7.94v8.117c0 .343 0 .515.05.667a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.267.133.028.27.028.402 0 .15-.03.292-.11.576-.267l.223-.124M7.5 4.5l9 5m0 6.5 5 5m0-5-5 5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Palette/PaletteIcon.tsx
const PaletteIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11a4 4 0 0 1-4 4h-.5c-.496 0-.648.002-.761.017a2 2 0 0 0-1.722 1.722c-.015.113-.017.265-.017.761v.5a4 4 0 0 1-4 4C5.925 23 1 18.075 1 12m9-7a2 2 0 1 0 0 4 2 2 0 0 0 0-4m4 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-9 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M2 12c0 5.523 4.477 10 10 10a3 3 0 0 0 3-3v-.5c0-.464 0-.697.026-.892a3 3 0 0 1 2.582-2.582c.195-.026.428-.026.892-.026h.5a3 3 0 0 0 3-3c0-5.523-4.477-10-10-10S2 6.477 2 12"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2m9-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-6-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Paint/PaintIcon.tsx
const PaintIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.207 1.293a1 1 0 0 0-1.414 1.414l.293.293-5.928 5.928c-.57.569-1.04 1.039-1.39 1.453-.366.43-.661.865-.83 1.383a4 4 0 0 0 0 2.472c.169.518.464.953.83 1.383.35.414.82.884 1.39 1.453l3.27 3.27c.57.57 1.039 1.04 1.453 1.39.43.365.865.661 1.383.83a4 4 0 0 0 2.472 0c.518-.169.953-.465 1.383-.83.414-.35.884-.82 1.453-1.39l5.526-5.526c.179-.179.353-.352.488-.512.148-.175.308-.396.402-.686.13-.402.13-.835 0-1.236a2 2 0 0 0-.402-.687c-.135-.159-.31-.333-.488-.511l-8.89-8.891-.013-.012zm.293 3.121-5.899 5.899c-.605.605-1.017 1.018-1.309 1.362A4 4 0 0 0 4.04 12h15.046z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 13h17m-8-9.5L10.5 2m1 1 8.868 8.869c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822l-5.474 5.475c-1.188 1.188-1.782 1.782-2.467 2.004a3 3 0 0 1-1.854 0c-.685-.222-1.28-.816-2.468-2.004l-3.211-3.212c-1.188-1.188-1.782-1.782-2.005-2.467a3 3 0 0 1 0-1.854c.223-.685.817-1.28 2.005-2.467z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Passcode/PasscodeIcon.tsx
const PasscodeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.161 6H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v3.678c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031H5.162c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 14.82 1 14.365 1 13.839V10.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 6 4.635 6 5.161 6M7 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 12h.005M17 12h.005M7 12h.005M5.2 7h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 8.52 22 9.08 22 10.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 17 19.92 17 18.8 17H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 15.48 2 14.92 2 13.8v-3.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 7 4.08 7 5.2 7m7.05 5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Paperclip/PaperclipIcon.tsx
const PaperclipIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.97 4.182a2.5 2.5 0 0 0-3.535 0L5.42 13.198a4.25 4.25 0 1 0 6.01 6.01l9.016-9.016a1 1 0 0 1 1.414 1.415l-9.016 9.015a6.25 6.25 0 0 1-8.839-8.839l9.016-9.015a4.5 4.5 0 0 1 6.364 6.364l-8.662 8.662a2.75 2.75 0 1 1-3.89-3.89l7.602-7.6a1 1 0 1 1 1.414 1.413L8.248 15.32a.75.75 0 1 0 1.06 1.06l8.663-8.662a2.5 2.5 0 0 0 0-3.535",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m21.153 10.9-9.016 9.015a5.25 5.25 0 1 1-7.425-7.424l9.016-9.016a3.5 3.5 0 1 1 4.95 4.95l-8.662 8.662a1.75 1.75 0 0 1-2.475-2.475l7.601-7.602"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Pause/PauseIcon.tsx
const PauseIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m-1.5 8a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0zm5 0a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.5 15V9m5 6V9m7.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PasscodeLock/PasscodeLockIcon.tsx
const PasscodeLockIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.161 4H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V11a1 1 0 1 1-2 0V8.2c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C19.75 6 19.377 6 18.8 6H5.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3 7.25 3 7.623 3 8.2v3.6c0 .577 0 .949.024 1.232.022.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C4.25 14 4.623 14 5.2 14H11a1 1 0 1 1 0 2H5.161c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 12.82 1 12.365 1 11.839V8.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 4 4.635 4 5.161 4"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.75 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M12 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M14.75 15.25a2.75 2.75 0 1 1 5.5 0v.778c.203.024.43.074.658.19a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C13 19.93 13 19.684 13 19.432v-.864c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 1.9 1.9 0 0 1 .658-.19zm3.5 0V16h-1.5v-.75a.75.75 0 0 1 1.5 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 11V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 5 19.92 5 18.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 15 4.08 15 5.2 15H11m1-5h.005M17 10h.005M7 10h.005m12.245 7v-1.75a1.75 1.75 0 1 0-3.5 0V17m-3.5-7a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m8.35 11h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C14 17.76 14 18.04 14 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 21 15.04 21 15.6 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Pen/PenIcon.tsx
const PenIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M4.52 22.262c-.887.26-1.33.391-1.513.29a.5.5 0 0 1-.258-.434c-.001-.21.325-.536.979-1.19l6.754-6.754A2.002 2.002 0 0 0 13 12.242a2 2 0 1 0-3.932.518l-6.754 6.754c-.654.654-.98.98-1.19.98a.5.5 0 0 1-.433-.258c-.102-.183.029-.627.29-1.513L4.307 7.425c.065-.277.148-.625.34-.92a2 2 0 0 1 .65-.625c.303-.18.653-.249.932-.304l5.207-1.04a2 2 0 0 1 .076-.912c.094-.29.254-.512.402-.686.136-.16.31-.333.488-.512l.782-.782c.179-.179.353-.353.512-.488a2 2 0 0 1 .686-.402 2 2 0 0 1 1.236 0c.29.094.512.254.687.402.159.135.333.31.511.488L21.6 6.426c.178.179.352.352.487.512.148.174.308.396.402.686a2 2 0 0 1 0 1.236c-.094.29-.254.512-.402.687a9 9 0 0 1-.487.51l-.783.783a9 9 0 0 1-.511.488 2 2 0 0 1-.687.402 2 2 0 0 1-.91.076l-1.042 5.207c-.055.28-.123.63-.304.932a2 2 0 0 1-.625.65c-.295.193-.642.275-.92.34z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13 6 6.502 7.3c-.363.072-.545.109-.692.197a1 1 0 0 0-.325.312c-.094.144-.138.324-.225.684L2 22m0 0 13.507-3.26c.36-.087.54-.13.684-.225a1 1 0 0 0 .312-.325c.088-.147.125-.329.197-.692L18 11M2 22l7.586-7.586m11.283-6.545L16.13 3.13c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668l-.738.738c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l4.738 4.738c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668l.738-.738c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822M11 11a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Pencil/PencilIcon.tsx
const PencilIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M21.707 2.293a3.83 3.83 0 0 0-5.414 0L4.976 13.609c-.233.234-.41.41-.565.61a4 4 0 0 0-.364.56c-.12.223-.209.456-.327.764l-2.153 5.598a1 1 0 0 0 1.292 1.292l5.38-2.069.093-.036.125-.048c.308-.118.541-.208.764-.327q.295-.16.56-.364c.2-.155.376-.332.61-.566L21.707 7.707a3.83 3.83 0 0 0 0-5.414M5.381 16.795l-1.14 2.964 2.964-1.14z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m2.5 21.5 5.55-2.134c.354-.137.532-.205.698-.294q.221-.12.42-.273c.149-.116.283-.25.552-.52L21 7a2.828 2.828 0 1 0-4-4L5.72 14.28c-.269.269-.403.403-.519.552a3 3 0 0 0-.273.42c-.089.166-.157.344-.294.699zm0 0 2.058-5.351c.147-.383.221-.574.347-.662a.5.5 0 0 1 .38-.08c.15.028.295.173.585.463l2.26 2.26c.29.29.435.435.464.586a.5.5 0 0 1-.08.379c-.089.126-.28.2-.663.347z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ParagraphSpacing/ParagraphSpacingIcon.tsx
const ParagraphSpacingIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L7 6.414v11.172l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L5 17.586V6.414L3.707 7.707a1 1 0 0 1-1.414-1.414zM12 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 10h-8m8-4h-8m8 8h-8m8 4h-8m-7 2V4m0 16-3-3m3 3 3-3M6 4 3 7m3-3 3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PercentCircle/PercentCircleIcon.tsx
const PercentCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m4.707 7.707a1 1 0 0 0-1.414-1.414l-8 8a1 1 0 1 0 1.414 1.414zM7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 9h.01M15 15h.01M16 8l-8 8m1.5-7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6.5-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Pentagon/PentagonIcon.tsx
const PentagonIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.497 1.548a2 2 0 0 0-.994 0c-.378.097-.701.334-.959.522l-.071.053-8.119 5.892-.072.052c-.26.186-.585.42-.794.75a2 2 0 0 0-.308.947c-.025.39.101.771.201 1.075l.028.084 3.1 9.531.027.085c.098.304.22.685.47.986.214.26.49.46.804.585.363.143.764.142 1.083.14h10.214c.32.002.72.003 1.083-.14a2 2 0 0 0 .805-.585c.249-.3.371-.682.469-.986l.027-.085 3.1-9.53.028-.085c.1-.304.226-.685.201-1.075a2 2 0 0 0-.308-.947c-.21-.33-.535-.564-.794-.75l-.072-.052-8.119-5.892-.071-.053c-.258-.188-.58-.425-.959-.522"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11.06 2.932c.338-.245.507-.368.692-.415a1 1 0 0 1 .497 0c.184.047.353.17.691.415l8.119 5.892c.338.246.507.368.61.53a1 1 0 0 1 .153.473c.012.19-.052.39-.182.787l-3.1 9.53c-.13.398-.194.597-.315.744a1 1 0 0 1-.403.292c-.177.07-.386.07-.803.07H6.982c-.418 0-.626 0-.804-.07a1 1 0 0 1-.402-.292c-.122-.147-.186-.346-.316-.743l-3.1-9.531c-.13-.398-.194-.597-.182-.787a1 1 0 0 1 .154-.473c.102-.162.272-.284.61-.53z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Percent/PercentIcon.tsx
const PercentIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.707 4.293a1 1 0 0 1 0 1.414l-14 14a1 1 0 0 1-1.414-1.414l14-14a1 1 0 0 1 1.414 0M4.5 6.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m11 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 5 5 19M7.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PhoneActive/PhoneActiveIcon.tsx
const PhoneActiveIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M13.069 5.808a1 1 0 0 1 1.173-.79 6 6 0 0 1 4.74 4.74 1 1 0 0 1-1.963.384 4 4 0 0 0-3.16-3.16 1 1 0 0 1-.79-1.174",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M13.056 1.89a1 1 0 0 1 1.105-.884 10 10 0 0 1 8.833 8.822 1 1 0 0 1-1.988.224 8 8 0 0 0-7.066-7.058 1 1 0 0 1-.884-1.104M6.338 17.752a20.25 20.25 0 0 1-5.144-8.774C1.046 8.459.932 8.057.93 7.505a4.4 4.4 0 0 1 .513-1.971c.531-.946 1.672-2.158 2.657-2.657a3 3 0 0 1 2.708 0c.836.423 1.794 1.402 2.303 2.184a3 3 0 0 1 0 3.27c-.173.267-.42.514-.706.8-.09.09-.188.153-.123.29a13.6 13.6 0 0 0 2.652 3.735 13.6 13.6 0 0 0 3.736 2.652c.14.067.197-.03.29-.122.285-.287.532-.534.798-.707a3 3 0 0 1 3.27 0c.784.509 1.762 1.467 2.185 2.303a3 3 0 0 1 0 2.708c-.495.978-1.697 2.119-2.657 2.657a4.35 4.35 0 0 1-1.97.513c-.552-.002-.955-.116-1.474-.264-3.31-.94-6.34-2.71-8.774-5.144",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14.05 6A5 5 0 0 1 18 9.95M14.05 2A9 9 0 0 1 22 9.94m-11.773 3.923a14.6 14.6 0 0 1-2.847-4.01 2 2 0 0 1-.113-.266 1.05 1.05 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.04 19.04 0 0 0 4.874 8.283 19.04 19.04 0 0 0 8.283 4.874c.565.16.847.24 1.26.241a3.4 3.4 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a2 2 0 0 1-.266-.113 14.6 14.6 0 0 1-4.01-2.846"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Package/PackageIcon.tsx
const PackageIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.403 1.185a2 2 0 0 0-.806 0c-.307.063-.582.217-.8.34l-.06.033L8.4 2.856l8.963 4.98 2.33-1.31c.407-.23.61-.344.678-.495a.5.5 0 0 0-.001-.411c-.069-.15-.273-.264-.68-.49l-6.427-3.572-.06-.034c-.218-.122-.493-.276-.8-.339m2.914 7.802L6.342 4c-.76.423-1.469.816-2.031 1.13-.409.226-.613.34-.681.49a.5.5 0 0 0-.001.411c.067.15.271.265.679.494l7.3 4.107c.143.08.214.12.29.136a.5.5 0 0 0 .204 0c.075-.016.147-.056.29-.136zm6.679-.097c0-.448 0-.672-.095-.803a.5.5 0 0 0-.35-.204c-.16-.018-.356.092-.747.312l-7.396 4.16c-.149.084-.223.125-.277.184a.5.5 0 0 0-.106.182c-.025.076-.025.161-.025.331v8.176c0 .447 0 .67.094.801a.5.5 0 0 0 .348.205c.16.019.355-.09.744-.306l6.477-3.597.063-.034c.23-.128.521-.288.745-.53.193-.21.339-.457.428-.728.103-.313.102-.644.101-.908v-.072c0-1.963-.003-5.303-.004-7.169M10.558 22.234c-.16.019-.355-.09-.745-.306l-6.476-3.597-.063-.034c-.231-.128-.522-.288-.745-.53a2 2 0 0 1-.428-.728c-.103-.313-.102-.644-.101-.908v-.072c0-1.963.002-5.303.004-7.169 0-.448 0-.672.095-.803a.5.5 0 0 1 .35-.204c.16-.018.356.092.747.312l7.396 4.16c.149.084.223.125.277.185a.5.5 0 0 1 .106.18c.025.077.025.162.025.332v8.176c0 .447 0 .67-.094.801a.5.5 0 0 1-.348.205"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.5 7.278 12 12m0 0L3.5 7.278M12 12v9.5m9-5.441V7.94c0-.342 0-.513-.05-.666a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.268a1 1 0 0 0-.403 0c-.15.031-.292.11-.576.268l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.94v8.118c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.576.268.133.027.27.027.402 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a1 1 0 0 0 .215-.364c.05-.152.05-.324.05-.666M16.5 9.5l-9-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PhoneIncoming/PhoneIncomingIcon.tsx
const PhoneIncomingIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21.707 3.707 17.414 8H20a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v2.586l4.293-4.293a1 1 0 1 1 1.414 1.414M1.194 8.978c.94 3.31 2.71 6.34 5.144 8.774a20.25 20.25 0 0 0 8.774 5.145c.52.147.922.261 1.473.263a4.4 4.4 0 0 0 1.971-.512c.96-.54 2.162-1.68 2.657-2.658a3 3 0 0 0 0-2.708c-.423-.836-1.401-1.794-2.184-2.303a3 3 0 0 0-3.27 0c-.267.173-.514.42-.8.707l-.037.039c-.073.078-.132.14-.252.083a13.6 13.6 0 0 1-3.736-2.652A13.6 13.6 0 0 1 8.282 9.42c-.057-.118.01-.182.088-.256l.035-.033c.286-.286.533-.533.706-.8a3 3 0 0 0 0-3.27c-.509-.782-1.467-1.76-2.303-2.183a3 3 0 0 0-2.708 0c-.985.498-2.126 1.71-2.657 2.656a4.4 4.4 0 0 0-.513 1.97c.002.553.116.955.264 1.474"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 4v5m0 0h5m-5 0 6-6M10.227 13.863a14.6 14.6 0 0 1-2.847-4.01 2 2 0 0 1-.113-.266 1.05 1.05 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.04 19.04 0 0 0 4.874 8.283 19.04 19.04 0 0 0 8.283 4.874c.565.16.847.24 1.26.241a3.4 3.4 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a2 2 0 0 1-.266-.113 14.6 14.6 0 0 1-4.01-2.846"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PieChart/PieChartIcon.tsx
const PieChartIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13.595 1.115a11.01 11.01 0 0 1 9.29 9.29c.07.475.104.712.008.957a1.1 1.1 0 0 1-.44.509c-.229.13-.503.13-1.053.13h-7.8c-.56 0-.84 0-1.054-.11a1 1 0 0 1-.437-.437C12 11.24 12 10.96 12 10.4V2.6c0-.55 0-.824.13-1.053.103-.184.311-.364.508-.44.245-.096.483-.061.957.008"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10 3.102c0-.638 0-.957-.163-1.206a1.1 1.1 0 0 0-.618-.43c-.29-.064-.55.033-1.068.226C3.974 3.252 1 7.28 1 12c0 6.075 4.925 11 11 11 4.721 0 8.747-2.974 10.308-7.15.194-.52.29-.779.225-1.07a1.1 1.1 0 0 0-.429-.617C21.855 14 21.536 14 20.898 14h-7.344c-.239 0-.523 0-.774-.02a3 3 0 0 1-1.142-.307 3 3 0 0 1-1.311-1.311 3 3 0 0 1-.307-1.142c-.02-.25-.02-.535-.02-.774z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21.21 15.89A10 10 0 1 1 8 2.83m13.24 5.343a10 10 0 0 1 .728 3.028c.021.257.031.385-.02.5a.53.53 0 0 1-.22.239c-.11.06-.25.06-.528.06h-8.4c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.218-.219C12 11.62 12 11.48 12 11.2V2.8c0-.278 0-.417.06-.528a.53.53 0 0 1 .239-.22c.115-.05.244-.04.5-.02a10 10 0 0 1 8.44 6.141"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Phone/PhoneIcon.tsx
const PhoneIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M16.056 21.88a20.04 20.04 0 0 1-8.718-5.128A20.04 20.04 0 0 1 2.21 8.034l-.016-.056c-.148-.519-.262-.921-.264-1.473a4.4 4.4 0 0 1 .513-1.971c.531-.946 1.672-2.158 2.657-2.656a3 3 0 0 1 2.708 0c.842.426 1.78 1.38 2.303 2.183a3 3 0 0 1 0 3.271c-.173.266-.42.513-.706.8-.09.088-.188.153-.123.289a13.6 13.6 0 0 0 2.652 3.735 13.6 13.6 0 0 0 3.736 2.652c.14.068.196-.029.29-.122.285-.287.532-.534.798-.707a3 3 0 0 1 3.27 0c.784.509 1.762 1.468 2.185 2.303a3 3 0 0 1 0 2.708c-.499.986-1.71 2.126-2.657 2.658-.55.308-1.34.514-1.97.512-.552-.002-.955-.116-1.474-.263z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.38 8.853a14.6 14.6 0 0 0 2.847 4.01 14.6 14.6 0 0 0 4.01 2.847c.124.06.187.09.265.112.28.082.625.023.862-.147.067-.048.124-.105.239-.219.35-.35.524-.524.7-.639a2 2 0 0 1 2.18 0c.176.115.35.29.7.64l.195.194c.532.531.797.797.942 1.082a2 2 0 0 1 0 1.806c-.145.285-.41.551-.942 1.082l-.157.158c-.53.53-.795.794-1.155.997-.4.224-1.02.386-1.478.384-.413-.001-.695-.081-1.26-.241a19.04 19.04 0 0 1-8.283-4.874A19.04 19.04 0 0 1 3.17 7.761c-.16-.564-.24-.846-.241-1.26a3.4 3.4 0 0 1 .384-1.477c.202-.36.467-.625.997-1.155l.157-.158c.532-.53.798-.797 1.083-.941a2 2 0 0 1 1.805 0c.286.144.551.41 1.083.942l.195.194c.35.35.524.525.638.7a2 2 0 0 1 0 2.18c-.114.177-.289.352-.638.701a2 2 0 0 0-.22.238 1.05 1.05 0 0 0-.147.862c.023.08.053.142.113.266"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PiggyBank/PiggyBankIcon.tsx
const PiggyBankIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.5 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6.976 8.628c-.24-.345-.359-.517-.487-.574a.5.5 0 0 0-.357-.018c-.134.043-.239.166-.45.411A6.97 6.97 0 0 0 4.072 12H4a1 1 0 0 1-.5-1.867 1 1 0 0 0-1-1.73A3 3 0 0 0 4 14h.07A7 7 0 0 0 6 17.9v2.323c0 .12 0 .262.01.387.012.145.042.353.153.571a1.5 1.5 0 0 0 .656.656c.218.11.426.141.571.153.125.01.268.01.387.01h1.946c.12 0 .261 0 .387-.01.145-.012.353-.042.57-.153a1.5 1.5 0 0 0 .656-.656c.111-.218.142-.426.154-.57.01-.126.01-.268.01-.388V20h1v.223c0 .12 0 .261.01.387.012.145.042.353.153.57a1.5 1.5 0 0 0 .656.656c.218.111.426.142.571.154.125.01.268.01.387.01h1.946c.12 0 .262 0 .387-.01.145-.012.353-.043.571-.154a1.5 1.5 0 0 0 .656-.655 1.5 1.5 0 0 0 .153-.571c.01-.126.01-.268.01-.387v-.897A7 7 0 0 0 20.745 17h.478c.12 0 .262 0 .387-.01.145-.012.353-.043.571-.154a1.5 1.5 0 0 0 .656-.655 1.5 1.5 0 0 0 .153-.571c.01-.126.01-.268.01-.387v-3.46c0-.113 0-.248-.01-.368a1.5 1.5 0 0 0-.139-.546 1.5 1.5 0 0 0-.7-.7 1.5 1.5 0 0 0-.546-.14 4 4 0 0 0-.279-.009A7 7 0 0 0 20 8.1V7.033c0-.155 0-.33-.013-.48a1.5 1.5 0 0 0-.212-.68 1.5 1.5 0 0 0-.866-.652 1.5 1.5 0 0 0-.71-.017c-.15.028-.318.076-.466.119l-.156.044c-.205.059-.308.088-.38.141a.46.46 0 0 0-.15.178c-.041.08-.055.202-.083.445a5.5 5.5 0 0 1-9.988 2.498"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 13c0 1.648.665 3.142 1.74 4.226.104.105.156.157.187.207.03.048.046.09.06.144.013.057.013.122.013.253v2.37c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C7.38 21 7.52 21 7.8 21h1.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-.4c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C10.88 19 11.02 19 11.3 19h1.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h1.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C17 20.62 17 20.48 17 20.2v-.976c0-.202 0-.303.029-.384a.46.46 0 0 1 .121-.19c.061-.06.166-.108.374-.205a6 6 0 0 0 2.427-2.055c.107-.155.16-.233.217-.28a.5.5 0 0 1 .17-.089c.07-.021.154-.021.32-.021h.542c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 15.62 22 15.48 22 15.2v-3.414c0-.267 0-.4-.05-.503a.5.5 0 0 0-.233-.233c-.103-.05-.236-.05-.503-.05-.193 0-.29 0-.367-.026a.46.46 0 0 1-.203-.13c-.057-.06-.103-.16-.195-.358a6 6 0 0 0-1.19-1.712 1.4 1.4 0 0 1-.186-.207.5.5 0 0 1-.06-.144C19 8.366 19 8.3 19 8.17V7.06c0-.36 0-.54-.075-.66a.5.5 0 0 0-.288-.218c-.137-.039-.31.01-.657.11l-2.372.677a.5.5 0 0 1-.136.029C15.45 7 15.43 7 15.388 7h-.429m-9.96 6a6 6 0 0 1 3.205-5.31M5 13H4a2 2 0 0 1-1-3.732M15 6.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Framer/FramerIcon.tsx
const FramerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5 .5a1 1 0 0 0-.707 1.707L9.586 7.5H5a1 1 0 0 0-1 1v7a1 1 0 0 0 .293.707l7 7A1 1 0 0 0 13 22.5v-6h6a1 1 0 0 0 .707-1.707L14.414 9.5H19a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zm6 16H7.414L11 20.086zm7-9h-5.586l-5-5H18zm-12 2h5.586l5 5H6z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 15.5v7l-7-7m0 0v-7h7m-7 7h14l-7-7m0 0h7v-7H5z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Play/PlayIcon.tsx
const PlayIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m8.006 2.802.036.024L18.591 9.86c.305.203.588.392.805.567.227.183.495.437.649.808a2 2 0 0 1 0 1.532c-.154.371-.422.625-.649.808-.217.175-.5.364-.805.567L8.006 21.198c-.373.248-.708.472-.993.627-.285.154-.676.33-1.132.303a2 2 0 0 1-1.476-.79c-.276-.364-.346-.788-.376-1.11S4 19.502 4 19.054V4.947c0-.449 0-.852.03-1.175.029-.322.1-.745.375-1.11a2 2 0 0 1 1.476-.79c.456-.027.847.15 1.132.304s.62.378.993.626",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 4.99c0-.972 0-1.457.202-1.725a1 1 0 0 1 .738-.395c.335-.02.74.25 1.548.788l10.515 7.01c.668.446 1.002.668 1.118.949a1 1 0 0 1 0 .766c-.116.28-.45.503-1.118.948l-10.515 7.01c-.809.54-1.213.809-1.548.789a1 1 0 0 1-.738-.395C5 20.467 5 19.982 5 19.01z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PhoneOff/PhoneOffIcon.tsx
const PhoneOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21.707 3.707a1 1 0 0 0-1.414-1.414l-18 18a1 1 0 1 0 1.414 1.414L8.016 17.4a20.3 20.3 0 0 0 8.096 4.497c.52.148.922.262 1.474.264a4.4 4.4 0 0 0 1.97-.512c.96-.54 2.162-1.68 2.657-2.658a3 3 0 0 0 0-2.708c-.423-.836-1.401-1.794-2.184-2.303a3 3 0 0 0-3.27 0c-.267.173-.514.42-.8.707l-.037.039c-.073.078-.132.14-.252.083a13.6 13.6 0 0 1-3.051-2.012zM10.012 9.745a14 14 0 0 1-.73-1.325c-.057-.118.01-.182.088-.256l.035-.033c.286-.286.533-.533.706-.8a3 3 0 0 0 0-3.27c-.509-.782-1.467-1.76-2.303-2.183a3 3 0 0 0-2.708 0c-.985.498-2.126 1.71-2.657 2.656a4.4 4.4 0 0 0-.513 1.97c.002.553.116.955.264 1.474a20.3 20.3 0 0 0 3.144 6.44z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5.475 12.863a19 19 0 0 1-2.304-5.102c-.16-.564-.24-.846-.241-1.26a3.4 3.4 0 0 1 .384-1.478c.202-.36.467-.624.997-1.154l.157-.158c.532-.531.798-.797 1.083-.941a2 2 0 0 1 1.805 0c.286.144.551.41 1.083.941l.195.195c.35.35.524.525.638.7a2 2 0 0 1 0 2.18c-.114.177-.289.351-.638.701a2 2 0 0 0-.22.238 1.05 1.05 0 0 0-.147.862c.023.08.053.142.113.266q.182.377.386.747m2.416 3.218.045.045a14.6 14.6 0 0 0 4.01 2.846c.124.06.187.09.265.113.28.082.625.023.862-.147.067-.048.124-.105.239-.22.35-.349.524-.524.7-.638a2 2 0 0 1 2.18 0c.176.114.35.29.7.639l.195.195c.532.531.797.797.942 1.082a2 2 0 0 1 0 1.806c-.145.285-.41.55-.942 1.082l-.157.158c-.53.53-.795.794-1.155.997-.4.224-1.02.385-1.478.384-.413-.001-.695-.081-1.26-.241a19.04 19.04 0 0 1-8.283-4.874L8 16M21 3 3 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Plane/PlaneIcon.tsx
const PlaneIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.026 2.117a3.483 3.483 0 0 1 5.022 4.828l-2.998 3.146 1.811 7.867c.057.243.13.55.105.861a2 2 0 0 1-.222.773c-.368.704-1.155 1.348-1.752 1.844-.233.194-.55.418-.964.492a2 2 0 0 1-1.54-.364c-.338-.25-.522-.594-.643-.87-.118-.27-.232-.612-.357-.985l-1.51-4.534-2.202 2.202c-.107.106-.16.16-.197.201l-.003.004q.01.142.028.285l.19 1.712c.025.217.056.49.013.764a2 2 0 0 1-.236.673c-.137.24-.332.434-.487.588-.304.302-.608.62-.869.84-.199.166-.458.35-.798.438a2 2 0 0 1-1.378-.136 2.04 2.04 0 0 1-.697-.587c-.792-.99-1.406-2.127-2.135-3.164-1.036-.728-2.173-1.342-3.163-2.134a2.04 2.04 0 0 1-.587-.697 2 2 0 0 1-.137-1.378 2.04 2.04 0 0 1 .44-.798c.219-.262.537-.565.838-.87.154-.154.348-.35.589-.486.208-.118.436-.198.673-.236.273-.044.546-.012.764.012q.855.098 1.712.19c.15.018.225.026.28.029h.005q.106-.098.205-.2l2.201-2.201-4.533-1.512a12 12 0 0 1-.984-.356c-.278-.121-.62-.305-.871-.643a2 2 0 0 1-.364-1.54c.073-.414.298-.732.492-.964.494-.595 1.142-1.386 1.843-1.753a2 2 0 0 1 .773-.221c.313-.024.618.047.861.104l7.838 1.805z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17.745 2.813a2.483 2.483 0 0 1 3.58 3.442l-2.78 2.91c-.217.227-.326.341-.393.475a1 1 0 0 0-.104.38c-.01.148.025.302.096.61l1.728 7.487c.073.315.109.473.097.625a1 1 0 0 1-.11.387c-.072.136-.186.25-.415.479l-.37.37c-.607.607-.91.91-1.22.965a1 1 0 0 1-.77-.182c-.253-.188-.389-.595-.66-1.408l-2.01-6.03-3.345 3.346c-.2.2-.3.3-.366.417q-.09.158-.118.337c-.022.133-.006.274.025.554l.184 1.654c.031.28.047.42.025.554a1 1 0 0 1-.118.337c-.067.117-.166.217-.366.417l-.198.197c-.473.473-.71.71-.972.778a1 1 0 0 1-.69-.068c-.244-.119-.43-.397-.8-.954L6.106 18.54c-.066-.1-.099-.15-.137-.194a1 1 0 0 0-.112-.112 2 2 0 0 0-.194-.138L3.31 16.528c-.556-.371-.835-.557-.953-.801a1 1 0 0 1-.069-.69c.069-.262.305-.499.778-.972l.198-.197c.2-.2.3-.3.417-.367q.158-.089.336-.118c.134-.021.274-.005.555.026l1.653.183c.281.032.421.047.555.026a1 1 0 0 0 .336-.118c.118-.067.218-.167.417-.366l3.346-3.346-6.03-2.01c-.813-.27-1.22-.406-1.407-.659a1 1 0 0 1-.182-.77c.055-.31.358-.614.964-1.22l.37-.37c.23-.23.344-.344.48-.415a1 1 0 0 1 .386-.11c.153-.012.31.024.626.097l7.46 1.721c.31.072.464.108.614.097a1 1 0 0 0 .412-.122c.13-.072.242-.187.463-.415z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Plus/PlusIcon.tsx
const PlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 5v14m-7-7h14"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PhoneOutgoing/PhoneOutgoingIcon.tsx
const PhoneOutgoingIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15 3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L18.586 4H16a1 1 0 0 1-1-1M1.194 8.978c.94 3.31 2.71 6.34 5.144 8.774a20.25 20.25 0 0 0 8.774 5.145c.52.147.922.261 1.473.263a4.4 4.4 0 0 0 1.971-.512c.96-.54 2.162-1.68 2.657-2.658a3 3 0 0 0 0-2.708c-.423-.836-1.401-1.794-2.184-2.303a3 3 0 0 0-3.27 0c-.267.173-.514.42-.8.707l-.037.039c-.073.078-.132.14-.252.083a13.6 13.6 0 0 1-3.736-2.652A13.6 13.6 0 0 1 8.282 9.42c-.057-.118.01-.182.088-.256l.035-.033c.286-.286.533-.533.706-.8a3 3 0 0 0 0-3.27c-.509-.782-1.467-1.76-2.303-2.183a3 3 0 0 0-2.708 0c-.985.498-2.126 1.71-2.657 2.656a4.4 4.4 0 0 0-.513 1.97c.002.553.116.955.264 1.474"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M21 8V3m0 0h-5m5 0-6 6m-4.773 4.863a14.6 14.6 0 0 1-2.847-4.01 2 2 0 0 1-.113-.266 1.05 1.05 0 0 1 .147-.862c.048-.067.105-.124.22-.238.35-.35.524-.524.638-.7a2 2 0 0 0 0-2.18c-.114-.176-.289-.351-.638-.7l-.195-.196c-.532-.531-.797-.797-1.083-.941a2 2 0 0 0-1.805 0c-.285.144-.551.41-1.083.941l-.157.158c-.53.53-.795.794-.997 1.154-.224.4-.386 1.02-.384 1.479 0 .413.081.695.241 1.26a19.04 19.04 0 0 0 4.874 8.283 19.04 19.04 0 0 0 8.283 4.874c.565.16.847.24 1.26.241a3.4 3.4 0 0 0 1.478-.384c.36-.203.625-.468 1.155-.997l.157-.158c.532-.531.797-.797.942-1.082a2 2 0 0 0 0-1.806c-.145-.285-.41-.55-.942-1.082l-.195-.195c-.35-.35-.524-.524-.7-.639a2 2 0 0 0-2.18 0c-.176.114-.35.29-.7.639-.115.114-.172.171-.239.22-.237.17-.581.228-.862.146a2 2 0 0 1-.266-.113 14.6 14.6 0 0 1-4.01-2.846"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Podcast/PodcastIcon.tsx
const PodcastIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M9 18a3 3 0 1 1 6 0v2a3 3 0 1 1-6 0z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M2 10.785C2 5.358 6.5 1 12 1s10 4.358 10 9.785c0 3.347-1.721 6.285-4.32 8.043a1 1 0 0 1-1.121-1.656C18.646 15.76 20 13.424 20 10.785 20 6.508 16.441 3 12 3s-8 3.508-8 7.785c0 2.639 1.354 4.975 3.441 6.387a1 1 0 1 1-1.12 1.656C3.72 17.07 2 14.132 2 10.785",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 7c-2.258 0-4 1.727-4 3.75 0 .975.4 1.87 1.07 2.547a1 1 0 1 1-1.421 1.406C6.637 13.681 6 12.293 6 10.751 6 7.527 8.735 5 12 5s6 2.527 6 5.75c0 1.543-.637 2.931-1.649 3.953a1 1 0 0 1-1.422-1.406C15.6 12.619 16 11.726 16 10.75 16 8.727 14.258 7 12 7",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M10 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17.119 18C19.462 16.415 21 13.778 21 10.785 21 5.933 16.97 2 12 2s-9 3.933-9 8.785c0 2.993 1.538 5.63 3.881 7.215m1.479-4C7.519 13.15 7 12.009 7 10.75 7 8.128 9.239 6 12 6s5 2.127 5 4.75c0 1.26-.519 2.4-1.36 3.25M12 22a2 2 0 0 1-2-2v-2a2 2 0 1 1 4 0v2a2 2 0 0 1-2 2m1-11a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Printer/PrinterIcon.tsx
const PrinterIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.161 1h5.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v.866q.13.007.252.017c.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v2.38c0 .795 0 1.386-.136 1.897a4 4 0 0 1-2.829 2.829c-.307.082-.643.115-1.035.128 0 .462-.003.865-.03 1.203-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H9.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167-.028-.338-.03-.74-.031-1.203-.392-.013-.728-.046-1.035-.128a4 4 0 0 1-2.829-2.829C1 15.524 1 14.933 1 14.138v-2.38c0-.804 0-1.469.044-2.01.046-.562.145-1.079.392-1.564a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392L5 6.027v-.866c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C8.18 1 8.635 1 9.161 1M7 6h10v-.8c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C15.75 3 15.377 3 14.8 3H9.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C7 4.25 7 4.623 7 5.2zm0 12.8c0 .577 0 .949.024 1.232.022.272.06.372.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C8.25 21 8.623 21 9.2 21h5.6c.577 0 .949 0 1.232-.024.272-.022.372-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C17 19.75 17 19.377 17 18.8v-1.6c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085l-.11-.008A21 21 0 0 0 14.8 15H9.2c-.576 0-.948 0-1.232.024-.271.022-.372.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C7.001 16.25 7 16.623 7 17.2zm7-8.3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18 7V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 2 15.92 2 14.8 2H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 3.52 6 4.08 6 5.2V7m0 11c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.121C2 15.395 2 14.93 2 14v-2.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 7 5.12 7 6.8 7h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.28 22 10.12 22 11.8V14c0 .93 0 1.395-.102 1.777a3 3 0 0 1-2.122 2.12C19.396 18 18.93 18 18 18m-3-7.5h3M9.2 22h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C18 20.48 18 19.92 18 18.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 14 15.92 14 14.8 14H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 15.52 6 16.08 6 17.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C7.52 22 8.08 22 9.2 22"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Power/PowerIcon.tsx
const PowerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m1 6a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0zM8.8 9.6a1 1 0 1 0-1.6-1.2 6 6 0 1 0 9.599 0 1 1 0 0 0-1.598 1.2 4 4 0 1 1-6.401 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 7v5M8 9a5 5 0 1 0 8 0m6 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PlusCircle/PlusCircleIcon.tsx
const PlusCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m0 6a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 8v8m-4-4h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PuzzlePieceAlt/PuzzlePieceAltIcon.tsx
const PuzzlePieceAltIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.293 1.293a1 1 0 0 1 1.414 0l2.62 2.62c.632-.985 1.441-1.606 2.363-1.84 1.266-.322 2.482.16 3.28.957.798.798 1.279 2.014.957 3.28-.234.922-.855 1.731-1.84 2.363l2.62 2.62a1 1 0 0 1 0 1.414l-3.6 3.6a1 1 0 0 1-1.642-.351c-.527-1.384-1.197-1.83-1.647-1.945-.468-.118-.984.044-1.373.434-.39.39-.553.905-.434 1.373.115.45.561 1.12 1.945 1.647a1 1 0 0 1 .351 1.642l-3.6 3.6a1 1 0 0 1-1.414 0l-2.62-2.62c-.632.985-1.441 1.606-2.363 1.84-1.266.322-2.482-.16-3.28-.957-.798-.798-1.279-2.014-.957-3.28.234-.922.855-1.731 1.84-2.363l-2.62-2.62a1 1 0 0 1 0-1.414l3.6-3.6a1 1 0 0 1 1.641.351c.528 1.384 1.198 1.83 1.648 1.945.468.118.984-.044 1.373-.434.39-.39.553-.905.434-1.373-.115-.45-.561-1.12-1.945-1.648a1 1 0 0 1-.351-1.641z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m12 2 3.6 3.6c2.4-6.3 9.1.4 2.8 2.8L22 12l-3.6 3.6c-2.4-6.3-9.1.4-2.8 2.8L12 22l-3.6-3.6C6 24.7-.7 18 5.6 15.6L2 12l3.6-3.6C8 14.7 14.7 8 8.4 5.6z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PuzzlePiece/PuzzlePieceIcon.tsx
const PuzzlePieceIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.5 4.5a3.5 3.5 0 1 1 7 0V5h.034c.67 0 1.223 0 1.675.03.47.033.904.101 1.322.274a4 4 0 0 1 2.165 2.165c.173.418.241.852.273 1.321q.021.32.026.71h.505a3.5 3.5 0 1 1 0 7H19v.741c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H12.5a1 1 0 0 1-1-1v-1.75a1.25 1.25 0 1 0-2.5 0V22a1 1 0 0 1-1 1H6.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 18.71 1 18.046 1 17.242V15.5a1 1 0 0 1 1-1h1.5a1.5 1.5 0 0 0 0-3H2a1 1 0 0 1-1-1v-.034c0-.67 0-1.223.03-1.676.033-.469.101-.903.274-1.32A4 4 0 0 1 3.47 5.303c.418-.173.852-.241 1.321-.273C5.243 5 5.796 5 6.466 5H6.5z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7.5 4.5a2.5 2.5 0 0 1 5 0V6h1c1.398 0 2.097 0 2.648.228a3 3 0 0 1 1.624 1.624C18 8.403 18 9.102 18 10.5h1.5a2.5 2.5 0 0 1 0 5H18v1.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C15.72 22 14.88 22 13.2 22h-.7v-1.75a2.25 2.25 0 0 0-4.5 0V22H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2v-1.7h1.5a2.5 2.5 0 0 0 0-5H2c0-1.398 0-2.097.228-2.648a3 3 0 0 1 1.624-1.624C4.403 6 5.102 6 6.5 6h1z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/QrCode/QrCodeIcon.tsx
const QrCodeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m5 5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m4 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1m9-9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1M2 17a1 1 0 0 1 1-1h1.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m12.5-5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1M2 21a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M12 1a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1m5.568 14h1.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v1.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201c-.208.017-.454.017-.706.017h-1.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C15 19.93 15 19.684 15 19.432v-1.864c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201c.208-.017.454-.017.706-.017M6 12a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-4H7a1 1 0 0 1-1-1M17.568 2h1.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v1.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201C19.93 9 19.684 9 19.432 9h-1.864c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C15 6.93 15 6.684 15 6.432V4.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C17.07 2 17.316 2 17.568 2m-13 0h1.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77C9 4.07 9 4.316 9 4.568v1.864c0 .252 0 .498-.017.706a2 2 0 0 1-.201.77 2 2 0 0 1-.874.874 2 2 0 0 1-.77.201C6.93 9 6.684 9 6.432 9H4.568c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C2 6.93 2 6.684 2 6.432V4.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C4.07 2 4.316 2 4.568 2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 12h5v5m-8.99-5H3m5.01 5H8m4.01 4H12m9.01-9H21M3 17h1.5m11-5h2M3 21h5m4-19v6m5.6 13h1.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-1.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 16 19.96 16 19.4 16h-1.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C16 16.76 16 17.04 16 17.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C16.76 21 17.04 21 17.6 21m0-13h1.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 7.24 21 6.96 21 6.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 3 19.96 3 19.4 3h-1.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C16 3.76 16 4.04 16 4.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C16.76 8 17.04 8 17.6 8m-13 0h1.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 7.24 8 6.96 8 6.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 3 6.96 3 6.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 8 4.04 8 4.6 8"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Presentation/PresentationIcon.tsx
const PresentationIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 1a1 1 0 0 1 1 1v1h5.839c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v6.678c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031h-1.425l3.293 3.293a1 1 0 0 1-1.414 1.414L14.586 18H13v4a1 1 0 1 1-2 0v-4H9.414l-4.707 4.707a1 1 0 0 1-1.414-1.414L6.586 18H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 14.82 1 14.365 1 13.839V7.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 3 4.635 3 5.161 3H11V2a1 1 0 0 1 1-1"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 17-5 5m11-5 5 5M12 2v2m0 18v-5m-6.8 0h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 15.48 22 14.92 22 13.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 4 19.92 4 18.8 4H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 5.52 2 6.08 2 7.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 17 4.08 17 5.2 17"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Receipt/ReceiptIcon.tsx
const ReceiptIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15.241 2H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 6.29 3 6.954 3 7.758V21a1 1 0 0 0 1.588.809l2.133-1.552 1.904 1.524a1 1 0 0 0 1.213.028L12 20.236l2.162 1.573a1 1 0 0 0 1.213-.028l1.904-1.523 2.133 1.55A1 1 0 0 0 21 21V7.759c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 2 16.046 2 15.242 2"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 3 7.12 3 8.8 3h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C20 5.28 20 6.12 20 7.8V21l-2.75-2-2.5 2L12 19l-2.75 2-2.5-2L4 21z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ReceiptCheck/ReceiptCheckIcon.tsx
const ReceiptCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.759 2h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C21 6.29 21 6.954 21 7.758V21a1 1 0 0 1-1.588.809l-2.133-1.552-1.904 1.524a1 1 0 0 1-1.213.028L12 20.236 9.838 21.81a1 1 0 0 1-1.213-.028l-1.904-1.523-2.133 1.55A1 1 0 0 1 3 21V7.759c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 2 7.954 2 8.758 2m7.448 6.707a1 1 0 0 0-1.414-1.414L11 11.086 9.707 9.793a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 10.5 2 2L15.5 8M20 21V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 3 16.88 3 15.2 3H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 5.28 4 6.12 4 7.8V21l2.75-2 2.5 2L12 19l2.75 2 2.5-2z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/RecordingCircle/RecordingCircleIcon.tsx
const RecordingCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m2 5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m-3 3a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0zm-4 2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm12 0a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 11v2m4-4v6m4-8v10m4-6v2m4-1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Rewind/RewindIcon.tsx
const RewindIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.925 4.228a2 2 0 0 1 1.619.727c.319.387.392.864.424 1.212.032.363.032.824.032 1.35v8.965c0 .527 0 .988-.032 1.35-.032.349-.105.826-.424 1.213a2 2 0 0 1-1.619.727c-.501-.019-.907-.281-1.188-.489-.292-.216-.637-.523-1.03-.873l-5.051-4.49a10 10 0 0 1-.57-.532 2 2 0 0 1-.468-.726 2 2 0 0 1 0-1.325 2 2 0 0 1 .468-.725 10 10 0 0 1 .595-.555L7.707 5.59c.393-.35.738-.657 1.03-.873.281-.208.687-.47 1.188-.489m11 0a2 2 0 0 1 1.619.727c.319.387.392.864.424 1.212.032.363.032.824.032 1.35v8.965c0 .527 0 .988-.032 1.35-.032.349-.105.826-.424 1.213a2 2 0 0 1-1.619.727c-.501-.019-.907-.281-1.187-.489-.293-.216-.638-.523-1.032-.873l-5.05-4.49c-.21-.187-.413-.366-.57-.532a2 2 0 0 1-.468-.726 2 2 0 0 1 0-1.325 2 2 0 0 1 .468-.725c.157-.166.359-.345.57-.533l.025-.022 5.025-4.467c.394-.35.739-.657 1.032-.873.28-.208.686-.47 1.187-.489",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 16.437c0 1.13 0 1.695-.229 1.972a1 1 0 0 1-.809.363c-.358-.013-.78-.388-1.625-1.14l-4.992-4.436c-.465-.414-.698-.62-.784-.865a1 1 0 0 1 0-.662c.086-.245.319-.451.784-.865l4.992-4.437c.844-.75 1.267-1.126 1.625-1.14a1 1 0 0 1 .81.364c.228.277.228.842.228 1.972zm-11 0c0 1.13 0 1.695-.229 1.972a1 1 0 0 1-.809.363c-.358-.013-.78-.388-1.625-1.14l-4.992-4.436c-.465-.414-.698-.62-.784-.865a1 1 0 0 1 0-.662c.086-.245.319-.451.784-.865l4.992-4.437c.844-.75 1.267-1.126 1.625-1.14a1 1 0 0 1 .81.364c.228.277.228.842.228 1.972z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Recording/RecordingIcon.tsx
const RecordingIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1m4.5 1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1M12 5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1m4.5-3a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1M21 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 10v4m4.5-3v2M12 6v12m4.5-15v18M21 10v4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Refresh/RefreshIcon.tsx
const RefreshIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21.473 6.193a1 1 0 1 0-1.932-.518l-.109.406C16.553 2.457 11.38 1.389 7.25 3.773A9.49 9.49 0 0 0 2.552 11a1 1 0 0 0 1.989.212A7.502 7.502 0 0 1 17.645 7.06l-.343-.092a1 1 0 1 0-.518 1.932l2.732.732a1 1 0 0 0 1.225-.707zm-.025 6.806a1 1 0 1 0-1.989-.212A7.503 7.503 0 0 1 6.354 16.94l.345.092a1 1 0 0 0 .517-1.932l-2.732-.732a1 1 0 0 0-1.224.707l-.733 2.732a1 1 0 0 0 1.932.518l.109-.406c2.879 3.624 8.053 4.692 12.182 2.308A9.49 9.49 0 0 0 21.448 13"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20.453 12.893A8.5 8.5 0 0 1 4.638 16.25l-.25-.433m-.842-4.71A8.5 8.5 0 0 1 19.361 7.75l.25.433M3.493 18.066l.732-2.732 2.732.732m10.085-8.132 2.732.732.732-2.732"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Repeat/RepeatIcon.tsx
const RepeatIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M10.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414L11.586 6H6.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.82C3 8.361 3 8.942 3 9.8v5.7c0 .496.002.648.017.761a2 2 0 0 0 1.722 1.722c.114.015.265.017.761.017a1 1 0 1 1 0 2h-.069c-.397 0-.692 0-.953-.034a4 4 0 0 1-3.444-3.444C1 16.261 1 15.966 1 15.57V9.76c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C5.29 4 5.954 4 6.758 4h4.828l-1.293-1.293a1 1 0 0 1 0-1.414m8.968 4.724C19.148 6.002 18.996 6 18.5 6a1 1 0 1 1 0-2h.069c.397 0 .692 0 .953.034a4 4 0 0 1 3.444 3.444c.034.261.034.556.034.953v5.81c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044h-4.828l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L12.414 18H17.2c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V8.5c0-.496-.002-.647-.017-.761a2 2 0 0 0-1.722-1.722"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m11 2 3 3m0 0-3 3m3-3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 7.28 2 8.12 2 9.8v5.7c0 .464 0 .697.026.892a3 3 0 0 0 2.582 2.582c.195.026.428.026.892.026m4.5 0h7.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 16.72 22 15.88 22 14.2V8.5c0-.464 0-.697-.026-.892a3 3 0 0 0-2.582-2.582C19.197 5 18.964 5 18.5 5M10 19l3 3m-3-3 3-3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Rocket/RocketIcon.tsx
const RocketIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15.231 2.718A13.9 13.9 0 0 1 22.006 1 1 1 0 0 1 23 2c0 2.81-.788 7.707-5.852 11.416.085.358.182.829.249 1.349.073.567.114 1.22.054 1.863-.059.634-.222 1.332-.619 1.927v.001c-.68 1.015-1.96 1.603-2.855 1.928a13 13 0 0 1-1.751.49 1.03 1.03 0 0 1-.867-.206A1 1 0 0 1 11 20v-4.586L8.587 13H4a1 1 0 0 1-.984-1.179 12.6 12.6 0 0 1 .5-1.799c.325-.894.913-2.174 1.928-2.853l.001-.001c.595-.397 1.293-.56 1.927-.62a8.6 8.6 0 0 1 1.863.055c.526.068 1 .166 1.36.252a13.9 13.9 0 0 1 4.636-4.137"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.003 14.988a3.18 3.18 0 0 0-2.147.747c-.527.442-.913 1.052-1.2 1.639a11.3 11.3 0 0 0-.68 1.823 17 17 0 0 0-.467 2.168v.002a1 1 0 0 0 1.124 1.124 12 12 0 0 0 .658-.11c.39-.075.928-.19 1.511-.357.58-.166 1.226-.388 1.824-.68.586-.287 1.196-.673 1.639-1.2 1.02-1.209 1.036-3.092-.152-4.266l-.013-.012a3.18 3.18 0 0 0-2.097-.878",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m12 15-3-3m3 3a22.4 22.4 0 0 0 4-2m-4 2v5s3.03-.55 4-2c1.08-1.62 0-5 0-5m-7-1a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11m-7-1H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m-6.5 8.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/RollerBrush/RollerBrushIcon.tsx
const RollerBrushIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5.416 1c-.38 0-.708 0-1.001.058a3 3 0 0 0-2.357 2.357C1.999 3.708 2 4.035 2 4.416v.168c0 .38 0 .709.058 1.001a3 3 0 0 0 2.357 2.357c.293.059.62.058 1.001.058h11.168c.38 0 .709 0 1.001-.058a3 3 0 0 0 2.37-2.43l.071.005c.228.015.315.042.357.06a1 1 0 0 1 .54.54c.018.042.045.129.06.357C21 6.71 21 7.02 21 7.5v.3c0 .577 0 .949-.024 1.232-.022.272-.06.373-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085C19.75 10 19.377 10 18.8 10h-3.639c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167-.028.338-.03.74-.031 1.203l-.138.009a2 2 0 0 0-.77.201 2 2 0 0 0-.874.874 2 2 0 0 0-.201.77C9 16.07 9 16.316 9 16.568v3.864c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h.864c.252 0 .498 0 .706-.017a2 2 0 0 0 .77-.201 2 2 0 0 0 .874-.874 2 2 0 0 0 .201-.77c.017-.208.017-.454.017-.706v-3.864c0-.252 0-.498-.017-.706a2 2 0 0 0-.201-.77 2 2 0 0 0-.874-.874 2 2 0 0 0-.77-.201L13 14.008c0-.47.004-.79.024-1.04.022-.272.06-.373.085-.422a1 1 0 0 1 .437-.437c.05-.025.15-.063.422-.085C14.25 12 14.623 12 15.2 12h3.639c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167C23 8.82 23 8.365 23 7.839v-.371c0-.439 0-.817-.021-1.13a3.1 3.1 0 0 0-.207-.986 3 3 0 0 0-1.624-1.624 3 3 0 0 0-.986-.207l-.203-.01-.017-.096a3 3 0 0 0-2.357-2.357C17.292.999 16.965 1 16.584 1z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 4.5c0 .465 0 .697-.038.89a2 2 0 0 1-1.572 1.572C17.197 7 16.965 7 16.5 7h-11c-.465 0-.697 0-.89-.038A2 2 0 0 1 3.038 5.39C3 5.197 3 4.965 3 4.5s0-.697.038-.89A2 2 0 0 1 4.61 2.038C4.803 2 5.035 2 5.5 2h11c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89m0 0c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C22 6.102 22 6.568 22 7.5v.3c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 11 19.92 11 18.8 11h-3.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C12 12.52 12 13.08 12 14.2v.8m-.4 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 21.24 14 20.96 14 20.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 15 12.96 15 12.4 15h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 15.76 10 16.04 10 16.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 22 11.04 22 11.6 22"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/PlayCircle/PlayCircleIcon.tsx
const PlayCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M9.6 8.116c-.1.133-.1.372-.1.85v6.069c0 .477 0 .716.1.849a.5.5 0 0 0 .364.199c.166.012.367-.117.769-.375l4.72-3.035c.349-.224.523-.336.583-.479a.5.5 0 0 0 0-.389c-.06-.142-.234-.254-.583-.478l-4.72-3.035c-.402-.258-.603-.387-.769-.375a.5.5 0 0 0-.364.2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M9.5 8.965c0-.477 0-.716.1-.849a.5.5 0 0 1 .364-.199c.166-.012.367.117.769.375l4.72 3.035c.349.224.523.336.583.478a.5.5 0 0 1 0 .39c-.06.142-.234.254-.583.478l-4.72 3.035c-.402.258-.603.387-.769.375a.5.5 0 0 1-.364-.2c-.1-.132-.1-.371-.1-.848z"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Rows/RowsIcon.tsx
const RowsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M22 17.162v.677c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031H6.162c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A18 18 0 0 1 2 17.839v-.678c0-.527 0-.982.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C5.18 13 5.635 13 6.161 13H17.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.357M22 6.161v.678c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031H6.162c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C2 7.82 2 7.365 2 6.839V6.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C5.18 2 5.635 2 6.161 2H17.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17.8 10c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 8.48 21 7.92 21 6.8v-.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2v.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 10 5.08 10 6.2 10zm0 11c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 14 18.92 14 17.8 14H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 15.52 3 16.08 3 17.2v.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Safe/SafeIcon.tsx
const SafeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7.5 10.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M17.839 2H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C2 5.18 2 5.635 2 6.161v8.677c0 .528 0 .982.03 1.357.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C18.82 2 18.365 2 17.838 2m.661 4.5a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0zM9 7a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5 21a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m9 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 21h3m6 0h3m-.5-14.5v8M3 6.2v8.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 18 5.08 18 6.2 18h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 16.48 21 15.92 21 14.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 3 18.92 3 17.8 3H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 4.52 3 5.08 3 6.2m8.5 4.3a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Sale/SaleIcon.tsx
const SaleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m14.53 2.394-1.247-.958a2.106 2.106 0 0 0-2.567 0l-1.245.957a.12.12 0 0 1-.083.022l-1.56-.205a2.11 2.11 0 0 0-2.223 1.283l-.6 1.451a.12.12 0 0 1-.06.062l-1.453.6a2.11 2.11 0 0 0-1.282 2.22l.205 1.56a.1.1 0 0 1-.02.082l-.959 1.247a2.106 2.106 0 0 0 0 2.568l.958 1.247a.1.1 0 0 1 .021.081l-.205 1.56a2.11 2.11 0 0 0 1.282 2.223l1.452.599q.043.019.062.062l.6 1.451a2.11 2.11 0 0 0 2.221 1.283l1.56-.205a.12.12 0 0 1 .084.022l1.245.956c.757.583 1.81.582 2.567 0l1.248-.957a.1.1 0 0 1 .073-.02h.006l1.562.206a2.11 2.11 0 0 0 2.223-1.284l.6-1.454a.1.1 0 0 1 .057-.056h.001l1.454-.602a2.11 2.11 0 0 0 1.283-2.222l-.206-1.564a.1.1 0 0 1 .022-.078l.957-1.247a2.1 2.1 0 0 0 0-2.57l-.957-1.247a.1.1 0 0 1-.022-.078l.206-1.564a2.11 2.11 0 0 0-1.282-2.222l-1.455-.601a.1.1 0 0 1-.057-.057l-.601-1.454a2.11 2.11 0 0 0-2.223-1.284l-1.562.205h-.006a.1.1 0 0 1-.073-.02m2.177 6.313a1 1 0 0 0-1.414-1.414l-8 8a1 1 0 1 0 1.414 1.414zM7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 9h.01M15 15h.01M16 8l-8 8m1.202 4.6a1.24 1.24 0 0 1 .92.247l1.203.924c.398.305.951.305 1.348 0l1.249-.959c.233-.179.527-.258.818-.219l1.562.206a1.11 1.11 0 0 0 1.168-.675l.601-1.453c.112-.272.328-.488.6-.6l1.453-.601c.464-.191.74-.671.675-1.168l-.198-1.505a1.24 1.24 0 0 1 .247-.92l.923-1.204a1.105 1.105 0 0 0 0-1.347l-.959-1.25a1.1 1.1 0 0 1-.219-.818l.206-1.562a1.11 1.11 0 0 0-.675-1.168l-1.453-.601a1.1 1.1 0 0 1-.6-.6l-.6-1.453a1.11 1.11 0 0 0-1.169-.675l-1.562.206a1.1 1.1 0 0 1-.817-.217l-1.25-.959a1.105 1.105 0 0 0-1.347 0l-1.249.959a1.12 1.12 0 0 1-.818.219L7.696 3.2a1.11 1.11 0 0 0-1.167.675l-.6 1.453a1.12 1.12 0 0 1-.6.6l-1.453.6c-.464.192-.74.671-.675 1.168l.206 1.562a1.1 1.1 0 0 1-.219.818l-.959 1.249a1.105 1.105 0 0 0 0 1.347l.959 1.25a1.1 1.1 0 0 1 .219.818L3.2 16.303c-.065.497.211.976.675 1.168l1.453.601c.272.112.488.328.6.6l.6 1.453c.192.464.672.74 1.169.675zM9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/SaleCircle/SaleCircleIcon.tsx
const SaleCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m4.707 7.707a1 1 0 0 0-1.414-1.414l-8 8a1 1 0 1 0 1.414 1.414zM7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 9h.01M15 15h.01M16 8l-8 8m14-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Rss/RssIcon.tsx
const RssIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3 11a1 1 0 0 1 1-1 10 10 0 0 1 10 10 1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1-1-1",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3 4a1 1 0 0 1 1-1 17 17 0 0 1 17 17 1 1 0 1 1-2 0A15 15 0 0 0 4 5a1 1 0 0 1-1-1m0 15a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16M6 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Scale/ScaleIcon.tsx
const ScaleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5.863 1H6a1 1 0 1 1 0 2c-.994 0-1.295.009-1.518.068a2 2 0 0 0-1.414 1.414C3.008 4.705 3 5.006 3 6a1 1 0 0 1-2 0v-.137c0-.796 0-1.387.136-1.898a4 4 0 0 1 2.829-2.829C4.476 1 5.067 1 5.863 1m13.655 2.068C19.295 3.008 18.994 3 18 3a1 1 0 1 1 0-2h.138c.795 0 1.386 0 1.897.136a4 4 0 0 1 2.829 2.829C23 4.476 23 5.067 23 5.863V6a1 1 0 1 1-2 0c0-.994-.009-1.295-.068-1.518a2 2 0 0 0-1.414-1.414M9 2a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1M2 9a1 1 0 0 1 1 1v1.536q.09-.052.184-.1c.485-.247 1.002-.346 1.564-.392C5.29 11 5.954 11 6.758 11h.483c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-.1.184H14a1 1 0 1 1 0 2H6.76c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 18.71 1 18.046 1 17.242V10a1 1 0 0 1 1-1m20 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1m0 8a1 1 0 0 1 1 1v.138c0 .795 0 1.386-.136 1.897a4 4 0 0 1-2.829 2.829c-.511.137-1.102.137-1.897.136H18a1 1 0 1 1 0-2c.994 0 1.296-.009 1.518-.068a2 2 0 0 0 1.414-1.414c.06-.223.068-.524.068-1.518a1 1 0 0 1 1-1"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14 22H6.8m0 0c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2M6.8 22h.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C12 19.72 12 18.88 12 17.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C9.72 12 8.88 12 7.2 12h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 14.28 2 15.12 2 16.8v.4m0 0V10m8-8h4m8 8v4m-4 8c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C22 19.396 22 18.93 22 18m0-12c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C19.396 2 18.93 2 18 2M6 2c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122C2 4.605 2 5.07 2 6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ScaleDown/ScaleDownIcon.tsx
const ScaleDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.759 2c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 22 6.954 22 7.758 22h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V7.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.425-.216-.873-.319-1.355-.372l-.21-.02c-.479-.039-1.056-.043-1.741-.044zM7.8 4h3.378a3.6 3.6 0 0 0-.147.805C11 5.18 11 5.635 11 6.161V8.84c0 .527 0 .981.03 1.356.03.371.096.74.263 1.098L8 14.586V12a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2H9.414l3.293-3.293c.357.167.727.232 1.098.262.375.031.83.031 1.356.031h2.678c.527 0 .982 0 1.356-.03.27-.023.54-.063.805-.148V16.2c0 .857 0 1.439-.038 1.889-.035.438-.1.663-.18.819a2 2 0 0 1-.874.874c-.156.08-.38.145-.819.18-.45.037-1.032.038-1.889.038H7.8c-.857 0-1.439 0-1.889-.038-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C4 17.639 4 17.057 4 16.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874c.156-.08.38-.145.819-.18C6.361 4 6.943 4 7.8 4",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8M16.2 3c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8M16.2 3h-1c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C12 4.52 12 5.08 12 6.2v2.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C13.52 12 14.08 12 15.2 12h2.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 10.48 21 9.92 21 8.8v-1m-8.5 3.7L7 17m0 0h5m-5 0v-5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Scales/ScalesIcon.tsx
const ScalesIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.645 5.5H4a1 1 0 0 1 0-2h4.645a3.502 3.502 0 0 1 6.71 0H20a1 1 0 1 1 0 2h-4.645A3.51 3.51 0 0 1 13 7.855V20h7a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h7V7.855A3.51 3.51 0 0 1 8.645 5.5"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.5 7a1 1 0 0 1 .84.456l3.003 4.635c.163.25.31.477.43.834.052.154.09.346.112.484s.047.332.046.495c0 .142-.006.269-.022.393-.017.124-.043.222-.059.283l-.002.01C9.34 16.534 7.601 18 5.5 18s-3.84-1.465-4.348-3.41l-.002-.01a2 2 0 0 1-.059-.283 3 3 0 0 1-.022-.393 3 3 0 0 1 .046-.495c.023-.138.06-.33.112-.484.12-.357.267-.583.43-.835l3.004-4.634A1 1 0 0 1 5.5 7m0 2.839L4.1 12h2.8zm13.84-2.383a1 1 0 0 0-1.68 0l-3.003 4.635c-.163.25-.31.477-.43.834-.053.154-.09.346-.112.484a3 3 0 0 0-.046.495c0 .142.006.269.022.393.017.124.043.222.059.283l.002.01C14.66 16.534 16.399 18 18.5 18s3.84-1.465 4.348-3.41l.002-.01a2.3 2.3 0 0 0 .081-.676 3 3 0 0 0-.047-.495 3 3 0 0 0-.11-.484c-.121-.357-.268-.583-.431-.835zM17.1 12l1.4-2.161L19.9 12z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M2.5 13h6m7 0h6M12 7v14m0-14a2.5 2.5 0 0 0 2.5-2.5M12 7a2.5 2.5 0 0 1-2.5-2.5M4 21h16M4 4.5h5.5m0 0a2.5 2.5 0 0 1 5 0m0 0H20M8.88 14.336C8.48 15.871 7.12 17 5.5 17s-2.98-1.13-3.38-2.664a1.4 1.4 0 0 1-.05-.438 3 3 0 0 1 .105-.653c.08-.237.167-.371.34-.64L5.5 8l2.986 4.606c.173.268.26.402.34.639.05.145.107.5.106.653-.002.25-.018.313-.051.438m13 0C21.48 15.871 20.12 17 18.5 17s-2.98-1.13-3.38-2.664c-.033-.125-.05-.188-.05-.438a2.8 2.8 0 0 1 .105-.653c.08-.237.167-.371.34-.64L18.5 8l2.986 4.606c.173.268.26.402.34.639.05.145.107.5.106.653-.002.25-.018.313-.051.438"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Save/SaveIcon.tsx
const SaveIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15.872 2.083C15.524 1.999 15.165 2 14.758 2h-7c-.804 0-1.469 0-2.01.044-.562.046-1.079.145-1.564.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 22 6.954 22 7.758 22h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-7c0-.407 0-.765-.083-1.114a3 3 0 0 0-.36-.867c-.186-.306-.44-.559-.728-.846L17.585 3.17c-.287-.288-.54-.542-.846-.729a3 3 0 0 0-.867-.359m-.467 1.945c-.088-.022-.194-.028-.73-.028H7.8q-.446 0-.8.002V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C7.76 8 8.04 8 8.6 8h6.8c.56 0 .84 0 1.054-.11a1 1 0 0 0 .437-.436C17 7.24 17 6.96 17 6.4v-.986l-.77-.77c-.38-.38-.459-.45-.536-.497a1 1 0 0 0-.289-.12M8.6 13h6.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C17 13.76 17 14.04 17 14.6V20H7v-5.4c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437c.214-.11.494-.11 1.054-.11",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 3v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C7.76 8 8.04 8 8.6 8h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C17 7.24 17 6.96 17 6.4V4m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C16.24 13 15.96 13 15.4 13H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 13.76 7 14.04 7 14.6V21M21 9.325V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h6.875c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72q.165.27.24.579c.055.23.055.474.055.963"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Ruler/RulerIcon.tsx
const RulerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.463 1.28a1.5 1.5 0 0 0-.927 0 1.5 1.5 0 0 0-.512.296c-.096.081-.196.182-.28.266L1.842 15.743c-.084.085-.185.185-.266.281-.094.111-.22.28-.296.512a1.5 1.5 0 0 0 0 .927c.076.233.202.402.296.513.081.096.182.196.266.28l3.901 3.902c.085.084.185.185.281.266.111.094.28.22.512.295a1.5 1.5 0 0 0 .927 0c.233-.075.402-.2.513-.295.096-.081.196-.182.28-.266L22.158 8.256c.084-.084.185-.184.266-.28.094-.111.22-.28.295-.513a1.5 1.5 0 0 0 0-.927 1.5 1.5 0 0 0-.295-.512 5 5 0 0 0-.266-.28l-3.902-3.902a5 5 0 0 0-.28-.266 1.5 1.5 0 0 0-.513-.296m-2.67 4.513a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414m-1.586 3a1 1 0 1 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.414-1.414zm-4.414 3a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414m-1.586 3a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.414-1.414z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14.5 5.5 16 7m-4.5 1.5L13 10m-4.5 1.5L10 13m-4.5 1.5L7 16m-4.434 1.566 3.868 3.868c.198.198.297.297.411.334.1.033.209.033.31 0 .114-.037.213-.136.41-.334l13.87-13.868c.197-.198.296-.297.333-.412a.5.5 0 0 0 0-.309c-.037-.114-.136-.213-.334-.41l-3.868-3.87c-.198-.197-.297-.296-.412-.333a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334L2.564 16.434c-.197.198-.296.297-.333.411a.5.5 0 0 0 0 .31c.037.114.136.213.334.41"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ScaleUp/ScaleUpIcon.tsx
const ScaleUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H16a1 1 0 1 1 0-2h.2c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V7.8c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C17.639 4 17.057 4 16.2 4H7.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8V8a1 1 0 1 1-2 0v-.241c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.839 11H6.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167-.03.375-.03.83-.03 1.356v2.678c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H8.84c.527 0 .981 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356v-2.677c0-.528 0-.982-.03-1.357-.03-.371-.096-.74-.263-1.098L16 9.414V12a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1h-5a1 1 0 1 0 0 2h2.586l-3.293 3.293c-.357-.167-.727-.232-1.098-.262C9.82 11 9.365 11 8.839 11"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 21h.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m8.5 4.5L17 7m0 0h-5m5 0v5M6.2 21h2.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C12 19.48 12 18.92 12 17.8v-2.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C10.48 12 9.92 12 8.8 12H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 13.52 3 14.08 3 15.2v2.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Search/SearchIcon.tsx
const SearchIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10 6a1 1 0 0 1 1-1 6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1-1-1"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M2 11a9 9 0 1 1 16.032 5.618l3.675 3.675a1 1 0 0 1-1.414 1.414l-3.675-3.675A9 9 0 0 1 2 11m9-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m21 21-4.35-4.35M11 6a5 5 0 0 1 5 5m3 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Scan/ScanIcon.tsx
const ScanIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.759 2H8a1 1 0 1 1 0 2h-.2c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 6.361 4 6.943 4 7.8V8a1 1 0 1 1-2 0v-.241c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2M3 15a1 1 0 0 1 1 1v.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 20 6.943 20 7.8 20H8a1 1 0 1 1 0 2h-.241c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V16a1 1 0 0 1 1-1M18.089 4.038C17.639 4 17.057 4 16.2 4H16a1 1 0 1 1 0-2h.241c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758V8a1 1 0 1 1-2 0v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18M21 15a1 1 0 0 1 1 1v.241c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H16a1 1 0 1 1 0-2h.2c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V16a1 1 0 0 1 1-1M2 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m4.5 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7.5a1 1 0 0 1-1-1m9 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M11 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1m9 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 3h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m5 13h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V16m18-8v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H16m5 13v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H16M3 12h.01m4.49 0h.01m8.99 0h.01M12 12h.01M21 12h.01"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Scissors/ScissorsIcon.tsx
const ScissorsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3.957 9.44a4 4 0 1 1 4.226-.087l2.996 1.525 9.367-4.769a1 1 0 1 1 .908 1.782L13.384 12l8.07 4.109a1 1 0 1 1-.908 1.782l-9.367-4.769-2.996 1.526a4 4 0 1 1-3.845-.287L8.975 12 4.338 9.64a4 4 0 0 1-.38-.2M4 6a2 2 0 1 1 1.193 1.83l-.196-.1A2 2 0 0 1 4 6m.997 10.27a2 2 0 1 0 .197-.1z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4.5 8.6 21 17m0-10L4.5 15.4M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Monitor/MonitorIcon.tsx
const MonitorIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.241 2H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 6.29 1 6.954 1 7.758v4.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 18 5.954 18 6.758 18H11v2H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-2h4.241c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V7.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 2 18.046 2 17.242 2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 21h8m-4-4v4m-5.2-4h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.72 22 13.88 22 12.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 17 5.12 17 6.8 17"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Settings/SettingsIcon.tsx
const SettingsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.286 15.96A1.65 1.65 0 0 1 19.4 15a1.65 1.65 0 0 1 1.51-1H21a2 2 0 0 0 0-4h-.17a1.65 1.65 0 0 1-1.51-1v-.08a1.65 1.65 0 0 1 .33-1.82l.06-.06a2 2 0 0 0 0-2.83 2 2 0 0 0-2.83 0l-.06.06A1.65 1.65 0 0 1 15 4.6a1.65 1.65 0 0 1-1-1.51V3a2 2 0 1 0-4 0v.17a1.65 1.65 0 0 1-1 1.51h-.08a1.65 1.65 0 0 1-1.82-.33l-.06-.06a2 2 0 1 0-2.83 2.83l.06.06A1.65 1.65 0 0 1 4.6 9a1.65 1.65 0 0 1-1.51 1.08H3a2 2 0 1 0 0 4h.17a1.65 1.65 0 0 1 1.51 1 1.65 1.65 0 0 1-.33 1.82l-.06.06a2 2 0 0 0 1.415 3.417 2 2 0 0 0 1.415-.587l.06-.06A1.65 1.65 0 0 1 9 19.4a1.65 1.65 0 0 1 1.08 1.51V21a2 2 0 0 0 4 0v-.17a1.65 1.65 0 0 1 1-1.51 1.65 1.65 0 0 1 1.82.33l.06.06a2 2 0 0 0 2.83 0 2 2 0 0 0 0-2.83l-.06-.06a1.65 1.65 0 0 1-.444-.86M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M18.727 14.727a1.5 1.5 0 0 0 .3 1.655l.055.054a1.816 1.816 0 0 1 0 2.573 1.82 1.82 0 0 1-2.573 0l-.055-.055a1.5 1.5 0 0 0-1.654-.3 1.5 1.5 0 0 0-.91 1.373v.155a1.818 1.818 0 1 1-3.636 0V20.1a1.5 1.5 0 0 0-.981-1.373 1.5 1.5 0 0 0-1.655.3l-.054.055a1.818 1.818 0 0 1-3.106-1.287 1.82 1.82 0 0 1 .533-1.286l.054-.055a1.5 1.5 0 0 0 .3-1.654 1.5 1.5 0 0 0-1.372-.91h-.155a1.818 1.818 0 1 1 0-3.636H3.9a1.5 1.5 0 0 0 1.373-.981 1.5 1.5 0 0 0-.3-1.655l-.055-.054A1.818 1.818 0 1 1 7.491 4.99l.054.054a1.5 1.5 0 0 0 1.655.3h.073a1.5 1.5 0 0 0 .909-1.372v-.155a1.818 1.818 0 0 1 3.636 0V3.9a1.5 1.5 0 0 0 .91 1.373 1.5 1.5 0 0 0 1.654-.3l.054-.055a1.817 1.817 0 0 1 2.573 0 1.82 1.82 0 0 1 0 2.573l-.055.054a1.5 1.5 0 0 0-.3 1.655v.073a1.5 1.5 0 0 0 1.373.909h.155a1.818 1.818 0 0 1 0 3.636H20.1a1.5 1.5 0 0 0-1.373.91"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Share/ShareIcon.tsx
const ShareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 5.414V15a1 1 0 1 1-2 0V5.414L8.707 7.707a1 1 0 0 1-1.414-1.414z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M9 12.534c0-.498 0-.747-.087-.941a1 1 0 0 0-.506-.506C8.213 11 7.964 11 7.466 11c-.67 0-1.223 0-1.676.03-.469.033-.903.101-1.32.275a4 4 0 0 0-2.166 2.164c-.173.418-.241.852-.273 1.322C2 15.243 2 15.796 2 16.466v.068c0 .67 0 1.223.03 1.675.033.47.101.904.274 1.322a4 4 0 0 0 2.165 2.165c.418.173.852.241 1.321.273C6.243 22 6.796 22 7.466 22h9.068c.67 0 1.223 0 1.675-.03.47-.033.904-.101 1.322-.274a4 4 0 0 0 2.165-2.165c.173-.418.241-.852.273-1.322.031-.452.031-1.005.031-1.675v-.068c0-.67 0-1.223-.03-1.676-.033-.469-.101-.903-.274-1.32a4 4 0 0 0-2.165-2.165c-.418-.174-.852-.242-1.322-.274C17.757 11 17.205 11 16.534 11c-.498 0-.747 0-.941.087a1 1 0 0 0-.506.506c-.087.194-.087.443-.087.941V15a3 3 0 1 1-6 0z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 11c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.121C3 13.606 3 14.07 3 15v1.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V15c0-.93 0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C18.396 11 17.93 11 17 11m-1-4-4-4m0 0L8 7m4-4v12"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Shield/ShieldIcon.tsx
const ShieldIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.286 1.088a2 2 0 0 0-.572 0 2.8 2.8 0 0 0-.583.17l-.044.016-5.492 2.06c-.618.23-1.16.433-1.578.801a3 3 0 0 0-.82 1.184c-.199.52-.198 1.1-.197 1.759V12c0 2.826 1.538 5.183 3.2 6.914 1.672 1.743 3.586 2.974 4.598 3.564l.041.024c.185.109.425.25.742.318.26.055.58.055.839 0 .317-.068.556-.209.741-.317l.041-.024c1.012-.591 2.926-1.822 4.6-3.565C19.462 17.184 21 14.826 21 12V7.078c.001-.66.002-1.239-.196-1.76a3 3 0 0 0-.82-1.183c-.418-.368-.96-.57-1.578-.801l-5.493-2.06-.043-.016a2.8 2.8 0 0 0-.584-.17"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11.302 21.615c.221.129.332.194.488.227.122.026.298.026.42 0 .156-.033.267-.098.488-.227C14.646 20.478 20 16.908 20 12V7.218c0-.8 0-1.2-.13-1.543a2 2 0 0 0-.548-.79c-.275-.243-.65-.383-1.398-.664l-5.362-2.01c-.208-.078-.312-.117-.419-.133a1 1 0 0 0-.286 0c-.107.016-.21.055-.419.133L6.076 4.22c-.748.281-1.122.421-1.398.665a2 2 0 0 0-.547.789C4 6.018 4 6.418 4 7.218V12c0 4.908 5.354 8.478 7.302 9.615"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ShieldCheck/ShieldCheckIcon.tsx
const ShieldCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.714 1.088a2 2 0 0 1 .572 0c.219.032.422.109.584.17l.043.016 5.493 2.06c.617.23 1.16.433 1.578.801a3 3 0 0 1 .82 1.184c.198.52.197 1.1.196 1.759V12c0 2.826-1.537 5.183-3.199 6.914-1.673 1.743-3.587 2.974-4.599 3.564l-.04.024c-.186.109-.425.25-.742.318a2.1 2.1 0 0 1-.84 0 2.4 2.4 0 0 1-.74-.317l-.042-.024c-1.012-.591-2.926-1.822-4.599-3.565C4.538 17.184 3 14.826 3 12V7.078c0-.66-.002-1.239.196-1.76a3 3 0 0 1 .82-1.183c.419-.368.961-.57 1.579-.801l5.492-2.06.044-.016c.161-.061.365-.138.583-.17m4.493 8.62a1 1 0 0 0-1.414-1.415L11 12.086l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m9 11.5 2 2L15.5 9m4.5 3c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.1 1.1 0 0 1-.42 0c-.156-.033-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.218c0-.8 0-1.2.13-1.543a2 2 0 0 1 .548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.281 1.123.421 1.398.665a2 2 0 0 1 .547.789c.131.343.131.743.131 1.543z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ShieldDollar/ShieldDollarIcon.tsx
const ShieldDollarIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.714 1.089a2 2 0 0 1 .572 0c.219.032.422.108.584.17l.043.016 5.493 2.06c.617.23 1.16.432 1.578.8a3 3 0 0 1 .82 1.184c.198.52.197 1.1.196 1.76V12c0 2.827-1.537 5.184-3.199 6.915-1.673 1.743-3.587 2.974-4.599 3.564l-.04.024a2.4 2.4 0 0 1-.742.317c-.26.056-.58.056-.84 0a2.4 2.4 0 0 1-.74-.317l-.042-.024c-1.012-.59-2.926-1.821-4.599-3.564C4.538 17.184 3 14.827 3 12V7.078c0-.659-.002-1.238.196-1.759a3 3 0 0 1 .82-1.183c.419-.369.961-.571 1.579-.802l5.492-2.06.044-.016c.161-.06.365-.137.583-.17M13 6a1 1 0 1 0-2 0v.5a3 3 0 0 0 0 6h2a1 1 0 0 1 0 2h-2.133a.87.87 0 0 1-.769-.465 1 1 0 1 0-1.77.93 2.87 2.87 0 0 0 2.539 1.535H11v.5a1 1 0 0 0 2 0v-.5a3 3 0 1 0 0-6h-2a1 1 0 0 1 0-2h2.134c.332 0 .622.187.768.465a1 1 0 0 0 1.77-.93A2.87 2.87 0 0 0 13.135 6.5H13z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9.213 14.5c.312.595.936 1 1.654 1H13a2 2 0 1 0 0-4h-2a2 2 0 1 1 0-4h2.133c.718 0 1.342.405 1.654 1M12 6v1.5m0 8V17m8-5c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.1 1.1 0 0 1-.42 0c-.156-.033-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.218c0-.8 0-1.2.13-1.543a2 2 0 0 1 .548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.281 1.123.421 1.398.665a2 2 0 0 1 .547.789c.131.343.131.743.131 1.543z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ShieldPlus/ShieldPlusIcon.tsx
const ShieldPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.714 1.088a2 2 0 0 1 .572 0c.219.032.422.109.584.17l.043.016 5.493 2.06c.617.23 1.16.433 1.578.801a3 3 0 0 1 .82 1.184c.198.52.197 1.1.196 1.759V12c0 2.826-1.537 5.183-3.199 6.914-1.673 1.743-3.587 2.974-4.599 3.564l-.04.024c-.186.109-.425.25-.742.318a2.1 2.1 0 0 1-.84 0 2.4 2.4 0 0 1-.74-.317l-.042-.024c-1.012-.591-2.926-1.822-4.599-3.565C4.538 17.184 3 14.826 3 12V7.078c0-.66-.002-1.239.196-1.76a3 3 0 0 1 .82-1.183c.419-.368.961-.57 1.579-.801l5.492-2.06.044-.016c.161-.061.365-.138.583-.17M12 7.5a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 14.5v-6m-3 3h6m5 .5c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.1 1.1 0 0 1-.42 0c-.156-.033-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.218c0-.8 0-1.2.13-1.543a2 2 0 0 1 .548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.281 1.123.421 1.398.665a2 2 0 0 1 .547.789c.131.343.131.743.131 1.543z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ShieldOff/ShieldOffIcon.tsx
const ShieldOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l.998.998A2.1 2.1 0 0 0 3 5.776V12c0 2.827 1.537 5.183 3.2 6.914 1.672 1.743 3.586 2.974 4.598 3.565l.041.024c.185.108.425.249.742.317.26.055.58.055.838 0 .318-.068.558-.21.743-.318l.042-.024c.978-.571 2.81-1.747 4.449-3.411l2.64 2.64a1 1 0 0 0 1.414-1.414z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20.053 15.81c.575-1.144.947-2.42.947-3.81V7.078c.001-.66.002-1.239-.196-1.76a3 3 0 0 0-.82-1.183c-.418-.368-.96-.57-1.579-.801l-5.492-2.06-.043-.016c-.162-.061-.365-.138-.584-.17a2 2 0 0 0-.572 0 2.8 2.8 0 0 0-.584.17l-.043.016-4.051 1.52z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m8.809 3.197 2.63-.986c.207-.078.311-.117.418-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.281 1.123.421 1.398.665a2 2 0 0 1 .547.789c.131.343.131.743.131 1.543V12a7 7 0 0 1-.318 2.071m-2.06 3.555c-1.686 1.96-3.834 3.353-4.922 3.988-.223.13-.334.195-.49.228a1.1 1.1 0 0 1-.42 0c-.156-.033-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V5.776c0-.467.29-.885.727-1.049M3 3l18 18"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ShoppingCart/ShoppingCartIcon.tsx
const ShoppingCartIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2 3h1.133l.448 3.138 1.056 7.763c.063.46.117.861.188 1.19.075.35.183.693.389 1.018a3 3 0 0 0 1.28 1.117c.349.16.703.22 1.06.248.336.026.74.026 1.205.026h8.627c.442 0 .828 0 1.149-.024a3 3 0 0 0 1.019-.23 3 3 0 0 0 1.262-1.045c.209-.303.328-.626.417-.958.084-.31.156-.69.238-1.123l1.335-7.01c.027-.139.058-.3.072-.442a1.5 1.5 0 0 0-.068-.667 1.5 1.5 0 0 0-.659-.797 1.5 1.5 0 0 0-.643-.192A5 5 0 0 0 21.06 5H5.439l-.354-2.475c-.015-.103-.032-.23-.057-.34a1.5 1.5 0 0 0-.2-.495 1.5 1.5 0 0 0-.638-.554 1.5 1.5 0 0 0-.518-.127A5 5 0 0 0 3.327 1H2a1 1 0 0 0 0 2m5 18a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M2 2h1.306c.246 0 .37 0 .468.045a.5.5 0 0 1 .213.185c.059.092.076.213.111.457L4.571 6m0 0 1.052 7.731c.134.982.2 1.472.435 1.841a2 2 0 0 0 .853.745c.398.183.893.183 1.883.183h8.558c.942 0 1.414 0 1.799-.17a2 2 0 0 0 .841-.696c.239-.346.327-.81.503-1.735l1.324-6.95c.062-.325.093-.488.048-.615a.5.5 0 0 0-.22-.266C21.532 6 21.366 6 21.034 6zM10 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ShieldZap/ShieldZapIcon.tsx
const ShieldZapIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.714 1.088a2 2 0 0 1 .572 0c.219.032.422.109.584.17l.043.016 5.493 2.06c.617.23 1.16.433 1.578.801a3 3 0 0 1 .82 1.184c.198.52.197 1.1.196 1.759V12c0 2.826-1.537 5.183-3.199 6.914-1.673 1.743-3.587 2.974-4.599 3.564l-.04.024c-.186.109-.425.25-.742.318a2.1 2.1 0 0 1-.84 0 2.4 2.4 0 0 1-.74-.317l-.042-.024c-1.012-.591-2.926-1.822-4.599-3.565C4.538 17.184 3 14.826 3 12V7.078c0-.66-.002-1.239.196-1.76a3 3 0 0 1 .82-1.183c.419-.368.961-.57 1.579-.801l5.492-2.06.044-.016c.161-.061.365-.138.583-.17m1.993 7.12a1 1 0 0 0-1.414-1.415l-3 3a1 1 0 0 0 .26 1.601l2.76 1.38-2.02 2.019a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0-.26-1.601l-2.759-1.38z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m13 7.5-3 3 4 2-3 3m9-3.5c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.1 1.1 0 0 1-.42 0c-.156-.033-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.218c0-.8 0-1.2.13-1.543a2 2 0 0 1 .548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.21.055.419.133l5.362 2.01c.748.281 1.123.421 1.398.665a2 2 0 0 1 .547.789c.131.343.131.743.131 1.543z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Shuffle/ShuffleIcon.tsx
const ShuffleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.707 2.293a1 1 0 1 0-1.414 1.414L18.586 5h-.149c-.81 0-1.422 0-1.994.173a4 4 0 0 0-1.377.737c-.462.379-.8.888-1.25 1.563l-5.223 7.835c-.556.833-.726 1.07-.929 1.237a2 2 0 0 1-.688.369c-.251.076-.543.086-1.545.086H3a1 1 0 1 0 0 2h2.563c.81 0 1.422.001 1.994-.172a4 4 0 0 0 1.377-.738c.462-.379.8-.888 1.25-1.563l5.223-7.835c.556-.833.726-1.07.929-1.237a2 2 0 0 1 .688-.369C17.275 7.01 17.567 7 18.57 7h.017l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414zm0 12a1 1 0 0 0-1.414 1.414L18.586 17h-.017c-1.002 0-1.294-.01-1.545-.086a2 2 0 0 1-.688-.369c-.203-.166-.373-.404-.929-1.237l-.242-.363a1 1 0 0 0-1.664 1.11l.315.472c.45.675.788 1.184 1.25 1.563a4 4 0 0 0 1.377.738c.572.173 1.183.173 1.994.172h.149l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6.976 7.086C6.725 7.01 6.433 7 5.43 7H3a1 1 0 1 1 0-2h2.563c.81 0 1.422 0 1.994.173a4 4 0 0 1 1.377.737c.462.379.8.888 1.25 1.563l.315.472a1 1 0 1 1-1.664 1.11l-.242-.363c-.556-.833-.726-1.07-.929-1.237a2 2 0 0 0-.688-.369"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m18 15 3 3m0 0-3 3m3-3h-2.431c-.94 0-1.409 0-1.835-.13a3 3 0 0 1-1.033-.552c-.344-.283-.605-.674-1.126-1.455l-.242-.363M18 3l3 3m0 0-3 3m3-3h-2.431c-.94 0-1.409 0-1.835.13a3 3 0 0 0-1.033.552c-.344.283-.605.674-1.126 1.455l-5.15 7.726c-.521.781-.782 1.172-1.126 1.455-.304.25-.655.438-1.033.552-.426.13-.896.13-1.835.13H3M3 6h2.431c.94 0 1.409 0 1.835.13a3 3 0 0 1 1.033.552c.344.283.605.674 1.126 1.455l.242.363"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Signal/SignalIcon.tsx
const SignalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M15.536 7.05a1 1 0 0 1 1.414 0 7 7 0 0 1 0 9.9 1 1 0 0 1-1.414-1.414 5 5 0 0 0 0-7.072 1 1 0 0 1 0-1.414m-7.072 0a1 1 0 0 1 0 1.414 5 5 0 0 0 0 7.072A1 1 0 1 1 7.05 16.95a7 7 0 0 1 0-9.9 1 1 0 0 1 1.414 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M5.636 4.222a1 1 0 0 1 0 1.414 9 9 0 0 0 0 12.728 1 1 0 1 1-1.414 1.414c-4.296-4.296-4.296-11.26 0-15.556a1 1 0 0 1 1.414 0m12.728 0a1 1 0 0 1 1.414 0c4.296 4.296 4.296 11.26 0 15.556a1 1 0 1 1-1.414-1.414 9 9 0 0 0 0-12.728 1 1 0 0 1 0-1.414M9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.243 7.757a6 6 0 0 1 0 8.486m-8.486 0a6 6 0 0 1 0-8.486M4.93 19.071c-3.905-3.905-3.905-10.237 0-14.142m14.142 0c3.905 3.905 3.905 10.237 0 14.142M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ShoppingBag/ShoppingBagIcon.tsx
const ShoppingBagIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.098 5.01a5.002 5.002 0 0 1 9.804 0q.333.007.618.03c.522.04 1.003.128 1.463.346a4 4 0 0 1 1.723 1.569c.26.437.392.908.482 1.425.086.495.143 1.104.212 1.84l.608 6.482c.081.873.149 1.59.154 2.176.006.605-.052 1.167-.281 1.701a4 4 0 0 1-1.76 1.933c-.51.278-1.064.388-1.668.439-.583.049-1.304.049-2.18.049H7.727c-.877 0-1.598 0-2.181-.05-.604-.05-1.158-.16-1.668-.438a4 4 0 0 1-1.76-1.933c-.23-.534-.287-1.096-.281-1.701.005-.585.072-1.303.154-2.176L2.6 10.22c.069-.736.126-1.345.212-1.84.09-.517.222-.988.482-1.425a4 4 0 0 1 1.722-1.569c.46-.218.942-.306 1.464-.347q.285-.022.618-.03M9.171 5a3.001 3.001 0 0 1 5.658 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 9V6a4 4 0 0 0-8 0v3m-4.408 1.352-.6 6.4c-.17 1.82-.256 2.73.046 3.432a3 3 0 0 0 1.32 1.45C5.03 22 5.944 22 7.771 22h8.458c1.828 0 2.742 0 3.413-.366a3 3 0 0 0 1.32-1.45c.302-.703.217-1.612.046-3.432l-.6-6.4c-.144-1.537-.216-2.305-.561-2.886a3 3 0 0 0-1.292-1.176C17.945 6 17.173 6 15.629 6H8.371c-1.543 0-2.315 0-2.925.29a3 3 0 0 0-1.292 1.176c-.346.581-.418 1.35-.562 2.886"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/SkipForward/SkipForwardIcon.tsx
const SkipForwardIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19 4a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1m-12.998.08a2 2 0 0 0-1.565.753c-.302.379-.375.834-.406 1.172C4 6.352 4 6.79 4 7.285v9.43c0 .495 0 .933.031 1.28.031.338.104.793.406 1.172a2 2 0 0 0 1.565.752c.485 0 .886-.228 1.17-.415.29-.192.631-.466 1.018-.775l5.901-4.721a10 10 0 0 0 .65-.548c.191-.182.406-.424.531-.758a2 2 0 0 0 0-1.404 2.04 2.04 0 0 0-.53-.758 10 10 0 0 0-.679-.57l-5.874-4.7a15 15 0 0 0-1.018-.775c-.283-.187-.684-.415-1.169-.415",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19 5v14M7.6 17.92l5.838-4.67c.534-.428.801-.641.898-.9a1 1 0 0 0 0-.7c-.097-.259-.364-.472-.898-.9L7.6 6.08c-.833-.666-1.25-1-1.6-1a1 1 0 0 0-.783.377C5 5.73 5 6.263 5 7.329v9.342c0 1.066 0 1.599.218 1.872a1 1 0 0 0 .783.376c.35 0 .766-.333 1.599-.999"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/SkipBack/SkipBackIcon.tsx
const SkipBackIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5 4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m12.998.08a2 2 0 0 1 1.565.753c.302.379.375.834.406 1.172.031.347.031.785.031 1.28v9.43c0 .495 0 .933-.031 1.28-.031.338-.104.793-.406 1.172a2 2 0 0 1-1.565.752c-.485 0-.886-.228-1.169-.415-.29-.192-.632-.466-1.019-.775l-5.9-4.721a10 10 0 0 1-.65-.548 2.04 2.04 0 0 1-.531-.758 2 2 0 0 1 0-1.404c.125-.334.34-.576.53-.758a10 10 0 0 1 .679-.57l5.874-4.699c.386-.31.728-.583 1.018-.775.283-.187.684-.415 1.169-.415",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 19V5m11.4 1.08-5.838 4.67c-.534.428-.801.641-.898.9a1 1 0 0 0 0 .7c.097.259.364.472.898.9l5.839 4.67c.832.666 1.248.999 1.598 1a1 1 0 0 0 .783-.377c.218-.273.218-.806.218-1.872V7.329c0-1.066 0-1.599-.218-1.872a1 1 0 0 0-.783-.376c-.35 0-.766.333-1.598.999"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Sliders/SlidersIcon.tsx
const SlidersIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5 2a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6 15.83a3.001 3.001 0 1 0-2 0V21a1 1 0 1 0 2 0z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13 15a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 2a1 1 0 0 1 1 1v3.17a3.001 3.001 0 1 1-2 0V3a1 1 0 0 1 1-1m10 13a3 3 0 0 1-2 2.83V21a1 1 0 1 1-2 0v-3.17A3.001 3.001 0 1 1 22 15",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19 2a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 21v-6m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-8V3m7 18v-6m0-8V3m0 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 14v-4m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-8V3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Slash/SlashIcon.tsx
const SlashIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M6.382 4.968a9 9 0 0 1 12.65 12.65zM4.968 6.382a9 9 0 0 0 12.65 12.65z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m4.93 4.93 14.14 14.14M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Send/SendIcon.tsx
const SendIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21.595 1.458c-.396-.133-.764-.037-.947.016-.2.058-.438.151-.677.244L3.014 8.336a10 10 0 0 0-.724.303c-.173.085-.54.275-.744.669a1.5 1.5 0 0 0 .001 1.384c.205.394.572.583.744.668.2.098.458.199.725.303l4.72 1.835c.352.137.528.206.704.21a1 1 0 0 0 .448-.095c.159-.074.292-.208.56-.475l4.845-4.845a1 1 0 1 1 1.414 1.414l-4.845 4.845c-.267.268-.401.401-.475.56a1 1 0 0 0-.095.448c.005.176.073.352.21.704l1.835 4.72c.104.267.205.525.303.725.085.172.274.539.668.744a1.5 1.5 0 0 0 1.384 0c.394-.204.584-.57.669-.742.098-.2.2-.458.303-.725l6.618-16.957c.093-.24.186-.477.244-.677.053-.183.149-.551.017-.947a1.5 1.5 0 0 0-.948-.947"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10.5 13.5 21 3M10.627 13.828l2.628 6.758c.232.596.347.893.514.98a.5.5 0 0 0 .462 0c.167-.086.283-.384.515-.979l6.59-16.888c.21-.537.315-.806.258-.977a.5.5 0 0 0-.316-.316c-.172-.057-.44.048-.978.257L3.413 9.253c-.595.233-.893.349-.98.516a.5.5 0 0 0 0 .461c.087.167.385.283.98.514l6.759 2.629c.12.046.18.07.232.106a.5.5 0 0 1 .116.117c.037.05.06.111.107.232"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Square/SquareIcon.tsx
const SquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M16.241 2H7.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 22 6.954 22 7.758 22h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V7.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C17.71 2 17.046 2 16.242 2"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/StarAlt1/StarAlt1Icon.tsx
const StarAlt1Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.611 1.634a1.5 1.5 0 0 0-1.222 0 1.54 1.54 0 0 0-.626.544c-.102.146-.208.33-.307.502L8.542 6.01l-3.84-.007c-.2 0-.412-.001-.59.015-.181.016-.494.06-.784.27a1.5 1.5 0 0 0-.611 1.058 1.55 1.55 0 0 0 .158.814c.075.162.182.345.282.517L5.084 12l-1.927 3.322c-.1.173-.207.356-.282.518a1.54 1.54 0 0 0-.158.814 1.5 1.5 0 0 0 .611 1.058c.29.21.603.254.784.27.178.016.39.016.59.015l3.84-.008 1.914 3.33c.099.173.205.357.307.503.105.15.3.398.626.544a1.5 1.5 0 0 0 1.222 0c.327-.146.521-.395.626-.544.102-.146.208-.33.307-.502l1.914-3.33 3.841.007c.2 0 .411.001.589-.015.181-.016.494-.06.784-.27a1.5 1.5 0 0 0 .611-1.058 1.54 1.54 0 0 0-.158-.814 7 7 0 0 0-.282-.518L18.916 12l1.927-3.323c.1-.172.207-.355.282-.517a1.55 1.55 0 0 0 .158-.814 1.5 1.5 0 0 0-.611-1.059 1.54 1.54 0 0 0-.784-.27 7 7 0 0 0-.589-.014l-3.84.007-1.915-3.33a7 7 0 0 0-.307-.502 1.53 1.53 0 0 0-.626-.544"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11.306 3.207c.228-.396.342-.594.49-.66a.5.5 0 0 1 .408 0c.148.066.262.264.49.66l1.955 3.402c.084.147.126.22.185.273a.5.5 0 0 0 .18.105c.077.024.161.024.33.024l3.924-.008c.457-.001.685-.002.817.094a.5.5 0 0 1 .203.353c.017.162-.097.36-.326.754l-1.97 3.395c-.084.146-.126.219-.143.297a.5.5 0 0 0 0 .208c.017.078.059.151.144.297l1.969 3.395c.229.395.343.592.326.754a.5.5 0 0 1-.203.353c-.132.096-.36.095-.817.094l-3.924-.008c-.169 0-.253 0-.33.024a.5.5 0 0 0-.18.105c-.059.053-.101.126-.185.273l-1.955 3.402c-.228.396-.342.594-.49.66a.5.5 0 0 1-.408 0c-.148-.066-.262-.264-.49-.66l-1.955-3.402c-.084-.147-.126-.22-.185-.273a.5.5 0 0 0-.18-.105c-.077-.024-.161-.024-.33-.024l-3.924.008c-.457.001-.685.002-.817-.094a.5.5 0 0 1-.203-.353c-.017-.162.097-.36.326-.754l1.97-3.395c.084-.146.126-.219.143-.297a.5.5 0 0 0 0-.208c-.017-.078-.059-.151-.144-.297L4.038 8.204c-.229-.395-.343-.592-.326-.754a.5.5 0 0 1 .203-.353c.132-.096.36-.095.817-.094l3.924.008c.169 0 .253 0 .33-.024a.5.5 0 0 0 .18-.105c.059-.053.101-.126.185-.273z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Star/StarIcon.tsx
const StarIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.646 1.776a1.5 1.5 0 0 0-1.292 0c-.353.168-.547.46-.645.62a8 8 0 0 0-.307.583L8.246 7.346l-4.822.705a8 8 0 0 0-.65.113c-.182.044-.52.139-.789.423a1.5 1.5 0 0 0-.398 1.228c.051.387.27.663.391.805.127.148.295.312.46.472l3.488 3.397-.823 4.799a8 8 0 0 0-.095.652c-.014.187-.029.538.158.882a1.5 1.5 0 0 0 1.045.759c.384.071.714-.051.887-.123a8 8 0 0 0 .591-.291L12 18.9l4.31 2.267c.204.107.412.216.592.29.174.073.503.195.887.124a1.5 1.5 0 0 0 1.045-.76c.187-.343.172-.694.158-.881a8 8 0 0 0-.095-.652l-.822-4.799 3.487-3.397c.165-.16.333-.324.46-.472.122-.142.34-.418.39-.805a1.5 1.5 0 0 0-.397-1.228c-.27-.284-.607-.38-.79-.423a8 8 0 0 0-.649-.113l-4.822-.705L13.6 2.98a8 8 0 0 0-.308-.582c-.098-.16-.292-.453-.645-.621"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11.283 3.453c.23-.467.345-.7.502-.775a.5.5 0 0 1 .43 0c.157.075.272.308.502.775l2.187 4.43c.068.138.102.207.152.26a.5.5 0 0 0 .155.114c.066.03.143.042.295.064l4.891.715c.515.075.773.113.892.238a.5.5 0 0 1 .133.41c-.023.172-.21.353-.582.716l-3.54 3.446c-.11.108-.165.162-.2.225a.5.5 0 0 0-.06.184c-.009.072.004.148.03.3l.835 4.867c.088.514.132.77.05.922a.5.5 0 0 1-.349.253c-.17.032-.4-.09-.862-.332l-4.373-2.3c-.136-.07-.204-.107-.276-.12a.5.5 0 0 0-.192 0c-.072.013-.14.05-.276.12l-4.373 2.3c-.461.243-.692.364-.862.332a.5.5 0 0 1-.348-.253c-.083-.152-.039-.409.05-.922l.834-4.867c.026-.152.039-.228.03-.3a.5.5 0 0 0-.06-.184c-.035-.063-.09-.117-.2-.225L3.16 10.4c-.373-.363-.56-.544-.582-.716a.5.5 0 0 1 .132-.41c.12-.125.377-.163.892-.238l4.891-.715c.152-.022.228-.034.295-.064a.5.5 0 0 0 .155-.113c.05-.054.084-.123.152-.26z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Speedometer/SpeedometerIcon.tsx
const SpeedometerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M6 12a6 6 0 0 1 6-6 1 1 0 1 0 0-2 8 8 0 0 0-8 8 1 1 0 1 0 2 0m11.207-3.793a1 1 0 0 0-1.414-1.414l-3.275 3.275A2.001 2.001 0 1 0 12 14a2 2 0 0 0 1.932-2.518z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 12a7 7 0 0 1 7-7m4.5 2.5L12 12m10 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/StarAlt5/StarAlt5Icon.tsx
const StarAlt5Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1M5.636 4.222a1 1 0 1 0-1.414 1.414L5.636 7.05A1 1 0 0 0 7.05 5.636zM1 12a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1m19-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm-1.636 5.95a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414-1.414zm1.414-11.314a1 1 0 0 0-1.414-1.414L16.95 5.636a1 1 0 0 0 1.414 1.414zM12 19a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m-4.95-.636a1 1 0 1 0-1.414-1.414l-1.414 1.414a1 1 0 0 0 1.414 1.414zm5.847-11.807a1 1 0 0 0-1.794 0l-1.312 2.66-2.936.429a1 1 0 0 0-.553 1.705l2.124 2.068-.502 2.922a1 1 0 0 0 1.451 1.054L12 16.015l2.625 1.38a1 1 0 0 0 1.45-1.054l-.5-2.922 2.123-2.068a1 1 0 0 0-.553-1.705l-2.936-.43z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 12h-2m-.929 7.071-1.414-1.414M4 12H2m4.343-5.657L4.929 4.93M12 4V2m5.657 4.343L19.07 4.93M12 22v-2m-7.071-.929 1.414-1.414M12 7l1.545 3.13 3.455.505-2.5 2.435.59 3.44L12 14.885 8.91 16.51l.59-3.44L7 10.635l3.455-.505z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/StarAlt3/StarAlt3Icon.tsx
const StarAlt3Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.97 1.757a1 1 0 0 0-1.94 0L9.728 6.963c-.27 1.084-.362 1.398-.517 1.641a2 2 0 0 1-.607.607c-.243.155-.557.246-1.64.517L1.756 11.03a1 1 0 0 0 0 1.94l5.206 1.302c1.084.27 1.398.362 1.641.517a2 2 0 0 1 .607.607c.155.243.246.556.517 1.64l1.302 5.206a1 1 0 0 0 1.94 0l1.302-5.206c.27-1.084.362-1.397.517-1.64.156-.244.363-.45.607-.607.243-.155.556-.246 1.64-.517l5.206-1.302a1 1 0 0 0 0-1.94l-5.206-1.302c-1.084-.27-1.397-.362-1.64-.517a2 2 0 0 1-.607-.607c-.155-.243-.246-.557-.517-1.64z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m12 2-1.302 5.206c-.254 1.016-.38 1.524-.645 1.937a3 3 0 0 1-.91.91c-.413.265-.921.391-1.937.645L2 12l5.206 1.302c1.016.254 1.524.38 1.937.645a3 3 0 0 1 .91.91c.265.413.391.921.645 1.937L12 22l1.302-5.206c.254-1.016.38-1.524.645-1.937.234-.366.544-.676.91-.91.413-.265.921-.391 1.937-.645L22 12l-5.206-1.302c-1.016-.254-1.524-.38-1.937-.645a3 3 0 0 1-.91-.91c-.265-.413-.391-.921-.645-1.937z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/StarAlt2/StarAlt2Icon.tsx
const StarAlt2Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.634 1.725a1.5 1.5 0 0 0-1.268 0c-.344.16-.54.438-.64.595-.102.159-.207.36-.307.555l-1.46 2.81-3.107-.61a7 7 0 0 0-.626-.106c-.185-.02-.523-.04-.864.129a1.5 1.5 0 0 0-.79.992c-.09.369.006.694.066.87.06.18.153.387.242.587l1.286 2.893-2.414 2.049c-.167.141-.34.288-.473.423-.13.133-.357.384-.437.756a1.5 1.5 0 0 0 .282 1.237c.233.3.547.428.722.49.178.065.398.122.61.177l3.064.798.096 3.165c.007.219.013.446.036.633.023.185.078.52.318.814.281.343.7.545 1.144.55.38.005.675-.16.834-.258.16-.099.343-.235.518-.366L12 19.009l2.534 1.898c.175.132.357.268.518.367.159.098.455.263.835.258a1.5 1.5 0 0 0 1.143-.55c.24-.294.295-.629.318-.814.023-.187.03-.414.036-.633l.096-3.165 3.064-.798c.212-.055.432-.112.61-.176.175-.063.489-.192.722-.491a1.5 1.5 0 0 0 .282-1.237c-.08-.371-.307-.623-.437-.756a7 7 0 0 0-.473-.423l-2.414-2.049 1.286-2.893c.09-.2.182-.408.242-.586.06-.177.156-.502.067-.871a1.5 1.5 0 0 0-.791-.992c-.34-.17-.679-.149-.864-.13-.188.02-.411.064-.626.106l-3.107.61-1.46-2.81a7 7 0 0 0-.307-.554c-.1-.157-.295-.434-.64-.595"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M11.29 3.366c.23-.442.344-.663.498-.735a.5.5 0 0 1 .423 0c.154.072.269.293.498.735l1.514 2.913c.099.19.148.286.222.349a.5.5 0 0 0 .23.11c.095.019.2-.002.412-.043l3.22-.633c.489-.096.733-.144.885-.069a.5.5 0 0 1 .264.331c.04.165-.061.393-.264.848l-1.333 2.999c-.088.196-.131.294-.135.392a.5.5 0 0 0 .057.248c.045.086.127.156.291.295l2.503 2.123c.38.322.57.483.605.65a.5.5 0 0 1-.094.412c-.104.134-.345.197-.827.322l-3.176.827c-.208.054-.312.082-.39.14a.5.5 0 0 0-.159.199c-.04.089-.043.196-.05.411l-.099 3.28c-.015.498-.023.748-.13.879a.5.5 0 0 1-.381.183c-.17.003-.37-.147-.768-.445l-2.627-1.968c-.172-.129-.258-.193-.352-.218a.5.5 0 0 0-.255 0c-.094.025-.18.09-.352.218l-2.627 1.968c-.399.298-.598.448-.768.445a.5.5 0 0 1-.38-.183c-.108-.131-.116-.38-.131-.878l-.1-3.28c-.006-.216-.01-.323-.049-.412a.5.5 0 0 0-.158-.2c-.079-.058-.183-.085-.39-.139l-3.177-.827c-.482-.125-.723-.188-.827-.322a.5.5 0 0 1-.094-.412c.036-.167.226-.328.605-.65l2.503-2.123c.164-.14.246-.209.291-.295a.5.5 0 0 0 .057-.248c-.004-.098-.047-.196-.135-.392L4.808 7.172c-.203-.455-.304-.683-.264-.848a.5.5 0 0 1 .264-.33c.152-.076.396-.028.885.068l3.22.633c.211.041.317.062.413.043a.5.5 0 0 0 .229-.11c.074-.063.124-.159.223-.35z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/StarAlt4/StarAlt4Icon.tsx
const StarAlt4Icon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M5.5 2a1 1 0 0 0-2 0v1.5H2a1 1 0 0 0 0 2h1.5V7a1 1 0 0 0 2 0V5.5H7a1 1 0 0 0 0-2H5.5zm0 15a1 1 0 1 0-2 0v1.5H2a1 1 0 1 0 0 2h1.5V22a1 1 0 1 0 2 0v-1.5H7a1 1 0 1 0 0-2H5.5zm8.433-14.359a1 1 0 0 0-1.866 0L10.332 7.15c-.3.78-.394 1.006-.523 1.188a2 2 0 0 1-.471.47c-.182.13-.407.224-1.188.524l-4.51 1.735a1 1 0 0 0 0 1.866l4.509 1.735c.78.3 1.006.394 1.188.523.182.13.341.29.47.471.13.182.224.407.524 1.188l1.735 4.509a1 1 0 0 0 1.866 0l1.735-4.509c.3-.78.394-1.006.523-1.188.13-.182.29-.341.471-.47.182-.13.407-.224 1.188-.524l4.509-1.735a1 1 0 0 0 0-1.866L17.85 9.332c-.78-.3-1.006-.394-1.188-.523a2 2 0 0 1-.47-.471c-.13-.182-.224-.407-.524-1.188z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4.5 22v-5m0-10V2M2 4.5h5m-5 15h5M13 3l-1.734 4.509c-.282.733-.423 1.1-.643 1.408a3 3 0 0 1-.706.707c-.308.219-.675.36-1.408.642L4 12l4.509 1.734c.733.282 1.1.423 1.408.643.273.194.512.433.707.706.219.308.36.675.642 1.408L13 21l1.734-4.509c.282-.733.423-1.1.643-1.408.194-.273.433-.512.706-.707.308-.219.675-.36 1.408-.642L22 12l-4.509-1.734c-.733-.282-1.1-.423-1.408-.642a3 3 0 0 1-.706-.707c-.22-.308-.36-.675-.643-1.408z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/StickerCircle/StickerCircleIcon.tsx
const StickerCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.778 1C7.425 1 3.05 3.786 1.454 7.885c-.147.377-.22.565-.178.722.036.136.13.254.256.318.145.074.379.037.847-.038a11 11 0 0 1 1.753-.137c6.14 0 11.118 4.977 11.118 11.117q0 .79-.108 1.55c-.068.49-.102.735-.024.88a.5.5 0 0 0 .327.248c.16.037.355-.048.745-.216 3.992-1.73 6.705-5.81 6.705-10.212C22.895 5.977 17.918 1 11.778 1"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.941 21.394c.305.305.457.457.63.477a.53.53 0 0 0 .408-.14c.124-.122.148-.317.198-.707q.072-.57.072-1.157A9.117 9.117 0 0 0 2.97 10.823c-.39.05-.586.075-.707.2a.53.53 0 0 0-.14.407c.02.173.173.325.477.63z"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M22 12.117C22 6.53 17.472 2 11.885 2 7.348 2 3.51 4.984 2.224 9.095c-.082.264-.123.395-.12.56.004.134.045.3.104.42.073.147.186.26.41.485L13.44 21.38c.225.226.338.339.486.412.12.059.285.1.419.103.165.004.296-.037.56-.12C19.017 20.49 22 16.652 22 12.117"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M3.447 9.734q.36-.026.728-.026c5.588 0 10.117 4.53 10.117 10.117q0 .367-.026.729c-.03.42-.044.63-.167.76a.53.53 0 0 1-.413.154c-.178-.018-.34-.18-.662-.502l-9.99-9.99c-.322-.322-.484-.484-.502-.661a.53.53 0 0 1 .155-.414c.13-.122.34-.137.76-.167"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Sun/SunIcon.tsx
const SunIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M13 2a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zm0 18a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zM1 12a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1m4.607-7.807a1 1 0 1 0-1.414 1.414l1.414 1.414a1 1 0 1 0 1.414-1.414zm14.2 0a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 1 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0M7.021 18.397a1 1 0 1 0-1.414-1.414l-1.414 1.414a1 1 0 0 0 1.414 1.414zm9.958-1.414a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 1 1-1.414 1.414l-1.414-1.414a1 1 0 0 1 0-1.414M20 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm-8-5a6 6 0 1 0 0 12 6 6 0 0 0 0-12"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 2v2m0 16v2M4 12H2m4.314-5.686L4.9 4.9m12.786 1.414L19.1 4.9M6.314 17.69 4.9 19.104m12.786-1.414 1.414 1.414M22 12h-2m-3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Stop/StopIcon.tsx
const StopIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.161 2H17.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V17.84c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H6.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A18 18 0 0 1 2 17.838V6.162c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C5.18 2 5.635 2 6.161 2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/StopCircle/StopCircleIcon.tsx
const StopCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M8.109 8.546C8 8.76 8 9.04 8 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 16 9.04 16 9.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 15.24 16 14.96 16 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 8 14.96 8 14.4 8H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M8 9.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.76 8 9.04 8 9.6 8h4.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C16 8.76 16 9.04 16 9.6v4.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C15.24 16 14.96 16 14.4 16H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 15.24 8 14.96 8 14.4z"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/StickerSquare/StickerSquareIcon.tsx
const StickerSquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 2.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219C11.62 2 11.48 2 11.201 2H7.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 6.29 2 6.954 2 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 22 6.954 22 7.758 22h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-3.443c0-.28 0-.42-.055-.526a.5.5 0 0 0-.218-.219C21.62 12 21.48 12 21.2 12h-3.441c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C12 7.71 12 7.046 12 6.242z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.908 10c.293 0 .44 0 .56-.074a.54.54 0 0 0 .225-.543c-.033-.137-.128-.233-.32-.424l-5.332-5.332c-.191-.192-.287-.288-.424-.32a.54.54 0 0 0-.543.224c-.074.12-.074.267-.074.561V6.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18.45.037 1.032.038 1.889.038z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13 3.5v2.7c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C15.28 11 16.12 11 17.8 11h2.7m.5 1.988V16.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l5.19 5.188c.518.519.777.778.963 1.081.164.269.286.561.36.867.082.346.082.713.082 1.446"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/SwitchHorizontal/SwitchHorizontalIcon.tsx
const SwitchHorizontalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M16.707 2.293a1 1 0 1 0-1.414 1.414L17.586 6H4a1 1 0 0 0 0 2h13.586l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414zm-8 11.414a1 1 0 1 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L6.414 18H20a1 1 0 1 0 0-2H6.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 17H4m0 0 4-4m-4 4 4 4M4 7h16m0 0-4-4m4 4-4 4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Tablet/TabletIcon.tsx
const TabletIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M16.839 1H7.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C3 4.18 3 4.635 3 5.161V18.84c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h9.678c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V5.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C17.82 1 17.365 1 16.838 1M12 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 17.5h.01M7.2 22h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 2 17.92 2 16.8 2H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 3.52 4 4.08 4 5.2v13.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22m5.3-4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Target/TargetIcon.tsx
const TargetIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1a1 1 0 0 1 1 1v1.055A9.004 9.004 0 0 1 20.945 11H22a1 1 0 1 1 0 2h-1.055A9.004 9.004 0 0 1 13 20.945V22a1 1 0 1 1-2 0v-1.055A9.004 9.004 0 0 1 3.055 13H2a1 1 0 1 1 0-2h1.055A9.004 9.004 0 0 1 11 3.055V2a1 1 0 0 1 1-1m1 17.93V18a1 1 0 1 0-2 0v.93A7 7 0 0 1 5.07 13H6a1 1 0 1 0 0-2h-.93A7.005 7.005 0 0 1 11 5.07V6a1 1 0 1 0 2 0v-.93A7 7 0 0 1 18.93 11H18a1 1 0 1 0 0 2h.93A7 7 0 0 1 13 18.93",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 12h-4M6 12H2m10-6V2m0 20v-4m8-6a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Snowflake/SnowflakeIcon.tsx
const SnowflakeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M8.293 1.293a1 1 0 0 1 1.414 0L12 3.586l2.293-2.293a1 1 0 1 1 1.414 1.414L13 5.414v4.854l4.203-2.427.991-3.698a1 1 0 1 1 1.932.518l-.84 3.132 3.133.84a1 1 0 1 1-.518 1.931l-3.698-.99L14 12l4.203 2.427 3.698-.991a1 1 0 1 1 .518 1.931l-3.132.84.839 3.132a1 1 0 1 1-1.932.518l-.99-3.698L13 13.732v4.854l2.707 2.707a1 1 0 0 1-1.414 1.414L12 20.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L11 18.586v-4.854L6.796 16.16l-.99 3.698a1 1 0 0 1-1.932-.518l.839-3.132-3.132-.839a1 1 0 1 1 .517-1.932l3.698.991L10 12 5.797 9.573l-3.698.991a1 1 0 0 1-.518-1.932l3.132-.839-.84-3.132a1 1 0 0 1 1.933-.518l.99 3.698L11 10.268V5.414L8.293 2.707a1 1 0 0 1 0-1.414"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m18.062 8.5-12.124 7m12.124-7 1.098-4.098M18.062 8.5l4.098 1.098M5.938 15.5 1.84 14.402M5.938 15.5 4.84 19.598M18.062 15.5l-12.124-7m12.124 7 4.098-1.098M18.062 15.5l1.098 4.098M5.938 8.5 4.84 4.402M5.938 8.5 1.84 9.598M12 5v14m0-14L9 2m3 3 3-3m-3 17-3 3m3-3 3 3"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Sunset/SunsetIcon.tsx
const SunsetIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1M4 19a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m.607-13.807a1 1 0 1 0-1.414 1.414l1.414 1.414a1 1 0 1 0 1.414-1.414zm16.2 0a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 1 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0M5.07 14a7.002 7.002 0 0 1 13.86 0H22a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 3v2M5.314 7.314 3.9 5.9m14.786 1.414L20.1 5.9M6 15a6 6 0 0 1 12 0m4 0H2m17 4H5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Thermometer/ThermometerIcon.tsx
const ThermometerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1a3.5 3.5 0 0 0-3.5 3.5v8.757a5.5 5.5 0 1 0 7 0V4.5A3.5 3.5 0 0 0 12 1m0 14.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M14.5 4.5a2.5 2.5 0 0 0-5 0v9.258a4.5 4.5 0 1 0 5 0z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 18.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Tag/TagIcon.tsx
const TagIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1.327 2.638a3 3 0 0 1 1.311-1.31c.379-.194.772-.265 1.167-.297C4.18 1 4.635 1 5.162 1h4.596c.407-.001.766-.002 1.114.082a3 3 0 0 1 .867.36c.306.186.56.44.847.728l7.756 7.757c.57.57 1.04 1.039 1.39 1.453.366.43.661.865.83 1.383a4 4 0 0 1 0 2.472c-.169.518-.464.953-.83 1.383-.35.414-.82.884-1.39 1.453l-2.27 2.27c-.57.57-1.039 1.04-1.453 1.39-.43.366-.865.661-1.383.83a4 4 0 0 1-2.472 0c-.518-.169-.953-.464-1.383-.83-.414-.35-.884-.82-1.453-1.39l-7.757-7.756c-.288-.288-.542-.541-.729-.847a3 3 0 0 1-.359-.867C.999 10.524 1 10.165 1 9.758V5.162c0-.528 0-.982.03-1.357.033-.395.104-.788.297-1.167M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 8h.01M2 5.2v4.475c0 .489 0 .733.055.963.05.204.13.4.24.579.123.201.296.374.642.72l7.669 7.669c1.188 1.188 1.782 1.782 2.467 2.004a3 3 0 0 0 1.854 0c.685-.222 1.28-.816 2.467-2.004l2.212-2.212c1.188-1.188 1.782-1.782 2.004-2.467a3 3 0 0 0 0-1.854c-.222-.685-.816-1.28-2.004-2.467l-7.669-7.669c-.346-.346-.519-.519-.72-.642a2 2 0 0 0-.578-.24C10.409 2 10.164 2 9.675 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2M8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Pin/PinIcon.tsx
const PinIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.324 1c-.362 0-.698 0-.973.025-.288.026-.647.088-.98.308a2 2 0 0 0-.852 1.26c-.081.39-.005.746.077 1.023.08.265.204.577.338.913l1.023 2.556c.014.035.035.073.042.11v2.243q.002.105 0 .21l-.003.003-.128.163-1.597 1.996c-.31.387-.583.729-.775 1.019-.187.283-.415.684-.415 1.169a2 2 0 0 0 .752 1.565c.379.302.834.375 1.172.406.347.031.785.031 1.28.031H11v6a1 1 0 0 0 2 0v-6h3.715c.495 0 .933 0 1.28-.031.338-.031.793-.104 1.172-.406a2 2 0 0 0 .752-1.565c0-.485-.228-.886-.416-1.169-.191-.29-.465-.632-.774-1.019l-1.598-1.996q-.066-.082-.13-.165v-.003L17 9.439V7.193l.043-.108 1.022-2.556c.135-.336.26-.648.339-.913.082-.277.158-.633.077-1.023a2 2 0 0 0-.853-1.26c-.332-.22-.691-.282-.979-.308C16.374 1 16.038 1 15.676 1z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 15v7M8 7.308v2.13c0 .209 0 .313-.02.412a1 1 0 0 1-.09.254c-.045.09-.11.172-.24.334L6.08 12.4c-.666.833-.999 1.249-.999 1.599a1 1 0 0 0 .376.782C5.731 15 6.264 15 7.33 15h9.342c1.066 0 1.599 0 1.873-.219A1 1 0 0 0 18.92 14c0-.35-.333-.766-1-1.599l-1.569-1.962c-.13-.162-.195-.243-.241-.334a1 1 0 0 1-.09-.254C16 9.75 16 9.647 16 9.44V7.31c0-.116 0-.174.007-.23q.009-.075.029-.15a2 2 0 0 1 .079-.215l1.008-2.52c.294-.735.44-1.102.38-1.397a1 1 0 0 0-.427-.63C16.825 2 16.429 2 15.637 2H8.364c-.792 0-1.188 0-1.44.167a1 1 0 0 0-.426.63c-.06.295.086.662.38 1.397l1.008 2.52c.043.107.064.16.08.215a1 1 0 0 1 .028.15c.006.056.006.114.006.23"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Server/ServerIcon.tsx
const ServerIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18.839 1H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 4.18 1 4.635 1 5.161V6.84c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H18.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.03-.376.03-.831.03-1.357V5.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C19.82 1 19.365 1 18.838 1M6 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M18.839 13H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167-.03.375-.03.83-.03 1.356v1.677c0 .528 0 .982.03 1.357.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h13.677c.528 0 .982 0 1.357-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V17.16c0-.527 0-.982-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296-.375-.03-.83-.03-1.357-.03M4.75 18a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M6 6h.01M6 18h.01m-.81-8h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 8.48 22 7.92 22 6.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 2 19.92 2 18.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 10 4.08 10 5.2 10m0 12h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 14 19.92 14 18.8 14H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 15.52 2 16.08 2 17.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Tool/ToolIcon.tsx
const ToolIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9 8a7 7 0 0 1 9.353-6.595 1 1 0 0 1 .37 1.65L16.48 5.321c-.318.321-.477.482-.552.66a1 1 0 0 0 .002.781c.076.178.236.338.556.657.32.32.481.481.66.557a1 1 0 0 0 .781 0c.178-.075.339-.235.66-.554l2.304-2.293a1 1 0 0 1 1.64.346 7 7 0 0 1-8.193 9.325 16 16 0 0 0-.583-.134l-.013.011a9 9 0 0 0-.287.281l-6.248 6.248a3.121 3.121 0 1 1-4.414-4.414l6.248-6.248c.144-.144.225-.225.28-.287.016-.018.007-.037.002-.066a16 16 0 0 0-.124-.53A7 7 0 0 1 9 8",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.631 7.631c-.396-.396-.594-.594-.668-.822a1 1 0 0 1 0-.618c.074-.228.272-.426.668-.822L18.47 2.53a6 6 0 0 0-8.3 6.895c.12.49.179.734.168.888a.85.85 0 0 1-.11.392c-.07.138-.207.274-.48.547L3.5 17.5a2.121 2.121 0 0 0 3 3l6.248-6.248c.273-.273.41-.41.547-.48a.85.85 0 0 1 .392-.11c.154-.011.399.049.888.168q.687.168 1.425.17a6 6 0 0 0 5.47-8.47l-2.84 2.84c-.396.396-.594.594-.822.668a1 1 0 0 1-.618 0c-.228-.074-.426-.272-.822-.668z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/MicrophoneOff/MicrophoneOffIcon.tsx
const MicrophoneOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M2.707 1.293a1 1 0 0 0-1.414 1.414L8 9.414V12a4 4 0 0 0 6.032 3.446l1.444 1.445A6 6 0 0 1 6 12V9.999a1 1 0 1 0-2 0v2a8 8 0 0 0 7 7.938V21H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-1.062a7.96 7.96 0 0 0 3.906-1.618l4.387 4.387a1 1 0 0 0 1.414-1.414l-4.387-4.387A7.97 7.97 0 0 0 20 12v-2a1 1 0 1 0-2 0v2c0 1.296-.41 2.496-1.11 3.476l-4.735-4.736z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M16 11.757V5a4 4 0 0 0-7.85-1.092z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 9.4V5a3 3 0 0 0-5.688-1.334M12 19v3m0-3a7 7 0 0 1-7-7v-2m7 9a7 7 0 0 0 7-7v-2M8 22h8M2 2l20 20m-10-7a3 3 0 0 1-3-3V9l5.123 5.12A3 3 0 0 1 12 15"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ThumbsDown/ThumbsDownIcon.tsx
const ThumbsDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M16 2.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 1 14.96 1 14.4 1H8.08c-.698 0-1.278 0-1.756.036-.498.038-.957.12-1.401.32a4 4 0 0 0-1.7 1.458c-.265.408-.415.85-.529 1.337-.108.466-.196 1.04-.303 1.73l-.535 3.481c-.141.915-.257 1.665-.297 2.278-.042.631-.015 1.22.2 1.785a4 4 0 0 0 1.76 2.052c.526.299 1.105.416 1.735.47C5.866 16 6.624 16 7.55 16h.85c.297 0 .459 0 .575.01l.014.002v.013c.01.116.011.279.011.575v2.934A3.466 3.466 0 0 0 12.466 23c.72 0 1.372-.424 1.665-1.082l3.36-7.562c.082-.183.125-.278.16-.344l.003-.006h.006c.075-.005.18-.006.38-.006h.799c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.297-1.167.03-.375.03-.83.03-1.356V5.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.31-1.311c-.38-.193-.773-.264-1.168-.296C19.821 1 19.365 1 18.84 1a.84.84 0 0 0-.839.839V10a1 1 0 1 1-2 0z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 2v11m5-3.2V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 2 19.92 2 18.8 2H8.118c-1.461 0-2.192 0-2.782.267A3 3 0 0 0 4.06 3.361c-.354.542-.465 1.265-.687 2.71l-.523 3.4c-.293 1.904-.44 2.857-.157 3.598a3 3 0 0 0 1.32 1.539c.69.392 1.653.392 3.58.392H8.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C10 15.76 10 16.04 10 16.6v2.934A2.466 2.466 0 0 0 12.466 22a.82.82 0 0 0 .75-.488l3.362-7.562c.152-.344.229-.516.35-.642a1 1 0 0 1 .383-.249c.164-.059.352-.059.729-.059h.76c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 11.48 22 10.92 22 9.8"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/TrendUp/TrendUpIcon.tsx
const TrendUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M15 6a1 1 0 1 0 0 2h4.586l-6.162 6.162c-.21.21-.325.323-.414.4l-.01.008-.01-.009a8 8 0 0 1-.414-.4l-2.76-2.76a9 9 0 0 0-.512-.487 2 2 0 0 0-.686-.402 2 2 0 0 0-1.236 0c-.29.094-.512.254-.686.402-.16.135-.333.31-.512.488l-4.891 4.89a1 1 0 1 0 1.414 1.415l4.869-4.869c.21-.21.325-.323.414-.4L8 12.43l.01.009c.09.076.205.19.414.4l2.76 2.76c.179.178.352.352.511.487.175.148.397.308.687.402a2 2 0 0 0 1.236 0c.29-.094.512-.254.687-.402a9 9 0 0 0 .51-.488L21 9.414V14a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m22 7-7.869 7.869c-.396.396-.594.594-.822.668a1 1 0 0 1-.618 0c-.228-.074-.426-.272-.822-.668L9.13 12.13c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668L2 17M22 7h-7m7 0v7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Tram/TramIcon.tsx
const TramIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.575 1c-.367 0-.644 0-.921.039a4 4 0 0 0-.721.17c-.266.09-.514.213-.842.377l-1.038.52a1 1 0 0 0 .894 1.788l.987-.493c.402-.2.52-.257.636-.297a2 2 0 0 1 .36-.085A3 3 0 0 1 8.383 3l1 2H8.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564q-.025.325-.036.652c-.017.542-.025.813.081 1.034.092.19.251.355.438.453C3.745 11 4.03 11 4.6 11h14.8c.57 0 .855 0 1.073-.113a1.02 1.02 0 0 0 .438-.453c.106-.22.098-.492.08-1.034a13 13 0 0 0-.035-.652c-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C16.71 5 16.046 5 15.242 5h-.624l1-2c.255.002.355.006.451.02a2 2 0 0 1 .36.084c.118.04.236.096.637.297l.987.493a1 1 0 0 0 .894-1.788l-1.038-.52c-.328-.164-.576-.288-.842-.377a4 4 0 0 0-.72-.17c-.278-.04-.555-.04-.922-.039zm3.807 4 1-2h-2.764l1 2zm3.997 15.994q-.514.008-1.138.006H8.76q-.624.002-1.138-.006l-.726 1.453a1 1 0 0 1-1.79-.894l.42-.84a3 3 0 0 1-.34-.149 4 4 0 0 1-1.749-1.748c-.247-.485-.346-1.002-.392-1.564C3 16.71 3 16.046 3 15.242V14.6c0-.56 0-.84.11-1.054a1 1 0 0 1 .436-.437C3.76 13 4.04 13 4.6 13h14.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437c.11.214.11.494.11 1.054v.641c0 .805 0 1.47-.045 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748 3 3 0 0 1-.342.149l.42.84a1 1 0 1 1-1.788.894zM8.5 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m18.5 3-.986-.493c-.378-.19-.567-.284-.765-.35a3 3 0 0 0-.541-.128C16 2 15.79 2 15.367 2H8.633c-.422 0-.634 0-.84.029a3 3 0 0 0-.541.128c-.199.066-.388.16-.765.35L5.5 3M11 6 9 2m4 4 2-4M4 13h16m-3 7 1 2M7 20l-1 2m2.5-5.5h.01m6.99 0h.01M8.8 20h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.72 20 16.88 20 15.2v-4.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 6 16.88 6 15.2 6H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 8.28 4 9.12 4 10.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 20 7.12 20 8.8 20m.2-3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m7 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ThumbsUp/ThumbsUpIcon.tsx
const ThumbsUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M11.534 1c-.72 0-1.372.424-1.665 1.082L6.51 9.644a7 7 0 0 1-.16.344l-.003.006H6.34a7 7 0 0 1-.38.006h-.799c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 13.18 1 13.635 1 14.161v4.678c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031A.84.84 0 0 0 6 22.161V14a1 1 0 1 1 2 0v7.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.76 23 9.04 23 9.6 23h6.32c.698 0 1.278 0 1.756-.036.498-.038.958-.12 1.401-.32a4 4 0 0 0 1.7-1.458c.265-.408.416-.85.529-1.337.108-.466.197-1.04.303-1.73l.535-3.481c.141-.915.257-1.665.297-2.278.043-.631.015-1.22-.2-1.785a4 4 0 0 0-1.76-2.052c-.526-.299-1.105-.416-1.735-.47C18.135 8 17.376 8 16.45 8h-.85c-.296 0-.459 0-.575-.01l-.014-.001v-.014A8 8 0 0 1 15 7.4V4.466A3.466 3.466 0 0 0 11.534 1"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M7 22V11m-5 2v7a2 2 0 0 0 2 2h13.426a3 3 0 0 0 2.965-2.544l1.077-7A3 3 0 0 0 18.503 9H15a1 1 0 0 1-1-1V4.466A2.466 2.466 0 0 0 11.534 2a.82.82 0 0 0-.75.488l-3.52 7.918A1 1 0 0 1 6.35 11H4a2 2 0 0 0-2 2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/SwitchVertical/SwitchVerticalIcon.tsx
const SwitchVerticalIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7.707 3.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L6 6.414V20a1 1 0 1 0 2 0V6.414l2.293 2.293a1 1 0 1 0 1.414-1.414zM18 17.586V4a1 1 0 1 0-2 0v13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 4v16m0 0-4-4m4 4 4-4M7 20V4m0 0L3 8m4-4 4 4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Triangle/TriangleIcon.tsx
const TriangleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.812 1.668a2 2 0 0 0-1.625 0c-.4.178-.659.49-.84.746-.177.25-.367.579-.576.94l-8.267 14.28c-.21.362-.401.692-.53.971-.132.285-.274.666-.229 1.102a2 2 0 0 0 .813 1.41c.355.258.757.326 1.068.355.307.028.688.028 1.107.028h16.534c.419 0 .8 0 1.106-.028.312-.029.714-.097 1.068-.354a2 2 0 0 0 .814-1.41c.045-.437-.098-.818-.23-1.103-.128-.28-.32-.609-.53-.971L14.23 3.354c-.21-.361-.4-.69-.577-.94-.18-.255-.44-.568-.84-.746"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m2.39 18.098 8.225-14.206c.455-.785.682-1.178.979-1.31a1 1 0 0 1 .812 0c.297.132.524.525.978 1.31l8.225 14.206c.456.788.685 1.182.65 1.506a1 1 0 0 1-.406.705c-.263.191-.718.191-1.628.191H3.775c-.91 0-1.366 0-1.629-.191a1 1 0 0 1-.406-.705c-.034-.324.194-.718.65-1.506"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Truck/TruckIcon.tsx
const TruckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10.839 3H5.16c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 6.18 1 6.635 1 7.161V15c0 1.34.88 2.476 2.093 2.86a4.001 4.001 0 0 0 7.781.14h3.662a3.5 3.5 0 0 0 6.937-.06 2 2 0 0 0 .292-.092 2 2 0 0 0 1.083-1.082 2 2 0 0 0 .14-.65c.012-.175.012-.38.012-.59v-2.914c0-.19.001-.43-.055-.665q-.075-.308-.24-.578a2.8 2.8 0 0 0-.43-.508l-.037-.037-4.062-4.062-.036-.036a2.8 2.8 0 0 0-.51-.431 2 2 0 0 0-.577-.24A2.8 2.8 0 0 0 16.388 6h-1.406l-.013-.195c-.032-.395-.103-.789-.296-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 10.838 3m10.16 12.696L21 15.5v-2.837c0-.131 0-.196-.002-.244v-.004l-.003-.002a6 6 0 0 0-.17-.174l-4.063-4.063a6 6 0 0 0-.175-.17l-.002-.003h-.004A6 6 0 0 0 16.337 8H15v7.696A3.5 3.5 0 0 1 18 14a3.5 3.5 0 0 1 3 1.696M7 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4m9.5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14 7h2.337c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l4.062 4.063c.173.173.26.26.322.36q.082.136.12.29c.027.115.027.237.027.482V15.5c0 .466 0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077m-5 0H14m0 0V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C12.48 4 11.92 4 10.8 4H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 5.52 2 6.08 2 7.2V15a2 2 0 0 0 2 2m10 0h-4m0 0a3 3 0 1 1-6 0m6 0a3 3 0 1 0-6 0m16.5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Translate/TranslateIcon.tsx
const TranslateIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M9 3a1 1 0 0 0-2 0v1H2a1 1 0 1 0 0 2h8.28a17 17 0 0 1-2.304 5.413c-.89-.835-1.644-1.829-2.055-2.802a1 1 0 0 0-1.842.778c.554 1.31 1.542 2.592 2.696 3.637a16.3 16.3 0 0 1-5.22 4.079 1 1 0 1 0 .89 1.79 18.3 18.3 0 0 0 5.919-4.651c.406.26.818.485 1.226.668a1 1 0 0 0 .82-1.824 7 7 0 0 1-.845-.451A19 19 0 0 0 12.328 6H14a1 1 0 1 0 0-2H9z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M17.152 9.308a1.5 1.5 0 0 0-1.304 0c-.359.173-.553.475-.65.637a8 8 0 0 0-.306.6L12.02 16.55l-.019.038-1.903 3.98a1 1 0 1 0 1.804.863L13.543 18h5.914l1.64 3.431a1 1 0 1 0 1.805-.863L21 16.589l-.019-.038-2.872-6.004a8 8 0 0 0-.306-.6c-.097-.163-.291-.465-.65-.638m-.652 2.51 2 4.182h-4z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12.913 17h7.174m-7.174 0L11 21m1.913-4 2.865-5.991c.231-.483.347-.724.505-.8a.5.5 0 0 1 .434 0c.158.076.274.317.505.8L20.087 17m0 0L22 21M2 5h6m0 0h3.5M8 5V3m3.5 2H14m-2.5 0c-.496 2.957-1.647 5.636-3.334 7.884M10 14a9.4 9.4 0 0 1-1.834-1.116m0 0C6.813 11.848 5.603 10.427 5 9m3.166 3.884A17.3 17.3 0 0 1 2 18"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Trophy/TrophyIcon.tsx
const TrophyIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.444 1h-.09c-.313-.001-.698-.003-1.038.12a2 2 0 0 0-1.195 1.196c-.08.22-.108.458-.117.684h-1.53c-.21 0-.415 0-.59.012-.19.013-.415.043-.65.14a2 2 0 0 0-1.082 1.083c-.097.234-.127.46-.14.65C1 5.059 1 5.263 1 5.474v.664c0 .795 0 1.386.136 1.897a4 4 0 0 0 2.829 2.829c.38.102.805.128 1.324.134A7.01 7.01 0 0 0 11 15.93V17h-.444A4.556 4.556 0 0 0 6 21.556C6 22.353 6.647 23 7.444 23h9.112c.797 0 1.444-.647 1.444-1.444A4.556 4.556 0 0 0 13.444 17H13v-1.07a7.01 7.01 0 0 0 5.71-4.932c.52-.006.945-.032 1.325-.134a4 4 0 0 0 2.829-2.829C23 7.524 23 6.933 23 6.138v-.664c0-.21 0-.415-.012-.59a2 2 0 0 0-.14-.65 2 2 0 0 0-1.083-1.082 2 2 0 0 0-.65-.14C20.941 3 20.737 3 20.527 3h-1.53a2.3 2.3 0 0 0-.118-.684 2 2 0 0 0-1.195-1.195C17.344.997 16.96.999 16.645 1h-9.2M5 5.8c0-.28 0-.42-.054-.527a.5.5 0 0 0-.219-.218C4.62 5 4.48 5 4.2 5h-.456c-.265 0-.397 0-.5.051a.5.5 0 0 0-.218.206c-.056.101-.063.229-.076.485-.032.603-.028 1.228.118 1.776a2 2 0 0 0 1.414 1.414c.12.032.26.049.518.058zm14 .003c0-.28 0-.421.055-.528a.5.5 0 0 1 .22-.22c.107-.053.247-.053.528-.052l.448.002c.264.001.395.002.499.053.09.044.167.118.216.205.056.101.063.229.076.484.032.604.032 1.241-.11 1.77a2 2 0 0 1-1.414 1.415c-.12.032-.26.049-.518.058z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 15a6 6 0 0 1-6-6V3.444c0-.413 0-.62.06-.786a1 1 0 0 1 .598-.598C6.824 2 7.031 2 7.444 2h9.112c.413 0 .62 0 .786.06a1 1 0 0 1 .598.598c.06.166.06.373.06.786V9a6 6 0 0 1-6 6m0 0v3m6-14h2.5c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883V6c0 .93 0 1.395-.102 1.776a3 3 0 0 1-2.122 2.122C19.396 10 18.93 10 18 10M6 4H3.5c-.466 0-.699 0-.883.076a1 1 0 0 0-.54.541C2 4.801 2 5.034 2 5.5V6c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C4.605 10 5.07 10 6 10m1.444 12h9.112a.444.444 0 0 0 .444-.444A3.556 3.556 0 0 0 13.444 18h-2.888A3.556 3.556 0 0 0 7 21.556c0 .245.199.444.444.444"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Tv/TvIcon.tsx
const TvIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7.625 2.22a1 1 0 1 0-1.25 1.56L9.15 6H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 10.29 1 10.954 1 11.758v4.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 22 5.954 22 6.758 22h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01v-4.483c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 6 18.046 6 17.242 6H14.85l2.774-2.22a1 1 0 1 0-1.25-1.56L12 5.72z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m17 3-5 4-5-4m-.2 18h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2v-4.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 7 18.88 7 17.2 7H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.28 2 10.12 2 11.8v4.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Underline/UnderlineIcon.tsx
const UnderlineIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3 21a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1M6 3a1 1 0 0 1 1 1v7a5 5 0 0 0 10 0V4a1 1 0 1 1 2 0v7a7 7 0 1 1-14 0V4a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18 4v7a6 6 0 0 1-12 0V4M4 21h16"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Umbrella/UmbrellaIcon.tsx
const UmbrellaIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12 1C6.52 1 1.979 5.005 1.139 10.248l-.015.09c-.061.372-.142.86.048 1.367.157.415.494.812.88 1.032.278.159.555.217.804.242.216.021.466.021.709.021H11v6.4c0 1.95 1.53 3.6 3.5 3.6s3.5-1.65 3.5-3.6a1 1 0 1 0-2 0c0 .921-.708 1.6-1.5 1.6s-1.5-.679-1.5-1.6V13h7.435c.243 0 .493 0 .709-.021a2 2 0 0 0 .804-.242c.386-.22.723-.617.88-1.032.19-.506.11-.995.048-1.367l-.015-.09C22.021 5.005 17.48 1 12 1"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M17 19.4c0 1.436-1.12 2.6-2.5 2.6S12 20.836 12 19.4V12m-9.874-1.594C2.89 5.641 7.02 2 12 2s9.11 3.64 9.874 8.406c.074.465.111.698.018.946a1.1 1.1 0 0 1-.44.516c-.23.132-.504.132-1.052.132H3.6c-.548 0-.821 0-1.052-.132a1.1 1.1 0 0 1-.44-.516c-.093-.248-.056-.48.018-.946"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/USB/USBIcon.tsx
const USBIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10 4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m5 1a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M7.568 1h8.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v4.61q.183.059.362.149a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v5.08c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 18.71 3 18.046 3 17.242v-5.08c0-.528 0-.982.03-1.357.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311q.18-.09.362-.149v-4.61c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C7.07 1 7.316 1 7.568 1M7 8h10V3.6c0-.297 0-.459-.01-.575l-.001-.014h-.014A8 8 0 0 0 16.4 3H7.6c-.297 0-.459 0-.575.01l-.014.001v.014C7 3.14 7 3.303 7 3.6z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18 9V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.24 2 16.96 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V9m4-3V5m4 1V5M8.8 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2v-5c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 9 17.92 9 16.8 9H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 10.52 4 11.08 4 12.2v5c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/User/UserIcon.tsx
const UserIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.786 14.5h6.428c.727 0 1.222 0 1.654.076a5 5 0 0 1 4.056 4.056c.076.432.076.927.076 1.654 0 .158.005.318-.023.474a1.5 1.5 0 0 1-1.216 1.217c-.137.024-.28.023-.351.023Q12 21.961 4.59 22c-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216c-.028-.157-.023-.317-.023-.475 0-.727 0-1.222.076-1.654a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M6.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M20 21c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667c-.568-.172-1.265-.172-2.661-.172h-5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C4 18.907 4 19.604 4 21M16.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Telescope/TelescopeIcon.tsx
const TelescopeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M20.12 1.676a1.5 1.5 0 0 1 .592 0c.31.066.59.228.803.464.163.181.246.375.296.512.042.118.079.256.11.37l1.409 5.261c.03.115.068.253.09.376.026.144.05.353 0 .592a1.5 1.5 0 0 1-.464.803 1.5 1.5 0 0 1-.512.296 5 5 0 0 1-.37.11l-.06.015c-.51.137-.948.255-1.318.322-.39.071-.789.104-1.204.016a3 3 0 0 1-1.019-.424l-4.024 1.078c.347.49.55 1.088.55 1.733 0 .664-.215 1.277-.58 1.774l4.407 6.463a1 1 0 1 1-1.652 1.126l-4.406-6.462a3 3 0 0 1-1.536 0l-4.406 6.462a1 1 0 1 1-1.652-1.126l4.406-6.463a3 3 0 0 1-.568-2.05l-2.117.567a5 5 0 0 1-.376.09 1.5 1.5 0 0 1-.592 0 1.5 1.5 0 0 1-.923-.618l-1.266.339c-.115.03-.252.067-.376.09a1.5 1.5 0 0 1-.591 0 1.5 1.5 0 0 1-.803-.464 1.5 1.5 0 0 1-.296-.512 4 4 0 0 1-.11-.37l-.374-1.398c-.031-.115-.068-.252-.09-.376a1.5 1.5 0 0 1 0-.591 1.5 1.5 0 0 1 .463-.803c.182-.164.375-.247.512-.296.118-.042.256-.08.371-.11l1.266-.34q.006-.091.026-.193a1.5 1.5 0 0 1 .464-.803c.182-.164.375-.247.512-.296.118-.043.256-.08.37-.11l11.58-3.103a3 3 0 0 1 .67-.876c.315-.284.677-.455 1.05-.588.354-.127.793-.244 1.303-.38l.06-.017c.114-.03.252-.068.375-.09m-.074 2.08c-.449.12-.755.206-.99.29-.257.092-.345.154-.386.191a1 1 0 0 0-.309.536c-.012.054-.022.16.027.43.051.279.147.639.296 1.195l.155.58c.15.557.246.916.342 1.184.092.257.154.344.191.385a1 1 0 0 0 .536.31c.054.011.161.021.43-.028.245-.044.553-.124 1.002-.244z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M13.122 14.845 18 22m-7.121-7.155L6 22m8-8.8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3.149-8.668L5.365 7.69c-.27.072-.406.109-.495.189a.5.5 0 0 0-.155.267c-.025.118.011.253.084.524l.88 3.284c.072.27.109.406.189.495a.5.5 0 0 0 .268.154c.117.025.252-.011.523-.083l11.784-3.158zM21.793 9.5c-1.082.29-1.623.434-2.093.335a2 2 0 0 1-1.07-.618c-.322-.357-.466-.898-.756-1.98l-.156-.58c-.29-1.082-.434-1.623-.335-2.092a2 2 0 0 1 .618-1.07c.357-.322.898-.467 1.98-.757.27-.072.406-.109.523-.084a.5.5 0 0 1 .268.155c.08.09.116.224.189.495l1.398 5.216c.072.27.108.406.083.523a.5.5 0 0 1-.154.268c-.09.08-.225.116-.495.189m-18.29 2.83 1.351-.362c.27-.073.406-.11.495-.19a.5.5 0 0 0 .155-.267c.025-.117-.011-.253-.084-.523l-.362-1.352c-.073-.27-.109-.406-.19-.495a.5.5 0 0 0-.267-.155c-.117-.025-.253.011-.523.084l-1.352.362c-.27.073-.406.109-.495.19a.5.5 0 0 0-.155.267c-.025.117.011.253.084.523l.362 1.352c.073.27.109.406.19.495a.5.5 0 0 0 .267.155c.117.025.253-.011.523-.084"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UnderlineSquare/UnderlineSquareIcon.tsx
const UnderlineSquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.759 2h8.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 6.29 22 6.954 22 7.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 17.71 2 17.046 2 16.242V7.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 2 6.954 2 7.758 2M9.5 7a1 1 0 1 0-2 0v3.5a4.5 4.5 0 1 0 9 0V7a1 1 0 1 0-2 0v3.5a2.5 2.5 0 0 1-5 0zM8 16a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.5 7v3.5a3.5 3.5 0 1 1-7 0V7M8 17h8m-8.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Upload/UploadIcon.tsx
const UploadIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.491 8.187A6 6 0 0 1 18 20H6.5A6.5 6.5 0 0 1 4.968 7.181a8.003 8.003 0 0 1 14.523 1.005m-12.198 4.52a1 1 0 0 0 1.414 0L11 10.414V16a1 1 0 1 0 2 0v-5.586l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 0 1.414",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M4 16.242A4.5 4.5 0 0 1 6.08 8.02a6.002 6.002 0 0 1 11.84 0A4.5 4.5 0 0 1 20 16.242M8 16l4-4m0 0 4 4m-4-4v9"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserDown/UserDownIcon.tsx
const UserDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20 15a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L20 18.586z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.786 14.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-5.755-.015-8.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21m14-3 3 3m0 0 3-3m-3 3v-6m-4.5-7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserPlus/UserPlusIcon.tsx
const UserPlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20 15a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.786 14.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-5.755-.015-8.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21m17 0v-6m-3 3h6M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserCheck/UserCheckIcon.tsx
const UserCheckIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M22.707 15.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L18 18.586l3.293-3.293a1 1 0 0 1 1.414 0M6.786 14.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-5.755-.015-8.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21m14-3 2 2 4-4m-7.5-8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserCircle/UserCircleIcon.tsx
const UserCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M7 9.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M3 12a9 9 0 1 1 15.862 5.824A4.99 4.99 0 0 0 15 16H9a4.99 4.99 0 0 0-3.862 1.824A8.97 8.97 0 0 1 3 12",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5.316 19.438A4 4 0 0 1 9 17h6a4 4 0 0 1 3.684 2.438M16 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0m6 2.5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserUp/UserUpIcon.tsx
const UserUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.707 14.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L18 17.414V21a1 1 0 1 0 2 0v-3.586l1.293 1.293a1 1 0 0 0 1.414-1.414z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.786 14.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-5.755-.015-8.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16 18 3-3m0 0 3 3m-3-3v6m-7-5.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserEdit/UserEditIcon.tsx
const UserEditIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M18.043 10.043a2.768 2.768 0 1 1 3.914 3.914c-2.16 2.16-4.323 4.316-6.48 6.48a3 3 0 0 1-.317.285q-.164.12-.35.205a3 3 0 0 1-.403.14q-1.567.445-3.132.895a1 1 0 0 1-1.237-1.237q.45-1.565.895-3.132c.033-.116.075-.262.14-.404q.084-.185.205-.349c.092-.125.2-.232.285-.318 2.164-2.156 4.32-4.32 6.48-6.48M6.61 14.51c.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-.755-.015-3.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056 6 6 0 0 1 1.478-.066M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M11 21l3.101-.886c.149-.043.223-.064.292-.096a1 1 0 0 0 .175-.102c.061-.045.116-.1.225-.21l6.457-6.456a1.768 1.768 0 1 0-2.5-2.5l-6.457 6.457a2 2 0 0 0-.209.225 1 1 0 0 0-.102.175 2 2 0 0 0-.096.292z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserRight/UserRightIcon.tsx
const UserRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.707 14.293a1 1 0 0 0-1.414 1.414L19.586 17H16a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.786 14.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-5.755-.015-8.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m19 21 3-3m0 0-3-3m3 3h-6m-4-2.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserMinus/UserMinusIcon.tsx
const UserMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15 18a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-8.214-3.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-5.755-.015-8.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 18h6m-10-2.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserLeft/UserLeftIcon.tsx
const UserLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M19.707 15.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L18.414 19H22a1 1 0 1 0 0-2h-3.586z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.786 14.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-5.755-.015-8.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m19 21-3-3m0 0 3-3m-3 3h6m-10-2.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/UserX/UserXIcon.tsx
const UserXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.207 15.293a1 1 0 0 0-1.414 1.414l1.793 1.793-1.793 1.793a1 1 0 1 0 1.414 1.414L19 19.914l1.793 1.793a1 1 0 0 0 1.414-1.414L20.414 18.5l1.793-1.793a1 1 0 0 0-1.414-1.414L19 17.086z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.786 14.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.57.154a1.5 1.5 0 0 1 .656.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.5 1.5 0 0 1-.154.571 1.5 1.5 0 0 1-.655.656 1.5 1.5 0 0 1-.571.153c-.126.01-.268.01-.387.01-2.877-.001-5.755-.015-8.633 0-.07 0-.214.001-.35-.023a1.5 1.5 0 0 1-1.217-1.216A2 2 0 0 1 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076M4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m16.5 16 5 5m0-5-5 5M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Video/VideoIcon.tsx
const VideoIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12.241 4H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 8.29 1 8.954 1 9.758v4.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 20 5.954 20 6.758 20h5.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.04-.502.044-1.11.044-1.838l1.953 1.954c.192.19.38.379.544.517.147.123.457.37.885.403a1.5 1.5 0 0 0 1.259-.521c.279-.327.323-.72.34-.911.02-.214.019-.48.019-.75V8.894c0-.27 0-.536-.019-.75-.017-.19-.061-.584-.34-.911a1.5 1.5 0 0 0-1.259-.521c-.428.033-.738.28-.885.403a9 9 0 0 0-.543.517L18 9.586c0-.728-.003-1.336-.044-1.838-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C13.71 4 13.046 4 12.242 4",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 8.931c0-.605 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657L17 12l3.634 3.634c.429.429.643.643.827.657a.5.5 0 0 0 .42-.173c.119-.14.119-.444.119-1.05zM2 9.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 5 5.12 5 6.8 5h5.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C17 7.28 17 8.12 17 9.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C14.72 19 13.88 19 12.2 19H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 16.72 2 15.88 2 14.2z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Users/UsersIcon.tsx
const UsersIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18.032 14.877a1 1 0 0 1 1.217-.72A5 5 0 0 1 23 19v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.25-2.905 1 1 0 0 1-.718-1.218M14.573 2.916a1 1 0 0 1 1.302-.552 5.001 5.001 0 0 1 0 9.272 1 1 0 0 1-.75-1.854 3.001 3.001 0 0 0 0-5.564 1 1 0 0 1-.552-1.302M7.179 14h4.642c1.09 0 1.835 0 2.473.17a5 5 0 0 1 3.536 3.536c.23.86.163 1.778.17 2.658.001.107.003.323-.051.524a1.5 1.5 0 0 1-1.06 1.06 2 2 0 0 1-.525.052 861 861 0 0 0-13.728 0 2 2 0 0 1-.524-.051 1.5 1.5 0 0 1-1.06-1.06A2 2 0 0 1 1 20.364c.007-.878-.06-1.8.17-2.658a5 5 0 0 1 3.536-3.536C5.344 14 6.088 14 7.179 14",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M4.5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M22 21v-2a4 4 0 0 0-3-3.874M15.5 3.291a4.001 4.001 0 0 1 0 7.418M17 21c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.165C13.796 15 12.864 15 11 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/VolumeMin/VolumeMinIcon.tsx
const VolumeMinIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M17.673 7.18a1 1 0 0 1 1.392.248A7.97 7.97 0 0 1 20.5 12c0 1.698-.53 3.276-1.435 4.572a1 1 0 1 1-1.64-1.144A5.97 5.97 0 0 0 18.5 12a5.97 5.97 0 0 0-1.075-3.428 1 1 0 0 1 .248-1.392m-4.791-4.468a1.5 1.5 0 0 1 1.259.52c.279.328.323.721.34.912.02.214.019.48.019.75v14.212c0 .27 0 .536-.019.75-.017.19-.061.584-.34.911a1.5 1.5 0 0 1-1.259.521c-.428-.034-.738-.28-.885-.403a9 9 0 0 1-.543-.517l-3.192-3.192a6 6 0 0 0-.175-.171l-.002-.002H8.08A6 6 0 0 0 7.837 17H6.068c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77c-.017-.208-.017-.454-.017-.706V9.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C5.57 7 5.816 7 6.068 7h1.769c.131 0 .197 0 .244-.002h.004l.002-.003c.036-.032.082-.078.175-.17l3.165-3.166.027-.027c.19-.191.379-.379.543-.517.147-.123.457-.37.885-.403",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18.245 8a6.97 6.97 0 0 1 1.255 4 6.97 6.97 0 0 1-1.255 4m-6.11-11.634L8.968 7.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C8.204 8 8.082 8 7.837 8H6.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4.5 8.76 4.5 9.04 4.5 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C5.26 16 5.54 16 6.1 16h1.737c.245 0 .367 0 .482.028q.154.037.29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.173c.119-.14.119-.444.119-1.05V4.932c0-.605 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/VolumeX/VolumeXIcon.tsx
const VolumeXIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.64 3.233a1.5 1.5 0 0 0-1.258-.521c-.428.033-.738.28-.885.403-.164.138-.352.326-.543.517L5.762 6.824a6 6 0 0 1-.175.17l-.002.003H5.58A6 6 0 0 1 5.337 7H3.568c-.252 0-.498 0-.706.017a2 2 0 0 0-.77.2 2 2 0 0 0-.874.875 2 2 0 0 0-.201.77C1 9.07 1 9.316 1 9.568v4.864c0 .252 0 .498.017.706.019.229.063.498.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h1.77c.13 0 .196 0 .243.002h.004l.002.003c.035.032.082.078.175.17l3.192 3.193c.19.19.379.379.543.517.147.123.457.37.885.403a1.5 1.5 0 0 0 1.259-.521c.279-.327.323-.72.34-.911.02-.214.019-.48.019-.75V4.894c0-.27 0-.536-.019-.75-.017-.19-.061-.584-.34-.911",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M22.707 8.293a1 1 0 0 1 0 1.414L20.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L19 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L17.586 12l-2.293-2.293a1 1 0 0 1 1.414-1.414L19 10.586l2.293-2.293a1 1 0 0 1 1.414 0"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m22 9-6 6m0-6 6 6M9.634 4.366 6.47 7.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C5.704 8 5.582 8 5.337 8H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 16 3.04 16 3.6 16h1.737c.245 0 .367 0 .482.028q.154.037.29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.173c.119-.14.119-.444.119-1.05V4.932c0-.605 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/TrendDown/TrendDownIcon.tsx
const TrendDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2.707 6.293a1 1 0 0 0-1.414 1.414l4.891 4.891c.179.179.352.353.512.488.174.148.396.308.686.402a2 2 0 0 0 1.236 0c.29-.094.512-.254.686-.402a9 9 0 0 0 .512-.488l2.76-2.76c.21-.21.325-.323.414-.4L13 9.43l.01.009c.09.076.205.19.414.4L19.586 16H15a1 1 0 1 0 0 2h7a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v4.586l-6.184-6.184a9 9 0 0 0-.511-.488 2 2 0 0 0-.687-.402 2 2 0 0 0-1.236 0c-.29.094-.512.254-.687.402-.159.135-.332.31-.51.488l-2.76 2.76c-.21.21-.326.323-.415.4L8 11.57l-.01-.009a8 8 0 0 1-.414-.4z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m22 17-7.869-7.869c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668L9.13 11.87c-.396.396-.594.594-.822.668a1 1 0 0 1-.618 0c-.228-.074-.426-.272-.822-.668L2 7m20 10h-7m7 0v-7"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/WatchSquare/WatchSquareIcon.tsx
const WatchSquareIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10.414 1h-.152C9.55.999 8.925.998 8.374 1.223a3 3 0 0 0-1.224.923c-.368.468-.538 1.069-.733 1.754l-.042.146-.22.773-.017.008a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167-.031.375-.031.83-.031 1.356v6.678c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311l.017.009.22.772.042.146c.195.685.365 1.286.733 1.753a3 3 0 0 0 1.224.924c.551.225 1.176.224 1.888.223h3.476c.712.001 1.337.002 1.888-.223a3 3 0 0 0 1.224-.924c.368-.467.538-1.068.733-1.753l.042-.146.22-.773.017-.008a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.357V8.662c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311l-.017-.008-.22-.773-.042-.146c-.194-.685-.365-1.286-.733-1.754a3 3 0 0 0-1.224-.923C15.075.998 14.45.999 13.738 1zM8.66 4.5h-.335c.24-.835.308-1.005.396-1.118a1 1 0 0 1 .409-.308C9.268 3.018 9.459 3 10.414 3h3.172c.955 0 1.146.018 1.284.074a1 1 0 0 1 .408.308c.088.113.156.283.396 1.118zm.061 16.118c-.088-.113-.156-.283-.396-1.118h7.348c-.24.835-.308 1.005-.396 1.118a1 1 0 0 1-.409.308c-.137.056-.328.074-1.283.074h-3.172c-.955 0-1.146-.018-1.283-.075a1 1 0 0 1-.409-.307M13 9a1 1 0 1 0-2 0v3a1 1 0 0 0 .293.707l1.5 1.5a1 1 0 0 0 1.414-1.414L13 11.586z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m17 18.5-.337 1.18c-.238.831-.356 1.247-.6 1.556a2 2 0 0 1-.815.616c-.364.148-.796.148-1.662.148h-3.172c-.865 0-1.298 0-1.662-.148a2 2 0 0 1-.816-.616c-.243-.309-.361-.725-.6-1.557L7 18.5m10-13-.337-1.18c-.238-.831-.356-1.247-.6-1.556a2 2 0 0 0-.815-.616C14.884 2 14.452 2 13.586 2h-3.172c-.865 0-1.298 0-1.662.148a2 2 0 0 0-.816.616c-.243.309-.361.725-.6 1.557L7 5.5M12 9v3l1.5 1.5m-4.8 5h6.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V8.7c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.98 5.5 16.42 5.5 15.3 5.5H8.7c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5.5 7.02 5.5 7.58 5.5 8.7v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/VolumeMax/VolumeMaxIcon.tsx
const VolumeMaxIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.164 4.188a1 1 0 0 1 1.396.228A12.95 12.95 0 0 1 23 12c0 2.829-.905 5.45-2.44 7.584a1 1 0 0 1-1.624-1.168A10.95 10.95 0 0 0 21 12c0-2.396-.765-4.61-2.064-6.416a1 1 0 0 1 .228-1.396M15.173 7.18a1 1 0 0 1 1.393.248A7.97 7.97 0 0 1 18 12c0 1.698-.53 3.276-1.434 4.572a1 1 0 1 1-1.64-1.144A5.97 5.97 0 0 0 16 12a5.97 5.97 0 0 0-1.075-3.428 1 1 0 0 1 .248-1.392m-4.791-4.468a1.5 1.5 0 0 1 1.259.52c.279.328.323.721.34.912.02.214.019.48.019.75v14.212c0 .27 0 .536-.019.75-.017.19-.061.584-.34.911a1.5 1.5 0 0 1-1.259.521c-.428-.034-.738-.28-.885-.403a9 9 0 0 1-.543-.517l-3.192-3.192a6 6 0 0 0-.175-.171l-.002-.002H5.58A6 6 0 0 0 5.337 17H3.568c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C1 14.93 1 14.684 1 14.432V9.568c0-.252 0-.498.017-.706a2 2 0 0 1 .201-.77 2 2 0 0 1 .874-.874 2 2 0 0 1 .77-.201C3.07 7 3.316 7 3.568 7h1.769c.131 0 .197 0 .244-.002h.004l.002-.003c.035-.032.082-.078.175-.17l3.165-3.166.027-.027c.19-.191.379-.379.543-.517.147-.123.457-.37.885-.403",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19.748 5A11.95 11.95 0 0 1 22 12c0 2.612-.835 5.03-2.252 7M15.745 8A6.97 6.97 0 0 1 17 12a6.97 6.97 0 0 1-1.255 4M9.635 4.366 6.468 7.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C5.704 8 5.582 8 5.337 8H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 16 3.04 16 3.6 16h1.737c.245 0 .367 0 .482.028q.154.037.29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.173c.119-.14.119-.444.119-1.05V4.932c0-.605 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/WatchCircle/WatchCircleIcon.tsx
const WatchCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13.41 1h-2.82c-.439 0-.821 0-1.14.024-.34.025-.677.08-1.012.227A3 3 0 0 0 7.18 2.283c-.21.3-.33.62-.422.947-.086.309-.16.683-.246 1.113l-.462 2.31A7.97 7.97 0 0 0 4 12a7.97 7.97 0 0 0 2.05 5.347l.462 2.31c.085.43.16.805.246 1.113.092.328.212.647.422.947a3 3 0 0 0 1.258 1.032c.335.147.672.202 1.012.228.319.023.701.023 1.14.023h2.82c.439 0 .82 0 1.14-.023.34-.026.676-.081 1.012-.228a3 3 0 0 0 1.258-1.032c.21-.3.33-.62.422-.947.085-.308.16-.683.246-1.113l.462-2.31A7.97 7.97 0 0 0 20 12a7.97 7.97 0 0 0-2.05-5.347l-.462-2.31c-.086-.43-.16-.805-.246-1.113a3 3 0 0 0-.422-.947 3 3 0 0 0-1.258-1.032 3 3 0 0 0-1.012-.227C14.23 1 13.849 1 13.41 1M12 4a8 8 0 0 0-3.546.827l.012-.058c.095-.473.155-.774.219-1.002.06-.216.105-.297.135-.34a1 1 0 0 1 .42-.343c.047-.021.135-.05.358-.066.236-.017.543-.018 1.025-.018h2.754c.481 0 .789 0 1.025.018.223.017.311.045.359.066a1 1 0 0 1 .42.344c.03.042.074.123.134.339.064.228.124.529.219 1.002l.011.058A8 8 0 0 0 12 4M8.466 19.232l-.012-.059A8 8 0 0 0 12 20a8 8 0 0 0 3.546-.827l-.012.059c-.095.472-.155.773-.219 1.001-.06.216-.105.297-.135.34a1 1 0 0 1-.42.343c-.047.021-.135.05-.358.066-.236.018-.543.018-1.025.018h-2.754c-.482 0-.789 0-1.025-.018-.223-.017-.311-.045-.359-.066a1 1 0 0 1-.42-.343c-.03-.043-.074-.124-.134-.34a16 16 0 0 1-.219-1.001M13 9a1 1 0 1 0-2 0v3a1 1 0 0 0 .293.707l1.5 1.5a1 1 0 0 0 1.414-1.414L13 11.586z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m7 17 .486 2.428c.183.916.274 1.374.514 1.717a2 2 0 0 0 .839.688c.383.167.85.167 1.784.167h2.754c.934 0 1.401 0 1.784-.167a2 2 0 0 0 .84-.688c.239-.343.33-.801.514-1.717L17 17M7 7l.486-2.428c.183-.916.274-1.374.514-1.717a2 2 0 0 1 .839-.688C9.222 2 9.689 2 10.623 2h2.754c.934 0 1.401 0 1.784.167a2 2 0 0 1 .84.688c.239.343.33.801.514 1.717L17 7m-5 2v3l1.5 1.5M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Webcam/WebcamIcon.tsx
const WebcamIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 1a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19m3.188 9.5a3.188 3.188 0 1 1-6.376 0 3.188 3.188 0 0 1 6.376 0",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8 21a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8 22h8m4.5-11.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-5.312 0a3.188 3.188 0 1 1-6.376 0 3.188 3.188 0 0 1 6.376 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/VideoOff/VideoOffIcon.tsx
const VideoOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M21.535 17.292a1.5 1.5 0 0 0 1.106-.525c.279-.327.323-.72.34-.911.02-.214.019-.48.019-.75V8.894c0-.27 0-.536-.019-.75-.017-.19-.061-.584-.34-.911a1.5 1.5 0 0 0-1.259-.521c-.428.033-.738.28-.885.403a9 9 0 0 0-.543.517L18 9.586c0-.728-.003-1.336-.044-1.838-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C13.71 4 13.046 4 12.242 4h-4zM2.707 1.293a1 1 0 0 0-1.414 1.414l1.785 1.785a4 4 0 0 0-1.642 1.692c-.247.485-.346 1.002-.392 1.564C1 8.29 1 8.954 1 9.758v4.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 20 5.954 20 6.758 20h5.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.29-1.044l4.187 4.187a1 1 0 0 0 1.414-1.414z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M5 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h9a3 3 0 0 0 2.87-2.125M17 12l3.634-3.634c.429-.429.643-.643.827-.657a.5.5 0 0 1 .42.173c.119.14.119.444.119 1.05v6.137c0 .605 0 .908-.12 1.049a.5.5 0 0 1-.42.173c-.183-.014-.397-.228-.826-.657zm0 0V9.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C14.72 5 13.88 5 12.2 5H9.5M2 2l20 20"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Wallet/WalletIcon.tsx
const WalletIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 15v2.839c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031H17.84c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V11.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 7H17V4.46c0-.381 0-.732-.026-1.018-.027-.296-.091-.67-.324-1.01a2 2 0 0 0-1.314-.841c-.407-.07-.773.03-1.053.129-.271.096-.59.243-.936.403L4.323 6.288c-.557.256-1.046.48-1.42.846a3 3 0 0 0-.73 1.14C1.998 8.768 2 9.307 2 9.919zM14.952 3.604c-.174.062-.408.17-.803.352L7.552 7H15V4.5c0-.435-.001-.693-.018-.876l-.003-.03zM16.5 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16 8V4.5c0-.831 0-1.247-.175-1.502a1 1 0 0 0-.657-.42c-.306-.053-.683.121-1.438.47L4.858 7.142c-.673.31-1.01.466-1.257.707a2 2 0 0 0-.486.76C3 8.936 3 9.307 3 10.048V15m13.5-.5h.01M3 11.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-6.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 8 18.92 8 17.8 8H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 9.52 3 10.08 3 11.2m14 3.3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/VolumePlus/VolumePlusIcon.tsx
const VolumePlusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.64 3.233a1.5 1.5 0 0 0-1.258-.521c-.428.033-.738.28-.885.403-.164.138-.352.326-.543.517L5.762 6.824a6 6 0 0 1-.175.17l-.002.003H5.58A6 6 0 0 1 5.337 7H3.568c-.252 0-.498 0-.706.017a2 2 0 0 0-.77.2 2 2 0 0 0-.874.875 2 2 0 0 0-.201.77C1 9.07 1 9.316 1 9.568v4.864c0 .252 0 .498.017.706.019.229.063.498.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h1.77c.13 0 .196 0 .243.002h.004l.002.003c.035.032.082.078.175.17l3.192 3.193c.19.19.379.379.543.517.147.123.457.37.885.403a1.5 1.5 0 0 0 1.259-.521c.279-.327.323-.72.34-.911.02-.214.019-.48.019-.75V4.894c0-.27 0-.536-.019-.75-.017-.19-.061-.584-.34-.911",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.5 7.5a1 1 0 0 1 1 1V11H22a1 1 0 1 1 0 2h-2.5v2.5a1 1 0 1 1-2 0V13H15a1 1 0 1 1 0-2h2.5V8.5a1 1 0 0 1 1-1"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18.5 15.5v-7M15 12h7M9.634 4.366 6.47 7.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C5.704 8 5.582 8 5.337 8H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 16 3.04 16 3.6 16h1.737c.245 0 .367 0 .482.028q.154.037.29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.173c.119-.14.119-.444.119-1.05V4.932c0-.605 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Wind/WindIcon.tsx
const WindIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19 6.5c-.592 0-1.123.256-1.49.667a1 1 0 0 1-1.491-1.334A4 4 0 1 1 19 12.5h-6a1 1 0 1 1 0-2h6a2 2 0 1 0 0-4M9 4c-.592 0-1.123.256-1.491.667a1 1 0 1 1-1.49-1.334A4 4 0 1 1 9 10H2a1 1 0 0 1 0-2h7a2 2 0 1 0 0-4m4 16a2 2 0 0 1-1.491-.667 1 1 0 1 0-1.49 1.334A4 4 0 1 0 13 14H2a1 1 0 1 0 0 2h11a2 2 0 1 1 0 4",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M16.764 6.5a3 3 0 1 1 2.236 5h-6M6.764 4A3 3 0 1 1 9 9H2m8.764 11A3 3 0 1 0 13 15H2"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/X/XIcon.tsx
const XIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18 6 6 18M6 6l12 12"
		}),
		line: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M18 6 6 18M6 6l12 12"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/WifiOff/WifiOffIcon.tsx
const WifiOffIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l1.76 1.76A17 17 0 0 0 .519 7.964 1 1 0 0 0 1.87 9.439a15 15 0 0 1 3.674-2.481L7.83 9.244a12 12 0 0 0-3.76 2.249 1 1 0 0 0 1.323 1.5 10 10 0 0 1 4.028-2.158l2.665 2.665H12a6.98 6.98 0 0 0-4.37 1.53 1 1 0 1 0 1.25 1.563q.078-.063.157-.121l.072-.047a5 5 0 0 1 5.972.137q.086.067.179.112l5.033 5.033a1 1 0 0 0 1.414-1.414zm6.603 3.305A15 15 0 0 1 21.919 9.25a1 1 0 1 0 1.322-1.5 17 17 0 0 0-13.156-4.14 1 1 0 1 0 .225 1.988m5.3 3.447a1 1 0 1 0-.595 1.91 10 10 0 0 1 3.425 1.863 1 1 0 1 0 1.28-1.536 12 12 0 0 0-4.11-2.237"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 18.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.312 10c1.368.426 2.65 1.12 3.768 2.05m3.5-3.55a16 16 0 0 0-12.383-3.896M8.53 15.61a6 6 0 0 1 6.95 0M12 19.5h.01M1.193 8.7A16 16 0 0 1 5.76 5.764m-1.027 6.48a10.97 10.97 0 0 1 5-2.51m5.966 6.042A5.97 5.97 0 0 0 12 14.5c-1.416 0-2.718.49-3.745 1.312M3 3l18 18"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Ticket/TicketIcon.tsx
const TicketIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.161 3H18.84c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V8.5a1 1 0 0 1-1 1 2.5 2.5 0 0 0 0 5 1 1 0 0 1 1 1v1.339c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H5.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C1 17.82 1 17.365 1 16.839V15.5a1 1 0 0 1 1-1 2.5 2.5 0 0 0 0-5 1 1 0 0 1-1-1V7.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 3 4.635 3 5.161 3M11 6.5a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0zm-1 4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1m1 6a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M10 8V7m0 5.5v-1m0 5.5v-1M5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v1.3a3.5 3.5 0 1 0 0 7v1.3c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 20 19.92 20 18.8 20H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 18.48 2 17.92 2 16.8v-1.3a3.5 3.5 0 1 0 0-7V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/VolumeMinus/VolumeMinusIcon.tsx
const VolumeMinusIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.64 3.233a1.5 1.5 0 0 0-1.258-.521c-.428.033-.738.28-.885.403-.164.138-.352.326-.543.517L5.762 6.824a6 6 0 0 1-.175.17l-.002.003H5.58A6 6 0 0 1 5.337 7H3.568c-.252 0-.498 0-.706.017a2 2 0 0 0-.77.2 2 2 0 0 0-.874.875 2 2 0 0 0-.201.77C1 9.07 1 9.316 1 9.568v4.864c0 .252 0 .498.017.706.019.229.063.498.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017h1.77c.13 0 .196 0 .243.002h.004l.002.003c.035.032.082.078.175.17l3.192 3.193c.19.19.379.379.543.517.147.123.457.37.885.403a1.5 1.5 0 0 0 1.259-.521c.279-.327.323-.72.34-.911.02-.214.019-.48.019-.75V4.894c0-.27 0-.536-.019-.75-.017-.19-.061-.584-.34-.911",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15 11a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15 12h7M9.634 4.366 6.47 7.53c-.173.173-.26.26-.36.322a1 1 0 0 1-.29.12C5.704 8 5.582 8 5.337 8H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C2.76 16 3.04 16 3.6 16h1.737c.245 0 .367 0 .482.028q.154.037.29.12c.1.061.187.148.36.32l3.165 3.166c.429.429.643.643.827.657a.5.5 0 0 0 .42-.173c.119-.14.119-.444.119-1.05V4.932c0-.605 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Waves/WavesIcon.tsx
const WavesIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.417 7.589C5.887 7.843 5.27 8 4.5 8c-.789 0-1.414-.154-1.948-.412-.499-.242-.88-.559-1.167-.799l-.025-.02a1 1 0 1 1 1.28-1.537c.31.258.522.429.783.555C3.664 5.904 3.99 6 4.5 6c.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.687-.55 1.182-.788C8.113 4.157 8.73 4 9.5 4c.789 0 1.414.154 1.948.412.499.242.88.559 1.167.799l.025.02c.31.259.522.43.783.556.241.117.566.213 1.077.213.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.688-.55 1.182-.788C18.113 4.157 18.73 4 19.5 4c.789 0 1.414.154 1.948.412.499.242.88.559 1.167.799l.025.02a1 1 0 1 1-1.28 1.537c-.31-.258-.521-.429-.783-.555C20.336 6.096 20.011 6 19.5 6c-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788-.53.254-1.147.411-1.917.411-.789 0-1.414-.154-1.948-.412-.499-.242-.88-.559-1.167-.799l-.025-.02c-.31-.259-.521-.43-.783-.556C10.336 6.096 10.011 6 9.5 6c-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788m0 12C5.887 19.843 5.27 20 4.5 20c-.789 0-1.414-.154-1.948-.412-.499-.242-.88-.559-1.167-.799l-.025-.02a1 1 0 1 1 1.28-1.537c.31.258.522.429.783.555.241.117.566.213 1.077.213.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.687-.55 1.182-.788C8.113 16.157 8.73 16 9.5 16c.789 0 1.414.154 1.948.412.499.242.88.559 1.167.799l.025.02c.31.259.522.43.783.556.241.117.566.213 1.077.213.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.688-.55 1.182-.788.53-.254 1.147-.411 1.917-.411.789 0 1.414.154 1.948.412.499.242.88.559 1.167.799l.025.02a1 1 0 1 1-1.28 1.537c-.31-.258-.521-.429-.783-.555-.241-.117-.566-.213-1.077-.213-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788-.53.254-1.147.411-1.917.411-.789 0-1.414-.154-1.948-.412-.499-.242-.88-.559-1.167-.799l-.025-.02c-.31-.259-.521-.43-.783-.556-.241-.117-.566-.213-1.077-.213-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788m0-6C5.887 13.843 5.27 14 4.5 14c-.789 0-1.414-.154-1.948-.412-.499-.242-.88-.559-1.167-.799l-.025-.02a1 1 0 1 1 1.28-1.537c.31.258.522.429.783.555.241.117.566.213 1.077.213.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.687-.55 1.182-.788C8.113 10.157 8.73 10 9.5 10c.789 0 1.414.154 1.948.412.499.242.88.559 1.167.799l.025.02c.31.259.522.43.783.556.241.117.566.213 1.077.213.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.688-.55 1.182-.788.53-.254 1.147-.411 1.917-.411.789 0 1.414.154 1.948.412.499.242.88.559 1.167.799l.025.02a1 1 0 1 1-1.28 1.537c-.31-.258-.521-.429-.783-.555-.241-.117-.566-.213-1.077-.213-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788-.53.254-1.147.411-1.917.411-.789 0-1.414-.154-1.948-.412-.499-.242-.88-.559-1.167-.799l-.025-.02c-.31-.259-.521-.43-.783-.556-.241-.117-.566-.213-1.077-.213-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Wifi/WifiIcon.tsx
const WifiIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11 19.5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1m1-14A14.94 14.94 0 0 0 1.869 9.438 1 1 0 0 1 .518 7.963 16.94 16.94 0 0 1 12 3.5a16.94 16.94 0 0 1 11.482 4.464 1 1 0 1 1-1.351 1.474A14.94 14.94 0 0 0 12 5.5",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12 10.5c-2.533 0-4.845.94-6.607 2.493a1 1 0 1 1-1.322-1.5A11.96 11.96 0 0 1 12 8.5c3.039 0 5.815 1.13 7.929 2.993a1 1 0 1 1-1.322 1.5A9.96 9.96 0 0 0 12 10.5m0 5a4.97 4.97 0 0 0-3.12 1.093 1 1 0 0 1-1.25-1.562A6.98 6.98 0 0 1 12 13.5c1.627 0 3.126.556 4.315 1.488a1 1 0 0 1-1.234 1.574A4.97 4.97 0 0 0 12 15.5",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 19.5h.01M22.806 8.7A15.94 15.94 0 0 0 12 4.5c-4.166 0-7.96 1.592-10.807 4.2m3.539 3.543A10.96 10.96 0 0 1 12 9.5a10.96 10.96 0 0 1 7.268 2.743m-3.57 3.532A5.97 5.97 0 0 0 12 14.5c-1.416 0-2.718.49-3.745 1.312"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/XCircle/XCircleIcon.tsx
const XCircleIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1m3.707 7.293a1 1 0 0 1 0 1.414L13.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L10.586 12 8.293 9.707a1 1 0 0 1 1.414-1.414L12 10.586l2.293-2.293a1 1 0 0 1 1.414 0",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m15 9-6 6m0-6 6 6m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Trash/TrashIcon.tsx
const TrashIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2h-1.064l-.642 9.625c-.05.756-.092 1.381-.167 1.89-.078.53-.201 1.014-.458 1.465a4 4 0 0 1-1.731 1.62c-.467.226-.959.317-1.493.36-.512.04-1.139.04-1.896.04h-3.098c-.757 0-1.384 0-1.896-.04-.534-.043-1.025-.134-1.493-.36a4 4 0 0 1-1.73-1.62c-.258-.451-.381-.935-.46-1.465-.074-.509-.115-1.134-.166-1.89L4.064 7H3a1 1 0 0 1-1-1m8 3.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1m5 1a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M9 3h6M3 6h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 6.2 19.485c-.34-.598-.394-1.387-.499-2.966L5 6m5 4.5v5m4-5v5"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Youtube/YoutubeIcon.tsx
const YoutubeIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M13.011 4.006 12.5 4h-1q-.036 0-.073.003a131 131 0 0 0-2.78.05c-.885.026-1.83.065-2.656.125-.799.058-1.572.14-2.066.272l-.014.004a3.53 3.53 0 0 0-2.462 2.53l-.014.066A27 27 0 0 0 1 12.017c-.01 1.679.136 3.354.435 5.006a1 1 0 0 0 .022.097 3.52 3.52 0 0 0 2.462 2.428l.006.002c.494.131 1.267.214 2.066.272.826.06 1.77.1 2.657.126A125 125 0 0 0 11.5 20h1q.036 0 .073-.003.194 0 .44-.004c.614-.006 1.451-.02 2.34-.045.885-.027 1.83-.066 2.656-.126.799-.058 1.572-.14 2.066-.272l.014-.004a3.53 3.53 0 0 0 2.462-2.53l.014-.066A27 27 0 0 0 23 12.02a27 27 0 0 0-.448-5.072 3.51 3.51 0 0 0-2.497-2.54c-.486-.118-1.252-.192-2.051-.245a70 70 0 0 0-2.653-.115 138 138 0 0 0-2.339-.042M9.85 8.616c-.1.133-.1.372-.1.85v5.069c0 .477 0 .716.1.849a.5.5 0 0 0 .364.199c.166.012.367-.117.769-.376l3.942-2.534c.349-.224.523-.336.583-.479a.5.5 0 0 0 0-.389c-.06-.142-.234-.254-.583-.478l-3.942-2.535c-.402-.258-.603-.387-.769-.375a.5.5 0 0 0-.364.2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M21.581 7.2a2.53 2.53 0 0 0-1.763-1.818C18.254 5 12 5 12 5s-6.254 0-7.818.418A2.53 2.53 0 0 0 2.42 7.236a26.4 26.4 0 0 0-.42 4.81c-.01 1.624.13 3.246.418 4.844a2.53 2.53 0 0 0 1.763 1.746c1.564.418 7.818.418 7.818.418s6.254 0 7.818-.418a2.53 2.53 0 0 0 1.763-1.818c.284-1.575.424-3.173.419-4.773A26.4 26.4 0 0 0 21.58 7.2"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M9.75 9.465c0-.477 0-.716.1-.849a.5.5 0 0 1 .364-.199c.166-.012.367.117.769.375l3.942 2.535c.349.224.523.336.583.478a.5.5 0 0 1 0 .39c-.06.142-.234.254-.583.478l-3.942 2.535c-.402.258-.603.387-.769.375a.5.5 0 0 1-.364-.2c-.1-.132-.1-.371-.1-.848z"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ZoomIn/ZoomInIcon.tsx
const ZoomInIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11 2a9 9 0 1 0 5.618 16.032l3.675 3.675a1 1 0 0 0 1.414-1.414l-3.675-3.675A9 9 0 0 0 11 2m0 5a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H8a1 1 0 1 1 0-2h2V8a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m21 21-4.35-4.35M11 8v6m-3-3h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ZoomOut/ZoomOutIcon.tsx
const ZoomOutIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11 2a9 9 0 1 0 5.618 16.032l3.675 3.675a1 1 0 0 0 1.414-1.414l-3.675-3.675A9 9 0 0 0 11 2m-3 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m21 21-4.35-4.35M8 11h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Assist/AssistIcon.tsx
const AssistIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.637 22.368c.62.473 1.33 1.014 2.241 1.016h-.006.012-.006c.912-.002 1.622-.543 2.242-1.016l.14-.103c.29-.216.574-.427.808-.495.294-.09.745-.08 1.175-.057.779.034 1.648.068 2.37-.44.735-.508 1.006-1.355 1.243-2.1.124-.407.26-.825.44-1.062.17-.223.5-.447.83-.67l.063-.041c.654-.43 1.4-.926 1.693-1.785.276-.815.003-1.62-.241-2.34l-.018-.054c-.159-.429-.294-.835-.294-1.151 0-.297.129-.672.266-1.072l.028-.08c.26-.723.542-1.559.26-2.394-.294-.858-1.04-1.355-1.694-1.784l-.062-.042c-.33-.223-.66-.447-.83-.67-.181-.237-.317-.655-.441-1.061-.237-.745-.508-1.581-1.242-2.1-.723-.509-1.604-.475-2.372-.44-.429.022-.88.033-1.174-.057-.26-.09-.61-.35-.937-.599-.621-.474-1.333-1.016-2.247-1.016-.915 0-1.626.542-2.247 1.016l-.09.068c-.299.228-.601.459-.848.53-.267.083-.665.072-1.059.06l-.115-.003c-.78-.034-1.649-.068-2.371.44-.734.509-1.005 1.356-1.243 2.1-.124.407-.26.825-.44 1.062-.17.223-.5.447-.83.67l-.062.042c-.655.429-1.4.926-1.694 1.784-.275.815-.003 1.62.241 2.34l.019.054c.158.429.293.835.293 1.152 0 .296-.129.672-.266 1.07l-.027.081c-.26.723-.542 1.559-.26 2.394.294.859 1.039 1.355 1.694 1.784l.062.042c.33.224.66.447.83.67.18.237.316.655.44 1.061.238.746.509 1.581 1.243 2.1.722.509 1.603.475 2.37.441.43-.023.882-.034 1.175.056.26.09.61.35.938.599m5.477-14.562a3.236 3.236 0 0 0-3.228-3.229 3.236 3.236 0 0 0-3.229 3.229 3.236 3.236 0 0 0 3.229 3.228 3.236 3.236 0 0 0 3.228-3.228m-3.241 12.53a7.87 7.87 0 0 0 6.115-2.9c.247-.286.329-.657.247-1.025l-.26-1.11c-.426-1.849-2.109-2.942-4.078-2.942H9.848c-1.93 0-3.655 1.08-4.078 2.942l-.26 1.11c-.069.354 0 .739.247 1.025a7.91 7.91 0 0 0 6.116 2.9",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M9.637 22.368c.62.473 1.33 1.014 2.241 1.016h-.006.012-.006c.912-.002 1.622-.543 2.242-1.016l.14-.103c.29-.216.574-.427.808-.495.294-.09.745-.08 1.175-.057.779.034 1.648.068 2.37-.44.735-.508 1.006-1.355 1.243-2.1.124-.407.26-.825.44-1.062.17-.223.5-.447.83-.67l.063-.041c.654-.43 1.4-.926 1.693-1.785.276-.815.003-1.62-.241-2.34l-.018-.054c-.159-.429-.294-.835-.294-1.151 0-.297.129-.672.266-1.072l.028-.08c.26-.723.542-1.559.26-2.394-.294-.858-1.04-1.355-1.694-1.784l-.062-.042c-.33-.223-.66-.447-.83-.67-.181-.237-.317-.655-.441-1.061-.237-.745-.508-1.581-1.242-2.1-.723-.509-1.604-.475-2.372-.44-.429.022-.88.033-1.174-.057-.26-.09-.61-.35-.937-.599-.621-.474-1.333-1.016-2.247-1.016-.915 0-1.626.542-2.247 1.016l-.09.068c-.299.228-.601.459-.848.53-.267.083-.665.072-1.059.06l-.115-.003c-.78-.034-1.649-.068-2.371.44-.734.509-1.005 1.356-1.243 2.1-.124.407-.26.825-.44 1.062-.17.223-.5.447-.83.67l-.062.042c-.655.429-1.4.926-1.694 1.784-.275.815-.003 1.62.241 2.34l.019.054c.158.429.293.835.293 1.152 0 .296-.129.672-.266 1.07l-.027.081c-.26.723-.542 1.559-.26 2.394.294.859 1.039 1.355 1.694 1.784l.062.042c.33.224.66.447.83.67.18.237.316.655.44 1.061.238.746.509 1.581 1.243 2.1.722.509 1.603.475 2.37.441.43-.023.882-.034 1.175.056.26.09.61.35.938.599m5.477-14.562a3.236 3.236 0 0 0-3.228-3.229 3.236 3.236 0 0 0-3.229 3.229 3.236 3.236 0 0 0 3.229 3.228 3.236 3.236 0 0 0 3.228-3.228m-3.241 12.53a7.87 7.87 0 0 0 6.115-2.9c.247-.286.329-.657.247-1.025l-.26-1.11c-.426-1.849-2.109-2.942-4.078-2.942H9.848c-1.93 0-3.655 1.08-4.078 2.942l-.26 1.11c-.069.354 0 .739.247 1.025a7.91 7.91 0 0 0 6.116 2.9",
			clipRule: "evenodd"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Signature/SignatureIcon.tsx
const SignatureIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.236 6.432c-.872-1.225-1.855-1.587-2.598-1.37-.974.286-1.468.923-1.601 1.679-.14.8.109 1.865.94 2.907a1 1 0 0 1-1.565 1.246c-1.107-1.39-1.605-3.019-1.345-4.5.268-1.524 1.324-2.756 3.008-3.25 1.915-.563 3.68.567 4.79 2.13.941 1.322 1.559 3.114 1.617 5.07q.4-.096.769-.155c.638-.1 1.464-.158 2.117.193.377.203.68.533.827.982.137.418.113.856.023 1.262q-.027.12-.045.225c.303-.203.67-.502 1.086-.894.488-.461.934-.809 1.35-1.017.408-.204.96-.355 1.512-.108.527.236.762.707.871 1 .116.31.177.656.22.92l.035.218c.024.148.044.276.068.397q.044-.03.095-.068a1 1 0 0 1 1.18 1.616c-.425.31-.888.565-1.377.615a1.52 1.52 0 0 1-1.393-.596c-.255-.331-.367-.73-.43-1.006a11 11 0 0 1-.126-.694l-.052-.318a6 6 0 0 0-.58.496c-.494.466-.98.865-1.433 1.157-.418.27-.942.536-1.481.551a1.5 1.5 0 0 1-.949-.287 1.56 1.56 0 0 1-.555-.823c-.157-.532-.092-1.172.052-1.818l.014-.073-.066-.005a3.4 3.4 0 0 0-.652.05c-.37.06-.778.157-1.21.279-.238 2.015-.694 4.196-1.517 5.83-.472.937-1.117 1.802-2.015 2.3-.949.527-2.04.57-3.196.107-1.874-.751-2.446-2.796-1.884-4.632.573-1.87 2.287-3.661 5.146-4.59q.36-.117.77-.256.399-.135.826-.275c.061-1.788-.468-3.4-1.246-4.495m1.008 6.683q-.374.126-.74.245c-2.37.77-3.507 2.148-3.852 3.274-.355 1.16.087 1.937.716 2.19.674.27 1.127.197 1.48.001.404-.224.817-.69 1.2-1.451.567-1.125.952-2.66 1.196-4.259m8.86-.618-.005-.01z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2",
			d: "M4.195 10.271C2.257 7.84 2.699 4.883 5.357 4.103s5.496 2.983 5.09 7.388c-.405 4.406-1.792 9.727-5.45 8.26-2.503-1.002-2.03-5.644 3.198-7.342 2.628-.853 6.588-2.432 6.047 0-.54 2.432.833 2.04 2.703.276C20.64 9.197 17.981 16.31 21 14.107"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Split/SplitIcon.tsx
const SplitIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			fill: "none",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m12 6 4-4m0 0 4 4m-4-4v1.485c0 3.327 0 4-.654 5.271a5.97 5.97 0 0 1-2.622 2.596C11.441 12 9.76 12 6.4 12m0 0H5m1.4 0c3.36 0 5.04 0 6.324.648a5.97 5.97 0 0 1 2.622 2.596c.654 1.27.654 1.944.654 5.27V22m0 0-4-4m4 4 4-4"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m12 6 4-4m0 0 4 4m-4-4v1.485c0 3.327 0 4-.654 5.271a5.97 5.97 0 0 1-2.622 2.596C11.441 12 9.76 12 6.4 12m0 0H5m1.4 0c3.36 0 5.04 0 6.324.648a5.97 5.97 0 0 1 2.622 2.596c.654 1.27.654 1.944.654 5.27V22m0 0-4-4m4 4 4-4"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ShieldLock/ShieldLockIcon.tsx
const ShieldLockIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12.667 10.316v-.71c0-.393-.299-.711-.667-.711s-.667.318-.667.71v.71z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.286 1.02a2 2 0 0 0-.572 0 2.8 2.8 0 0 0-.583.17l-.044.016-5.492 2.06c-.618.23-1.16.433-1.578.801a3 3 0 0 0-.82 1.184c-.199.52-.198 1.1-.197 1.76v4.921c0 2.827 1.538 5.183 3.2 6.914 1.672 1.743 3.586 2.974 4.598 3.565l.041.024c.185.108.425.249.742.317.26.056.58.056.839 0a2.4 2.4 0 0 0 .741-.317l.041-.024c1.012-.59 2.926-1.822 4.6-3.565C19.462 17.116 21 14.76 21 11.932V7.01c.001-.66.002-1.238-.196-1.759a3 3 0 0 0-.82-1.184c-.418-.368-.96-.57-1.578-.801l-5.493-2.06-.043-.016a2.8 2.8 0 0 0-.584-.17M12 7c-1.35 0-2.444 1.166-2.444 2.605v.737c-.18.023-.382.07-.585.18a1.84 1.84 0 0 0-.777.828 2 2 0 0 0-.179.73C8 12.277 8 12.51 8 12.749v.818c0 .24 0 .472.015.67.017.216.056.471.179.729.17.356.442.646.777.828.24.13.48.172.684.19.185.016.403.016.628.016h3.434c.225 0 .443 0 .628-.016a1.7 1.7 0 0 0 .684-.19 1.84 1.84 0 0 0 .777-.828 2 2 0 0 0 .179-.73c.015-.197.015-.43.015-.669v-.818c0-.24 0-.472-.015-.67a2 2 0 0 0-.179-.729 1.84 1.84 0 0 0-.777-.828 1.6 1.6 0 0 0-.585-.18v-.737C14.444 8.166 13.35 7 12 7",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M9.556 9.605C9.556 8.166 10.65 7 12 7s2.444 1.166 2.444 2.605v.737c.18.023.382.07.585.18.335.182.607.472.777.828.123.258.162.513.179.73.015.197.015.43.015.669v.818c0 .24 0 .472-.015.67a2 2 0 0 1-.179.729 1.84 1.84 0 0 1-.777.828 1.7 1.7 0 0 1-.684.19c-.185.016-.403.016-.628.016h-3.434c-.225 0-.443 0-.628-.016a1.7 1.7 0 0 1-.684-.19 1.84 1.84 0 0 1-.777-.828 2 2 0 0 1-.179-.73C8 14.04 8 13.806 8 13.567v-.818c0-.24 0-.472.015-.67.017-.216.056-.472.179-.729a1.84 1.84 0 0 1 .777-.828c.203-.11.405-.157.585-.18zm3.11 0v.71h-1.333v-.71c0-.392.299-.71.667-.71s.667.318.667.71",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M11.302 21.615c.221.13.332.194.488.228.122.026.298.026.42 0 .156-.034.267-.099.488-.228C14.646 20.48 20 16.91 20 12V7.218c0-.8 0-1.2-.13-1.543a2 2 0 0 0-.548-.79c-.275-.242-.65-.383-1.398-.663L12.562 2.21c-.208-.078-.312-.117-.419-.132a1 1 0 0 0-.286 0c-.107.015-.21.054-.419.132L6.076 4.22c-.748.281-1.122.422-1.398.665a2 2 0 0 0-.547.79C4 6.018 4 6.417 4 7.217V12c0 4.909 5.354 8.479 7.302 9.615"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Collapse/CollapseIcon.tsx
const CollapseIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M3 2a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m6.414 9 5.293-5.293a1 1 0 0 0-1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L9.414 13H21a1 1 0 1 0 0-2z"
		}),
		line: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M3 2a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m6.414 9 5.293-5.293a1 1 0 0 0-1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L9.414 13H21a1 1 0 1 0 0-2z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Documents/DocumentsIcon.tsx
const DocumentsIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "m13 2.016-.001-.064a1.03 1.03 0 0 0-.952-.95L12 1H8.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C3 5.29 3 5.954 3 6.758v10.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C7.29 23 7.954 23 8.758 23h6.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V10l-.001-.047A1.03 1.03 0 0 0 20.048 9h-4.48c-.252 0-.498 0-.706-.017a2 2 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2 2 0 0 1-.201-.77C13 6.93 13 6.684 13 6.432zM8 13a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M18.908 7c.294 0 .44 0 .56-.074a.54.54 0 0 0 .226-.543c-.034-.137-.13-.233-.32-.424L16.04 2.627c-.191-.192-.287-.288-.424-.32a.54.54 0 0 0-.543.224c-.074.12-.074.267-.074.561V6.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C15.38 7 15.52 7 15.8 7z"
			})
		] }),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M14 17H8m8-4H8m12-3.012V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Trademark/TrademarkIcon.tsx
const TrademarkIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20.99 5c0-2.21-1.79-4-3.99-4H7.97c.28 1.03.23 1.78.18 2.38-.03.32-.05.63-.01 1.04.2-.03.39-.06.58-.08.11-.01.21-.02.32-.02 1.26 0 2.37.81 2.75 2.02l.08.25c.24.76.16 1.56-.23 2.25a3 3 0 0 1-1.86 1.45L3.9 11.88c-.26.07-.53.11-.81.11h-.1V19c0 2.21 1.8 3.99 4 3.99h10c2.21.01 4-1.78 4-3.99zm-9.985 10.005a1 1 0 0 1-1 .995H9v2.988a1.012 1.012 0 1 1-2.025-.005L6.99 16H6a1 1 0 1 1 0-2h4.005a1 1 0 0 1 1 1.005m8.007 3.99a1.006 1.006 0 0 1-2.012 0V17.99l-1.5 1.52-1.49-1.52V19a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1h.086a1 1 0 0 1 .707.293L15.51 16l1.707-1.707a1 1 0 0 1 .707-.293h.095a1 1 0 0 1 1 1.002z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m9.96 7.2-.08-.25a.88.88 0 0 0-.84-.62h-.1c-.63.07-1.45.23-2.31.43-.01-.04-.02-.09-.04-.13-.57-1.81-.49-2.68-.43-3.42.05-.56.09-1.06-.16-1.84-.02-.07-.07-.13-.1-.19C5.58.47 4.85.01 4.04.01c-.19 0-.38.02-.57.08-1.08.29-1.7 1.34-1.39 2.35.25.78.57 1.18.93 1.63.03.03.05.06.08.1.47.58 1 1.29 1.54 3.01.01.04.03.09.04.13-.61.18-1.18.38-1.67.57-.19.07-.37.15-.52.22-.4.18-.56.6-.44.99l.08.25c.12.38.48.63.88.67.03 0 .07.01.1.01.09 0 .19-.01.29-.04l5.88-1.59c.54-.15.85-.67.69-1.17z"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20.99 5c0-2.21-1.79-4-3.99-4H7.97c.28 1.03.23 1.78.18 2.38-.03.32-.05.63-.01 1.04.2-.03.39-.06.58-.08.11-.01.21-.02.32-.02 1.26 0 2.37.81 2.75 2.02l.08.25c.24.76.16 1.56-.23 2.25a3 3 0 0 1-1.86 1.45L3.9 11.88c-.26.07-.53.11-.81.11h-.1V19c0 2.21 1.8 3.99 4 3.99h10c2.21.01 4-1.78 4-3.99zm-9.985 10.005a1 1 0 0 1-1 .995H9v2.988a1.012 1.012 0 1 1-2.025-.005L6.99 16H6a1 1 0 1 1 0-2h4.005a1 1 0 0 1 1 1.005m8.007 3.99a1.006 1.006 0 0 1-2.012 0V17.99l-1.5 1.52-1.49-1.52V19a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1h.086a1 1 0 0 1 .707.293L15.51 16l1.707-1.707a1 1 0 0 1 .707-.293h.095a1 1 0 0 1 1 1.002z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m9.96 7.2-.08-.25a.88.88 0 0 0-.84-.62h-.1c-.63.07-1.45.23-2.31.43-.01-.04-.02-.09-.04-.13-.57-1.81-.49-2.68-.43-3.42.05-.56.09-1.06-.16-1.84-.02-.07-.07-.13-.1-.19C5.58.47 4.85.01 4.04.01c-.19 0-.38.02-.57.08-1.08.29-1.7 1.34-1.39 2.35.25.78.57 1.18.93 1.63.03.03.05.06.08.1.47.58 1 1.29 1.54 3.01.01.04.03.09.04.13-.61.18-1.18.38-1.67.57-.19.07-.37.15-.52.22-.4.18-.56.6-.44.99l.08.25c.12.38.48.63.88.67.03 0 .07.01.1.01.09 0 .19-.01.29-.04l5.88-1.59c.54-.15.85-.67.69-1.17z"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Dining/DiningIcon.tsx
const DiningIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6.5 12C8.433 12 10 9.985 10 7.5S8.433 3 6.5 3 3 5.015 3 7.5 4.567 12 6.5 12"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.5 4C5.339 4 4 5.319 4 7.5S5.339 11 6.5 11 9 9.681 9 7.5 7.661 4 6.5 4M2 7.5C2 4.71 3.795 2 6.5 2S11 4.71 11 7.5 9.205 13 6.5 13 2 10.29 2 7.5",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M13.5 3v5.183A3.817 3.817 0 0 0 17.317 12h-.609L16 20.065c0 .393.172.771.477 1.05.305.277.72.434 1.152.434.22.009.439-.023.645-.094.206-.07.393-.179.552-.317a1.5 1.5 0 0 0 .372-.49c.086-.184.13-.383.13-.583L18.62 12h-.937A3.817 3.817 0 0 0 21.5 8.183V3H21v4.775a.764.764 0 0 1-.764.763h-1.622a.764.764 0 0 1-.764-.763V3h-.7v4.775a.763.763 0 0 1-.763.763h-1.623A.763.763 0 0 1 14 7.775V3zM6.629 21.549c-.432 0-.847-.157-1.152-.435A1.42 1.42 0 0 1 5 20.064L5.708 12H7.62l.708 8.065c0 .2-.044.399-.13.583a1.5 1.5 0 0 1-.372.49 1.7 1.7 0 0 1-.552.317c-.206.07-.426.103-.645.094",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M14.847 9.538A2.82 2.82 0 0 0 17.317 11q.094 0 .183.017.09-.017.183-.017c1.064 0 1.99-.59 2.47-1.462h-1.54c-.422 0-.81-.148-1.113-.395a1.76 1.76 0 0 1-1.113.395zm.796 3.163A4.82 4.82 0 0 1 12.5 8.183V3a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.538h1.15V3a1 1 0 0 1 1-1h.7a1 1 0 0 1 1 1v4.538H20V3a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v5.183c0 1.95-1.16 3.63-2.826 4.387l.65 7.407q.004.044.004.087c0 .35-.077.693-.224 1.008l-.906-.424.906.424a2.5 2.5 0 0 1-.62.819l-.658-.753.658.753c-.26.227-.561.399-.886.51a2.8 2.8 0 0 1-.99.148 2.7 2.7 0 0 1-1.805-.696A2.42 2.42 0 0 1 15 20.065q0-.044.004-.088zm1.981.297-.623 7.096c.008.09.051.191.15.281a.7.7 0 0 0 .478.174h.04a.8.8 0 0 0 .28-.04.7.7 0 0 0 .22-.125.5.5 0 0 0 .123-.16.4.4 0 0 0 .035-.129L17.704 13h-.021q-.03 0-.059-.002M4.712 11.913A1 1 0 0 1 5.708 11H7.62a1 1 0 0 1 .996.912l.708 8.065.004.087c0 .35-.077.693-.224 1.008s-.36.592-.62.819l-.658-.753.658.753c-.26.227-.561.399-.886.51a2.8 2.8 0 0 1-.99.148 2.7 2.7 0 0 1-1.804-.696A2.42 2.42 0 0 1 4 20.065l.004-.088zM6.624 13l-.623 7.094c.008.09.051.191.15.281a.7.7 0 0 0 .478.174h.04a.8.8 0 0 0 .28-.04.7.7 0 0 0 .22-.125.5.5 0 0 0 .123-.16.4.4 0 0 0 .035-.129L6.704 13z",
				clipRule: "evenodd"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.5 4C5.339 4 4 5.319 4 7.5S5.339 11 6.5 11 9 9.681 9 7.5 7.661 4 6.5 4M2 7.5C2 4.71 3.795 2 6.5 2S11 4.71 11 7.5 9.205 13 6.5 13 2 10.29 2 7.5",
				clipRule: "evenodd"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.5 3a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.538h1.15V3a1 1 0 0 1 1-1h.7a1 1 0 0 1 1 1v4.538H20V3a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v5.183c0 1.95-1.16 3.63-2.826 4.387l.65 7.407q.004.044.004.087c0 .35-.077.693-.224 1.008a2.5 2.5 0 0 1-.62.819 2.7 2.7 0 0 1-.886.51 2.8 2.8 0 0 1-.99.148 2.7 2.7 0 0 1-1.805-.696l.674-.739-.674.74a2.42 2.42 0 0 1-.803-1.79q0-.043.004-.087l.639-7.276A4.82 4.82 0 0 1 12.5 8.183zm5.124 9.998-.623 7.096c.008.09.051.191.15.281a.7.7 0 0 0 .478.174h.039a.8.8 0 0 0 .281-.04.7.7 0 0 0 .22-.125.5.5 0 0 0 .123-.16.4.4 0 0 0 .035-.129L17.704 13h-.021q-.03 0-.059-.002M17.683 11c1.064 0 1.99-.59 2.47-1.462h-1.54c-.422 0-.81-.148-1.113-.395a1.76 1.76 0 0 1-1.113.395h-1.54A2.82 2.82 0 0 0 17.317 11q.094 0 .183.017.09-.017.183-.017m-12.971.912A1 1 0 0 1 5.708 11H7.62a1 1 0 0 1 .996.912l.708 8.065.004.087c0 .35-.077.693-.224 1.008s-.36.592-.62.819-.561.399-.886.51a2.8 2.8 0 0 1-.99.148 2.7 2.7 0 0 1-1.804-.696A2.42 2.42 0 0 1 4 20.065q0-.045.004-.088zM6.624 13l-.623 7.094c.008.09.051.191.15.281a.7.7 0 0 0 .478.174h.04a.8.8 0 0 0 .28-.04.7.7 0 0 0 .22-.125.5.5 0 0 0 .123-.16.4.4 0 0 0 .035-.129L6.704 13z",
				clipRule: "evenodd"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CircleDashed/CircleDashedIcon.tsx
const CircleDashedIcon = ({ size = "md", variant, ...props }) => {
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: "none",
		...props,
		children: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeDasharray: "4 4",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
		})
	});
};
//#endregion
//#region src/icons/Mobile/MobileIcon.tsx
const MobileIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.161 1h7.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V18.84c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031H8.16c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A18 18 0 0 1 4 18.839V5.16c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C7.18 1 7.635 1 8.161 1M15 3.4V3H9v.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C9.76 5 10.04 5 10.6 5h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C15 4.24 15 3.96 15 3.4M12 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M15 2v1.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.24 5 13.96 5 13.4 5h-2.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C9 4.24 9 3.96 9 3.4V2m-.8 20h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C19 20.48 19 19.92 19 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C17.48 2 16.92 2 15.8 2H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 3.52 5 4.08 5 5.2v13.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C6.52 22 7.08 22 8.2 22"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeWidth: "2",
				d: "M12 18h.01"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Message/MessageIcon.tsx
const MessageIcon = ({ variant = "line", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.7588 2H16.2414C17.0464 1.99999 17.7107 1.99998 18.2519 2.04419C18.814 2.09012 19.3307 2.18868 19.8161 2.43598C20.5687 2.81947 21.1806 3.43139 21.5641 4.18404C21.8114 4.66937 21.91 5.18608 21.9559 5.74818C22.0001 6.28936 22.0001 6.95372 22.0001 7.75868V13.2413C22.0001 14.0463 22.0001 14.7106 21.9559 15.2518C21.91 15.8139 21.8114 16.3306 21.5641 16.816C21.1806 17.5686 20.5687 18.1805 19.8161 18.564C19.3307 18.8113 18.814 18.9099 18.2519 18.9558C17.7107 19 17.0464 19 16.2414 19H13.6838C13.0197 19 12.8263 19.0047 12.6504 19.0408C12.4738 19.0771 12.303 19.137 12.1425 19.219C11.9826 19.3007 11.8286 19.4178 11.31 19.8327L8.89688 21.7632C8.7132 21.9102 8.52597 22.06 8.36137 22.1689C8.20394 22.273 7.8987 22.4593 7.50172 22.4597C7.0449 22.4602 6.61276 22.2525 6.32778 21.8955C6.08012 21.5852 6.03492 21.2305 6.01785 21.0425C6 20.846 6.00005 20.6062 6.00009 20.371L6.0001 18.9918C5.60829 18.9789 5.27229 18.9461 4.96482 18.8637C3.58445 18.4938 2.50626 17.4156 2.13639 16.0353C1.9993 15.5236 1.99962 14.933 2.00005 14.1376L2.0001 7.7587C2.00008 6.95373 2.00007 6.28937 2.04429 5.74818C2.09022 5.18608 2.18878 4.66937 2.43607 4.18404C2.81956 3.43139 3.43149 2.81947 4.18413 2.43598C4.66947 2.18868 5.18617 2.09012 5.74827 2.04419C6.28946 1.99998 6.95383 1.99999 7.7588 2ZM6 8.5C6 7.94772 6.44772 7.5 7 7.5H12C12.5523 7.5 13 7.94772 13 8.5C13 9.05229 12.5523 9.5 12 9.5H7C6.44772 9.5 6 9.05229 6 8.5ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H7Z",
			fill: "currentColor"
		}),
		line: /* @__PURE__ */ jsx("path", {
			d: "M7 8.5H12M7 12H15M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CCIconSet/AchIcon.tsx
const AchIcon = ({ size = "md", ...rest }) => /* @__PURE__ */ jsxs("svg", {
	height: iconSizes[size],
	width: iconSizes[size] * 1.5,
	viewBox: "0 0 36 24",
	fill: "none",
	...rest,
	children: [
		/* @__PURE__ */ jsx("rect", {
			width: "36",
			height: "24",
			rx: "4",
			fill: "#F5F2EE"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.9048 8.14281C25.7485 8.00338 25.5134 7.96166 25.3091 8.03713C25.1049 8.11259 24.9717 8.29036 24.9717 8.48755V9.95015C24.6039 9.95015 23.6634 9.95018 22.4007 9.95022C17.894 9.95036 9.28394 9.95062 7.97124 9.95015H7.97124C7.90613 9.95013 7.82838 9.9501 7.75988 9.95509C7.6805 9.96088 7.56681 9.97572 7.44768 10.0299C7.29341 10.1 7.16798 10.2118 7.08937 10.3495C7.02867 10.4557 7.01203 10.5571 7.00555 10.6279C6.99995 10.689 6.99998 10.7584 7 10.8164C7.00018 11.2247 7.3309 11.5556 7.73912 11.5556H27.4288C28.1428 11.5556 28.4998 11.5556 28.6554 11.418C28.7903 11.2988 28.858 11.121 28.8368 10.9423C28.8122 10.736 28.5458 10.4984 28.0129 10.0231L28.0129 10.0231L25.9048 8.14281ZM9.98751 15.8572C10.1425 15.9966 10.3757 16.0383 10.5783 15.9629C10.7808 15.8874 10.9129 15.7096 10.9129 15.5125V14.0498C11.2761 14.0498 12.2117 14.0498 13.4702 14.0498C17.9859 14.0496 26.6587 14.0494 27.9621 14.0498C28.0266 14.0499 28.1038 14.0499 28.1717 14.0449C28.2504 14.0391 28.3632 14.0243 28.4813 13.9701C28.6343 13.9 28.7587 13.7882 28.8367 13.6505C28.8968 13.5443 28.9134 13.4429 28.9198 13.3721C28.9253 13.311 28.9253 13.2417 28.9253 13.1836V13.1836C28.9251 12.7753 28.5944 12.4444 28.1862 12.4444H8.481C7.77078 12.4444 7.41568 12.4444 7.2602 12.5816C7.12545 12.7004 7.05745 12.8777 7.07817 13.0562C7.10208 13.2621 7.36611 13.4996 7.89417 13.9745L9.98751 15.8572Z",
			fill: "#252424"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "12.25",
			y: "6.25",
			width: "11.5",
			height: "11.5",
			rx: "5.75",
			fill: "#252424"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.9421 8.67735C17.9808 8.67396 18.0198 8.67396 18.0586 8.67735C18.1031 8.68126 18.1456 8.69077 18.1794 8.69832L20.6639 9.25044C20.7307 9.26528 20.7971 9.28003 20.8532 9.2969C20.9159 9.31574 20.9872 9.3431 21.0567 9.39315C21.1548 9.46384 21.2318 9.55988 21.2796 9.67099C21.3133 9.74967 21.3246 9.82522 21.3294 9.89047C21.3337 9.94894 21.3337 10.017 21.3337 10.0854V10.4774C21.3337 10.5615 21.3337 10.6434 21.328 10.7127C21.3218 10.7889 21.3071 10.8789 21.261 10.9693C21.1971 11.0948 21.0951 11.1968 20.9697 11.2607C20.8792 11.3068 20.7893 11.3215 20.7131 11.3277C20.6982 11.3289 20.6829 11.3299 20.667 11.3306V13.3361C20.6829 13.3368 20.6982 13.3378 20.7131 13.339C20.7893 13.3452 20.8792 13.3599 20.9697 13.406C21.0951 13.4699 21.1971 13.5719 21.261 13.6973C21.3071 13.7878 21.3218 13.8777 21.328 13.9539C21.3337 14.0233 21.3337 14.1052 21.3337 14.1893V14.4774C21.3337 14.5615 21.3337 14.6434 21.328 14.7127C21.3218 14.7889 21.3071 14.8789 21.261 14.9693C21.1971 15.0948 21.0951 15.1968 20.9697 15.2607C20.8792 15.3068 20.7893 15.3215 20.7131 15.3277C20.6437 15.3334 20.5618 15.3333 20.4776 15.3333H15.523C15.4389 15.3333 15.357 15.3334 15.2876 15.3277C15.2114 15.3215 15.1215 15.3068 15.031 15.2607C14.9056 15.1968 14.8036 15.0948 14.7397 14.9693C14.6936 14.8789 14.6789 14.7889 14.6726 14.7127C14.667 14.6434 14.667 14.5614 14.667 14.4773L14.667 14.1894C14.667 14.1052 14.667 14.0233 14.6726 13.9539C14.6789 13.8777 14.6936 13.7878 14.7397 13.6973C14.8036 13.5719 14.9056 13.4699 15.031 13.406C15.1215 13.3599 15.2114 13.3452 15.2876 13.339C15.3024 13.3378 15.3178 13.3368 15.3337 13.3361V11.3306C15.3178 11.3299 15.3024 11.3289 15.2876 11.3277C15.2114 11.3215 15.1215 11.3068 15.031 11.2607C14.9056 11.1968 14.8036 11.0948 14.7397 10.9693C14.6936 10.8789 14.6789 10.7889 14.6726 10.7127C14.667 10.6434 14.667 10.5614 14.667 10.4773L14.667 10.0854C14.667 10.017 14.667 9.94894 14.6713 9.89047C14.6761 9.82522 14.6873 9.74967 14.7211 9.67099C14.7688 9.55988 14.8459 9.46384 14.944 9.39315C15.0134 9.3431 15.0848 9.31574 15.1474 9.2969C15.2036 9.28003 15.27 9.26528 15.3368 9.25044L17.8213 8.69832C17.855 8.69077 17.8975 8.68126 17.9421 8.67735ZM16.0003 11.3333V13.3333H16.8337V11.3333H16.0003ZM17.5003 11.3333V13.3333H18.5003V11.3333L17.5003 11.3333ZM19.167 11.3333V13.3333H20.0003V11.3333H19.167Z",
			fill: "#F5F2EE"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "12.25",
			y: "6.25",
			width: "11.5",
			height: "11.5",
			rx: "5.75",
			stroke: "#F5F2EE",
			strokeWidth: "0.5"
		})
	]
});
//#endregion
//#region src/icons/CCIconSet/AmericanExpressIcon.tsx
const AmericanExpressIcon = ({ size = "md", ...rest }) => /* @__PURE__ */ jsxs("svg", {
	height: iconSizes[size],
	width: iconSizes[size] * 1.5,
	viewBox: "0 0 36 24",
	fill: "none",
	...rest,
	children: [/* @__PURE__ */ jsx("rect", {
		width: "36.0001",
		height: "24",
		rx: "4",
		fill: "#F5F2EE"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.70858 8.91064L6 15.0809H9.24255L9.64453 14.0971H10.5634L10.9654 15.0809H14.5345V14.3301L14.8525 15.0809H16.6988L17.0168 14.3142V15.0809H24.4396L25.3422 14.1227L26.1874 15.0809L29.9999 15.0889L27.2827 12.013L29.9999 8.91064H26.2465L25.3679 9.85119L24.5493 8.91064H16.4743L15.7809 10.5033L15.0712 8.91064H11.8354V9.63596L11.4754 8.91064H8.70858ZM9.33608 9.78684H10.9167L12.7133 13.9709V9.78684H14.4447L15.8324 12.7868L17.1113 9.78684H18.8341V14.2144H17.7858L17.7772 10.745L16.2489 14.2144H15.3112L13.7743 10.745V14.2144H11.6178L11.2089 13.2218H9.0001L8.5921 14.2136H7.43664L9.33608 9.78684ZM24.0557 9.78684H19.7932V14.2118H23.9897L25.3423 12.7453L26.646 14.2118H28.0089L26.028 12.0122L28.0089 9.78684H26.7052L25.3594 11.2365L24.0557 9.78684ZM10.1049 10.536L9.37716 12.3042H10.8318L10.1049 10.536ZM20.8456 11.5118V10.7028H23.5053L24.6659 11.9954L23.4539 13.2951H20.8456V12.4127H23.171V11.5118H20.8456Z",
		fill: "#016FD0"
	})]
});
//#endregion
//#region src/icons/CCIconSet/ApplePayIcon.tsx
const ApplePayIcon = ({ size = "md", ...rest }) => /* @__PURE__ */ jsxs("svg", {
	height: iconSizes[size],
	width: iconSizes[size] * 1.5,
	viewBox: "0 0 36 24",
	fill: "none",
	...rest,
	children: [/* @__PURE__ */ jsx("rect", {
		width: "36.0001",
		height: "24",
		rx: "4",
		fill: "#F5F2EE"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.3854 8.18958C10.1041 8.53642 9.65402 8.80999 9.20397 8.77091C9.14772 8.30194 9.36805 7.80366 9.62589 7.4959C9.90718 7.13929 10.3994 6.88526 10.7979 6.86572C10.8448 7.35423 10.6619 7.83297 10.3854 8.18958ZM10.7931 8.86371C10.3966 8.83993 10.0348 8.98796 9.74262 9.10753C9.55457 9.18447 9.39533 9.24963 9.27418 9.24963C9.13822 9.24963 8.97241 9.18099 8.78623 9.10392C8.54228 9.00293 8.26338 8.88748 7.97091 8.89302C7.30052 8.90279 6.67701 9.29848 6.33479 9.92866C5.63158 11.189 6.15196 13.0551 6.83172 14.081C7.16457 14.589 7.56305 15.1459 8.08811 15.1264C8.3191 15.1173 8.48527 15.0438 8.65723 14.9678C8.85521 14.8803 9.06087 14.7893 9.382 14.7893C9.692 14.7893 9.88867 14.8779 10.0775 14.9629C10.257 15.0437 10.4294 15.1214 10.6853 15.1166C11.2291 15.1068 11.5713 14.6086 11.9042 14.1005C12.2634 13.5552 12.4212 13.0231 12.4452 12.9423L12.448 12.933C12.448 12.933 12.443 12.9303 12.4351 12.9265C12.3151 12.8693 11.3973 12.4314 11.3885 11.2574C11.3796 10.272 12.1164 9.77269 12.2324 9.69409C12.2395 9.68931 12.2442 9.68608 12.2464 9.6844C11.7776 8.96141 11.0463 8.88325 10.7931 8.86371ZM14.5577 15.0629V7.44703H17.3002C18.7159 7.44703 19.7051 8.46313 19.7051 9.9482C19.7051 11.4333 18.6972 12.4591 17.2627 12.4591H15.6922V15.0629H14.5577ZM15.692 8.44361H16.9999C17.9844 8.44361 18.547 8.99074 18.547 9.9531C18.547 10.9155 17.9844 11.4675 16.9952 11.4675H15.692V8.44361ZM23.4507 14.1494C23.1507 14.7454 22.4897 15.1215 21.7771 15.1215C20.7223 15.1215 19.9863 14.4669 19.9863 13.4801C19.9863 12.5031 20.6989 11.9413 22.0162 11.8583L23.432 11.7703V11.3502C23.432 10.7298 23.0429 10.3928 22.3491 10.3928C21.7771 10.3928 21.3599 10.7005 21.2755 11.1695H20.2535C20.2863 10.1827 21.177 9.46459 22.3819 9.46459C23.6805 9.46459 24.5243 10.1729 24.5243 11.2721V15.0629H23.4742V14.1494H23.4507ZM22.0819 14.2178C21.4771 14.2178 21.0927 13.9149 21.0927 13.4508C21.0927 12.9721 21.4631 12.6936 22.171 12.6497L23.432 12.5666V12.9965C23.432 13.7097 22.8507 14.2178 22.0819 14.2178ZM28.0075 15.3609C27.5528 16.6945 27.0324 17.1342 25.926 17.1342C25.8416 17.1342 25.5604 17.1244 25.4947 17.1049V16.1913C25.565 16.2011 25.7385 16.2109 25.8276 16.2109C26.3292 16.2109 26.6105 15.9911 26.7839 15.4195L26.8871 15.0824L24.965 9.53786H26.1511L27.4871 14.037H27.5106L28.8467 9.53786H29.9999L28.0075 15.3609Z",
		fill: "black"
	})]
});
//#endregion
//#region src/icons/CCIconSet/DiscoverIcon.tsx
const DiscoverIcon = ({ size = "md", ...rest }) => /* @__PURE__ */ jsxs("svg", {
	height: iconSizes[size],
	width: iconSizes[size] * 1.5,
	viewBox: "0 0 36 24",
	fill: "none",
	...rest,
	children: [
		/* @__PURE__ */ jsx("rect", {
			width: "36.0001",
			height: "24",
			rx: "4",
			fill: "#F5F2EE"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M13.4444 11.9895C13.4444 13.1208 14.3328 13.9981 15.4761 13.9981C15.7993 13.9981 16.0761 13.9345 16.4174 13.7738V12.89C16.1172 13.1904 15.8514 13.3115 15.5111 13.3115C14.7549 13.3115 14.2183 12.7633 14.2183 11.9838C14.2183 11.2449 14.7719 10.6619 15.4762 10.6619C15.8343 10.6619 16.1053 10.7897 16.4175 11.095V10.2116C16.0879 10.0444 15.817 9.9751 15.4939 9.9751C14.3563 9.97531 13.4444 10.8704 13.4444 11.9895Z",
			fill: "#231F20"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11.5177 11.0548C11.5177 11.2627 11.6499 11.3727 12.1005 11.5394C12.9545 11.8516 13.2075 12.1285 13.2075 12.7401C13.2075 13.4852 12.6603 14.0039 11.88 14.0039C11.3088 14.0039 10.8934 13.7788 10.5475 13.2711L11.0325 12.804C11.2053 13.1383 11.4937 13.3174 11.8518 13.3174C12.1868 13.3174 12.4347 13.0863 12.4347 12.7745C12.4347 12.6129 12.3596 12.4741 12.2096 12.3762C12.1341 12.3298 11.9845 12.2607 11.6906 12.1571C10.9855 11.9033 10.7436 11.6319 10.7436 11.1016C10.7436 10.4716 11.2631 9.99864 11.9441 9.99864C12.3661 9.99864 12.7523 10.143 13.0751 10.4254L12.6823 10.9398C12.4867 10.7205 12.3019 10.6281 12.0769 10.6281C11.7534 10.6281 11.5177 10.8123 11.5177 11.0548Z",
			fill: "#231F20"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.10207 10.0623H6V13.9113H7.09624C7.67915 13.9113 8.10009 13.7738 8.46956 13.4669C8.90862 13.1036 9.16831 12.5559 9.16831 11.9895C9.16841 10.8536 8.31967 10.0623 7.10207 10.0623ZM7.97915 12.9537C7.74321 13.1667 7.43686 13.2597 6.95176 13.2597H6.75031V10.7145H6.95176C7.43686 10.7145 7.73124 10.8012 7.97915 11.0257C8.23883 11.2569 8.39498 11.6152 8.39498 11.9838C8.39498 12.3534 8.23883 12.7227 7.97915 12.9537Z",
			fill: "#231F20"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M10.2647 10.0623H9.51383V13.9113H10.2647V10.0623Z",
			fill: "#231F20"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.3437 10.0623L22.3702 12.6477L23.41 10.0623H24.2238L22.561 14.0101H22.1571L20.5235 10.0623H21.3437Z",
			fill: "#231F20"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M24.5633 13.9113H26.6925V13.2598H25.3135V12.2208H26.6417V11.5688H25.3135V10.7145H26.6925V10.0623H24.5633V13.9113Z",
			fill: "#231F20"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.3029 10.0623C29.1687 10.0623 29.6651 10.478 29.6651 11.1986C29.6651 11.788 29.3537 12.1748 28.7883 12.2898L30 13.9113H29.0766L28.0375 12.3651H27.9396V13.9113H27.1897V10.0623H28.3029ZM27.9397 11.8344H28.1589C28.6384 11.8344 28.8926 11.626 28.8926 11.239C28.8926 10.8645 28.6384 10.6685 28.1708 10.6685H27.9397V11.8344Z",
			fill: "#231F20"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M18.7097 14.0478C19.8405 14.0478 20.7573 13.1311 20.7573 12.0002C20.7573 10.8694 19.8405 9.95264 18.7097 9.95264C17.5788 9.95264 16.6621 10.8694 16.6621 12.0002C16.6621 13.1311 17.5788 14.0478 18.7097 14.0478Z",
			fill: "#F48120"
		})
	]
});
//#endregion
//#region src/icons/CCIconSet/GooglePayIcon.tsx
const GooglePayIcon = ({ size = "md", ...rest }) => /* @__PURE__ */ jsxs("svg", {
	height: iconSizes[size],
	width: iconSizes[size] * 1.5,
	viewBox: "0 0 36 24",
	fill: "none",
	...rest,
	children: [
		/* @__PURE__ */ jsx("rect", {
			width: "36.0001",
			height: "24",
			rx: "4",
			fill: "#F5F2EE"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.069 14.7892V11.8891H18.5658C19.1792 11.8891 19.6969 11.6836 20.1189 11.2783L20.2202 11.1755C20.9911 10.3363 20.9405 9.02898 20.1189 8.25257C19.7081 7.84153 19.1454 7.61888 18.5658 7.6303H16.1631V14.7892H17.069ZM17.0691 11.0099V8.50943H18.5886C18.915 8.50943 19.2246 8.63502 19.4553 8.86338C19.945 9.34292 19.9562 10.1422 19.4835 10.6388C19.2527 10.8843 18.9263 11.0213 18.5886 11.0099H17.0691Z",
			fill: "#3C4043"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.4462 10.2735C24.058 9.91383 23.529 9.73114 22.8594 9.73114C21.9985 9.73114 21.3514 10.0508 20.9237 10.6845L21.7227 11.1926C22.0153 10.7587 22.4149 10.5418 22.9213 10.5418C23.242 10.5418 23.5515 10.6617 23.7935 10.8786C24.0298 11.0841 24.1649 11.381 24.1649 11.695V11.9062C23.816 11.7121 23.3771 11.6094 22.8369 11.6094C22.2067 11.6094 21.7002 11.7578 21.3232 12.0604C20.9462 12.3629 20.7549 12.7626 20.7549 13.2707C20.7436 13.7331 20.9406 14.1727 21.2895 14.4695C21.644 14.7892 22.0941 14.9491 22.6231 14.9491C23.2477 14.9491 23.7429 14.6693 24.1199 14.1099H24.1593V14.7892H25.0258V11.7692C25.0258 11.1355 24.8345 10.6331 24.4462 10.2735ZM21.9874 13.8872C21.8017 13.7502 21.6891 13.5276 21.6891 13.2878C21.6891 13.0195 21.8129 12.7968 22.0549 12.6199C22.3026 12.4429 22.6121 12.3515 22.9779 12.3515C23.4844 12.3458 23.8784 12.46 24.1598 12.6884C24.1598 13.0766 24.0078 13.4134 23.7096 13.6988C23.4394 13.9729 23.0736 14.127 22.6909 14.127C22.4376 14.1327 22.19 14.0471 21.9874 13.8872Z",
			fill: "#3C4043"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M26.9729 16.9415L30.0002 9.89098H29.0155L27.6143 13.4077H27.5975L26.1626 9.89098H25.1778L27.1642 14.4752L26.0388 16.9415H26.9729Z",
			fill: "#3C4043"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M13.9411 11.2611C13.9411 10.9813 13.9186 10.7016 13.8736 10.4276H10.0528V12.0089H12.2417C12.1517 12.517 11.8591 12.9737 11.4314 13.2592V14.2868H12.7369C13.5022 13.5732 13.9411 12.517 13.9411 11.2611Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M10.053 15.2801C11.1446 15.2801 12.0673 14.9148 12.7369 14.2868L11.4314 13.2592C11.0657 13.5104 10.5988 13.6531 10.053 13.6531C8.99508 13.6531 8.10038 12.9281 7.77963 11.9576H6.43476V13.0194C7.12127 14.4067 8.52241 15.2801 10.053 15.2801Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M7.77963 11.9576C7.6108 11.4495 7.61101 10.8957 7.77985 10.3819V9.32576H6.43476C5.85508 10.4847 5.85508 11.8548 6.43476 13.0137L7.77963 11.9576Z",
			fill: "#FBBC04"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M10.053 8.68636C10.6326 8.67495 11.1896 8.89759 11.606 9.30292L12.7652 8.12689C12.0281 7.43041 11.0602 7.04791 10.053 7.05933C8.52241 7.05933 7.12126 7.9385 6.43476 9.32576L7.77963 10.3876C8.10038 9.41139 8.99508 8.68636 10.053 8.68636Z",
			fill: "#EA4335"
		})
	]
});
//#endregion
//#region src/icons/CCIconSet/MasterCardIcon.tsx
const MasterCardIcon = ({ size = "md", ...rest }) => /* @__PURE__ */ jsxs("svg", {
	height: iconSizes[size],
	width: iconSizes[size] * 1.5,
	viewBox: "0 0 36 24",
	fill: "none",
	...rest,
	children: [
		/* @__PURE__ */ jsx("rect", {
			width: "36.0001",
			height: "24",
			rx: "4",
			fill: "#F5F2EE"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.2441 6.16943H14.7549V17.8296H21.2441V6.16943Z",
			fill: "#FF5F00"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M15.1674 11.9999C15.1674 9.63074 16.2799 7.52944 17.9897 6.16977C16.7331 5.18093 15.1468 4.5835 13.4163 4.5835C9.31675 4.5835 6 7.90025 6 11.9999C6 16.0994 9.31675 19.4162 13.4163 19.4162C15.1468 19.4162 16.7331 18.8188 17.9897 17.8299C16.2799 16.4909 15.1674 14.369 15.1674 11.9999Z",
			fill: "#EB001B"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M30.0004 12.0003C30.0004 16.0999 26.6837 19.4167 22.5841 19.4167C20.8537 19.4167 19.2674 18.8193 18.0107 17.8304C19.7412 16.4708 20.8331 14.3695 20.8331 12.0003C20.8331 9.63123 19.7206 7.52993 18.0107 6.17026C19.2674 5.18142 20.8537 4.58398 22.5841 4.58398C26.6837 4.58398 30.0004 7.92134 30.0004 12.0003Z",
			fill: "#F79E1B"
		})
	]
});
//#endregion
//#region src/icons/CCIconSet/PayPalIcon.tsx
const PayPalIcon = ({ size = "md", ...rest }) => /* @__PURE__ */ jsxs("svg", {
	height: iconSizes[size],
	width: iconSizes[size] * 1.5,
	viewBox: "0 0 36 24",
	fill: "none",
	...rest,
	children: [/* @__PURE__ */ jsxs("g", {
		clipPath: "url(#clip0_2_21)",
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M32.0001 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H32.0001C34.2092 24 36.0001 22.2091 36.0001 20V4C36.0001 1.79086 34.2092 0 32.0001 0Z",
				fill: "#F5F2EE"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8.88 9.0003H7.01326C6.88552 9.0003 6.77688 9.09311 6.75695 9.21921L6.00196 14.006C5.98695 14.1005 6.0601 14.1856 6.15591 14.1856H7.04711C7.17485 14.1856 7.28349 14.0928 7.30341 13.9665L7.50704 12.6754C7.52669 12.549 7.6356 12.4562 7.76307 12.4562H8.35402C9.58368 12.4562 10.2934 11.8612 10.4787 10.682C10.5622 10.1661 10.4823 9.76076 10.2407 9.47688C9.97538 9.16517 9.5048 9.0003 8.88 9.0003ZM9.09537 10.7486C8.99328 11.4184 8.48149 11.4184 7.98662 11.4184H7.70493L7.90255 10.1675C7.91429 10.0919 7.9798 10.0362 8.05622 10.0362H8.18533C8.52243 10.0362 8.84043 10.0362 9.00475 10.2283C9.10274 10.343 9.13276 10.5133 9.09537 10.7486Z",
				fill: "#253B80"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M14.46 10.727H13.5661C13.49 10.727 13.4242 10.7827 13.4124 10.8583L13.3729 11.1083L13.3104 11.0177C13.1168 10.7368 12.6853 10.6429 12.2546 10.6429C11.2667 10.6429 10.423 11.3911 10.2587 12.4406C10.1733 12.9641 10.2947 13.4647 10.5917 13.8138C10.8641 14.1348 11.2539 14.2686 11.7177 14.2686C12.5136 14.2686 12.955 13.7568 12.955 13.7568L12.9151 14.0052C12.9001 14.1002 12.9733 14.1853 13.0685 14.1853H13.8737C14.0018 14.1853 14.1098 14.0925 14.13 13.9662L14.6132 10.9066C14.6285 10.8124 14.5556 10.727 14.46 10.727ZM13.214 12.4668C13.1278 12.9775 12.7224 13.3203 12.2054 13.3203C11.9459 13.3203 11.7384 13.2371 11.6052 13.0793C11.4731 12.9226 11.4229 12.6996 11.4649 12.4513C11.5454 11.9449 11.9576 11.5909 12.4667 11.5909C12.7205 11.5909 12.9269 11.6752 13.0628 11.8344C13.199 11.9951 13.253 12.2195 13.214 12.4668Z",
				fill: "#253B80"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19.2209 10.727H18.3226C18.2369 10.727 18.1564 10.7696 18.1078 10.8408L16.8689 12.6658L16.3437 10.9121C16.3107 10.8023 16.2094 10.727 16.0948 10.727H15.212C15.1048 10.727 15.0303 10.8318 15.0644 10.9328L16.0538 13.8365L15.1236 15.1497C15.0505 15.2531 15.1242 15.3954 15.2505 15.3954H16.1477C16.2329 15.3954 16.3126 15.3539 16.3609 15.284L19.3487 10.9713C19.4202 10.8681 19.3468 10.727 19.2209 10.727Z",
				fill: "#253B80"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M22.1951 9.00027H20.328C20.2006 9.00027 20.0919 9.09308 20.072 9.21918L19.317 14.006C19.302 14.1005 19.3752 14.1856 19.4704 14.1856H20.4285C20.5175 14.1856 20.5936 14.1206 20.6076 14.0322L20.8218 12.6753C20.8415 12.549 20.9504 12.4562 21.0779 12.4562H21.6685C22.8985 12.4562 23.6079 11.8611 23.7935 10.682C23.8773 10.1661 23.7968 9.76073 23.5552 9.47685C23.2902 9.16514 22.8199 9.00027 22.1951 9.00027ZM22.4104 10.7486C22.3086 11.4184 21.7968 11.4184 21.3017 11.4184H21.0203L21.2182 10.1674C21.2299 10.0918 21.2949 10.0361 21.3716 10.0361H21.5007C21.8375 10.0361 22.1558 10.0361 22.3201 10.2283C22.4181 10.3429 22.4478 10.5133 22.4104 10.7486Z",
				fill: "#179BD7"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M27.7748 10.727H26.8814C26.8047 10.727 26.7395 10.7827 26.728 10.8583L26.6885 11.1083L26.6257 11.0177C26.4322 10.7368 26.0009 10.6429 25.5702 10.6429C24.5823 10.6429 23.7389 11.3911 23.5746 12.4406C23.4894 12.9641 23.6103 13.4647 23.9073 13.8138C24.1803 14.1348 24.5695 14.2686 25.0333 14.2686C25.8292 14.2686 26.2706 13.7568 26.2706 13.7568L26.2307 14.0052C26.2157 14.1002 26.2889 14.1853 26.3847 14.1853H27.1896C27.3171 14.1853 27.4257 14.0925 27.4456 13.9662L27.929 10.9066C27.9438 10.8124 27.8706 10.727 27.7748 10.727ZM26.5288 12.4668C26.4431 12.9775 26.0372 13.3203 25.5202 13.3203C25.2612 13.3203 25.0532 13.2371 24.92 13.0793C24.7879 12.9226 24.7382 12.6996 24.7797 12.4513C24.8607 11.9449 25.2724 11.5909 25.7814 11.5909C26.0353 11.5909 26.2416 11.6752 26.3776 11.8344C26.5143 11.9951 26.5684 12.2195 26.5288 12.4668Z",
				fill: "#179BD7"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M28.8287 9.13156L28.0625 14.006C28.0475 14.1005 28.1207 14.1856 28.2159 14.1856H28.9862C29.1142 14.1856 29.2228 14.0928 29.2425 13.9664L29.998 9.17988C30.0131 9.08544 29.9399 9 29.8446 9H28.9821C28.906 9.00027 28.8404 9.05596 28.8287 9.13156Z",
				fill: "#179BD7"
			})
		]
	}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
		id: "clip0_2_21",
		children: /* @__PURE__ */ jsx("rect", {
			width: "36",
			height: "24",
			fill: "white"
		})
	}) })]
});
//#endregion
//#region src/icons/CCIconSet/VisaCardIcon.tsx
const VisaCardIcon = ({ size = "md", ...rest }) => /* @__PURE__ */ jsxs("svg", {
	height: iconSizes[size],
	width: iconSizes[size] * 1.5,
	viewBox: "0 0 36 24",
	fill: "none",
	...rest,
	children: [
		/* @__PURE__ */ jsx("rect", {
			width: "36",
			height: "24",
			rx: "4",
			fill: "#F5F2EE"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.7043 8C22.4563 8 23.0646 8.17301 23.448 8.3297L23.1836 10.002L23.0078 9.91974C22.656 9.76315 22.1916 9.60668 21.5596 9.62321C20.792 9.62321 20.4477 9.9608 20.4398 10.2904C20.4398 10.6529 20.8562 10.8919 21.5362 11.2462C22.6563 11.7982 23.1759 12.4737 23.1681 13.3553C23.1524 14.9618 21.8243 16 19.7843 16C18.9121 15.9917 18.072 15.8018 17.6161 15.5878L17.8881 13.8494L18.1441 13.9732C18.7762 14.2618 19.1921 14.3851 19.9683 14.3851C20.528 14.3851 21.1282 14.146 21.1358 13.6272C21.1358 13.2894 20.8801 13.042 20.1279 12.663C19.392 12.2921 18.4081 11.6743 18.424 10.5621C18.4323 9.05448 19.7843 8 21.7043 8Z",
			fill: "#00579F"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M14.4561 15.8846H16.4003L17.6162 8.14038H15.6721L14.4561 15.8846Z",
			fill: "#00579F"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.4318 8.14038H26.928C26.4643 8.14038 26.1119 8.28032 25.9118 8.78292L23.024 15.8845H25.064C25.064 15.8845 25.3998 14.9287 25.472 14.7228H27.9682C28.024 14.9947 28.2001 15.8845 28.2001 15.8845H30.0003L28.4318 8.14038ZM26.032 13.1411C26.1921 12.6962 26.8082 10.9743 26.8082 10.9743C26.8049 10.981 26.8304 10.9084 26.8682 10.8004C26.924 10.6411 27.0068 10.4048 27.064 10.2329L27.1998 10.9002C27.1998 10.9002 27.568 12.7539 27.648 13.1411H26.032Z",
			fill: "#00579F"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M10.9282 13.4212L12.8322 8.14038H14.888L11.8321 15.8764H9.77621L8.03223 9.10408C9.2642 9.7717 10.3682 11.1144 10.7202 12.3502L10.9282 13.4212Z",
			fill: "#00579F"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M9.15998 8.14014H6.032L6 8.29661C8.44002 8.93926 10.056 10.4883 10.7199 12.3503L10.0399 8.79111C9.92799 8.2965 9.58396 8.15645 9.15998 8.14014Z",
			fill: "#FAA61A"
		})
	]
});
//#endregion
//#region src/icons/CaretDown/CaretDownIcon.tsx
const CaretDownIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.999 8.977a1.848 1.848 0 0 0-.748-1.542c-.399-.304-.89-.374-1.248-.404C17.63 7 17.155 7 16.613 7H7.387c-.542 0-1.017 0-1.39.031-.358.03-.85.1-1.248.404a1.849 1.849 0 0 0-.748 1.542c.02.478.29.864.503 1.132.223.279.539.607.899.982l4.62 4.813c.193.2.378.393.548.543.185.162.425.34.747.445.441.144.923.144 1.364 0 .322-.104.562-.283.747-.445.17-.15.355-.342.547-.543L14 15.88l4.597-4.789c.36-.375.676-.703.899-.982.214-.268.483-.654.503-1.132",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19.999 8.977a1.848 1.848 0 0 0-.748-1.542c-.399-.304-.89-.374-1.248-.404C17.63 7 17.155 7 16.613 7H7.387c-.542 0-1.017 0-1.39.031-.358.03-.85.1-1.248.404a1.849 1.849 0 0 0-.748 1.542c.02.478.29.864.503 1.132.223.279.539.607.899.982l4.62 4.813c.193.2.378.393.548.543.185.162.425.34.747.445.441.144.923.144 1.364 0 .322-.104.562-.283.747-.445.17-.15.355-.342.547-.543L14 15.88l4.597-4.789c.36-.375.676-.703.899-.982.214-.268.483-.654.503-1.132",
			clipRule: "evenodd"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CaretUp/CaretUpIcon.tsx
const CaretUpIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.999 15.023a1.848 1.848 0 0 1-.748 1.542c-.399.304-.89.374-1.248.404-.373.031-.848.031-1.39.031H7.387c-.542 0-1.017 0-1.39-.031-.358-.03-.85-.1-1.248-.404a1.848 1.848 0 0 1-.748-1.542c.02-.478.29-.864.503-1.132.223-.279.539-.607.899-.982l4.62-4.813c.193-.2.378-.393.548-.543.185-.162.425-.34.747-.445a2.214 2.214 0 0 1 1.364 0c.322.104.562.283.747.445.17.15.355.342.547.543L14 8.12l4.597 4.789c.36.375.676.703.899.982.214.268.483.654.503 1.132",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M19.999 15.023a1.848 1.848 0 0 1-.748 1.542c-.399.304-.89.374-1.248.404-.373.031-.848.031-1.39.031H7.387c-.542 0-1.017 0-1.39-.031-.358-.03-.85-.1-1.248-.404a1.848 1.848 0 0 1-.748-1.542c.02-.478.29-.864.503-1.132.223-.279.539-.607.899-.982l4.62-4.813c.193-.2.378-.393.548-.543.185-.162.425-.34.747-.445a2.214 2.214 0 0 1 1.364 0c.322.104.562.283.747.445.17.15.355.342.547.543L14 8.12l4.597 4.789c.36.375.676.703.899.982.214.268.483.654.503 1.132",
			clipRule: "evenodd"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CaretLeft/CaretLeftIcon.tsx
const CaretLeftIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15.023 4.001a1.848 1.848 0 0 1 1.542.748c.304.399.374.89.404 1.248.031.373.031.848.031 1.39v9.226c0 .542 0 1.017-.031 1.39-.03.358-.1.85-.404 1.248a1.848 1.848 0 0 1-1.542.748c-.478-.02-.864-.29-1.132-.503-.279-.223-.607-.539-.982-.899l-4.813-4.62c-.2-.193-.393-.378-.543-.548a2.115 2.115 0 0 1-.445-.747 2.214 2.214 0 0 1 0-1.364c.104-.322.283-.562.445-.747.15-.17.342-.355.543-.547L8.12 10l4.789-4.597c.375-.36.703-.676.982-.899.268-.214.654-.483 1.132-.503",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M15.023 4.001a1.848 1.848 0 0 1 1.542.748c.304.399.374.89.404 1.248.031.373.031.848.031 1.39v9.226c0 .542 0 1.017-.031 1.39-.03.358-.1.85-.404 1.248a1.848 1.848 0 0 1-1.542.748c-.478-.02-.864-.29-1.132-.503-.279-.223-.607-.539-.982-.899l-4.813-4.62c-.2-.193-.393-.378-.543-.548a2.115 2.115 0 0 1-.445-.747 2.214 2.214 0 0 1 0-1.364c.104-.322.283-.562.445-.747.15-.17.342-.355.543-.547L8.12 10l4.789-4.597c.375-.36.703-.676.982-.899.268-.214.654-.483 1.132-.503",
			clipRule: "evenodd"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/CaretRight/CaretRightIcon.tsx
const CaretRightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M8.977 4.001a1.849 1.849 0 0 0-1.542.748c-.304.399-.374.89-.404 1.248C7 6.37 7 6.845 7 7.387v9.226c0 .542 0 1.017.031 1.39.03.358.1.85.404 1.248a1.85 1.85 0 0 0 1.542.748c.478-.02.864-.29 1.132-.503.279-.223.607-.539.982-.899l4.813-4.62c.2-.193.393-.378.543-.548.162-.185.34-.425.445-.747a2.214 2.214 0 0 0 0-1.364 2.115 2.115 0 0 0-.445-.747 9.55 9.55 0 0 0-.543-.547L15.88 10l-4.79-4.597c-.375-.36-.703-.676-.982-.899-.268-.214-.654-.483-1.132-.503Z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "M8.977 4.001a1.849 1.849 0 0 0-1.542.748c-.304.399-.374.89-.404 1.248C7 6.37 7 6.845 7 7.387v9.226c0 .542 0 1.017.031 1.39.03.358.1.85.404 1.248a1.85 1.85 0 0 0 1.542.748c.478-.02.864-.29 1.132-.503.279-.223.607-.539.982-.899l4.813-4.62c.2-.193.393-.378.543-.548.162-.185.34-.425.445-.747a2.214 2.214 0 0 0 0-1.364 2.115 2.115 0 0 0-.445-.747 9.55 9.55 0 0 0-.543-.547L15.88 10l-4.79-4.597c-.375-.36-.703-.676-.982-.899-.268-.214-.654-.483-1.132-.503Z",
			clipRule: "evenodd"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Liquor/LiquorIcon.tsx
const LiquorIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M5.25618 2.80131C5.3507 2.3351 5.76055 2 6.23624 2H17.8327c.4757 0 .8855.3351.98.80131l1.0543 5.2c.0032.01591.006.03189.0085.04794.4822 3.16225-.4807 5.46385-2.1612 6.94575-1.3922 1.2277-2.8788 1.8217-4.7143 1.9682V20h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.55228 0-1-.4477-1-1s.44772-1 1-1h2v-3.0487c-1.92532-.1832-3.75175-.8882-5.07071-2.1894-1.59177-1.5703-2.31159-3.8787-1.72733-6.76059zM7.05385 4 6.4051 7.2h11.2587L17.0151 4z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M18.8868 8.2 17.8326 3H6.23619L5.18196 8.2m13.70484 0c.8723 5.72-2.6355 7.8-6.8524 7.8-4.21688 0-7.90666-2.6-6.85244-7.8m13.70484 0H5.18196"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M12 16v5m0 0H9m3 0h3"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/ClockPending/ClockPendingIcon.tsx
const ClockPendingIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12.86 19.96c-.46.05-.92.06-1.4.03-.47-.03-.94-.1-1.38-.21-.54-.13-1.08.2-1.21.73-.13.54.2 1.08.73 1.21.56.14 1.13.23 1.72.26.59.04 1.17.03 1.74-.04.55-.06.95-.55.89-1.1s-.55-.95-1.1-.89zm-7.71-3.8c-.29-.47-.9-.62-1.37-.34-.47.29-.62.9-.34 1.37.61 1 1.38 1.88 2.29 2.61.43.35 1.06.28 1.41-.15s.28-1.06-.15-1.41c-.73-.58-1.35-1.29-1.83-2.09zm13.08.86c-.58.73-1.29 1.35-2.09 1.83-.47.29-.62.9-.34 1.37.29.47.9.62 1.37.34 1-.61 1.88-1.38 2.61-2.29.35-.43.28-1.06-.15-1.41s-1.06-.28-1.41.15zm5.17-6.22c-.39-.39-1.02-.39-1.41 0l-.06.06c-.02-.17-.05-.33-.08-.5-.02-.13-.04-.27-.06-.4q-.09-.42-.21-.81c-.04-.14-.09-.27-.13-.4-.07-.2-.13-.39-.21-.58-.05-.12-.11-.24-.17-.37-.08-.16-.15-.32-.23-.48l-.21-.36c-.09-.15-.17-.3-.27-.44-.08-.12-.16-.23-.25-.35-.1-.14-.2-.27-.3-.41-.09-.11-.18-.22-.28-.32-.11-.13-.22-.25-.34-.37l-.3-.3c-.12-.12-.24-.23-.37-.34l-.33-.27c-.13-.1-.27-.21-.41-.3-.12-.08-.23-.16-.35-.24-.14-.09-.29-.18-.44-.27-.12-.07-.24-.14-.36-.2-.16-.08-.31-.16-.47-.23-.13-.06-.25-.12-.38-.17-.17-.07-.34-.13-.51-.19-.13-.04-.25-.09-.38-.13-.18-.06-.37-.1-.56-.14-.12-.03-.24-.06-.37-.09-.21-.04-.43-.07-.64-.1-.11-.01-.21-.03-.32-.05-.33-.03-.65-.05-.99-.05-4.7.01-8.62 3.23-9.71 7.58 0 .02-.02.03-.02.05-.01.06-.02.12-.04.18-.03.14-.06.27-.08.41-.03.17-.06.35-.08.52-.02.14-.03.28-.05.42 0 .06-.02.13-.02.19v.4c0 .09-.01.17-.01.26v.03c0 .36.01.71.05 1.06.06.55.55.95 1.1.89s.95-.55.89-1.1c-.04-.35-.05-.71-.04-1.08 0-.16.01-.32.02-.47 0-.11.02-.22.04-.33l.06-.42c.02-.11.04-.22.06-.32.8-3.57 3.99-6.25 7.8-6.25.27 0 .54.01.8.04.09 0 .17.03.26.04.17.02.35.04.52.08.1.02.2.05.3.07.15.04.3.07.45.11.11.03.21.07.31.11.14.05.27.09.41.15.11.04.21.09.31.14.13.06.25.12.38.18.1.05.2.11.3.17.12.07.23.14.35.21.1.06.19.13.29.2.11.08.21.16.32.24.09.07.18.15.27.23.1.09.19.17.29.26.09.08.17.17.25.26.09.09.17.19.26.28.08.09.16.19.23.29.08.1.15.2.23.3.07.1.14.2.21.31s.13.21.2.32l.18.33c.06.11.11.22.16.34s.11.23.15.35c.05.12.09.23.13.35s.09.25.12.37c.04.12.06.24.09.36l.09.39c.02.12.04.25.06.38s.04.27.05.4v.07l-.56-.56c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l2 2c.19.19.44.29.71.29s.52-.11.71-.29l2-2c.39-.39.39-1.02 0-1.41z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m15.54 13.18-2.55-1.7V7.01c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .33.17.65.45.83l3 2c.46.31 1.08.18 1.39-.28s.18-1.08-.28-1.39z"
			})
		] }),
		line: /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#252424",
				d: "M12.86 19.96c-.46.05-.92.06-1.4.03-.47-.03-.94-.1-1.38-.21-.54-.13-1.08.2-1.21.73-.13.54.2 1.08.73 1.21.56.14 1.13.23 1.72.26.59.04 1.17.03 1.74-.04.55-.06.95-.55.89-1.1s-.55-.95-1.1-.89zm-7.71-3.8c-.29-.47-.9-.62-1.37-.34-.47.29-.62.9-.34 1.37.61 1 1.38 1.88 2.29 2.61.43.35 1.06.28 1.41-.15s.28-1.06-.15-1.41c-.73-.58-1.35-1.29-1.83-2.09zm13.08.86c-.58.73-1.29 1.35-2.09 1.83-.47.29-.62.9-.34 1.37.29.47.9.62 1.37.34 1-.61 1.88-1.38 2.61-2.29.35-.43.28-1.06-.15-1.41s-1.06-.28-1.41.15zm5.17-6.22c-.39-.39-1.02-.39-1.41 0l-.06.06c-.02-.17-.05-.33-.08-.5-.02-.13-.04-.27-.06-.4q-.09-.42-.21-.81c-.04-.14-.09-.27-.13-.4-.07-.2-.13-.39-.21-.58-.05-.12-.11-.24-.17-.37-.08-.16-.15-.32-.23-.48l-.21-.36c-.09-.15-.17-.3-.27-.44-.08-.12-.16-.23-.25-.35-.1-.14-.2-.27-.3-.41-.09-.11-.18-.22-.28-.32-.11-.13-.22-.25-.34-.37l-.3-.3c-.12-.12-.24-.23-.37-.34l-.33-.27c-.13-.1-.27-.21-.41-.3-.12-.08-.23-.16-.35-.24-.14-.09-.29-.18-.44-.27-.12-.07-.24-.14-.36-.2-.16-.08-.31-.16-.47-.23-.13-.06-.25-.12-.38-.17-.17-.07-.34-.13-.51-.19-.13-.04-.25-.09-.38-.13-.18-.06-.37-.1-.56-.14-.12-.03-.24-.06-.37-.09-.21-.04-.43-.07-.64-.1-.11-.01-.21-.03-.32-.05-.33-.03-.65-.05-.99-.05-4.7.01-8.62 3.23-9.71 7.58 0 .02-.02.03-.02.05-.01.06-.02.12-.04.18-.03.14-.06.27-.08.41-.03.17-.06.35-.08.52-.02.14-.03.28-.05.42 0 .06-.02.13-.02.19v.4c0 .09-.01.17-.01.26v.03c0 .36.01.71.05 1.06.06.55.55.95 1.1.89s.95-.55.89-1.1c-.04-.35-.05-.71-.04-1.08 0-.16.01-.32.02-.47 0-.11.02-.22.04-.33l.06-.42c.02-.11.04-.22.06-.32.8-3.57 3.99-6.25 7.8-6.25.27 0 .54.01.8.04.09 0 .17.03.26.04.17.02.35.04.52.08.1.02.2.05.3.07.15.04.3.07.45.11.11.03.21.07.31.11.14.05.27.09.41.15.11.04.21.09.31.14.13.06.25.12.38.18.1.05.2.11.3.17.12.07.23.14.35.21.1.06.19.13.29.2.11.08.21.16.32.24.09.07.18.15.27.23.1.09.19.17.29.26.09.08.17.17.25.26.09.09.17.19.26.28.08.09.16.19.23.29.08.1.15.2.23.3.07.1.14.2.21.31s.13.21.2.32l.18.33c.06.11.11.22.16.34s.11.23.15.35c.05.12.09.23.13.35s.09.25.12.37c.04.12.06.24.09.36l.09.39c.02.12.04.25.06.38s.04.27.05.4v.07l-.56-.56c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l2 2c.19.19.44.29.71.29s.52-.11.71-.29l2-2c.39-.39.39-1.02 0-1.41z"
			}),
			" ",
			/* @__PURE__ */ jsx("path", {
				fill: "#252424",
				d: "m15.54 13.18-2.55-1.7V7.01c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .33.17.65.45.83l3 2c.46.31 1.08.18 1.39-.28s.18-1.08-.28-1.39z"
			})
		] })
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/SignaturePencil/SignaturePencilIcon.tsx
const SignaturePencilIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19.6748 16.2622c.4076.3726.436 1.0051.0634 1.4127l-1.0001 1.0941c-.7096.776-1.6922 1.2312-2.7379 1.2312-1.0453 0-2.0275-.4548-2.7371-1.2304-.3519-.3833-.8082-.5795-1.2628-.5795-.4549 0-.9114.1964-1.2634.58-.3734.407-1.00593.4342-1.41288.0608-.40695-.3733-.43417-1.0059-.06079-1.4129.71033-.7742 1.69227-1.2279 2.73707-1.2279 1.0447 0 2.0267.4537 2.737 1.2279l.0012.0013c.3512.3841.8073.5807 1.2617.5807s.9105-.1966 1.2617-.5806l1.0001-1.0941c.3726-.4076 1.0052-.436 1.4128-.0633M13.793 1.79312c1.219-1.21895 3.1953-1.21895 4.4142 0 1.219 1.21895 1.219 3.19526 0 4.41421L5.64449 18.7701c-.01979.0198-.03941.0394-.05887.0589-.28745.288-.54088.5419-.84642.7291a3 3 0 0 1-.86716.3592c-.34845.0837-.7072.0834-1.1141.083-.02754 0-.0553-.0001-.0833-.0001H1.0001c-.55228 0-1-.4477-1-1v-1.6745c0-.028-.00002-.0558-.00005-.0833-.00038-.4069-.00071-.7656.08294-1.1141.0735-.3061.1947-.5987.3592-.8671.18723-.3056.44114-.559.72913-.8465a36 36 0 0 0 .05894-.0588z",
			clipRule: "evenodd"
		}),
		line: /* @__PURE__ */ jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2",
			d: "m19 17.0002-1.0001 1.0941c-.5304.5801-1.2498.9059-1.9998.9059s-1.4693-.3258-1.9997-.9059c-.5312-.5789-1.2504-.904-2.0002-.904s-1.4691.3251-2.00023.904M1 19.0002h1.67454c.48918 0 .73378 0 .96395-.0552a2 2 0 0 0 .57811-.2395c.20183-.1237.37478-.2966.72069-.6425L17.5 5.50023c.8285-.82843.8285-2.17158 0-3-.8284-.82843-2.1715-.82843-3 0L1.93726 15.063c-.3459.3459-.51886.5188-.64254.7207a1.999 1.999 0 0 0-.23946.5781C1 16.5919 1 16.8365 1 17.3257z"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
//#region src/icons/Copyright/CopyrightIcon.tsx
const CopyrightIcon = ({ variant = "solid", size = "md", ...props }) => {
	const paths = {
		solid: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.016 22.8879c-2.15622 0-4.06695-.4697-5.73216-1.409q-2.4658-1.4091-3.87482-3.8748C1.46967 15.9602 1 14.0922 1 12q0-3.17033 1.40902-5.6041 1.40903-2.4658 3.87482-3.87482Q8.78166 1.11207 12.016 1.11206c2.1562 0 4.0563.46968 5.7002 1.40902Q20.214 3.93011 21.591 6.3959C22.5303 8.01842 23 9.88644 23 12c0 2.0922-.4697 3.9602-1.409 5.6041q-1.377 2.4657-3.8748 3.8748c-1.6439.9393-3.544 1.409-5.7002 1.409m0-2.4658c1.6652 0 3.1276-.3629 4.3872-1.0888 1.2596-.7258 2.2416-1.7292 2.9461-3.0102.7046-1.2809 1.0568-2.722 1.0568-4.3231 0-1.6225-.3522-3.06358-1.0568-4.32317-.7045-1.28093-1.6865-2.28432-2.9461-3.01018q-1.8894-1.0888-4.3872-1.0888t-4.38718 1.0888-2.94614 3.01018Q3.62591 9.56623 3.62591 12c0 1.6011.35226 3.0422 1.05677 4.3231q1.05677 1.9215 2.94614 3.0102c1.25958.7259 2.72198 1.0888 4.38718 1.0888m.1922-2.3377c-1.8787 0-3.35182-.5444-4.41926-1.6332s-1.60117-2.5618-1.60117-4.4192c0-1.8573.53372-3.33042 1.60117-4.41921C8.85638 6.524 10.3295 5.9796 12.2082 5.9796c1.3876 0 2.5298.30956 3.4264.92868.8967.59776 1.5372 1.40902 1.9214 2.43377L14.8661 10.655q-.35235-.86462-.9927-1.21688c-.4057-.25619-.9287-.38428-1.5692-.38428-.8753 0-1.5691.26686-2.0815.80058-.51236.51238-.76855 1.23828-.76855 2.17758q0 1.44105.76855 2.2416c.5124.5124 1.2062.7686 2.0815.7686.6618 0 1.2169-.1281 1.6652-.3843.4697-.2562.822-.6938 1.0568-1.3129l2.5619 1.1528c-.4697 1.1955-1.1422 2.0922-2.0175 2.69-.854.5977-1.9748.8966-3.3624.8966"
		}),
		line: /* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M12.016 22.8879c-2.15622 0-4.06695-.4697-5.73216-1.409q-2.4658-1.4091-3.87482-3.8748C1.46967 15.9602 1 14.0922 1 12q0-3.17033 1.40902-5.6041 1.40903-2.4658 3.87482-3.87482Q8.78166 1.11207 12.016 1.11206c2.1562 0 4.0563.46968 5.7002 1.40902Q20.214 3.93011 21.591 6.3959C22.5303 8.01842 23 9.88644 23 12c0 2.0922-.4697 3.9602-1.409 5.6041q-1.377 2.4657-3.8748 3.8748c-1.6439.9393-3.544 1.409-5.7002 1.409m0-2.4658c1.6652 0 3.1276-.3629 4.3872-1.0888 1.2596-.7258 2.2416-1.7292 2.9461-3.0102.7046-1.2809 1.0568-2.722 1.0568-4.3231 0-1.6225-.3522-3.06358-1.0568-4.32317-.7045-1.28093-1.6865-2.28432-2.9461-3.01018q-1.8894-1.0888-4.3872-1.0888t-4.38718 1.0888-2.94614 3.01018Q3.62591 9.56623 3.62591 12c0 1.6011.35226 3.0422 1.05677 4.3231q1.05677 1.9215 2.94614 3.0102c1.25958.7259 2.72198 1.0888 4.38718 1.0888m.1922-2.3377c-1.8787 0-3.35182-.5444-4.41926-1.6332s-1.60117-2.5618-1.60117-4.4192c0-1.8573.53372-3.33042 1.60117-4.41921C8.85638 6.524 10.3295 5.9796 12.2082 5.9796c1.3876 0 2.5298.30956 3.4264.92868.8967.59776 1.5372 1.40902 1.9214 2.43377L14.8661 10.655q-.35235-.86462-.9927-1.21688c-.4057-.25619-.9287-.38428-1.5692-.38428-.8753 0-1.5691.26686-2.0815.80058-.51236.51238-.76855 1.23828-.76855 2.17758q0 1.44105.76855 2.2416c.5124.5124 1.2062.7686 2.0815.7686.6618 0 1.2169-.1281 1.6652-.3843.4697-.2562.822-.6938 1.0568-1.3129l2.5619 1.1528c-.4697 1.1955-1.1422 2.0922-2.0175 2.69-.854.5977-1.9748.8966-3.3624.8966"
		})
	};
	return /* @__PURE__ */ jsx("svg", {
		height: iconSizes[size],
		width: iconSizes[size],
		viewBox: "0 0 24 24",
		fill: variant === "line" ? "none" : void 0,
		...props,
		children: paths[variant]
	});
};
//#endregion
export { UserLeftIcon as $, FaceUpIcon as $a, BarChartChunkIcon as $c, HexagonAltIcon as $i, PieChartIcon as $n, CreditCardUploadIcon as $o, LinkBrokenIcon as $r, ChevronRightDoubleIcon as $s, SkipForwardIcon as $t, YoutubeIcon as A, FlashOffIcon as Aa, BuildingAddIcon as Ac, ImageXIcon as Ai, AlignLeftIcon as Al, RepeatIcon as An, DiamondIcon as Ao, MinusIcon as Ar, CodeCircleIcon as As, ThermometerIcon as At, VolumePlusIcon as B, CreditCardUpIcon as Ba, BellPlusIcon as Bc, ImageUpIcon as Bi, PuzzlePieceAltIcon as Bn, CurrencyYenIcon as Bo, MaximizeIcon as Br, ClockPlusIcon as Bs, StickerCircleIcon as Bt, CollapseIcon as C, FolderPlusIcon as Ca, CalendarPlusIcon as Cc, LayersThreeIcon as Ci, ArrowChunkLeftIcon as Cl, SaleCircleIcon as Cn, Dice4Icon as Co, NavigationPointerIcon as Cr, CommandIcon as Cs, TrendUpIcon as Ct, AssistIcon as D, FolderDownloadIcon as Da, ArrowCircleDownIcon as Dc, KeyIcon as Di, ArrowChunkDownIcon as Dl, PlayCircleIcon as Dn, DataflowAlt2Icon as Do, MicroscopeIcon as Dr, CoinsIcon as Ds, ServerIcon as Dt, SignatureIcon as E, FolderClosedIcon as Ea, BusIcon as Ec, KeyboardIcon as Ei, AlertTriangleIcon as El, RowsIcon as En, Dice2Icon as Eo, NoCodeCircleIcon as Er, CoinsHandIcon as Es, ToolIcon as Et, VolumeMinusIcon as F, FlagIcon as Fa, BrushAltIcon as Fc, GiftIcon as Fi, AlignCenterIcon as Fl, ReceiptCheckIcon as Fn, CursorIcon as Fo, MinimizeIcon as Fr, ClockCheckIcon as Fs, SwitchHorizontalIcon as Ft, VolumeMaxIcon as G, FigmaIcon as Ga, BoldIcon as Gc, ImageIndentRightIcon as Gi, PhoneOutgoingIcon as Gn, ArrowChunkUpIcon as Go, LogOutIcon as Gr, ClipboardXIcon as Gs, SpeedometerIcon as Gt, VideoOffIcon as H, FilePlusIcon as Ha, BookmarkIcon as Hc, ImagePlusIcon as Hi, PowerIcon as Hn, CurrencyPoundCircleIcon as Ho, MarkIcon as Hr, ArrowCircleUpIcon as Hs, StarAlt2Icon as Ht, TicketIcon as I, FingerprintIcon as Ia, BookmarkCheckIcon as Ic, IndentRightIcon as Ii, AlignJustifyIcon as Il, ReceiptIcon as In, CursorBoxIcon as Io, InboxIcon as Ir, ClockSnoozeIcon as Is, StickerSquareIcon as It, VolumeXIcon as J, FileDownloadIcon as Ja, ArrowsRightIcon as Jc, HourglassIcon as Ji, PhoneOffIcon as Jn, CurrencyEthereumCircleIcon as Jo, ListBulletIcon as Jr, ChevronSelectorHorizontalIcon as Js, SquareIcon as Jt, WatchSquareIcon as K, FileAttachmentIcon as Ka, BookOpenIcon as Kc, ImageCheckIcon as Ki, PlusIcon as Kn, CurrencyBitcoinIcon as Ko, LuggageIcon as Kr, ClipboardDownloadIcon as Ks, StarIcon as Kt, WifiOffIcon as L, FilterIcon as La, BrushIcon as Lc, InfinityIcon as Li, AlarmClockPlusIcon as Ll, PresentationIcon as Ln, CurrencyYenCircleIcon as Lo, MenuIcon as Lr, ClockStopwatchIcon as Ls, StopCircleIcon as Lt, XCircleIcon as M, FlagAlt1Icon as Ma, BackpackIcon as Mc, ItalicIcon as Mi, AnchorIcon as Ml, RecordingIcon as Mn, DatabaseIcon as Mo, LuggageSuitcaseIcon as Mr, ClockRewindIcon as Ms, SnowflakeIcon as Mt, WifiIcon as N, FlashIcon as Na, BuildingIcon as Nc, IntersectCircleIcon as Ni, AlignRightIcon as Nl, RewindIcon as Nn, CursorClickIcon as No, MoonIcon as Nr, CloudIcon as Ns, TargetIcon as Nt, ZoomOutIcon as O, FolderCheckIcon as Oa, CalendarCheckIcon as Oc, LLCIcon as Oi, AlarmClockCheckIcon as Ol, RollerBrushIcon as On, DataflowIcon as Oo, MoveIcon as Or, ColorsIcon as Os, PinIcon as Ot, WavesIcon as P, FlagAlt2Icon as Pa, BriefcaseIcon as Pc, InfoIcon as Pi, ArchiveIcon as Pl, RecordingCircleIcon as Pn, DataflowAlt1Icon as Po, MinusCircleIcon as Pr, ClockRefreshIcon as Ps, TabletIcon as Pt, UserXIcon as Q, FileIcon as Qa, BeachIcon as Qc, HexagonIcon as Qi, PhoneIcon as Qn, CodeIcon as Qo, LockIcon as Qr, ChevronUpIcon as Qs, SkipBackIcon as Qt, XIcon as R, FileQuestionIcon as Ra, BookmarkXIcon as Rc, IndentLeftIcon as Ri, AlarmClockMinusIcon as Rl, QrCodeIcon as Rn, CurrencyRubleCircleIcon as Ro, MicrophoneIcon as Rr, ClipboardMinusIcon as Rs, StopIcon as Rt, DocumentsIcon as S, FolderMinusIcon as Sa, CalendarMinusIcon as Sc, LayerSingleIcon as Si, ArrowCircleDownRightIcon as Sl, RssIcon as Sn, Dice6Icon as So, MusicIcon as Sr, CompassIcon as Ss, TramIcon as St, SplitIcon as T, FolderLockIcon as Ta, BoxIcon as Tc, LaptopIcon as Ti, ArrowCircleDownLeftIcon as Tl, SafeIcon as Tn, DataIcon as To, NavigationPointerOffIcon as Tr, CoinsStackIcon as Ts, MicrophoneOffIcon as Tt, WebcamIcon as U, FileMinusIcon as Ua, BookClosedIcon as Uc, ImageLeftIcon as Ui, PrinterIcon as Un, CurrencyRupeeCircleIcon as Uo, MailClosedIcon as Ur, ClipboardIcon as Us, StarAlt3Icon as Ut, WalletIcon as V, FileLockIcon as Va, BookmarkMinusIcon as Vc, ImageDownIcon as Vi, PlusCircleIcon as Vn, CurrencyRubleIcon as Vo, MailOpenIcon as Vr, ClipboardAttachmentIcon as Vs, StarAlt4Icon as Vt, WatchCircleIcon as W, EqualNotIcon as Wa, BoldSquareIcon as Wc, ImageIndentLeftIcon as Wi, PodcastIcon as Wn, CurrencyEuroCircleIcon as Wo, MagicWandIcon as Wr, ClipboardPlusIcon as Ws, StarAlt5Icon as Wt, UsersIcon as X, FeatherIcon as Xa, BellIcon as Xc, INCIcon as Xi, FramerIcon as Xn, CurrencyEthereumIcon as Xo, LuggageBriefcaseIcon as Xr, ChevronUpDoubleIcon as Xs, SlashIcon as Xt, VolumeMinIcon as Y, CurrencyDollarCircleIcon as Ya, BellOffIcon as Yc, ImageIcon as Yi, PlayIcon as Yn, CurrencyDollarIcon as Yo, ListNumbersIcon as Yr, ChevronSelectorVerticalIcon as Ys, SendIcon as Yt, VideoIcon as Z, FileCheckIcon as Za, BeakerIcon as Zc, HomeIcon as Zi, PiggyBankIcon as Zn, CurrencyBitcoinCircleIcon as Zo, LockUnlockedIcon as Zr, CircleIcon as Zs, SlidersIcon as Zt, MessageIcon as _, CurrencyEuroIcon as _a, CashIcon as _c, IntersectSquareIcon as _i, ArrowDownRightIcon as _l, RulerIcon as _n, DownloadCircleIcon as _o, PackageCheckIcon as _r, CornerDownRightIcon as _s, TranslateIcon as _t, CaretRightIcon as a, HeartHandIcon as aa, CheckIcon as ac, LightningOffIcon as ai, AtomIcon as al, ShieldOffIcon as an, EyeIcon as ao, PercentCircleIcon as ar, ClockIcon as as, UserCheckIcon as at, DiningIcon as b, FolderShieldIcon as ba, CalendarDateIcon as bc, LayoutAlt02Icon as bi, ArrowCircleUpLeftIcon as bl, ScaleDownIcon as bn, DivideCircleIcon as bo, OctagonIcon as br, ContrastIcon as bs, SwitchVerticalIcon as bt, CaretDownIcon as c, HeadphonesIcon as ca, CheckCircleIcon as cc, LightningCircleIcon as ci, ArrowsLeftIcon as cl, ShieldCheckIcon as cn, EditIcon as co, PenIcon as cr, CreditCardDownloadIcon as cs, UploadIcon as ct, MasterCardIcon as d, HandIcon as da, ChatDotsIcon as dc, LayersTwoIcon as di, ArrowRightIcon as dl, SettingsIcon as dn, EarthPinIcon as do, PaperclipIcon as dr, CornerUpIcon as ds, UserIcon as dt, HelpIcon as ea, ChevronDownDoubleIcon as ec, LocationPinIcon as ei, AwardMedalIcon as el, ShoppingBagIcon as en, FaceNeutralIcon as eo, PhoneIncomingIcon as er, CreditCardXIcon as es, UserMinusIcon as et, GooglePayIcon as f, GraduationIcon as fa, ChatIcon as fc, LayoutLeftIcon as fi, ArrowUpRightIcon as fl, MonitorIcon as fn, DropIcon as fo, PasscodeIcon as fr, CreditCardIcon as fs, USBIcon as ft, AchIcon as g, CurrencyPoundIcon as ga, CameraOffIcon as gc, LayoutBottomIcon as gi, ArrowDownIcon as gl, ScaleUpIcon as gn, DotsHorizontalIcon as go, PackageMinusIcon as gr, CornerUpLeftIcon as gs, TrophyIcon as gt, AmericanExpressIcon as h, GlobeIcon as ha, ChatAlertIcon as hc, LayoutGrid02Icon as hi, ArrowDownLeftIcon as hl, SearchIcon as hn, DotsGridIcon as ho, PackageXIcon as hr, CornerUpRightIcon as hs, TvIcon as ht, LiquorIcon as i, GridIcon as ia, ChevronDownIcon as ic, LightbulbOffIcon as ii, BankIcon as il, ShoppingCartIcon as in, FaceDownIcon as io, PentagonIcon as ir, CropIcon as is, UserCircleIcon as it, TrashIcon as j, FileShieldIcon as ja, BuildingAddLeftIcon as jc, InputIcon as ji, ActivityIcon as jl, RefreshIcon as jn, Dice1Icon as jo, MouseIcon as jr, ColumnsIcon as js, SunsetIcon as jt, ZoomInIcon as k, FlipForwardIcon as ka, BuildingAddRightIcon as kc, ItalicSquareIcon as ki, AlarmClockIcon as kl, RocketIcon as kn, Dice3Icon as ko, FileXIcon as kr, CloudMoonIcon as ks, TagIcon as kt, VisaCardIcon as l, GoogleChromeIcon as la, ChatDoubleIcon as lc, LayoutTopIcon as li, ArrowsUpIcon as ll, ShieldIcon as ln, EditSquareIcon as lo, PasscodeLockIcon as lr, CreditCardEditIcon as ls, UnderlineSquareIcon as lt, ApplePayIcon as m, FunnelIcon as ma, CameraIcon as mc, LayoutRightIcon as mi, ArrowCircleLeftIcon as ml, ScanIcon as mn, DownloadIcon as mo, PaletteIcon as mr, CreditCardCheckIcon as ms, UnderlineIcon as mt, SignaturePencilIcon as n, HeartCircleIcon as na, ChevronRightIcon as nc, LinkExternalIcon as ni, BarChartIcon as nl, ShuffleIcon as nn, FastForwardIcon as no, PhoneActiveIcon as nr, CreditCardMinusIcon as ns, UserEditIcon as nt, CaretLeftIcon as o, HeadingSquareIcon as oa, ChatCheckIcon as oc, LightningIcon as oi, ArrowCircleUpRightIcon as ol, ShieldPlusIcon as on, EyeHiddenIcon as oo, ParagraphSpacingIcon as or, CreditCardPlusIcon as os, UserPlusIcon as ot, DiscoverIcon as p, GlassesIcon as pa, CalculatorIcon as pc, LayoutGrid01Icon as pi, ArrowUpLeftIcon as pl, ScissorsIcon as pn, EarthArrowIcon as po, PaintIcon as pr, CreditCardDownIcon as ps, UmbrellaIcon as pt, TrendDownIcon as q, FileHeartIcon as qa, BellRingingIcon as qc, FlipBackwardIcon as qi, PlaneIcon as qn, CreditCardLockIcon as qo, LogInIcon as qr, ClipboardCheckIcon as qs, StarAlt1Icon as qt, ClockPendingIcon as r, HeartIcon as ra, ChevronLeftDoubleIcon as rc, LinkIcon as ri, ArrowCircleRightIcon as rl, ShieldZapIcon as rn, EqualIcon as ro, PercentIcon as rr, CryptocurrencyIcon as rs, UserUpIcon as rt, CaretUpIcon as s, HardDriveIcon as sa, CheckVerifiedIcon as sc, LightbulbOnIcon as si, AttachmentIcon as sl, ShieldDollarIcon as sn, EarthIcon as so, PencilIcon as sr, CreditCardSearchIcon as ss, UserDownIcon as st, CopyrightIcon as t, HeartsIcon as ta, ChevronLeftIcon as tc, LightningFastIcon as ti, AwardIcon as tl, SignalIcon as tn, FaceIdIcon as to, PackageIcon as tr, CreditCardShieldIcon as ts, UserRightIcon as tt, PayPalIcon as u, HeadingIcon as ua, ChatNotificationIcon as uc, LayoutAlt04Icon as ui, ArrowsDownIcon as ul, ShareIcon as un, EraserIcon as uo, PauseIcon as ur, CertificateIcon as us, TelescopeIcon as ut, MobileIcon as v, FolderXIcon as va, CertificateHeartIcon as vc, LayersTwoAltIcon as vi, ArrowUpIcon as vl, SaveIcon as vn, DivideIcon as vo, PackageSearchIcon as vr, CornerDownLeftIcon as vs, TruckIcon as vt, ShieldLockIcon as w, FolderIcon as wa, CalendarHeartIcon as wc, LayersThreeAltIcon as wi, AnnouncementIcon as wl, SaleIcon as wn, Dice5Icon as wo, NoCodeIcon as wr, CopyIcon as ws, ThumbsDownIcon as wt, TrademarkIcon as x, FolderQuestionIcon as xa, CarIcon as xc, LayoutAlt01Icon as xi, AlertCircleIcon as xl, ScaleIcon as xn, DeleteIcon as xo, NotificationIcon as xr, CornerDownIcon as xs, ThumbsUpIcon as xt, CircleDashedIcon as y, FolderSearchIcon as ya, CalendarIcon as yc, LayoutAlt03Icon as yi, ArrowLeftIcon as yl, ScalesIcon as yn, DotsVerticalIcon as yo, PackagePlusIcon as yr, ContainerIcon as ys, TriangleIcon as yt, WindIcon as z, FileSearchIcon as za, BookmarkAddIcon as zc, ImageRightIcon as zi, AlarmClockOffIcon as zl, PuzzlePieceIcon as zn, CurrencyRupeeIcon as zo, MapIcon as zr, ClockFastForwardIcon as zs, SunIcon as zt };

//# sourceMappingURL=icons-BxyjaHfi.mjs.map